import { defineComponent as W, createElementBlock as T, openBlock as m, renderSlot as ie, ref as L, watch as le, onMounted as he, computed as E, unref as O, normalizeClass as G, createBlock as H, resolveDynamicComponent as Er, withCtx as V, createElementVNode as D, createVNode as B, createCommentVNode as M, onBeforeUnmount as qe, createTextVNode as K, toDisplayString as U, mergeProps as $e, Fragment as se, withModifiers as ct, normalizeStyle as Ce, renderList as ve, Transition as ft, nextTick as at, getCurrentScope as Au, onScopeDispose as Tu, isRef as pn, getCurrentInstance as Ar, toValue as ke, shallowRef as Gt, reactive as It, withDirectives as we, vShow as Se, useAttrs as tl, onUnmounted as Xa, Teleport as rl, watchEffect as Ke, inject as ee, provide as _e, normalizeProps as Lu, guardReactiveProps as Mu, resolveComponent as nl, h as ba, markRaw as Ja, toRef as al, triggerRef as Ur, isReactive as Hs, mergeDefaults as sl, useSlots as Ou, toRefs as Nu } from "vue";
const Fu = { class: "ds-accordion" }, K1 = /* @__PURE__ */ W({
  __name: "ds-accordion",
  setup(e) {
    return (t, r) => (m(), T("div", Fu, [
      ie(t.$slots, "default")
    ]));
  }
}), yr = /* @__PURE__ */ new Map();
function il(e, t, r, n, a, s = "6.5.0") {
  const i = L(""), l = `${e}-version`, o = async (c) => {
    if (yr.has(c))
      return yr.get(c);
    const y = fetch(c).then(async (g) => {
      if (g.ok) {
        const b = await g.text();
        return yr.delete(c), b;
      } else
        throw new Error("Failed to load icon");
    }).catch(() => {
      throw yr.delete(c), new Error("Failed to load icon");
    });
    return yr.set(c, y), y;
  }, u = async () => {
    const c = `${p()}/${a.value}.svg`, g = c.split("/").slice(-2).join("/"), b = `${e}|${s}|${g}`, k = localStorage.getItem(b), P = k == null ? void 0 : k.startsWith("<svg");
    if (k && P)
      i.value = k;
    else {
      localStorage.removeItem(b);
      let I;
      try {
        I = await o(c), I && (i.value = I, localStorage.setItem(b, I));
      } catch (_) {
        console.error(_);
      }
    }
  }, f = () => window.dsConfig ? e === "ds-brand-icon" ? window.dsConfig.brandIconBasePath : window.dsConfig.iconBasePath : null, p = () => {
    const c = f();
    let y = r;
    return c && r === t && (y = c), y;
  }, h = () => {
    const c = s;
    localStorage.getItem(l) !== c && (Object.keys(localStorage).forEach((g) => {
      const b = g.startsWith("icon-"), k = g.startsWith("brand-icon-"), P = g.startsWith(`${e}|`) && !g.includes(`|${c}|`);
      (b || P || k) && localStorage.removeItem(g);
    }), localStorage.setItem(l, c));
  };
  return le(
    () => a.value,
    async () => {
      await u();
    }
  ), he(async () => {
    h(), await u(), n("iconLoaded");
  }), { loadIcon: u, svgContents: i };
}
const Du = ["aria-hidden", "aria-label", "role", "innerHTML", "data-icon-name"], Ru = "ds-icon", xu = "/dist/shared/images/design-system-icons", ae = /* @__PURE__ */ W({
  __name: "ds-icon",
  props: {
    /** Location of the icon files (no trailing slash) */
    basePath: {
      default: "/dist/shared/images/design-system-icons",
      type: String
    },
    /** Accessibility label: set if you want a screenreader to know what this icon represents */
    label: {
      default: null,
      type: String
    },
    /** Icon name: these correspond to the icon file names, e.g. {name}.svg  */
    iconName: {
      required: !0,
      type: String
    },
    /** Size option for the icon */
    size: {
      default: "md",
      type: String
    }
  },
  emits: ["iconLoaded"],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = E(() => n.iconName), s = r, { loadIcon: i, svgContents: l } = il(
      Ru,
      xu,
      n.basePath,
      s,
      a
    );
    return t({ loadIcon: i }), (o, u) => (m(), T("span", {
      "aria-hidden": e.label ? void 0 : !0,
      "aria-label": e.label ? e.label : void 0,
      role: e.label ? "img" : void 0,
      class: G(["ds-icon", `ds-icon--${e.size}`]),
      innerHTML: O(l),
      "data-icon-name": a.value,
      "data-testid": "ds-banner-icon"
    }, null, 10, Du));
  }
}), Y = /* @__PURE__ */ W({
  __name: "ds-text",
  props: {
    htmlElement: { default: "p" },
    textStyle: { default: "default" },
    textType: { default: "body-md" }
  },
  setup(e) {
    const t = e, r = E(
      () => `ds-text-${t.textType.toLowerCase().replace("_", "-")}`
    ), n = E(
      () => ` ds-text--${t.textStyle.toLowerCase()}`
    ), a = E(
      () => `${r.value}${n.value}`
    );
    return (s, i) => (m(), H(Er(s.htmlElement), {
      class: G(a.value)
    }, {
      default: V(() => [
        ie(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Hu = { class: "ds-accordion-item__summary" }, zu = ["innerHTML"], Y1 = /* @__PURE__ */ W({
  __name: "ds-accordion-item",
  props: {
    iconName: {},
    title: {}
  },
  setup(e) {
    const t = e, r = E(() => t.iconName ? "ds-accordion-item--has-icon" : null);
    return (n, a) => (m(), T("details", {
      class: G(["ds-accordion-item", r.value])
    }, [
      D("summary", Hu, [
        n.iconName ? (m(), H(ae, {
          key: 0,
          class: "ds-accordion-item__icon",
          "icon-name": n.iconName
        }, null, 8, ["icon-name"])) : M("", !0),
        B(Y, {
          "html-element": "span",
          "text-type": "heading-lg",
          "text-style": "medium",
          class: "ds-accordion-item__title"
        }, {
          default: V(() => [
            D("span", {
              class: "ds-accordion-item__title-text",
              innerHTML: n.title
            }, null, 8, zu)
          ]),
          _: 1
        }),
        B(ae, {
          class: "ds-accordion-item__expand-icon",
          "icon-name": "chevron-down",
          size: "lg"
        })
      ]),
      B(Y, {
        class: "ds-accordion-item__content",
        "html-element": "div",
        "text-type": "body-md"
      }, {
        default: V(() => [
          ie(n.$slots, "default")
        ]),
        _: 3
      })
    ], 2));
  }
}), Fe = (e = 768) => {
  const t = L(!1);
  let r = null;
  const n = (a) => {
    t.value = !a.matches;
  };
  return he(() => {
    r = window.matchMedia(`(min-width: ${e}px)`), r.addEventListener("change", n), t.value = !r.matches;
  }), qe(() => {
    r && r.removeEventListener("change", n);
  }), { isMobile: t };
}, Vu = ["role"], Bu = { class: "ds-alert__content" }, ju = ["innerHTML"], qu = ["aria-label"], Wu = /* @__PURE__ */ W({
  __name: "ds-alert",
  props: {
    appearance: { default: "neutral" },
    title: {},
    text: {},
    showIcon: { type: Boolean, default: !0 },
    dismissible: { type: Boolean, default: !1 },
    dismissLabel: { default: "Close" }
  },
  setup(e) {
    const t = e, { isMobile: r } = Fe(), n = E(() => r.value ? "md" : "lg"), a = E(
      () => `ds-alert--${t.appearance} ${t.showIcon ? "ds-alert--icon" : ""} ${t.dismissible ? "ds-alert--dismissable" : ""}`
    ), s = E(() => t.appearance === "attention" ? "attention-triangle" : t.appearance === "danger" ? "danger-circle" : "information-circle"), i = E(() => t.appearance === "attention" || t.appearance === "danger" ? "alert" : "status"), l = L(!1), o = () => {
      l.value = !0;
    };
    return (u, f) => l.value ? M("", !0) : (m(), T("div", {
      key: 0,
      role: i.value,
      class: G(["ds-alert", a.value])
    }, [
      u.showIcon ? (m(), H(ae, {
        key: 0,
        size: n.value,
        "icon-name": s.value,
        class: "ds-alert__icon"
      }, null, 8, ["size", "icon-name"])) : M("", !0),
      D("div", Bu, [
        u.title ? (m(), H(Y, {
          key: 0,
          "html-element": "h3",
          "text-type": "body-md",
          "text-style": "bold",
          class: "ds-alert__title"
        }, {
          default: V(() => [
            K(U(u.title), 1)
          ]),
          _: 1
        })) : M("", !0),
        B(Y, {
          "html-element": "div",
          "text-type": "body-md",
          "text-style": "regular",
          class: "ds-alert__text"
        }, {
          default: V(() => [
            D("div", { innerHTML: u.text }, null, 8, ju)
          ]),
          _: 1
        })
      ]),
      u.dismissible ? (m(), T("button", {
        key: 1,
        "aria-label": u.dismissLabel,
        class: "ds-alert__dismiss",
        onClick: o
      }, [
        B(ae, {
          "icon-name": "button-close",
          size: "sm",
          class: "ds-alert__dismiss-icon"
        })
      ], 8, qu)) : M("", !0)
    ], 10, Vu));
  }
}), Uu = /* @__PURE__ */ W({
  __name: "ds-badge",
  props: {
    text: {},
    variant: { default: "neutral" }
  },
  setup(e) {
    const r = `ds-badge--${e.variant}`;
    return (n, a) => (m(), T("span", {
      class: G(["ds-badge", r])
    }, U(n.text), 1));
  }
}), zs = L(0);
function St(e) {
  return zs.value++, `${e}-${zs.value}`;
}
const Ku = ["aria-labelledby"], Yu = { class: "ds-banner__inner" }, Gu = { class: "ds-banner__content" }, Qu = ["innerHTML", "id"], G1 = /* @__PURE__ */ W({
  __name: "ds-banner-sm",
  props: {
    iconName: { default: "information-circle" },
    text: {},
    showIcon: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { isMobile: r } = Fe(), n = E(() => r.value ? "md" : "lg"), a = `${t.showIcon ? "ds-banner--icon" : ""}`, s = St("banner-content");
    return (i, l) => (m(), T("section", $e({
      "aria-labelledby": O(s),
      class: ["ds-banner", a]
    }, i.$attrs), [
      D("div", Yu, [
        i.showIcon ? (m(), H(ae, {
          key: 0,
          size: n.value,
          "icon-name": i.iconName,
          class: "ds-banner__icon"
        }, null, 8, ["size", "icon-name"])) : M("", !0),
        D("div", Gu, [
          B(Y, {
            "html-element": "div",
            "text-type": "body-md",
            "text-style": "regular",
            class: "ds-banner__text"
          }, {
            default: V(() => [
              D("div", {
                innerHTML: i.text,
                id: O(s)
              }, null, 8, Qu)
            ]),
            _: 1
          })
        ])
      ])
    ], 16, Ku));
  }
}), Zu = { class: "ds-spinner-animation" }, ll = /* @__PURE__ */ W({
  __name: "ds-spinner-animation",
  setup(e) {
    return (t, r) => (m(), T("div", Zu, r[0] || (r[0] = [
      D("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        D("rect", {
          class: "ds-spinner-animation__track",
          x: "3",
          y: "3",
          width: "50",
          height: "50",
          rx: "25",
          "stroke-width": "6"
        }),
        D("path", {
          class: "ds-spinner-animation__snake",
          d: "M4.50674 36.5508C2.95033 37.1173 1.21245 36.3169 0.815599 34.7089C-0.175426 30.6933 -0.26744 26.4951 0.562107 22.4177C1.59161 17.3575 4.00037 12.6806 7.52209 8.90405C11.0438 5.12747 15.5413 2.39833 20.5173 1.01835C24.5269 -0.0935997 28.7213 -0.294665 32.7962 0.413827C34.428 0.697543 35.3477 2.37535 34.8912 3.96749V3.96749C34.4347 5.55962 32.7738 6.45833 31.1344 6.22238C28.1328 5.79039 25.0632 5.98204 22.1202 6.79819C18.2101 7.88256 14.6761 10.0271 11.9087 12.9947C9.14142 15.9623 7.24865 19.6373 6.43968 23.6135C5.83081 26.6062 5.85375 29.6818 6.49408 32.6459C6.84381 34.2648 6.06315 35.9844 4.50674 36.5508V36.5508Z"
        })
      ], -1)
    ])));
  }
}), Xu = [
  "button-add",
  "button-chevron-down",
  "button-chevron-left",
  "button-chevron-right",
  "button-chevron-up",
  "button-close",
  "button-delete",
  "button-document",
  "button-download",
  "button-external-link",
  "button-filter",
  "button-information",
  "button-information-circle",
  "button-menu",
  "button-more",
  "button-navigate-back",
  "button-navigate-down",
  "button-navigate-forward",
  "button-navigate-up",
  "button-pause",
  "button-play",
  "button-print",
  "button-question",
  "button-question-circle",
  "button-search",
  "button-share-ios",
  "button-shopping-basket",
  "button-zoom-in",
  "button-zoom-out"
], es = ({
  variant: e,
  size: t,
  selected: r = E(() => !1),
  padding: n = null,
  isValidLoadingState: a = E(() => !1)
}, s) => E(() => {
  let i = [];
  return i = hr(i, s, e.value), i = hr(i, s, t.value), i = hr(
    i,
    s,
    r.value ? "selected" : void 0
  ), i = hr(
    i,
    s,
    n,
    n !== "padding-normal"
  ), i = hr(
    i,
    s,
    "loading",
    a.value
  ), i;
}), hr = (e, t, r, n = !0) => (r && n && e.push(`${t}--${r}`), e), _a = (e) => {
  if (!e.startsWith("button-")) {
    const t = `button-${e}`;
    if (Ju(t))
      return t;
  }
  return e;
}, Ju = (e, t = !1) => e ? Xu.includes(e) ? !0 : (t && console.warn(
  `Icon "${e}" is not part of the button icon subset. Ensure you're using a "button-" prefixed icon name or reach out to the DS team.`
), !1) : !0, ec = ["aria-disabled", "disabled", "form", "name", "selected", "type", "value"], tc = ["aria-disabled", "download", "href", "selected", "target"], Ee = /* @__PURE__ */ W({
  __name: "ds-button",
  props: {
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    iconStart: {},
    iconEnd: {},
    labelLoading: { default: void 0 },
    name: {},
    padding: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    size: { default: "md" },
    state: { default: "default" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, n = t, a = E(() => r.size === "sm" ? "xs" : "sm"), s = E(() => r.selected), i = E(() => r.size), l = E(() => {
      if (r.iconStart)
        return _a(r.iconStart);
    }), o = E(() => {
      if (r.iconEnd)
        return _a(r.iconEnd);
    }), u = L(r.padding), f = E(() => r.variant);
    (r.variant === "link" || r.variant === "link-neutral" || r.variant === "link-inverted") && !r.padding && (u.value = "padding-none");
    const h = (g) => {
      r.state !== "loading" && (r.clickHandler(g), n("click", g));
    }, c = E(() => (r.variant === "primary" || r.variant === "primary-inverted") && r.state === "loading" && r.labelLoading !== void 0), y = es(
      {
        variant: f,
        size: i,
        padding: u.value,
        selected: s,
        isValidLoadingState: c
      },
      "ds-button"
    );
    return (g, b) => (m(), T(se, null, [
      g.href ? M("", !0) : (m(), T("button", $e({ key: 0 }, g.$attrs, {
        "aria-disabled": c.value || void 0,
        onClick: ct(h, ["stop"]),
        class: ["ds-button", O(y)],
        disabled: g.disabled || void 0,
        form: g.form,
        name: g.name,
        selected: g.selected || void 0,
        type: g.type,
        value: g.value
      }), [
        c.value ? M("", !0) : (m(), T(se, { key: 0 }, [
          l.value ? (m(), H(ae, {
            key: 0,
            class: "ds-button__icon-start",
            "icon-name": l.value,
            size: a.value
          }, null, 8, ["icon-name", "size"])) : M("", !0),
          B(Y, {
            "text-type": "label-md",
            "text-style": "medium",
            "html-element": "span"
          }, {
            default: V(() => [
              ie(g.$slots, "default")
            ]),
            _: 3
          }),
          o.value ? (m(), H(ae, {
            key: 1,
            class: "ds-button__icon-end",
            "icon-name": o.value,
            size: a.value
          }, null, 8, ["icon-name", "size"])) : M("", !0)
        ], 64)),
        c.value ? (m(), T(se, { key: 1 }, [
          B(ll),
          B(Y, {
            "text-type": "label-md",
            "text-style": "medium",
            "html-element": "span"
          }, {
            default: V(() => [
              K(U(g.labelLoading), 1)
            ]),
            _: 1
          })
        ], 64)) : M("", !0)
      ], 16, ec)),
      g.href ? (m(), T("a", $e({ key: 1 }, g.$attrs, {
        onClick: h,
        class: ["ds-button", O(y)],
        "aria-disabled": g.disabled || void 0,
        download: g.download === !0 ? "" : g.download,
        href: g.href,
        selected: g.selected || void 0,
        target: g.target
      }), [
        l.value ? (m(), H(ae, {
          key: 0,
          class: "ds-button__icon-start",
          "icon-name": l.value,
          size: a.value
        }, null, 8, ["icon-name", "size"])) : M("", !0),
        B(Y, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: V(() => [
            ie(g.$slots, "default")
          ]),
          _: 3
        }),
        o.value ? (m(), H(ae, {
          key: 1,
          class: "ds-button__icon-end",
          "icon-name": o.value,
          size: a.value
        }, null, 8, ["icon-name", "size"])) : M("", !0)
      ], 16, tc)) : M("", !0)
    ], 64));
  }
}), rc = ["aria-label", "role", "data-icon-name"], nc = ["innerHTML"], ac = "ds-brand-icon", sc = "/dist/shared/images/design-system-brand-icons", ol = /* @__PURE__ */ W({
  __name: "ds-brand-icon",
  props: {
    altText: {},
    basePath: { default: "/dist/shared/images/design-system-brand-icons" },
    iconName: {},
    mode: { default: "default" },
    size: { default: "md" },
    type: { default: "line" }
  },
  emits: ["iconLoaded"],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = E(() => n.iconName), s = r, { loadIcon: i, svgContents: l } = il(
      ac,
      sc,
      n.basePath,
      s,
      a
    ), o = E(() => {
      const u = [];
      return u.push(`ds-brand-icon--${n.size}`), u.push(`ds-brand-icon--${n.type}`), n.mode !== "default" && u.push(`ds-brand-icon--mode-${n.mode}`), u;
    });
    return t({ loadIcon: i }), (u, f) => (m(), T("div", {
      "aria-label": u.altText ? u.altText : void 0,
      role: u.altText ? "img" : void 0,
      class: G(["ds-brand-icon", o.value]),
      "data-icon-name": a.value
    }, [
      D("span", {
        class: "ds-brand-icon__svg",
        "aria-hidden": "true",
        innerHTML: O(l)
      }, null, 8, nc)
    ], 10, rc));
  }
}), ic = ["aria-labelledby"], lc = {
  key: 1,
  class: "ds-banner-md__content"
}, oc = { class: "ds-banner-md__icon-slot" }, Q1 = /* @__PURE__ */ W({
  __name: "ds-banner-md",
  props: {
    background: { default: "brand-muted" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    iconName: {},
    iconAltText: {},
    text: {},
    textHtmlElement: { default: "h3" },
    textWrapMode: { default: "balance" }
  },
  setup(e) {
    const t = e, r = L(!1);
    he(() => {
      r.value = !0;
    });
    const n = St("banner-md"), { isMobile: a } = Fe(), s = E(() => a.value ? "heading-md" : "heading-3xl"), i = E(() => t.background === "brand-muted" ? "default" : "on-color"), l = E(() => {
      const o = [];
      return o.push(`ds-banner-md--bg-${t.background}`), o.push(`ds-banner-md--tw-${t.textWrapMode}`), o;
    });
    return (o, u) => (m(), T("section", $e({
      "aria-labelledby": O(n),
      class: ["ds-banner-md", l.value]
    }, o.$attrs), [
      r.value ? M("", !0) : ie(o.$slots, "default", { key: 0 }),
      r.value ? (m(), T("div", lc, [
        B(Y, {
          class: "ds-banner-md__text",
          id: O(n),
          "text-type": s.value,
          "text-style": "medium",
          "html-element": o.textHtmlElement
        }, {
          default: V(() => [
            K(U(o.text), 1)
          ]),
          _: 1
        }, 8, ["id", "text-type", "html-element"]),
        o.buttonText ? (m(), H(Ee, {
          key: 0,
          class: "ds-banner-md__cta",
          href: o.buttonHref,
          clickHandler: o.buttonClickHandler,
          variant: "primary"
        }, {
          default: V(() => [
            K(U(o.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "clickHandler"])) : M("", !0)
      ])) : M("", !0),
      D("div", oc, [
        B(ol, {
          altText: o.iconAltText,
          iconName: o.iconName,
          mode: i.value,
          size: "md",
          type: "line"
        }, null, 8, ["altText", "iconName", "mode"])
      ])
    ], 16, ic));
  }
}), uc = ["aria-labelledby"], cc = {
  key: 1,
  class: "ds-banner-lg__content"
}, fc = { class: "ds-banner-lg__media" }, dc = ["sizes", "src", "srcset", "alt"], Z1 = /* @__PURE__ */ W({
  __name: "ds-banner-lg",
  props: {
    background: { default: "brand-subtle" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    mediaAltText: { default: "" },
    mediaFocalPoint: { default: "center" },
    mediaFocalPointMobile: {},
    mediaSrc: {},
    mediaSrcSet: {},
    mediaSizes: {},
    text: {},
    textHtmlElement: { default: "h3" },
    textWrapMode: { default: "balance" }
  },
  setup(e) {
    const t = e, r = L(!1);
    he(() => {
      r.value = !0;
    });
    const n = St("banner-lg"), { isMobile: a } = Fe(), s = E(() => a.value ? "heading-md" : "heading-3xl"), i = E(() => t.mediaFocalPointMobile && a.value ? t.mediaFocalPointMobile : t.mediaFocalPoint), l = E(() => {
      const u = [];
      return t.mediaFocalPoint !== "center" && u.push(`object-position: ${i.value};`), u;
    }), o = E(() => {
      const u = [];
      return u.push(`ds-banner-lg--bg-${t.background}`), u.push(`ds-banner-lg--tw-${t.textWrapMode}`), u;
    });
    return (u, f) => (m(), T("section", $e({
      "aria-labelledby": O(n),
      class: ["ds-banner-lg", o.value]
    }, u.$attrs), [
      r.value ? M("", !0) : ie(u.$slots, "default", { key: 0 }),
      r.value ? (m(), T("div", cc, [
        B(Y, {
          class: "ds-banner-lg__text",
          id: O(n),
          "text-type": s.value,
          "text-style": "medium",
          "html-element": u.textHtmlElement
        }, {
          default: V(() => [
            K(U(u.text), 1)
          ]),
          _: 1
        }, 8, ["id", "text-type", "html-element"]),
        B(Ee, {
          class: "ds-banner-lg__cta",
          href: u.buttonHref,
          clickHandler: u.buttonClickHandler,
          variant: "primary"
        }, {
          default: V(() => [
            K(U(u.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "clickHandler"])
      ])) : M("", !0),
      D("figure", fc, [
        D("img", {
          class: "ds-banner-lg__image",
          style: Ce(l.value),
          sizes: u.mediaSizes,
          src: u.mediaSrc,
          srcset: u.mediaSrcSet,
          alt: u.mediaAltText
        }, null, 12, dc)
      ])
    ], 16, uc));
  }
}), pc = ["aria-labelledby"], mc = {
  key: 1,
  class: "ds-banner-xl__content"
}, vc = { class: "ds-banner-xl__text" }, yc = ["innerHTML"], hc = { class: "ds-banner-xl__media" }, gc = ["sizes", "src", "srcset", "alt"], X1 = /* @__PURE__ */ W({
  __name: "ds-banner-xl",
  props: {
    background: { default: "brand-subtle" },
    buttonClickHandler: {},
    buttonHref: {},
    buttonText: {},
    description: {},
    mediaAltText: { default: "" },
    mediaPlacement: { default: "end" },
    mediaPlacementMobile: { default: "useMediaPlacementValue" },
    mediaFocalPoint: { default: "center" },
    mediaFocalPointMobile: {},
    mediaRenderMode: { default: "cover" },
    mediaRenderModeMobile: { default: "useMediaRenderModeValue" },
    mediaSrc: {},
    mediaSrcSet: {},
    mediaSizes: {},
    textWrapMode: { default: "balance" },
    titleSmall: {},
    titleSmallHtmlElement: { default: "h3" },
    titleLarge: {},
    titleLargeHtmlElement: { default: "h2" }
  },
  setup(e) {
    const t = e, r = L(!1);
    he(() => {
      r.value = !0;
    });
    const n = St("banner-xl"), { isMobile: a } = Fe(), s = E(() => t.description ? "long" : "short"), i = E(() => s.value === "long" ? "heading-3xl" : "heading-4xl"), l = E(() => t.mediaFocalPointMobile && a.value ? t.mediaFocalPointMobile : t.mediaFocalPoint), o = E(() => {
      const f = [];
      return t.mediaFocalPoint !== "center" && f.push(`--object-position: ${l.value};`), f;
    }), u = E(() => {
      const f = [];
      return f.push(`ds-banner-xl--${s.value}`), f.push(`ds-banner-xl--bg-${t.background}`), f.push(`ds-banner-xl--media-${t.mediaPlacement}`), f.push(`ds-banner-xl--media-rm-${t.mediaRenderMode}`), f.push(`ds-banner-xl--tw-${t.textWrapMode}`), t.mediaPlacementMobile !== "useMediaPlacementValue" && t.mediaPlacementMobile !== t.mediaPlacement && f.push(
        `ds-banner-xl--media-mobile-${t.mediaPlacementMobile}`
      ), t.mediaRenderModeMobile !== "useMediaRenderModeValue" && t.mediaRenderModeMobile !== t.mediaRenderMode && f.push(
        `ds-banner-xl--media-rm-mobile-${t.mediaRenderModeMobile}`
      ), f;
    });
    return (f, p) => (m(), T("section", $e({ "aria-labelledby": O(n) }, f.$attrs, {
      class: ["ds-banner-xl", u.value]
    }), [
      r.value ? M("", !0) : ie(f.$slots, "default", { key: 0 }),
      r.value ? (m(), T("div", mc, [
        D("div", vc, [
          s.value === "short" ? (m(), H(Y, {
            key: 0,
            class: "ds-banner-xl__title-small",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": f.titleSmallHtmlElement
          }, {
            default: V(() => [
              K(U(f.titleSmall), 1)
            ]),
            _: 1
          }, 8, ["html-element"])) : M("", !0),
          B(Y, {
            class: "ds-banner-xl__title-large",
            id: O(n),
            "text-type": i.value,
            "text-style": "medium",
            "html-element": f.titleLargeHtmlElement
          }, {
            default: V(() => [
              K(U(f.titleLarge), 1)
            ]),
            _: 1
          }, 8, ["id", "text-type", "html-element"]),
          s.value === "long" ? (m(), H(Y, {
            key: 1,
            class: "ds-banner-xl__description",
            "text-type": "heading-lg",
            "text-style": "medium",
            "html-element": "div"
          }, {
            default: V(() => [
              D("div", {
                class: "ds-banner-xl__description-inner",
                innerHTML: f.description
              }, null, 8, yc)
            ]),
            _: 1
          })) : M("", !0)
        ]),
        B(Ee, {
          href: f.buttonHref,
          clickHandler: f.buttonClickHandler,
          variant: "primary"
        }, {
          default: V(() => [
            K(U(f.buttonText), 1)
          ]),
          _: 1
        }, 8, ["href", "clickHandler"])
      ])) : M("", !0),
      D("figure", hc, [
        D("img", {
          class: "ds-banner-xl__image",
          style: Ce(o.value),
          sizes: f.mediaSizes,
          src: f.mediaSrc,
          srcset: f.mediaSrcSet,
          alt: f.mediaAltText
        }, null, 12, gc)
      ])
    ], 16, pc));
  }
}), bc = { class: "ds-block__content" }, xn = /* @__PURE__ */ W({
  __name: "ds-block",
  props: {
    background: { default: "default" },
    divider: { type: Boolean, default: !1 },
    grid: { type: Boolean, default: !1 },
    paddingTop: { default: "default" },
    paddingBottom: { default: "default" }
  },
  setup(e) {
    const t = e, r = E(() => {
      const n = {
        [`ds-block--bg-${t.background}`]: t.background !== "default",
        [`ds-block--pt-${t.paddingTop}`]: t.paddingTop !== "default",
        [`ds-block--pb-${t.paddingBottom}`]: t.paddingBottom !== "default",
        "ds-block--divider": t.divider,
        "ds-block--grid": t.grid
      };
      return Object.keys(n).filter((a) => n[a]);
    });
    return (n, a) => (m(), T("section", {
      class: G(["ds-block", r.value])
    }, [
      D("div", bc, [
        ie(n.$slots, "default")
      ])
    ], 2));
  }
}), _c = ["href", "aria-current", "title"], ra = /* @__PURE__ */ W({
  __name: "ds-breadcrumb-item",
  props: {
    iconStartName: {},
    item: {}
  },
  setup(e) {
    const t = e, n = t.item.name.length > 25 ? t.item.name : void 0;
    return (a, s) => (m(), T("a", {
      class: "ds-breadcrumb__link",
      onClick: s[0] || (s[0] = (i) => {
        a.item.isCurrentPage && i.preventDefault();
      }),
      href: a.item.url,
      "aria-current": a.item.isCurrentPage ? "page" : void 0,
      title: O(n)
    }, [
      a.iconStartName ? (m(), H(ae, {
        key: 0,
        class: "ds-breadcrumb__icon",
        "icon-name": a.iconStartName,
        size: "xs"
      }, null, 8, ["icon-name"])) : M("", !0),
      B(Y, {
        "html-element": "span",
        "text-type": "label-sm"
      }, {
        default: V(() => [
          K(U(a.item.name), 1)
        ]),
        _: 1
      })
    ], 8, _c));
  }
});
function je(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Rt(e) {
  var t = je(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ye(e) {
  var t = je(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ts(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = je(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
var Ft = Math.max, mn = Math.min, rr = Math.round;
function $a() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function ul() {
  return !/^((?!chrome|android).)*safari/i.test($a());
}
function nr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, s = 1;
  t && Ye(e) && (a = e.offsetWidth > 0 && rr(n.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && rr(n.height) / e.offsetHeight || 1);
  var i = Rt(e) ? je(e) : window, l = i.visualViewport, o = !ul() && r, u = (n.left + (o && l ? l.offsetLeft : 0)) / a, f = (n.top + (o && l ? l.offsetTop : 0)) / s, p = n.width / a, h = n.height / s;
  return {
    width: p,
    height: h,
    top: f,
    right: u + p,
    bottom: f + h,
    left: u,
    x: u,
    y: f
  };
}
function rs(e) {
  var t = je(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function $c(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function kc(e) {
  return e === je(e) || !Ye(e) ? rs(e) : $c(e);
}
function dt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function At(e) {
  return ((Rt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ns(e) {
  return nr(At(e)).left + rs(e).scrollLeft;
}
function bt(e) {
  return je(e).getComputedStyle(e);
}
function as(e) {
  var t = bt(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function wc(e) {
  var t = e.getBoundingClientRect(), r = rr(t.width) / e.offsetWidth || 1, n = rr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Sc(e, t, r) {
  r === void 0 && (r = !1);
  var n = Ye(t), a = Ye(t) && wc(t), s = At(t), i = nr(e, a, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((dt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  as(s)) && (l = kc(t)), Ye(t) ? (o = nr(t, !0), o.x += t.clientLeft, o.y += t.clientTop) : s && (o.x = ns(s))), {
    x: i.left + l.scrollLeft - o.x,
    y: i.top + l.scrollTop - o.y,
    width: i.width,
    height: i.height
  };
}
function ss(e) {
  var t = nr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Hn(e) {
  return dt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ts(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    At(e)
  );
}
function cl(e) {
  return ["html", "body", "#document"].indexOf(dt(e)) >= 0 ? e.ownerDocument.body : Ye(e) && as(e) ? e : cl(Hn(e));
}
function kr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = cl(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), s = je(n), i = a ? [s].concat(s.visualViewport || [], as(n) ? n : []) : n, l = t.concat(i);
  return a ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(kr(Hn(i)))
  );
}
function Pc(e) {
  return ["table", "td", "th"].indexOf(dt(e)) >= 0;
}
function Vs(e) {
  return !Ye(e) || // https://github.com/popperjs/popper-core/issues/837
  bt(e).position === "fixed" ? null : e.offsetParent;
}
function Ic(e) {
  var t = /firefox/i.test($a()), r = /Trident/i.test($a());
  if (r && Ye(e)) {
    var n = bt(e);
    if (n.position === "fixed")
      return null;
  }
  var a = Hn(e);
  for (ts(a) && (a = a.host); Ye(a) && ["html", "body"].indexOf(dt(a)) < 0; ) {
    var s = bt(a);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function zr(e) {
  for (var t = je(e), r = Vs(e); r && Pc(r) && bt(r).position === "static"; )
    r = Vs(r);
  return r && (dt(r) === "html" || dt(r) === "body" && bt(r).position === "static") ? t : r || Ic(e) || t;
}
var ze = "top", st = "bottom", it = "right", Ve = "left", is = "auto", Vr = [ze, st, it, Ve], ar = "start", Tr = "end", Cc = "clippingParents", fl = "viewport", gr = "popper", Ec = "reference", Bs = /* @__PURE__ */ Vr.reduce(function(e, t) {
  return e.concat([t + "-" + ar, t + "-" + Tr]);
}, []), dl = /* @__PURE__ */ [].concat(Vr, [is]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ar, t + "-" + Tr]);
}, []), Ac = "beforeRead", Tc = "read", Lc = "afterRead", Mc = "beforeMain", Oc = "main", Nc = "afterMain", Fc = "beforeWrite", Dc = "write", Rc = "afterWrite", xc = [Ac, Tc, Lc, Mc, Oc, Nc, Fc, Dc, Rc];
function Hc(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function a(s) {
    r.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(l) {
      if (!r.has(l)) {
        var o = t.get(l);
        o && a(o);
      }
    }), n.push(s);
  }
  return e.forEach(function(s) {
    r.has(s.name) || a(s);
  }), n;
}
function zc(e) {
  var t = Hc(e);
  return xc.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function Vc(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Bc(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
function jc(e, t) {
  var r = je(e), n = At(e), a = r.visualViewport, s = n.clientWidth, i = n.clientHeight, l = 0, o = 0;
  if (a) {
    s = a.width, i = a.height;
    var u = ul();
    (u || !u && t === "fixed") && (l = a.offsetLeft, o = a.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: l + ns(e),
    y: o
  };
}
function qc(e) {
  var t, r = At(e), n = rs(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, s = Ft(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = Ft(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), l = -n.scrollLeft + ns(e), o = -n.scrollTop;
  return bt(a || r).direction === "rtl" && (l += Ft(r.clientWidth, a ? a.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: l,
    y: o
  };
}
function pl(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && ts(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function ka(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Wc(e, t) {
  var r = nr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function js(e, t, r) {
  return t === fl ? ka(jc(e, r)) : Rt(t) ? Wc(t, r) : ka(qc(At(e)));
}
function Uc(e) {
  var t = kr(Hn(e)), r = ["absolute", "fixed"].indexOf(bt(e).position) >= 0, n = r && Ye(e) ? zr(e) : e;
  return Rt(n) ? t.filter(function(a) {
    return Rt(a) && pl(a, n) && dt(a) !== "body";
  }) : [];
}
function Kc(e, t, r, n) {
  var a = t === "clippingParents" ? Uc(e) : [].concat(t), s = [].concat(a, [r]), i = s[0], l = s.reduce(function(o, u) {
    var f = js(e, u, n);
    return o.top = Ft(f.top, o.top), o.right = mn(f.right, o.right), o.bottom = mn(f.bottom, o.bottom), o.left = Ft(f.left, o.left), o;
  }, js(e, i, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function ut(e) {
  return e.split("-")[0];
}
function sr(e) {
  return e.split("-")[1];
}
function ls(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function ml(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? ut(n) : null, s = n ? sr(n) : null, i = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, o;
  switch (a) {
    case ze:
      o = {
        x: i,
        y: t.y - r.height
      };
      break;
    case st:
      o = {
        x: i,
        y: t.y + t.height
      };
      break;
    case it:
      o = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Ve:
      o = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      o = {
        x: t.x,
        y: t.y
      };
  }
  var u = a ? ls(a) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (s) {
      case ar:
        o[u] = o[u] - (t[f] / 2 - r[f] / 2);
        break;
      case Tr:
        o[u] = o[u] + (t[f] / 2 - r[f] / 2);
        break;
    }
  }
  return o;
}
function vl() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function yl(e) {
  return Object.assign({}, vl(), e);
}
function hl(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
function os(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, s = r.strategy, i = s === void 0 ? e.strategy : s, l = r.boundary, o = l === void 0 ? Cc : l, u = r.rootBoundary, f = u === void 0 ? fl : u, p = r.elementContext, h = p === void 0 ? gr : p, c = r.altBoundary, y = c === void 0 ? !1 : c, g = r.padding, b = g === void 0 ? 0 : g, k = yl(typeof b != "number" ? b : hl(b, Vr)), P = h === gr ? Ec : gr, I = e.rects.popper, _ = e.elements[y ? P : h], S = Kc(Rt(_) ? _ : _.contextElement || At(e.elements.popper), o, f, i), v = nr(e.elements.reference), w = ml({
    reference: v,
    element: I,
    placement: a
  }), C = ka(Object.assign({}, I, w)), F = h === gr ? C : v, x = {
    top: S.top - F.top + k.top,
    bottom: F.bottom - S.bottom + k.bottom,
    left: S.left - F.left + k.left,
    right: F.right - S.right + k.right
  }, R = e.modifiersData.offset;
  if (h === gr && R) {
    var d = R[a];
    Object.keys(x).forEach(function($) {
      var A = [it, st].indexOf($) >= 0 ? 1 : -1, z = [ze, st].indexOf($) >= 0 ? "y" : "x";
      x[$] += d[z] * A;
    });
  }
  return x;
}
var qs = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ws() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Yc(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, s = a === void 0 ? qs : a;
  return function(l, o, u) {
    u === void 0 && (u = s);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, qs, s),
      modifiersData: {},
      elements: {
        reference: l,
        popper: o
      },
      attributes: {},
      styles: {}
    }, p = [], h = !1, c = {
      state: f,
      setOptions: function(k) {
        var P = typeof k == "function" ? k(f.options) : k;
        g(), f.options = Object.assign({}, s, f.options, P), f.scrollParents = {
          reference: Rt(l) ? kr(l) : l.contextElement ? kr(l.contextElement) : [],
          popper: kr(o)
        };
        var I = zc(Bc([].concat(n, f.options.modifiers)));
        return f.orderedModifiers = I.filter(function(_) {
          return _.enabled;
        }), y(), c.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var k = f.elements, P = k.reference, I = k.popper;
          if (Ws(P, I)) {
            f.rects = {
              reference: Sc(P, zr(I), f.options.strategy === "fixed"),
              popper: ss(I)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(x) {
              return f.modifiersData[x.name] = Object.assign({}, x.data);
            });
            for (var _ = 0; _ < f.orderedModifiers.length; _++) {
              if (f.reset === !0) {
                f.reset = !1, _ = -1;
                continue;
              }
              var S = f.orderedModifiers[_], v = S.fn, w = S.options, C = w === void 0 ? {} : w, F = S.name;
              typeof v == "function" && (f = v({
                state: f,
                options: C,
                name: F,
                instance: c
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Vc(function() {
        return new Promise(function(b) {
          c.forceUpdate(), b(f);
        });
      }),
      destroy: function() {
        g(), h = !0;
      }
    };
    if (!Ws(l, o))
      return c;
    c.setOptions(u).then(function(b) {
      !h && u.onFirstUpdate && u.onFirstUpdate(b);
    });
    function y() {
      f.orderedModifiers.forEach(function(b) {
        var k = b.name, P = b.options, I = P === void 0 ? {} : P, _ = b.effect;
        if (typeof _ == "function") {
          var S = _({
            state: f,
            name: k,
            instance: c,
            options: I
          }), v = function() {
          };
          p.push(S || v);
        }
      });
    }
    function g() {
      p.forEach(function(b) {
        return b();
      }), p = [];
    }
    return c;
  };
}
var Kr = {
  passive: !0
};
function Gc(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, s = a === void 0 ? !0 : a, i = n.resize, l = i === void 0 ? !0 : i, o = je(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && u.forEach(function(f) {
    f.addEventListener("scroll", r.update, Kr);
  }), l && o.addEventListener("resize", r.update, Kr), function() {
    s && u.forEach(function(f) {
      f.removeEventListener("scroll", r.update, Kr);
    }), l && o.removeEventListener("resize", r.update, Kr);
  };
}
const Qc = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Gc,
  data: {}
};
function Zc(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ml({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Xc = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Zc,
  data: {}
};
var Jc = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ef(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: rr(r * a) / a || 0,
    y: rr(n * a) / a || 0
  };
}
function Us(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, s = e.variation, i = e.offsets, l = e.position, o = e.gpuAcceleration, u = e.adaptive, f = e.roundOffsets, p = e.isFixed, h = i.x, c = h === void 0 ? 0 : h, y = i.y, g = y === void 0 ? 0 : y, b = typeof f == "function" ? f({
    x: c,
    y: g
  }) : {
    x: c,
    y: g
  };
  c = b.x, g = b.y;
  var k = i.hasOwnProperty("x"), P = i.hasOwnProperty("y"), I = Ve, _ = ze, S = window;
  if (u) {
    var v = zr(r), w = "clientHeight", C = "clientWidth";
    if (v === je(r) && (v = At(r), bt(v).position !== "static" && l === "absolute" && (w = "scrollHeight", C = "scrollWidth")), v = v, a === ze || (a === Ve || a === it) && s === Tr) {
      _ = st;
      var F = p && v === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        v[w]
      );
      g -= F - n.height, g *= o ? 1 : -1;
    }
    if (a === Ve || (a === ze || a === st) && s === Tr) {
      I = it;
      var x = p && v === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        v[C]
      );
      c -= x - n.width, c *= o ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: l
  }, u && Jc), d = f === !0 ? ef({
    x: c,
    y: g
  }, je(r)) : {
    x: c,
    y: g
  };
  if (c = d.x, g = d.y, o) {
    var $;
    return Object.assign({}, R, ($ = {}, $[_] = P ? "0" : "", $[I] = k ? "0" : "", $.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + g + "px)" : "translate3d(" + c + "px, " + g + "px, 0)", $));
  }
  return Object.assign({}, R, (t = {}, t[_] = P ? g + "px" : "", t[I] = k ? c + "px" : "", t.transform = "", t));
}
function tf(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, s = r.adaptive, i = s === void 0 ? !0 : s, l = r.roundOffsets, o = l === void 0 ? !0 : l, u = {
    placement: ut(t.placement),
    variation: sr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Us(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: o
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Us(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: o
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const rf = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: tf,
  data: {}
};
function nf(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, s = t.elements[r];
    !Ye(s) || !dt(s) || (Object.assign(s.style, n), Object.keys(a).forEach(function(i) {
      var l = a[i];
      l === !1 ? s.removeAttribute(i) : s.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function af(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], s = t.attributes[n] || {}, i = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = i.reduce(function(o, u) {
        return o[u] = "", o;
      }, {});
      !Ye(a) || !dt(a) || (Object.assign(a.style, l), Object.keys(s).forEach(function(o) {
        a.removeAttribute(o);
      }));
    });
  };
}
const sf = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: nf,
  effect: af,
  requires: ["computeStyles"]
};
var lf = [Qc, Xc, rf, sf], of = /* @__PURE__ */ Yc({
  defaultModifiers: lf
});
function uf(e) {
  return e === "x" ? "y" : "x";
}
function wr(e, t, r) {
  return Ft(e, mn(t, r));
}
function cf(e, t, r) {
  var n = wr(e, t, r);
  return n > r ? r : n;
}
function ff(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, s = a === void 0 ? !0 : a, i = r.altAxis, l = i === void 0 ? !1 : i, o = r.boundary, u = r.rootBoundary, f = r.altBoundary, p = r.padding, h = r.tether, c = h === void 0 ? !0 : h, y = r.tetherOffset, g = y === void 0 ? 0 : y, b = os(t, {
    boundary: o,
    rootBoundary: u,
    padding: p,
    altBoundary: f
  }), k = ut(t.placement), P = sr(t.placement), I = !P, _ = ls(k), S = uf(_), v = t.modifiersData.popperOffsets, w = t.rects.reference, C = t.rects.popper, F = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, x = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), R = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, d = {
    x: 0,
    y: 0
  };
  if (v) {
    if (s) {
      var $, A = _ === "y" ? ze : Ve, z = _ === "y" ? st : it, N = _ === "y" ? "height" : "width", j = v[_], Q = j + b[A], q = j - b[z], Z = c ? -C[N] / 2 : 0, re = P === ar ? w[N] : C[N], ne = P === ar ? -C[N] : -w[N], ye = t.elements.arrow, Ae = c && ye ? ss(ye) : {
        width: 0,
        height: 0
      }, xe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : vl(), X = xe[A], me = xe[z], ge = wr(0, w[N], Ae[N]), He = I ? w[N] / 2 - Z - ge - X - x.mainAxis : re - ge - X - x.mainAxis, mt = I ? -w[N] / 2 + Z + ge + me + x.mainAxis : ne + ge + me + x.mainAxis, Ge = t.elements.arrow && zr(t.elements.arrow), lt = Ge ? _ === "y" ? Ge.clientTop || 0 : Ge.clientLeft || 0 : 0, Pt = ($ = R == null ? void 0 : R[_]) != null ? $ : 0, Te = j + He - Pt - lt, qr = j + mt - Pt, mr = wr(c ? mn(Q, Te) : Q, j, c ? Ft(q, qr) : q);
      v[_] = mr, d[_] = mr - j;
    }
    if (l) {
      var J, Le = _ === "x" ? ze : Ve, Qe = _ === "x" ? st : it, We = v[S], Ze = S === "y" ? "height" : "width", vr = We + b[Le], Xe = We - b[Qe], Wr = [ze, Ve].indexOf(k) !== -1, Fs = (J = R == null ? void 0 : R[S]) != null ? J : 0, Ds = Wr ? vr : We - w[Ze] - C[Ze] - Fs + x.altAxis, Rs = Wr ? We + w[Ze] + C[Ze] - Fs - x.altAxis : Xe, xs = c && Wr ? cf(Ds, We, Rs) : wr(c ? Ds : vr, We, c ? Rs : Xe);
      v[S] = xs, d[S] = xs - We;
    }
    t.modifiersData[n] = d;
  }
}
const df = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ff,
  requiresIfExists: ["offset"]
};
var pf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Gr(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return pf[t];
  });
}
var mf = {
  start: "end",
  end: "start"
};
function Ks(e) {
  return e.replace(/start|end/g, function(t) {
    return mf[t];
  });
}
function vf(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, s = r.rootBoundary, i = r.padding, l = r.flipVariations, o = r.allowedAutoPlacements, u = o === void 0 ? dl : o, f = sr(n), p = f ? l ? Bs : Bs.filter(function(y) {
    return sr(y) === f;
  }) : Vr, h = p.filter(function(y) {
    return u.indexOf(y) >= 0;
  });
  h.length === 0 && (h = p);
  var c = h.reduce(function(y, g) {
    return y[g] = os(e, {
      placement: g,
      boundary: a,
      rootBoundary: s,
      padding: i
    })[ut(g)], y;
  }, {});
  return Object.keys(c).sort(function(y, g) {
    return c[y] - c[g];
  });
}
function yf(e) {
  if (ut(e) === is)
    return [];
  var t = Gr(e);
  return [Ks(e), t, Ks(t)];
}
function hf(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, s = a === void 0 ? !0 : a, i = r.altAxis, l = i === void 0 ? !0 : i, o = r.fallbackPlacements, u = r.padding, f = r.boundary, p = r.rootBoundary, h = r.altBoundary, c = r.flipVariations, y = c === void 0 ? !0 : c, g = r.allowedAutoPlacements, b = t.options.placement, k = ut(b), P = k === b, I = o || (P || !y ? [Gr(b)] : yf(b)), _ = [b].concat(I).reduce(function(Ae, xe) {
      return Ae.concat(ut(xe) === is ? vf(t, {
        placement: xe,
        boundary: f,
        rootBoundary: p,
        padding: u,
        flipVariations: y,
        allowedAutoPlacements: g
      }) : xe);
    }, []), S = t.rects.reference, v = t.rects.popper, w = /* @__PURE__ */ new Map(), C = !0, F = _[0], x = 0; x < _.length; x++) {
      var R = _[x], d = ut(R), $ = sr(R) === ar, A = [ze, st].indexOf(d) >= 0, z = A ? "width" : "height", N = os(t, {
        placement: R,
        boundary: f,
        rootBoundary: p,
        altBoundary: h,
        padding: u
      }), j = A ? $ ? it : Ve : $ ? st : ze;
      S[z] > v[z] && (j = Gr(j));
      var Q = Gr(j), q = [];
      if (s && q.push(N[d] <= 0), l && q.push(N[j] <= 0, N[Q] <= 0), q.every(function(Ae) {
        return Ae;
      })) {
        F = R, C = !1;
        break;
      }
      w.set(R, q);
    }
    if (C)
      for (var Z = y ? 3 : 1, re = function(xe) {
        var X = _.find(function(me) {
          var ge = w.get(me);
          if (ge)
            return ge.slice(0, xe).every(function(He) {
              return He;
            });
        });
        if (X)
          return F = X, "break";
      }, ne = Z; ne > 0; ne--) {
        var ye = re(ne);
        if (ye === "break") break;
      }
    t.placement !== F && (t.modifiersData[n]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const gf = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: hf,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function bf(e, t, r) {
  var n = ut(e), a = [Ve, ze].indexOf(n) >= 0 ? -1 : 1, s = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, i = s[0], l = s[1];
  return i = i || 0, l = (l || 0) * a, [Ve, it].indexOf(n) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function _f(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, s = a === void 0 ? [0, 0] : a, i = dl.reduce(function(f, p) {
    return f[p] = bf(p, t.rects, s), f;
  }, {}), l = i[t.placement], o = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += o, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = i;
}
const $f = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: _f
};
var kf = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, yl(typeof t != "number" ? t : hl(t, Vr));
};
function wf(e) {
  var t, r = e.state, n = e.name, a = e.options, s = r.elements.arrow, i = r.modifiersData.popperOffsets, l = ut(r.placement), o = ls(l), u = [Ve, it].indexOf(l) >= 0, f = u ? "height" : "width";
  if (!(!s || !i)) {
    var p = kf(a.padding, r), h = ss(s), c = o === "y" ? ze : Ve, y = o === "y" ? st : it, g = r.rects.reference[f] + r.rects.reference[o] - i[o] - r.rects.popper[f], b = i[o] - r.rects.reference[o], k = zr(s), P = k ? o === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, I = g / 2 - b / 2, _ = p[c], S = P - h[f] - p[y], v = P / 2 - h[f] / 2 + I, w = wr(_, v, S), C = o;
    r.modifiersData[n] = (t = {}, t[C] = w, t.centerOffset = w - v, t);
  }
}
function Sf(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || pl(t.elements.popper, a) && (t.elements.arrow = a));
}
const Pf = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: wf,
  effect: Sf,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function gl({
  targetNode: e,
  tooltipNode: t,
  placement: r,
  strategy: n,
  showArrow: a = !0
}) {
  const s = L(null), i = L(!1), l = () => {
    i.value = !i.value;
  };
  return qe(() => {
    var o;
    (o = s.value) == null || o.destroy();
  }), he(() => {
    let o = [];
    a && (o = [
      Pf,
      {
        name: "arrow",
        options: {
          padding: 8
        }
      }
    ]), e.value && t.value && (s.value = of(
      e.value,
      t.value,
      {
        placement: r,
        strategy: n,
        modifiers: [
          df,
          gf,
          $f,
          {
            name: "offset",
            options: {
              offset: [0, 10]
            }
          },
          ...o
        ]
      }
    ));
  }), le(i, (o) => {
    var u;
    o && ((u = s.value) == null || u.update());
  }), {
    toggle: l,
    isOpen: i
  };
}
const If = ["data-show"], Cf = ["id"], Ef = { class: "ds-tooltip__content" }, Af = ["innerHTML"], Tf = /* @__PURE__ */ W({
  __name: "ds-tooltip",
  props: {
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    text: {},
    title: {},
    titleElement: { default: "h3" }
  },
  setup(e) {
    const t = e, r = L(null), n = L(null), a = L(null), s = St("tooltip"), i = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"], l = (h) => {
      const c = h.target;
      return c ? i.includes(c.tagName) : !1;
    }, o = (h) => {
      l(h) && (p.value = !0);
    }, u = (h) => {
      l(h) && h.target !== document.activeElement && (p.value = !1);
    }, f = (h) => {
      if (l(h)) {
        const c = h.target;
        c && ["BUTTON", "A"].includes(c.tagName) && (h.preventDefault(), c == null || c.click());
      }
    };
    he(() => {
      const h = n.value, c = h == null ? void 0 : h.querySelector("a, button, input, select, textarea");
      if (c)
        r.value = c, r.value.setAttribute("aria-describedby", s);
      else
        throw new Error(
          "The tooltip can only be applied to interactive elements"
        );
    });
    const { isOpen: p } = gl({
      targetNode: r,
      tooltipNode: a,
      placement: t.placement,
      strategy: t.strategy
    });
    return (h, c) => (m(), T("div", {
      class: "ds-tooltip",
      "data-show": O(p)
    }, [
      D("div", {
        class: "ds-tooltip__target-wrapper",
        ref_key: "targetWrapper",
        ref: n,
        onFocusin: o,
        onFocusout: u,
        onMouseover: o,
        onMouseout: u,
        onTouchend: f
      }, [
        ie(h.$slots, "default")
      ], 544),
      D("div", {
        id: O(s),
        ref_key: "tooltip",
        ref: a,
        class: "ds-tooltip__tooltip",
        "data-testid": "tooltip"
      }, [
        D("div", Ef, [
          h.title ? (m(), H(Er(h.titleElement), {
            key: 0,
            class: "ds-tooltip__title"
          }, {
            default: V(() => [
              K(U(h.title), 1)
            ]),
            _: 1
          })) : M("", !0),
          B(Y, {
            "text-type": "label-sm",
            "html-element": "div"
          }, {
            default: V(() => [
              D("div", { innerHTML: h.text }, null, 8, Af)
            ]),
            _: 1
          })
        ]),
        c[0] || (c[0] = D("div", {
          class: "ds-tooltip__arrow",
          "data-popper-arrow": ""
        }, null, -1))
      ], 8, Cf)
    ], 8, If));
  }
}), Lf = ["aria-label"], Mf = {
  key: 0,
  class: "ds-breadcrumb__mobile"
}, Of = {
  key: 1,
  class: "ds-breadcrumb__list"
}, Nf = {
  key: 0,
  class: "ds-breadcrumb__item ds-breadcrumb__item--expand"
}, J1 = /* @__PURE__ */ W({
  __name: "ds-breadcrumb",
  props: {
    ariaLabel: {},
    items: {},
    overflowMenuTooltipText: {}
  },
  setup(e) {
    const t = e, r = L(!1), { isMobile: n } = Fe(), a = {
      ...t.items[0],
      itemClass: "ds-breadcrumb__item"
    }, s = t.items.slice(1), i = E(() => t.items.length > 3), l = t.items.filter((c) => c.isCurrentPage)[0], u = t.items.indexOf(l) - 1, f = u > -1 ? {
      ...t.items[u],
      itemClass: "ds-breadcrumb__item"
    } : null, p = E(() => s.map((c, y) => {
      const g = i.value && y < t.items.length - 3;
      return {
        ...c,
        itemClass: g ? "ds-breadcrumb__item ds-breadcrumb__item--initially-hidden" : "ds-breadcrumb__item"
      };
    })), h = E(() => {
      const c = ["ds-breadcrumb"];
      return r.value && c.push("ds-breadcrumb--expanded"), c;
    });
    return (c, y) => c.items.length > 1 ? (m(), T("nav", {
      key: 0,
      class: G(h.value),
      "aria-label": c.ariaLabel
    }, [
      O(f) && O(n) ? (m(), T("div", Mf, [
        B(ra, {
          "icon-start-name": "navigate-back",
          item: O(f)
        }, null, 8, ["item"])
      ])) : M("", !0),
      O(n) ? M("", !0) : (m(), T("ol", Of, [
        D("li", {
          class: G(a.itemClass)
        }, [
          B(ra, { item: a }),
          p.value.length ? (m(), H(ae, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : M("", !0)
        ], 2),
        i.value ? (m(), T("li", Nf, [
          B(Tf, {
            ref: "tooltip",
            text: c.overflowMenuTooltipText,
            placement: "top"
          }, {
            default: V(() => [
              D("button", {
                class: "ds-breadcrumb__expand",
                onClick: y[0] || (y[0] = () => r.value = !0)
              }, [
                B(Y, {
                  "text-type": "label-sm",
                  "html-element": "span"
                }, {
                  default: V(() => y[1] || (y[1] = [
                    K("…")
                  ])),
                  _: 1,
                  __: [1]
                })
              ])
            ]),
            _: 1
          }, 8, ["text"]),
          p.value.length ? (m(), H(ae, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : M("", !0)
        ])) : M("", !0),
        (m(!0), T(se, null, ve(p.value, (g, b) => (m(), T("li", {
          class: G(g.itemClass),
          key: g.url
        }, [
          B(ra, { item: g }, null, 8, ["item"]),
          b < p.value.length - 1 ? (m(), H(ae, {
            key: 0,
            class: "ds-breadcrumb__divider",
            "icon-name": "chevron-right",
            size: "xs"
          })) : M("", !0)
        ], 2))), 128))
      ]))
    ], 10, Lf)) : M("", !0);
  }
}), bl = /* @__PURE__ */ W({
  __name: "ds-button-group",
  props: {
    buttonSize: { default: "md" },
    desktopAlignment: { default: "end" },
    desktopDirection: { default: "row" },
    mobileAlignment: { default: "stretch" },
    mobileDirection: { default: "column-reverse" }
  },
  setup(e) {
    const t = e, r = E(() => [
      `ds-button-group--${t.buttonSize}`,
      `ds-button-group--${t.desktopAlignment}`,
      `ds-button-group--${t.desktopDirection}`,
      `ds-button-group--m-${t.mobileAlignment}`,
      `ds-button-group--m-${t.mobileDirection}`
    ]);
    return (n, a) => (m(), T("div", {
      class: G(["ds-button-group", r.value])
    }, [
      ie(n.$slots, "default", { buttonSize: n.buttonSize })
    ], 2));
  }
}), Ff = ["aria-label", "disabled"], eS = /* @__PURE__ */ W({
  __name: "ds-button-play",
  props: {
    ariaLabelPlay: {},
    ariaLabelPause: {},
    disabled: { type: Boolean, default: !1 },
    initialState: { default: "play" },
    pauseHandler: {},
    playHandler: {},
    size: { default: "md" },
    variant: { default: "primary" }
  },
  setup(e) {
    const t = e, r = E(() => t.playHandler && t.pauseHandler), n = E(() => i.value === "play" && t.playHandler), a = E(() => i.value === "pause" && t.pauseHandler), s = E(() => {
      if (n.value)
        return t.ariaLabelPlay;
      if (a.value)
        return t.ariaLabelPause;
    }), i = L(t.initialState), l = (h) => {
      n.value ? o(h) : a.value && u(h);
    }, o = (h) => {
      r.value && (i.value = "pause");
      try {
        t.playHandler && t.playHandler(h);
      } catch (c) {
        i.value = "play", console.error(c);
      }
    }, u = (h) => {
      r.value && (i.value = "play");
      try {
        t.pauseHandler && t.pauseHandler(h);
      } catch (c) {
        i.value = "pause", console.error(c);
      }
    }, f = E(() => [
      `ds-button-play--${t.variant}`,
      `ds-button-play--${t.size}`
    ]);
    let p = !0;
    return t.playHandler && !t.ariaLabelPlay && (p = !1), t.pauseHandler && !t.ariaLabelPause && (p = !1), p || console.error("The play button requires an accessible label"), (h, c) => (m(), T("button", {
      "aria-label": s.value,
      onClick: l,
      class: G(["ds-button-play", f.value]),
      disabled: h.disabled || void 0
    }, [
      c[0] || (c[0] = D("span", { class: "ds-button-play__bg" }, null, -1)),
      B(ft, {
        mode: "out-in",
        name: "swap"
      }, {
        default: V(() => [
          (m(), H(O(ae), {
            key: i.value,
            "icon-name": i.value,
            size: h.size
          }, null, 8, ["icon-name", "size"]))
        ]),
        _: 1
      })
    ], 10, Ff));
  }
}), Df = ["aria-label", "disabled"], Rf = {
  class: "ds-button-play-progress__progress",
  viewBox: "0 0 36 36"
}, xf = ["stroke-dasharray", "stroke-dashoffset"], Hf = 16, zf = /* @__PURE__ */ W({
  __name: "ds-button-play-progress",
  props: {
    ariaLabelPlay: {},
    ariaLabelPause: {},
    disabled: { type: Boolean, default: !1 },
    initialState: { default: "play" },
    pauseHandler: {},
    playHandler: {},
    progress: { default: 0 },
    loop: { type: Boolean, default: !0 },
    size: { default: "responsive" },
    variant: { default: "on-dark" }
  },
  setup(e, { expose: t }) {
    const r = e, n = E(() => {
      const _ = [];
      return _.push(`ds-button-play-progress--${r.variant}`), _.push(`ds-button-play-progress--${s.value}`), _;
    }), { isMobile: a } = Fe(), s = E(() => r.size === "responsive" ? a.value ? "md" : "sm" : r.size), i = E(() => s.value === "md" ? "sm" : "xs"), l = E(() => r.playHandler && r.pauseHandler), o = E(() => p.value === "play" && r.playHandler), u = E(() => p.value === "pause" && r.pauseHandler), f = E(() => {
      if (o.value)
        return r.ariaLabelPlay;
      if (u.value)
        return r.ariaLabelPause;
    }), p = L(r.initialState), h = E(() => p.value === "play" ? "button-play" : "button-pause");
    t({
      /**
       * Allows parent components to set the play state
       * @param isPlaying - Boolean to indicate whether the media is currently playing
       */
      setButtonState: (_) => {
        p.value = _ ? "pause" : "play";
      }
    });
    const y = (_) => {
      o.value ? g(_) : u.value && b(_);
    }, g = (_) => {
      l.value && (p.value = "pause");
      try {
        r.playHandler && r.playHandler(_);
      } catch (S) {
        p.value = "play", console.error(S);
      }
    }, b = (_) => {
      l.value && (p.value = "play");
      try {
        r.pauseHandler && r.pauseHandler(_);
      } catch (S) {
        p.value = "pause", console.error(S);
      }
    };
    let k = !0;
    r.playHandler && !r.ariaLabelPlay && (k = !1), r.pauseHandler && !r.ariaLabelPause && (k = !1);
    const P = E(() => 2 * Math.PI * Hf), I = E(() => {
      const _ = Math.min(Math.max(r.progress || 0, 0), 1);
      return P.value * (1 - _);
    });
    return r.loop || le(
      () => r.progress,
      (_) => {
        _ >= 1 && (p.value = "play");
      }
    ), k || console.error("The play button requires an accessible label"), (_, S) => (m(), T("button", {
      "aria-label": f.value,
      onClick: y,
      class: G(["ds-button-play-progress", n.value]),
      disabled: _.disabled || void 0
    }, [
      (m(), T("svg", Rf, [
        S[0] || (S[0] = D("circle", {
          class: "ds-button-play-progress__progress-bg",
          cx: "18",
          cy: "18",
          r: "16"
        }, null, -1)),
        D("circle", {
          class: "ds-button-play-progress__progress-indicator",
          cx: "18",
          cy: "18",
          r: "16",
          "stroke-dasharray": P.value,
          "stroke-dashoffset": I.value
        }, null, 8, xf)
      ])),
      B(ft, {
        mode: "out-in",
        name: "swap"
      }, {
        default: V(() => [
          (m(), H(O(ae), {
            key: h.value,
            "icon-name": h.value,
            size: i.value
          }, null, 8, ["icon-name", "size"]))
        ]),
        _: 1
      })
    ], 10, Df));
  }
}), Vf = ["aria-label", "disabled", "form", "name", "type", "value"], Bf = {
  key: 1,
  class: "ds-icon-button__notification"
}, jf = ["aria-disabled", "aria-label", "download", "href", "target"], Ie = /* @__PURE__ */ W({
  __name: "ds-icon-button",
  props: {
    ariaLabel: {},
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    iconName: { default: "button-add" },
    name: {},
    notificationCount: {},
    size: { default: "md" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  setup(e) {
    const t = e, r = E(() => t.size === "sm" ? "xs" : "sm"), n = E(() => t.size), a = E(() => t.variant), s = es(
      {
        variant: a,
        size: n
      },
      "ds-icon-button"
    ), i = E(() => {
      if (t.iconName)
        return _a(t.iconName);
    });
    return (l, o) => (m(), T(se, null, [
      l.href ? M("", !0) : (m(), T("button", $e({ key: 0 }, l.$attrs, {
        onClick: o[0] || (o[0] = //@ts-ignore
        (...u) => l.clickHandler && l.clickHandler(...u)),
        class: ["ds-icon-button", O(s)],
        "aria-label": l.ariaLabel,
        disabled: l.disabled || void 0,
        form: l.form,
        name: l.name,
        type: l.type,
        value: l.value
      }), [
        i.value ? (m(), H(ae, {
          key: 0,
          iconName: i.value,
          size: r.value
        }, null, 8, ["iconName", "size"])) : M("", !0),
        l.notificationCount ? (m(), T("span", Bf, U(l.notificationCount), 1)) : M("", !0)
      ], 16, Vf)),
      l.href ? (m(), T("a", $e({ key: 1 }, l.$attrs, {
        onClick: o[1] || (o[1] = //@ts-ignore
        (...u) => l.clickHandler && l.clickHandler(...u)),
        class: ["ds-icon-button", O(s)],
        "aria-disabled": l.disabled || void 0,
        "aria-label": l.ariaLabel,
        download: l.download === !0 ? "" : l.download,
        href: l.href,
        target: l.target
      }), [
        i.value ? (m(), H(ae, {
          key: 0,
          iconName: i.value,
          size: r.value
        }, null, 8, ["iconName", "size"])) : M("", !0)
      ], 16, jf)) : M("", !0)
    ], 64));
  }
}), tS = /* @__PURE__ */ W({
  __name: "ds-card-action",
  props: {
    action: { default: "favourite" },
    actionFn: {},
    actionLabel: {},
    actionState: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = async () => {
      t.actionFn && (n.value = t.actionFn());
    }, n = L(t.actionState), a = E(() => t.action === "favourite" ? n.value ? "heart-filled" : "heart" : null), { isMobile: s } = Fe(), i = E(() => s.value ? "md" : "sm");
    return (l, o) => l.action && l.actionLabel && a.value ? (m(), H(Ie, {
      key: 0,
      class: "ds-card-action",
      type: "button",
      variant: "secondary-neutral",
      "click-handler": r,
      ariaLabel: l.actionLabel,
      iconName: a.value,
      size: i.value
    }, null, 8, ["ariaLabel", "iconName", "size"])) : M("", !0);
  }
}), qf = {
  key: 0,
  class: "ds-card-colours"
}, Wf = { class: "ds-card-colours__list" }, Uf = ["title"], Kf = { class: "ds-visually-hidden" }, Yf = {
  key: 0,
  class: "ds-card-colours__additional"
}, Gf = { class: "ds-visually-hidden" }, na = 4, Qf = /* @__PURE__ */ W({
  __name: "ds-card-colours",
  props: {
    colours: { default: () => [] },
    coloursLabel: {}
  },
  setup(e) {
    const t = e, r = t.colours.slice(0, na), n = t.colours.length > na ? t.colours.length - na : 0, a = n ? `+${n}` : null;
    return (s, i) => O(r).length ? (m(), T("div", qf, [
      D("ul", Wf, [
        (m(!0), T(se, null, ve(O(r), (l) => (m(), T("li", {
          class: "ds-card-colours__option",
          key: l.value,
          style: Ce(`--colour-bg: ${l.value}`),
          title: l.label
        }, [
          D("span", Kf, U(l.label), 1)
        ], 12, Uf))), 128)),
        O(n) ? (m(), T("li", Yf, [
          B(Y, {
            class: "ds-card-colours__label",
            "html-element": "span",
            "text-type": "body-xs",
            "text-style": "regular"
          }, {
            default: V(() => [
              K(U(O(a)) + " ", 1),
              D("span", Gf, U(s.coloursLabel), 1)
            ]),
            _: 1
          })
        ])) : M("", !0)
      ])
    ])) : M("", !0);
  }
}), Zf = ["href"], Xf = { class: "ds-visually-hidden" }, Jf = { class: "ds-card-product__image-container" }, ed = ["src", "alt"], td = { class: "ds-card-product__content" }, rd = ["src", "alt"], nd = {
  key: 1,
  class: "ds-card-product__brow-placeholder"
}, ad = ["src", "alt"], sd = { class: "ds-card-product__footer" }, id = { class: "ds-card-product__labels" }, rS = /* @__PURE__ */ W({
  __name: "ds-card-product",
  props: {
    badgeText: {},
    badgeVariant: { default: "highlight" },
    browLogo: {},
    browLogoDark: {},
    browLogoAlt: {},
    browText: {},
    colours: {},
    coloursLabel: {},
    description: {},
    image: {},
    imageAlt: {},
    layout: { default: "responsive" },
    mediumLabel: {},
    smallLabel: {},
    title: {},
    url: {}
  },
  setup(e) {
    const t = e, r = E(() => {
      const n = [`ds-card-product--${t.layout}`];
      return t.badgeText && n.push("ds-card-product--badge"), n;
    });
    return (n, a) => (m(), T("article", {
      class: G(["ds-card-product", r.value])
    }, [
      D("a", {
        class: "ds-card-product__link",
        href: n.url
      }, [
        D("span", Xf, U(n.title), 1)
      ], 8, Zf),
      n.badgeText ? (m(), H(Uu, {
        class: "ds-card-product__badge",
        key: n.badgeVariant,
        text: n.badgeText,
        variant: n.badgeVariant
      }, null, 8, ["text", "variant"])) : M("", !0),
      D("div", Jf, [
        D("img", {
          class: "ds-card-product__image",
          src: n.image,
          alt: n.imageAlt
        }, null, 8, ed),
        ie(n.$slots, "action")
      ]),
      D("div", td, [
        n.browLogo && n.browLogoAlt ? (m(), T("img", {
          key: 0,
          class: "ds-card-product__brow-image ds-card-product__brow-image--light",
          src: n.browLogo,
          alt: n.browLogoAlt
        }, null, 8, rd)) : M("", !0),
        !n.browLogo && !n.browLogoDark && !n.browText ? (m(), T("span", nd)) : M("", !0),
        n.browLogoDark && n.browLogoAlt ? (m(), T("img", {
          key: 2,
          class: "ds-card-product__brow-image ds-card-product__brow-image--dark",
          src: n.browLogoDark,
          alt: n.browLogoAlt
        }, null, 8, ad)) : M("", !0),
        n.browText && !n.browLogo ? (m(), H(Y, {
          key: 3,
          class: "ds-card-product__brow-text",
          "text-type": "body-xs",
          "text-style": "regular"
        }, {
          default: V(() => [
            K(U(n.browText), 1)
          ]),
          _: 1
        })) : M("", !0),
        B(Y, {
          class: "ds-card-product__title",
          "html-element": "h2",
          "text-type": "heading-md",
          "text-style": "medium"
        }, {
          default: V(() => [
            K(U(n.title), 1)
          ]),
          _: 1
        }),
        n.description ? (m(), H(Y, {
          key: 4,
          class: "ds-card-product__description",
          "text-type": "body-sm",
          "text-style": "regular"
        }, {
          default: V(() => [
            K(U(n.description), 1)
          ]),
          _: 1
        })) : M("", !0),
        D("footer", sd, [
          D("div", id, [
            n.smallLabel ? (m(), H(Y, {
              key: 0,
              class: "ds-card-product__small-label",
              "text-type": "body-sm",
              "text-style": "bold"
            }, {
              default: V(() => [
                K(U(n.smallLabel), 1)
              ]),
              _: 1
            })) : M("", !0),
            B(Qf, {
              coloursLabel: n.coloursLabel,
              colours: n.colours
            }, null, 8, ["coloursLabel", "colours"])
          ]),
          n.mediumLabel ? (m(), H(Y, {
            key: 0,
            class: "ds-card-product__medium-label",
            "text-type": "label-md",
            "text-style": "bold"
          }, {
            default: V(() => [
              K(U(n.mediumLabel), 1)
            ]),
            _: 1
          })) : M("", !0)
        ])
      ])
    ], 2));
  }
});
function _l(e) {
  const t = L("ltr"), r = () => {
    if (e.value) {
      const n = window.getComputedStyle(e.value);
      t.value = n.direction;
    }
  };
  return le(
    e,
    () => {
      r();
    },
    { immediate: !0 }
  ), { direction: t };
}
function us(e) {
  return Au() ? (Tu(e), !0) : !1;
}
const $l = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ld = (e) => e != null, od = Object.prototype.toString, ud = (e) => od.call(e) === "[object Object]", Ne = () => {
}, cd = /* @__PURE__ */ fd();
function fd() {
  var e, t;
  return $l && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function kl(e, t) {
  function r(...n) {
    return new Promise((a, s) => {
      Promise.resolve(e(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(a).catch(s);
    });
  }
  return r;
}
function dd(e, t = {}) {
  let r, n, a = Ne;
  const s = (o) => {
    clearTimeout(o), a(), a = Ne;
  };
  let i;
  return (o) => {
    const u = ke(e), f = ke(t.maxWait);
    return r && s(r), u <= 0 || f !== void 0 && f <= 0 ? (n && (s(n), n = null), Promise.resolve(o())) : new Promise((p, h) => {
      a = t.rejectOnCancel ? h : p, i = o, f && !n && (n = setTimeout(() => {
        r && s(r), n = null, p(i());
      }, f)), r = setTimeout(() => {
        n && s(n), n = null, p(o());
      }, u);
    });
  };
}
function pd(...e) {
  let t = 0, r, n = !0, a = Ne, s, i, l, o, u;
  !pn(e[0]) && typeof e[0] == "object" ? { delay: i, trailing: l = !0, leading: o = !0, rejectOnCancel: u = !1 } = e[0] : [i, l = !0, o = !0, u = !1] = e;
  const f = () => {
    r && (clearTimeout(r), r = void 0, a(), a = Ne);
  };
  return (h) => {
    const c = ke(i), y = Date.now() - t, g = () => s = h();
    return f(), c <= 0 ? (t = Date.now(), g()) : (y > c && (o || !n) ? (t = Date.now(), g()) : l && (s = new Promise((b, k) => {
      a = u ? k : b, r = setTimeout(() => {
        t = Date.now(), n = !0, b(g()), f();
      }, Math.max(0, c - y));
    })), !o && !r && (r = setTimeout(() => n = !0, c)), n = !1, s);
  };
}
function Qr(e) {
  return Array.isArray(e) ? e : [e];
}
function md(e) {
  return Ar();
}
function cs(e, t = 200, r = {}) {
  return kl(
    dd(t, r),
    e
  );
}
function wl(e, t = 200, r = !1, n = !0, a = !1) {
  return kl(
    pd(t, r, n, a),
    e
  );
}
function vd(e, t = !0, r) {
  md() ? he(e, r) : t ? e() : at(e);
}
function yd(e, t, r) {
  return le(
    e,
    t,
    {
      ...r,
      immediate: !0
    }
  );
}
function hd(e, t, r) {
  return le(
    e,
    t,
    {
      ...r,
      once: !0
    }
  );
}
const Vt = $l ? window : void 0;
function et(e) {
  var t;
  const r = ke(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function Sr(...e) {
  const t = [], r = () => {
    t.forEach((l) => l()), t.length = 0;
  }, n = (l, o, u, f) => (l.addEventListener(o, u, f), () => l.removeEventListener(o, u, f)), a = E(() => {
    const l = Qr(ke(e[0])).filter((o) => o != null);
    return l.every((o) => typeof o != "string") ? l : void 0;
  }), s = yd(
    () => {
      var l, o;
      return [
        (o = (l = a.value) == null ? void 0 : l.map((u) => et(u))) != null ? o : [Vt].filter((u) => u != null),
        Qr(ke(a.value ? e[1] : e[0])),
        Qr(O(a.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ke(a.value ? e[3] : e[2])
      ];
    },
    ([l, o, u, f]) => {
      if (r(), !(l != null && l.length) || !(o != null && o.length) || !(u != null && u.length))
        return;
      const p = ud(f) ? { ...f } : f;
      t.push(
        ...l.flatMap(
          (h) => o.flatMap(
            (c) => u.map((y) => n(h, c, y, p))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    s(), r();
  };
  return us(r), i;
}
let Ys = !1;
function zn(e, t, r = {}) {
  const { window: n = Vt, ignore: a = [], capture: s = !0, detectIframe: i = !1, controls: l = !1 } = r;
  if (!n)
    return l ? { stop: Ne, cancel: Ne, trigger: Ne } : Ne;
  if (cd && !Ys) {
    Ys = !0;
    const b = { passive: !0 };
    Array.from(n.document.body.children).forEach((k) => k.addEventListener("click", Ne, b)), n.document.documentElement.addEventListener("click", Ne, b);
  }
  let o = !0;
  const u = (b) => ke(a).some((k) => {
    if (typeof k == "string")
      return Array.from(n.document.querySelectorAll(k)).some((P) => P === b.target || b.composedPath().includes(P));
    {
      const P = et(k);
      return P && (b.target === P || b.composedPath().includes(P));
    }
  });
  function f(b) {
    const k = ke(b);
    return k && k.$.subTree.shapeFlag === 16;
  }
  function p(b, k) {
    const P = ke(b), I = P.$.subTree && P.$.subTree.children;
    return I == null || !Array.isArray(I) ? !1 : I.some((_) => _.el === k.target || k.composedPath().includes(_.el));
  }
  const h = (b) => {
    const k = et(e);
    if (b.target != null && !(!(k instanceof Element) && f(e) && p(e, b)) && !(!k || k === b.target || b.composedPath().includes(k))) {
      if ("detail" in b && b.detail === 0 && (o = !u(b)), !o) {
        o = !0;
        return;
      }
      t(b);
    }
  };
  let c = !1;
  const y = [
    Sr(n, "click", (b) => {
      c || (c = !0, setTimeout(() => {
        c = !1;
      }, 0), h(b));
    }, { passive: !0, capture: s }),
    Sr(n, "pointerdown", (b) => {
      const k = et(e);
      o = !u(b) && !!(k && !b.composedPath().includes(k));
    }, { passive: !0 }),
    i && Sr(n, "blur", (b) => {
      setTimeout(() => {
        var k;
        const P = et(e);
        ((k = n.document.activeElement) == null ? void 0 : k.tagName) === "IFRAME" && !(P != null && P.contains(n.document.activeElement)) && t(b);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), g = () => y.forEach((b) => b());
  return l ? {
    stop: g,
    cancel: () => {
      o = !1;
    },
    trigger: (b) => {
      o = !0, h(b), o = !1;
    }
  } : g;
}
function gd() {
  const e = Gt(!1), t = Ar();
  return t && he(() => {
    e.value = !0;
  }, t), e;
}
function Sl(e) {
  const t = gd();
  return E(() => (t.value, !!e()));
}
function vn(e, t, r = {}) {
  const { window: n = Vt, ...a } = r;
  let s;
  const i = Sl(() => n && "ResizeObserver" in n), l = () => {
    s && (s.disconnect(), s = void 0);
  }, o = E(() => {
    const p = ke(e);
    return Array.isArray(p) ? p.map((h) => et(h)) : [et(p)];
  }), u = le(
    o,
    (p) => {
      if (l(), i.value && n) {
        s = new ResizeObserver(t);
        for (const h of p)
          h && s.observe(h, a);
      }
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    l(), u();
  };
  return us(f), {
    isSupported: i,
    stop: f
  };
}
function Kt(e, t, r = {}) {
  const {
    root: n,
    rootMargin: a = "0px",
    threshold: s = 0,
    window: i = Vt,
    immediate: l = !0
  } = r, o = Sl(() => i && "IntersectionObserver" in i), u = E(() => {
    const y = ke(e);
    return Qr(y).map(et).filter(ld);
  });
  let f = Ne;
  const p = Gt(l), h = o.value ? le(
    () => [u.value, et(n), p.value],
    ([y, g]) => {
      if (f(), !p.value || !y.length)
        return;
      const b = new IntersectionObserver(
        t,
        {
          root: et(g),
          rootMargin: a,
          threshold: s
        }
      );
      y.forEach((k) => k && b.observe(k)), f = () => {
        b.disconnect(), f = Ne;
      };
    },
    { immediate: l, flush: "post" }
  ) : Ne, c = () => {
    f(), h(), p.value = !1;
  };
  return us(c), {
    isSupported: o,
    isActive: p,
    pause() {
      f(), p.value = !1;
    },
    resume() {
      p.value = !0;
    },
    stop: c
  };
}
function Gs(e, t = {}) {
  const {
    window: r = Vt,
    scrollTarget: n,
    threshold: a = 0,
    rootMargin: s,
    once: i = !1
  } = t, l = Gt(!1), { stop: o } = Kt(
    e,
    (u) => {
      let f = l.value, p = 0;
      for (const h of u)
        h.time >= p && (p = h.time, f = h.isIntersecting);
      l.value = f, i && hd(l, () => {
        o();
      });
    },
    {
      root: n,
      window: r,
      threshold: a,
      rootMargin: ke(s)
    }
  );
  return l;
}
const Qs = 1;
function fs(e, t = {}) {
  const {
    throttle: r = 0,
    idle: n = 200,
    onStop: a = Ne,
    onScroll: s = Ne,
    offset: i = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: l = {
      capture: !1,
      passive: !0
    },
    behavior: o = "auto",
    window: u = Vt,
    onError: f = (w) => {
      console.error(w);
    }
  } = t, p = Gt(0), h = Gt(0), c = E({
    get() {
      return p.value;
    },
    set(w) {
      g(w, void 0);
    }
  }), y = E({
    get() {
      return h.value;
    },
    set(w) {
      g(void 0, w);
    }
  });
  function g(w, C) {
    var F, x, R, d;
    if (!u)
      return;
    const $ = ke(e);
    if (!$)
      return;
    (R = $ instanceof Document ? u.document.body : $) == null || R.scrollTo({
      top: (F = ke(C)) != null ? F : y.value,
      left: (x = ke(w)) != null ? x : c.value,
      behavior: ke(o)
    });
    const A = ((d = $ == null ? void 0 : $.document) == null ? void 0 : d.documentElement) || ($ == null ? void 0 : $.documentElement) || $;
    c != null && (p.value = A.scrollLeft), y != null && (h.value = A.scrollTop);
  }
  const b = Gt(!1), k = It({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), P = It({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), I = (w) => {
    b.value && (b.value = !1, P.left = !1, P.right = !1, P.top = !1, P.bottom = !1, a(w));
  }, _ = cs(I, r + n), S = (w) => {
    var C;
    if (!u)
      return;
    const F = ((C = w == null ? void 0 : w.document) == null ? void 0 : C.documentElement) || (w == null ? void 0 : w.documentElement) || et(w), { display: x, flexDirection: R, direction: d } = getComputedStyle(F), $ = d === "rtl" ? -1 : 1, A = F.scrollLeft;
    P.left = A < p.value, P.right = A > p.value;
    const z = Math.abs(A * $) <= (i.left || 0), N = Math.abs(A * $) + F.clientWidth >= F.scrollWidth - (i.right || 0) - Qs;
    x === "flex" && R === "row-reverse" ? (k.left = N, k.right = z) : (k.left = z, k.right = N), p.value = A;
    let j = F.scrollTop;
    w === u.document && !j && (j = u.document.body.scrollTop), P.top = j < h.value, P.bottom = j > h.value;
    const Q = Math.abs(j) <= (i.top || 0), q = Math.abs(j) + F.clientHeight >= F.scrollHeight - (i.bottom || 0) - Qs;
    x === "flex" && R === "column-reverse" ? (k.top = q, k.bottom = Q) : (k.top = Q, k.bottom = q), h.value = j;
  }, v = (w) => {
    var C;
    if (!u)
      return;
    const F = (C = w.target.documentElement) != null ? C : w.target;
    S(F), b.value = !0, _(w), s(w);
  };
  return Sr(
    e,
    "scroll",
    r ? wl(v, r, !0, !1) : v,
    l
  ), vd(() => {
    try {
      const w = ke(e);
      if (!w)
        return;
      S(w);
    } catch (w) {
      f(w);
    }
  }), Sr(
    e,
    "scrollend",
    I,
    l
  ), {
    x: c,
    y,
    isScrolling: b,
    arrivedState: k,
    directions: P,
    measure() {
      const w = ke(e);
      u && w && S(w);
    }
  };
}
function bd(e = {}) {
  const { window: t = Vt, ...r } = e;
  return fs(t, r);
}
const _d = {
  class: /* @__PURE__ */ G(["ds-carousel__buttons"])
}, $d = /* @__PURE__ */ W({
  __name: "ds-carousel-buttons",
  props: {
    ariaLabelNext: {},
    ariaLabelPrev: {},
    prevClick: { type: Function },
    nextClick: { type: Function },
    previousButtonDisabled: { type: Boolean },
    nextButtonDisabled: { type: Boolean }
  },
  setup(e) {
    return (t, r) => we((m(), T("div", _d, [
      B(O(Ie), {
        ariaLabel: t.ariaLabelPrev,
        "click-handler": t.prevClick,
        disabled: t.previousButtonDisabled,
        "icon-name": "button-chevron-left",
        variant: "secondary-neutral"
      }, null, 8, ["ariaLabel", "click-handler", "disabled"]),
      B(O(Ie), {
        ariaLabel: t.ariaLabelNext,
        "click-handler": t.nextClick,
        disabled: t.nextButtonDisabled,
        "icon-name": "button-chevron-right",
        variant: "secondary-neutral"
      }, null, 8, ["ariaLabel", "click-handler", "disabled"])
    ], 512)), [
      [Se, !(t.previousButtonDisabled && t.nextButtonDisabled)]
    ]);
  }
}), kd = { class: "ds-carousel__header" }, wd = { class: "ds-carousel__header-text" }, Sd = {
  key: 0,
  class: "ds-carousel__link"
}, nS = /* @__PURE__ */ W({
  __name: "ds-carousel",
  props: {
    ariaLabelNext: {},
    ariaLabelPrev: {},
    description: {},
    headingLevel: { default: "h2" },
    linkTarget: {},
    linkText: {},
    linkUrl: {},
    maxItemsPerView: { default: 4 },
    scrollMode: { default: "page" },
    title: {},
    tag: {}
  },
  setup(e) {
    const t = e, n = window.matchMedia("(prefers-reduced-motion: reduce)").matches === !0 ? "auto" : "smooth", a = L(null), s = L(null), i = L(null), l = L(0), o = L(0), u = L(t.maxItemsPerView), f = L(0), p = L(!0), h = L(!0), { direction: c } = _l(s), y = E(() => t.linkUrl && t.linkText), g = E(
      () => `ds-carousel--items-${u.value} ds-carousel--max-items-${b.value}`
    ), b = E(() => t.maxItemsPerView);
    let k;
    const P = () => {
      i.value && (l.value = 0, o.value = i.value.length - 1, f.value = i.value.length, [...i.value].forEach((d, $) => {
        d.dataset.index = $.toString();
      }));
    }, I = () => {
      if (!s.value || !i.value) return;
      const d = i == null ? void 0 : i.value[l.value], $ = i == null ? void 0 : i.value[o.value];
      k = new IntersectionObserver(
        (A) => {
          A.forEach((z) => {
            const N = z.target;
            N.dataset.inView = z.isIntersecting ? "true" : "false", z.target === d && (p.value = z.isIntersecting), z.target === $ && (h.value = z.isIntersecting);
          });
        },
        {
          threshold: 1,
          root: s.value,
          rootMargin: "4px"
        }
      );
    }, _ = () => {
      var $;
      const d = ($ = a.value) == null ? void 0 : $.querySelectorAll("[data-in-view='true']");
      d && d.length > 0 && (u.value = d.length || 0);
    }, S = cs(() => {
      _();
    }, 200);
    he(() => {
      s.value && s.value.addEventListener(
        "scroll",
        () => {
          S();
        },
        {
          passive: !0
        }
      );
    }), le(
      a,
      (d) => {
        d !== null && typeof d < "u" && (i.value = d.children);
      },
      { immediate: !0 }
    ), le(
      i,
      (d, $) => {
        k && $ && Array.from($).forEach((A) => {
          k.unobserve(A);
        }), d && (P(), I(), Array.from(d).forEach((A) => {
          k.observe(A);
        }), _());
      },
      { immediate: !0 }
    ), qe(() => {
      k && k.disconnect(), s.value && s.value.removeEventListener("scroll", () => {
        S();
      });
    });
    const v = (d) => c.value === "rtl" ? a.value ? -1 * Math.abs(a.value.offsetWidth) + d.offsetLeft + d.offsetWidth : 0 : d.offsetLeft, w = (d) => {
      if (!a.value) return;
      const $ = a.value.querySelector(
        `[data-index='${d}']`
      );
      $ && s.value && s.value.scrollTo({
        left: v($),
        behavior: n
      });
    }, C = (d) => {
      if (t.scrollMode === "item") {
        const N = d.length > 1 ? d[1] : d[0];
        return Number(N.dataset.index);
      }
      const $ = d[d.length - 1], A = Number(
        $.dataset.index
      );
      return Math.min(A + 1, f.value);
    }, F = () => {
      var A;
      const d = (A = a.value) == null ? void 0 : A.querySelectorAll(
        "[data-in-view='true']"
      );
      if (d && d.length > 0) {
        const z = C(d);
        w(z);
      }
    }, x = (d) => {
      const $ = d[0], A = Number(
        $.dataset.index
      );
      return t.scrollMode === "item" ? Math.max(A - 1, 0) : Math.max(
        A - u.value,
        0
      );
    }, R = () => {
      var A;
      const d = (A = a.value) == null ? void 0 : A.querySelectorAll(
        "[data-in-view='true']"
      );
      if (d && d.length > 0) {
        const z = x(d);
        w(z);
      }
    };
    return (d, $) => (m(), T("section", {
      class: G(["ds-carousel", g.value])
    }, [
      D("header", kd, [
        D("div", wd, [
          ie(d.$slots, "header", {}, () => [
            d.tag || d.title || d.description ? (m(), T(se, { key: 0 }, [
              d.tag ? (m(), H(O(gu), {
                key: 0,
                class: "ds-carousel__tag",
                text: d.tag
              }, null, 8, ["text"])) : M("", !0),
              d.title ? (m(), H(O(Y), {
                key: 1,
                class: "ds-carousel__title",
                "text-type": "heading-3xl",
                "html-element": d.headingLevel
              }, {
                default: V(() => [
                  K(U(d.title), 1)
                ]),
                _: 1
              }, 8, ["html-element"])) : M("", !0),
              d.description ? (m(), H(O(Y), {
                key: 2,
                class: "ds-carousel__description",
                "text-type": "body-md",
                "text-style": "regular",
                "html-element": "p"
              }, {
                default: V(() => [
                  K(U(d.description), 1)
                ]),
                _: 1
              })) : M("", !0)
            ], 64)) : M("", !0)
          ])
        ]),
        y.value ? (m(), T("div", Sd, [
          B(O(Ee), {
            variant: "link",
            target: d.linkTarget,
            href: d.linkUrl,
            size: "sm",
            "icon-end": "navigate-forward"
          }, {
            default: V(() => [
              K(U(d.linkText), 1)
            ]),
            _: 1
          }, 8, ["target", "href"])
        ])) : M("", !0)
      ]),
      D("div", {
        class: "ds-carousel__scroll",
        ref_key: "scroll",
        ref: s
      }, [
        D("div", {
          class: "ds-carousel__items",
          ref_key: "itemContainer",
          ref: a
        }, [
          ie(d.$slots, "default")
        ], 512)
      ], 512),
      B($d, {
        ariaLabelNext: d.ariaLabelNext,
        ariaLabelPrev: d.ariaLabelPrev,
        prevClick: R,
        nextClick: F,
        previousButtonDisabled: p.value,
        nextButtonDisabled: h.value
      }, null, 8, ["ariaLabelNext", "ariaLabelPrev", "previousButtonDisabled", "nextButtonDisabled"])
    ], 2));
  }
}), Pd = /* @__PURE__ */ W({
  __name: "ds-icon-attention",
  props: {
    ariaLabel: {},
    iconName: { default: "checkmark" },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, r = E(() => {
      const s = [];
      return t.iconName === "error" && s.push("ds-icon-attention--error"), s.push(`ds-icon-attention--${t.size}`), s;
    }), n = E(() => t.iconName === "error" ? "close" : t.iconName), a = E(() => t.size == "md" ? "xl" : "lg");
    return (s, i) => (m(), T("div", {
      class: G(["ds-icon-attention", r.value])
    }, [
      B(O(ae), {
        class: "ds-icon-attention__icon",
        "icon-name": n.value,
        label: s.ariaLabel,
        size: a.value
      }, null, 8, ["icon-name", "label", "size"])
    ], 2));
  }
}), Id = ["aria-labelledby"], Cd = { class: "ds-modal__container" }, Ed = {
  key: 0,
  class: "ds-modal__attention"
}, Ad = {
  key: 1,
  class: "ds-modal__header"
}, Td = 1e3, Ld = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "ds-modal",
  props: {
    attentionIcon: {},
    backdrop: { default: "default" },
    closeLabel: {},
    isOpen: { type: Boolean, default: !1 },
    overflow: { default: "page" },
    size: { default: "md" },
    teleportSelector: {},
    title: {},
    type: { default: "default" }
  },
  emits: ["close-modal"],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = L(null), s = L(null), i = L(null), l = L(!1), { arrivedState: o } = fs(i, {}), { isMobile: u } = Fe(), f = E(
      () => n.type === "attention" ? "center" : "end"
    ), p = E(() => u.value || n.size === "sm" ? "sm" : "md"), h = E(() => {
      let x = [];
      return !o.top && y.value && x.push("ds-modal__content-inner--fade-top"), !o.bottom && y.value && x.push("ds-modal__content-inner--fade-bottom"), x;
    }), c = St("modal-title"), y = L(!1), g = () => {
      i.value && (y.value = i.value.scrollHeight > i.value.clientHeight);
    };
    t({ checkOverflow: g }), zn(a, () => k());
    const b = r, k = () => {
      n.isOpen && P();
    }, P = () => {
      b("close-modal");
    }, _ = tl()["data-dialog"] ? "heading-2xl" : "heading-3xl", S = E(() => {
      const x = [];
      return n.backdrop === "blur" && x.push("ds-modal--blur"), x.push(`ds-modal--${n.type}`), x.push(`ds-modal--${n.size}`), x.push(`ds-modal--overflow-${n.overflow}`), x;
    });
    he(() => {
      window.addEventListener("resize", g), g();
    }), Xa(() => {
      window.removeEventListener("resize", g), F();
    });
    let v = null, w = null, C = null;
    const F = () => {
      v && clearTimeout(v), w && clearTimeout(w), C && clearTimeout(C);
    };
    return le(
      () => n.isOpen,
      (x, R, d) => {
        if (v = window.setTimeout(() => {
          l.value = x;
        }, 10), s.value) {
          const $ = s.value;
          if (x) {
            $.showModal();
            const A = $.querySelector("button");
            w = window.setTimeout(() => {
              A == null || A.focus(), g();
            }, 10);
          } else
            C = window.setTimeout(() => {
              $.close();
            }, 700);
        }
        d(F);
      },
      { immediate: !0 }
    ), (x, R) => (m(), H(rl, {
      to: x.teleportSelector,
      disabled: !x.teleportSelector
    }, [
      B(ft, {
        name: "modal",
        duration: Td
      }, {
        default: V(() => [
          we(D("dialog", $e({
            "aria-labelledby": O(c),
            class: [S.value, "ds-modal"],
            ref_key: "dialog",
            ref: s
          }, x.$attrs, {
            tabindex: "-1",
            onCancel: ct(P, ["prevent"])
          }), [
            D("div", Cd, [
              D("div", {
                ref_key: "content",
                ref: a,
                class: "ds-modal__content"
              }, [
                B(O(Ie), {
                  ariaLabel: x.closeLabel,
                  class: "ds-modal__close",
                  "click-handler": P,
                  "icon-name": "button-close",
                  variant: "ghost-neutral"
                }, null, 8, ["ariaLabel"]),
                x.type === "attention" ? (m(), T("div", Ed, [
                  B(Pd, {
                    size: p.value,
                    iconName: x.attentionIcon
                  }, null, 8, ["size", "iconName"])
                ])) : M("", !0),
                x.title ? (m(), T("header", Ad, [
                  x.title ? (m(), H(O(Y), {
                    key: 0,
                    class: "ds-modal__title",
                    "text-type": O(_),
                    "text-style": "regular",
                    "html-element": "h2",
                    id: O(c)
                  }, {
                    default: V(() => [
                      K(U(x.title), 1)
                    ]),
                    _: 1
                  }, 8, ["text-type", "id"])) : M("", !0)
                ])) : M("", !0),
                D("div", {
                  class: G(["ds-modal__content-inner", h.value]),
                  ref_key: "scrollContainer",
                  ref: i
                }, [
                  B(O(Y), {
                    class: "ds-modal__body",
                    "html-element": "div",
                    "text-type": "body-md"
                  }, {
                    default: V(() => [
                      ie(x.$slots, "default")
                    ]),
                    _: 3
                  })
                ], 2),
                B(O(bl), {
                  class: "ds-modal__actions",
                  "desktop-alignment": f.value,
                  "desktop-direction": "row",
                  "mobile-alignment": "stretch",
                  "mobile-direction": "column"
                }, {
                  default: V(() => [
                    ie(x.$slots, "actions")
                  ]),
                  _: 3
                }, 8, ["desktop-alignment"])
              ], 512)
            ])
          ], 16, Id), [
            [Se, l.value]
          ])
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
}), aS = /* @__PURE__ */ W({
  __name: "ds-dialog",
  props: {
    closeLabel: {},
    isOpen: { type: Boolean, default: !1 },
    overflow: { default: "page" },
    teleportSelector: {},
    title: {},
    type: { default: "default" }
  },
  setup(e) {
    const t = e, r = tl();
    return (n, a) => (m(), H(Ld, $e({
      class: ["ds-dialog", n.type === "progressive" ? "ds-dialog--progressive" : ""]
    }, O(r), {
      backdrop: "default",
      closeLabel: t.closeLabel,
      "data-dialog": "true",
      isOpen: t.isOpen,
      overflow: t.overflow,
      size: "sm",
      teleportSelector: t.teleportSelector,
      title: t.title,
      type: t.type === "progressive" ? "default" : t.type
    }), {
      actions: V(() => [
        ie(n.$slots, "actions")
      ]),
      default: V(() => [
        ie(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "closeLabel", "isOpen", "overflow", "teleportSelector", "title", "type"]));
  }
}), Md = (e, t, r, n, a, s) => ({
  accept: e,
  fileList: t,
  maxFileSize: r,
  validationMessageDuplicate: n,
  validationMessageFileSize: a,
  validationMessageType: s
}), ds = (e = !0, t = "") => ({
  message: t,
  valid: e
}), ps = (e, t) => e.replace(/\$\{(\w+)\}/g, (r, n) => t[n] ?? r), Od = (e, t) => {
  const r = t.fileList.value.filter(
    (a) => a.name === e.name
  ), n = ps(
    t.validationMessageDuplicate,
    { filename: e.name }
  );
  return ds(r.length === 0, n);
}, Nd = (e) => e / 1024 / 1024, Fd = (e) => e * 1024 * 1024, Dd = (e) => Number(e.toFixed(2)), Rd = (e, t) => {
  const r = Nd(e.size), n = Dd(r), a = Fd(t.maxFileSize), s = ps(
    t.validationMessageFileSize,
    {
      filename: e.name,
      filesize: n.toString(),
      maxsize: t.maxFileSize.toString()
    }
  );
  return ds(e.size < a, s);
}, xd = (e, t) => {
  const [r] = t.split("/");
  return e.startsWith(r);
}, Hd = (e, t) => e === t, zd = (e, t) => {
  const r = t.toLowerCase();
  return e.slice(e.lastIndexOf(".")).toLowerCase() === r;
}, Vd = (e, t) => e.type === "" ? !1 : t ? t.split(",").map((n) => n.trim()).some((n) => /^[a-zA-Z]+\/\*$/.test(n) ? xd(e.type, n) : n.includes("/") ? Hd(e.type, n) : n.startsWith(".") ? zd(e.name, n) : !1) : !0, Bd = (e, t) => {
  const r = Vd(e, t.accept), n = ps(t.validationMessageType, {
    filename: e.name
  });
  return ds(r, n);
}, jd = [Od, Rd, Bd], qd = ["src", "width", "height"], Wd = /* @__PURE__ */ W({
  __name: "ds-file-thumbnail",
  props: {
    file: {},
    width: { default: 100 },
    height: { default: 100 }
  },
  setup(e) {
    const t = e, r = L("");
    return Ke(() => {
      if (t.file) {
        const n = new FileReader();
        n.onload = (a) => {
          var s;
          r.value = (s = a.target) == null ? void 0 : s.result;
        }, n.readAsDataURL(t.file);
      }
    }), (n, a) => (m(), T("div", {
      class: "ds-file-thumbnail",
      style: Ce({
        width: n.width + "px",
        height: n.height + "px",
        minWidth: n.width + "px"
      }),
      "aria-hidden": "true"
    }, [
      D("img", {
        class: "ds-file-thumbnail__image",
        src: r.value,
        width: n.width * 2,
        height: n.height * 2,
        alt: ""
      }, null, 8, qd)
    ], 4));
  }
}), Ud = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
}, Kd = /* @__PURE__ */ Ud(Wd, [["__scopeId", "data-v-745a06ec"]]), Yd = { class: "ds-file-upload" }, Gd = ["accept", "aria-describedby", "capture", "disabled", "id", "name", "multiple"], Qd = ["id"], Zd = {
  key: 0,
  class: "ds-file-upload__list"
}, Xd = {
  key: 1,
  class: "ds-file-upload__errors"
}, sS = /* @__PURE__ */ W({
  __name: "ds-file-upload",
  props: {
    context: {}
  },
  setup(e) {
    var X, me, ge, He, mt, Ge, lt, Pt, Te, qr, mr;
    const t = e, r = St("mobileButton"), { isMobile: n } = Fe(), a = L(null), s = L([]), i = L([]), l = L(!1), o = L(!1), u = L(
      ((X = t.context) == null ? void 0 : X.accept) || void 0
    ), f = L(
      ((me = t.context) == null ? void 0 : me.maxFileSize) || 10
    ), p = L(
      ((ge = t.context) == null ? void 0 : ge.multiple) || void 0
    ), h = L(
      (He = t.context) == null ? void 0 : He.labelAddFilesButton
    ), c = L(
      (mt = t.context) == null ? void 0 : mt.labelDropFiles
    ), y = L((Ge = t.context) == null ? void 0 : Ge.labelRemove), g = L((lt = t.context) == null ? void 0 : lt.labelTapToAdd), b = L(
      (Pt = t.context) == null ? void 0 : Pt.listMode
    ), k = L(
      (Te = t.context) == null ? void 0 : Te.validationMessageFileSize
    ), P = L(
      (qr = t.context) == null ? void 0 : qr.validationMessageDuplicate
    ), I = L(
      (mr = t.context) == null ? void 0 : mr.validationMessageType
    ), _ = (J) => {
      if (J)
        return S[J];
    }, S = {
      true: !0,
      false: !1,
      user: "user",
      environment: "environment"
    }, v = E(
      () => {
        var J;
        return _((J = t.context) == null ? void 0 : J.capture);
      }
    ), w = E(
      () => {
        var J;
        return o.value || ((J = t.context) == null ? void 0 : J.disabled);
      }
    ), C = E(() => w.value || F.value), F = E(
      () => {
        var J;
        return ((J = t.context) == null ? void 0 : J.multiple) !== !0 && s.value.length > 0;
      }
    ), x = E(
      () => w.value || F.value
    ), R = E(() => {
      const J = [];
      return l.value && J.push("ds-file-upload__target--focus"), o.value && J.push("ds-file-upload__target--dragging"), F.value && J.push("ds-file-upload__target--disabled"), J;
    }), d = E(() => {
      var J;
      return `ds-help-${(J = t.context) == null ? void 0 : J.id}`;
    });
    he(() => {
      var J;
      s.value = ((J = t.context) == null ? void 0 : J.value) ?? [];
    });
    const $ = () => {
      var J;
      if (a.value) {
        const Le = ((J = a.value) == null ? void 0 : J.files) ?? [];
        if (Le)
          for (const Qe of Le)
            q(Qe);
        ne();
      }
    }, A = () => {
      o.value = !0;
    }, z = () => {
      o.value = !1;
    }, N = (J) => {
      o.value = !1;
      const Le = J.dataTransfer.files;
      if (Le)
        for (const Qe of Le)
          q(Qe);
    }, j = () => {
      l.value = !0;
    }, Q = () => {
      var J;
      l.value = !1, (J = t.context) == null || J.handlers.blur();
    }, q = (J) => {
      const Le = {
        name: J.name,
        file: J
      };
      xe(J) && s.value.push(Le);
    }, Z = (J) => {
      Ae(), s.value = s.value.filter(
        (Le) => Le.name !== J.name
      ), ne();
    }, re = () => {
      var J;
      a.value && ((J = a.value) == null || J.click());
    }, ne = () => {
      var J;
      (J = t.context) == null || J.node.input(s.value);
    }, ye = (J) => J.length > 30 ? `...${J.slice(-27)}` : J, Ae = () => {
      i.value = [];
    }, xe = (J) => {
      const Le = [];
      return jd.forEach((Qe) => {
        const We = Md(
          u.value,
          s,
          f.value,
          P.value,
          k.value,
          I.value
        ), Ze = Qe(J, We);
        Ze.valid || (Le.push(Ze), i.value.push(Ze));
      }), Le.length === 0;
    };
    return (J, Le) => {
      var Qe, We, Ze, vr;
      return m(), T("div", Yd, [
        D("div", {
          class: G(["ds-file-upload__target", R.value]),
          onDragover: ct(A, ["prevent"]),
          onDragleave: z,
          onDrop: ct(N, ["prevent"])
        }, [
          O(n) ? M("", !0) : (m(), H(O(ae), {
            key: 0,
            class: "ds-file-upload__icon",
            iconName: "upload"
          })),
          O(n) ? M("", !0) : (m(), H(O(Y), {
            key: 1,
            class: "ds-file-upload__drop-label",
            textType: "label-md"
          }, {
            default: V(() => [
              K(U(c.value), 1)
            ]),
            _: 1
          })),
          D("input", $e({
            class: "ds-file-upload__input",
            ref_key: "fileInput",
            ref: a
          }, J.$attrs, {
            accept: u.value,
            "aria-describedby": d.value,
            capture: v.value || void 0,
            disabled: C.value,
            id: (Qe = J.context) == null ? void 0 : Qe.id,
            name: (Ze = (We = J.context) == null ? void 0 : We.node) == null ? void 0 : Ze.name,
            onBlur: Q,
            onClick: Ae,
            onFocus: j,
            onInput: $,
            multiple: p.value || void 0,
            type: "file"
          }), null, 16, Gd),
          O(n) ? M("", !0) : (m(), H(O(Ee), {
            key: 2,
            class: "ds-file-upload__button",
            disabled: x.value,
            size: "sm",
            variant: "secondary",
            clickHandler: re
          }, {
            default: V(() => [
              K(U(h.value), 1)
            ]),
            _: 1
          }, 8, ["disabled"])),
          O(n) ? (m(), H(O(Ie), {
            key: 3,
            ariaLabel: g.value,
            class: "ds-file-upload__icon-button",
            disabled: x.value,
            iconName: "upload",
            id: O(r),
            variant: "secondary",
            onClick: re
          }, null, 8, ["ariaLabel", "disabled", "id"])) : M("", !0),
          O(n) ? (m(), H(O(Y), {
            key: 4,
            textType: "label-lg",
            htmlElement: "label",
            for: O(r)
          }, {
            default: V(() => [
              K(U(g.value), 1)
            ]),
            _: 1
          }, 8, ["for"])) : M("", !0)
        ], 34),
        D("div", {
          class: "formkit-help formkit-help--fileupload",
          id: d.value
        }, U((vr = J.context) == null ? void 0 : vr.help), 9, Qd),
        s.value && s.value.length ? (m(), T("ul", Zd, [
          (m(!0), T(se, null, ve(s.value, (Xe) => (m(), T("li", {
            class: "ds-file-upload__item",
            key: Xe.name
          }, [
            b.value === "icon" ? (m(), H(O(ae), {
              key: 0,
              class: "ds-file-upload__item-icon",
              iconName: "document"
            })) : M("", !0),
            b.value === "thumbnail" ? (m(), H(Kd, {
              key: 1,
              file: Xe.file,
              height: 28,
              width: 28
            }, null, 8, ["file"])) : M("", !0),
            B(O(Y), {
              class: "ds-file-upload__item-label",
              "html-element": "span",
              textType: "label-md",
              title: Xe.name
            }, {
              default: V(() => [
                K(U(ye(Xe.name)), 1)
              ]),
              _: 2
            }, 1032, ["title"]),
            B(O(Ee), {
              variant: "link",
              size: "sm",
              class: "ds-file-upload__item-action",
              onClick: (Wr) => Z(Xe),
              disabled: w.value
            }, {
              default: V(() => [
                K(U(y.value), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"])
          ]))), 128))
        ])) : M("", !0),
        i.value.length ? (m(), T("div", Xd, [
          (m(!0), T(se, null, ve(i.value, (Xe) => (m(), H(O(Wu), {
            appearance: "danger",
            key: Xe.message,
            text: Xe.message
          }, null, 8, ["text"]))), 128))
        ])) : M("", !0)
      ]);
    };
  }
}), Jd = /* @__PURE__ */ W({
  __name: "ds-grid",
  props: {
    columns: {},
    columnsSm: {},
    columnsMd: {},
    columnsLg: {},
    columnsXl: {},
    columns2xl: {},
    htmlElement: { default: "div" },
    queryType: { default: "media" }
  },
  setup(e) {
    const t = e, r = E(() => {
      const n = t.queryType === "media" ? "mq-" : "cq-", a = [], s = (l, o) => {
        l && a.push(o);
      };
      return (() => {
        Object.entries({
          columns: "",
          columnsSm: "sm",
          columnsMd: "md",
          columnsLg: "lg",
          columnsXl: "xl",
          columns2xl: "2xl"
        }).forEach(([o, u]) => {
          const f = o, p = u ? `${n}${u}:` : "";
          s(
            !!t[f],
            `${p}ds-grid--cols-${t[f]}`
          );
        });
      })(), a;
    });
    return (n, a) => n.queryType === "media" ? (m(), H(Er(n.htmlElement), {
      key: 0,
      class: G(["ds-grid", r.value])
    }, {
      default: V(() => [
        ie(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"])) : n.queryType === "container" ? (m(), H(Er(n.htmlElement), {
      key: 1,
      class: "ds-grid-container"
    }, {
      default: V(() => [
        D("div", {
          class: G(["ds-grid", r.value])
        }, [
          ie(n.$slots, "default")
        ], 2)
      ]),
      _: 3
    })) : M("", !0);
  }
}), ep = ["aria-label", "disabled", "form", "name", "type", "value"], tp = ["aria-disabled", "aria-label", "download", "href", "target"], rp = /* @__PURE__ */ W({
  __name: "ds-button-initials",
  props: {
    ariaLabel: {},
    clickHandler: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    download: { type: [Boolean, String, null], default: null },
    form: {},
    href: {},
    name: {},
    size: { default: "md" },
    target: {},
    type: { default: "button" },
    value: {},
    variant: { default: "secondary-neutral" }
  },
  setup(e) {
    const t = e, r = E(() => t.size), n = E(() => t.variant), a = es(
      {
        variant: n,
        size: r
      },
      "ds-button-initials"
    );
    return (s, i) => (m(), T(se, null, [
      s.href ? M("", !0) : (m(), T("button", $e({ key: 0 }, s.$attrs, {
        onClick: i[0] || (i[0] = //@ts-ignore
        (...l) => s.clickHandler && s.clickHandler(...l)),
        class: ["ds-button-initials", O(a)],
        "aria-label": s.ariaLabel,
        disabled: s.disabled || void 0,
        form: s.form,
        name: s.name,
        type: s.type,
        value: s.value
      }), [
        B(Y, {
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-md"
        }, {
          default: V(() => [
            ie(s.$slots, "default")
          ]),
          _: 3
        })
      ], 16, ep)),
      s.href ? (m(), T("a", $e({ key: 1 }, s.$attrs, {
        onClick: i[1] || (i[1] = //@ts-ignore
        (...l) => s.clickHandler && s.clickHandler(...l)),
        class: ["ds-button-initials", O(a)],
        "aria-disabled": s.disabled || void 0,
        "aria-label": s.ariaLabel,
        download: s.download === !0 ? "" : s.download,
        href: s.href,
        target: s.target
      }), [
        B(Y, {
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-md"
        }, {
          default: V(() => [
            ie(s.$slots, "default")
          ]),
          _: 3
        })
      ], 16, tp)) : M("", !0)
    ], 64));
  }
}), np = ["href"], ap = { class: "ds-logo__picture" }, sp = ["src", "alt"], ip = ["src", "alt"], Pl = /* @__PURE__ */ W({
  __name: "ds-logo",
  props: {
    href: { default: "/" },
    altText: {},
    imageSrc: {},
    imageSrcDark: {},
    clickHandler: {},
    isCompact: { type: Boolean, default: !0 },
    isInverted: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, r = E(() => {
      const n = [];
      return n.push(`ds-logo--${t.size}`), t.isCompact && n.push("ds-logo--compact"), n;
    });
    return (n, a) => (m(), T("div", {
      class: G(["ds-logo", r.value])
    }, [
      D("a", {
        class: "ds-logo__link",
        href: n.href,
        onClick: a[0] || (a[0] = //@ts-ignore
        (...s) => n.clickHandler && n.clickHandler(...s))
      }, [
        D("picture", ap, [
          D("img", {
            class: "ds-logo__image ds-logo__image--light",
            src: n.imageSrc,
            alt: n.altText,
            fetchpriority: "high"
          }, null, 8, sp),
          n.imageSrcDark ? (m(), T("img", {
            key: 0,
            class: "ds-logo__image ds-logo__image--dark",
            src: n.imageSrcDark,
            alt: n.altText,
            fetchpriority: "high"
          }, null, 8, ip)) : M("", !0)
        ])
      ], 8, np)
    ], 2));
  }
}), Il = (e) => e ? "checkVisibility" in e && typeof e.checkVisibility == "function" ? e.checkVisibility() : e instanceof HTMLElement && !!e.offsetParent : !1, lp = ["href", "target"], op = ["aria-expanded", "aria-controls", "id"], up = ["aria-expanded", "aria-controls", "id"], cp = /* @__PURE__ */ W({
  __name: "ds-nav-item",
  props: {
    navItem: {}
  },
  setup(e) {
    const t = e, r = L(!1), n = L(null), a = L(null), s = E(() => {
      const y = [];
      return t.navItem.isActive && y.push("ds-nav-item--active"), y;
    }), i = E(() => {
      const y = [];
      return r.value && y.push("ds-nav-item-dropdown--open"), y;
    }), l = ee("activeMegaMenuId", L("")), o = E(() => l ? (l == null ? void 0 : l.value) === t.navItem.itemId : !1), u = (y) => {
      o.value && (y.key === "Escape" && p(t.navItem.itemId, n), y.key === "Tab" && !y.shiftKey && (y.preventDefault(), f()));
    }, f = () => {
      const y = document.getElementById(
        l.value
      );
      if (y) {
        const b = [...y.querySelectorAll("a[href], button")].find((k) => Il(k));
        b && b.focus();
      }
    }, p = ee(
      "togglePrimaryMegaNav",
      (y, g) => {
        console.warn(
          "Missing open mega nav function for ",
          y,
          g
        );
      }
    ), h = () => {
      r.value = !r.value;
    }, c = () => {
      t.navItem.type === "mega" && p(t.navItem.itemId, n), t.navItem.type === "drilldown" && p(t.navItem.itemId, a), t.navItem.type === "dropdown" && h();
    };
    return (y, g) => (m(), T(se, null, [
      y.navItem.type === "link" ? (m(), T("a", {
        key: 0,
        class: G(["ds-nav-item", s.value]),
        href: y.navItem.linkUrl,
        target: y.navItem.linkTarget
      }, U(y.navItem.text), 11, lp)) : M("", !0),
      y.navItem.type === "drilldown" ? (m(), T("button", {
        key: 1,
        onClick: c,
        onKeydown: u,
        "aria-expanded": o.value,
        "aria-controls": y.navItem.itemId,
        id: `button-${y.navItem.itemId}`,
        class: G(["ds-nav-item", s.value]),
        ref_key: "primaryDrilldownItem",
        ref: a
      }, [
        K(U(y.navItem.text) + " ", 1),
        M("", !0)
      ], 42, op)) : M("", !0),
      y.navItem.type === "mega" ? (m(), T("button", {
        key: 2,
        onClick: c,
        onKeydown: u,
        "aria-expanded": o.value,
        "aria-controls": y.navItem.itemId,
        id: `button-${y.navItem.itemId}`,
        class: G(["ds-nav-item", s.value]),
        ref_key: "primaryMegaItem",
        ref: n
      }, [
        K(U(y.navItem.text) + " ", 1),
        M("", !0)
      ], 42, up)) : M("", !0),
      y.navItem.type === "dropdown" ? (m(), T("div", {
        key: 3,
        class: G(["ds-nav-item-dropdown", i.value])
      }, [
        D("button", {
          onClick: c,
          class: G(["ds-nav-item ds-nav-item--mega", s.value])
        }, [
          K(U(y.navItem.text) + " ", 1),
          B(ae, {
            class: "ds-nav-item__icon",
            iconName: "chevron-down",
            size: "sm"
          })
        ], 2),
        g[0] || (g[0] = D("div", { class: "ds-nav-item__dropdown" }, null, -1))
      ], 2)) : M("", !0)
    ], 64));
  }
}), fp = ["aria-label"], dp = { class: "ds-nav-primary__list" }, Zs = /* @__PURE__ */ W({
  __name: "ds-nav-primary",
  props: {
    navItems: {}
  },
  setup(e) {
    const t = ee("labels", {});
    return (r, n) => {
      var a;
      return m(), T("nav", {
        class: "ds-nav-primary",
        "aria-label": ((a = O(t)) == null ? void 0 : a.primaryNavLandmark) ?? "Primary"
      }, [
        D("ul", dp, [
          (m(!0), T(se, null, ve(r.navItems, (s) => (m(), T("li", {
            class: "ds-nav-primary__list-item",
            key: s.text
          }, [
            B(cp, { navItem: s }, null, 8, ["navItem"])
          ]))), 128))
        ])
      ], 8, fp);
    };
  }
}), pp = ["aria-expanded", "id", "data-trigger-id"], mp = /* @__PURE__ */ W({
  __name: "ds-nav-secondary-item",
  props: {
    id: {},
    isActive: { type: Boolean, default: !1 },
    isLink: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = ee("activeMegaMenuId", null), n = ee("activePrimaryId", void 0), a = E(() => {
      const o = [];
      return t.isActive && o.push("ds-nav-secondary-item--active"), o;
    }), s = L(null), i = ee(
      "openSecondaryMegaNav",
      (o, u) => {
        console.warn(
          "Missing open secondary mega nav function for ",
          o,
          u
        );
      }
    ), l = (o) => {
      i && i(o, s);
    };
    return (o, u) => o.isLink ? M("", !0) : (m(), T("button", {
      key: 0,
      onClick: u[0] || (u[0] = () => l(o.id)),
      "aria-expanded": O(r) === O(n),
      "aria-controls": "megaNav",
      id: `trigger-${o.id}`,
      "data-trigger-id": o.id,
      class: G(["ds-nav-secondary-item", a.value]),
      ref_key: "secondaryNavItem",
      ref: s
    }, [
      B(Y, {
        "html-element": "span",
        "text-type": "label-md"
      }, {
        default: V(() => [
          ie(o.$slots, "default")
        ]),
        _: 3
      }),
      B(ae, {
        class: "ds-nav-secondary-item__icon",
        iconName: "chevron-down",
        size: "xs"
      })
    ], 10, pp));
  }
}), vp = ["aria-label"], yp = { class: "ds-nav-secondary__list" }, hp = /* @__PURE__ */ W({
  __name: "ds-nav-secondary",
  props: {
    navItems: {}
  },
  setup(e) {
    const t = ee("labels", {});
    return (r, n) => {
      var a;
      return m(), T("nav", {
        class: "ds-nav-secondary",
        "aria-label": ((a = O(t)) == null ? void 0 : a.secondaryNavLandmark) ?? "Secondary"
      }, [
        D("ul", yp, [
          (m(!0), T(se, null, ve(r.navItems, (s) => (m(), T("li", {
            class: "ds-nav-secondary__list-item",
            key: `nav-${s.itemId}`
          }, [
            B(mp, {
              id: s.itemId,
              isActive: s.isActive
            }, {
              default: V(() => [
                K(U(s.text), 1)
              ]),
              _: 2
            }, 1032, ["id", "isActive"])
          ]))), 128))
        ])
      ], 8, vp);
    };
  }
});
function ms(e) {
  const t = ee("labels", {}), r = ee("hideBackdrop");
  return {
    ariaLabel: E(() => `${e.itemLabel} ${(t == null ? void 0 : t.megaMenuNavLandmark) ?? "Navigation"}`),
    handleKeydown: (s) => {
      s.key === "Escape" && typeof r == "function" && r();
    },
    hideBackdrop: r
  };
}
const gp = ["href", "target", "rel"], bp = ["innerHTML"], _p = /* @__PURE__ */ W({
  __name: "ds-nav-mega-link",
  props: {
    megaMenuLink: {}
  },
  setup(e) {
    const t = e, r = ee("labels", {}), n = E(() => !!t.megaMenuLink.linkIsExternal), a = E(() => {
      if (n.value)
        return "noopener noreferrer";
    }), s = E(() => t.megaMenuLink.linkTarget === "_blank" && (r != null && r.opensNewWindowLabel) ? `${t.megaMenuLink.linkText} <span class="ds-visually-hidden">(${r.opensNewWindowLabel})</span>` : t.megaMenuLink.linkText);
    return (i, l) => (m(), T("a", {
      class: "ds-nav-mega-link",
      href: i.megaMenuLink.linkUrl,
      target: i.megaMenuLink.linkTarget,
      rel: a.value
    }, [
      B(Y, {
        "html-element": "span",
        "text-type": "label-md",
        "text-style": "medium"
      }, {
        default: V(() => [
          D("span", { innerHTML: s.value }, null, 8, bp)
        ]),
        _: 1
      }),
      n.value ? (m(), H(ae, {
        key: 0,
        class: "ds-nav-mega-link__external",
        iconName: "external-link",
        size: "xs"
      })) : M("", !0)
    ], 8, gp));
  }
}), $p = { class: "ds-nav-mega-link-list" }, kp = ["aria-labelledby"], wp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-link-list",
  props: {
    categoryTitle: {},
    links: {}
  },
  setup(e) {
    const t = St("megamenu-linklist");
    return (r, n) => (m(), T("div", $p, [
      B(Y, {
        id: O(t),
        "html-element": "h2",
        "text-type": "label-sm",
        "text-style": "medium",
        class: "ds-nav-mega-link-list__category"
      }, {
        default: V(() => [
          K(U(r.categoryTitle), 1)
        ]),
        _: 1
      }, 8, ["id"]),
      D("ul", {
        class: "ds-nav-mega-link-list__list",
        "aria-labelledby": O(t)
      }, [
        (m(!0), T(se, null, ve(r.links, (a) => (m(), T("li", {
          class: "ds-nav-mega-link-list__item",
          key: `${a.linkText}${a.linkUrl}`
        }, [
          B(_p, { "mega-menu-link": a }, null, 8, ["mega-menu-link"])
        ]))), 128))
      ], 8, kp)
    ]));
  }
}), Sp = { class: "ds-nav-mega-title" }, Pp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-title",
  props: {
    title: {},
    linkText: {},
    linkUrl: {}
  },
  setup(e) {
    return (t, r) => (m(), T("div", Sp, [
      B(Y, {
        "text-type": "heading-2xl",
        "text-style": "regular",
        class: "ds-nav-mega-title__title"
      }, {
        default: V(() => [
          K(U(t.title), 1)
        ]),
        _: 1
      }),
      t.linkText ? (m(), H(Ee, {
        key: 0,
        "icon-end": "button-navigate-forward",
        variant: "link",
        href: t.linkUrl
      }, {
        default: V(() => [
          K(U(t.linkText), 1)
        ]),
        _: 1
      }, 8, ["href"])) : M("", !0)
    ]));
  }
}), Ip = ["href", "target"], Cp = { class: "ds-nav-card__figure" }, Ep = ["src", "alt"], Ap = ["innerHTML"], yn = /* @__PURE__ */ W({
  __name: "ds-nav-card",
  props: {
    title: {},
    description: {},
    linkUrl: {},
    linkIsExternal: { type: Boolean },
    linkTarget: {},
    imageSrc: {},
    imageAltText: {}
  },
  setup(e) {
    const t = e, r = E(() => t.linkUrl && t.imageSrc && t.title);
    return (n, a) => r.value ? (m(), T("a", {
      key: 0,
      class: "ds-nav-card",
      href: n.linkUrl,
      target: n.linkTarget
    }, [
      D("figure", Cp, [
        D("img", {
          class: "ds-nav-card__image",
          src: n.imageSrc,
          alt: n.imageAltText
        }, null, 8, Ep)
      ]),
      B(Y, {
        class: "ds-nav-card__title",
        "html-element": "h3",
        "text-style": "medium",
        "text-type": "label-md"
      }, {
        default: V(() => [
          K(U(n.title) + " ", 1),
          n.linkIsExternal ? (m(), H(ae, {
            key: 0,
            class: "ds-nav-card__icon",
            "icon-name": "button-external-link",
            size: "xs"
          })) : M("", !0)
        ]),
        _: 1
      }),
      n.description ? (m(), H(Y, {
        key: 0,
        class: "ds-nav-card__description",
        "html-element": "p",
        "text-type": "label-sm"
      }, {
        default: V(() => [
          D("span", { innerHTML: n.description }, null, 8, Ap)
        ]),
        _: 1
      })) : M("", !0)
    ], 8, Ip)) : M("", !0);
  }
}), Tp = { class: "ds-nav-mega-column ds-nav-mega-column--cards" }, Lp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-cards",
  props: {
    cards: {}
  },
  setup(e) {
    return (t, r) => (m(), T("div", Tp, [
      (m(!0), T(se, null, ve(t.cards, (n) => (m(), H(yn, $e({
        key: n.title,
        ref_for: !0
      }, n), null, 16))), 128))
    ]));
  }
}), vs = /* @__PURE__ */ W({
  __name: "ds-nav-mega-column",
  props: {
    megaNavColumn: {}
  },
  setup(e) {
    return (t, r) => t.megaNavColumn.type === "linkList" ? (m(), H(wp, {
      key: 0,
      categoryTitle: t.megaNavColumn.content.categoryTitle,
      links: t.megaNavColumn.content.links
    }, null, 8, ["categoryTitle", "links"])) : t.megaNavColumn.type === "titleBlock" ? (m(), H(Pp, {
      key: 1,
      title: t.megaNavColumn.content.title,
      linkText: t.megaNavColumn.content.linkText,
      linkUrl: t.megaNavColumn.content.linkUrl
    }, null, 8, ["title", "linkText", "linkUrl"])) : t.megaNavColumn.type === "promo" ? (m(), H(Lp, {
      key: 2,
      cards: t.megaNavColumn.content.cards
    }, null, 8, ["cards"])) : M("", !0);
  }
});
function ys(e, t = L(null)) {
  const r = L([]), n = L([]), a = L(null), s = L(null), i = L(null), l = ee("hideBackdrop"), o = ee(
    "lastFocusedSecondaryNavItem",
    L(null)
  ), u = ee(
    "lastFocusedPrimaryNavItem",
    L(null)
  ), f = ee(
    "primaryNextPrev",
    E(() => ({
      nextItem: ""
    }))
  ), p = () => {
    e.value && e.value !== null && (n.value = [
      ...e.value.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ].filter((d) => Il(d)), a.value = n.value[0] || null, i.value = n.value[n.value.length - 1] || null);
  }, h = () => {
    t.value && (r.value = [
      ...t.value.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ], s.value = r.value[0] || null);
  }, c = () => {
    p(), h();
  }, y = (d) => {
    var $;
    document.activeElement === a.value && (d.preventDefault(), F.value ? ($ = x.value) == null || $.focus() : k());
  }, g = (d, $, A = !1) => {
    var z;
    A && $ == x.value && ((z = a.value) == null || z.focus(), d.preventDefault());
  }, b = () => {
    typeof l == "function" && l();
  }, k = () => {
    F.value && R.value ? (o.value = R.value, b()) : !F.value && f.value.nextItem && b();
  }, P = (d, $, A) => {
    if ($ === A) {
      d.preventDefault();
      const z = document.querySelector(
        `.ds-nav-item[aria-controls='${f.value.nextItem}']`
      );
      u.value = z, k();
    }
  }, I = (d, $ = !1) => {
    const A = document.activeElement, z = i.value;
    g(d, A, $), P(d, A, z);
  }, _ = (d) => {
    !t.value || d.key !== "Tab" || (d.shiftKey ? y(d) : I(d, !0));
  }, S = (d) => {
    !e.value || d.key !== "Tab" || (d.shiftKey ? y(d) : I(d));
  };
  he(() => {
    t.value && t.value.addEventListener("keydown", _), e.value && e.value.addEventListener(
      "keydown",
      S
    ), c();
  }), qe(() => {
    t.value && t.value.removeEventListener("keydown", _), e.value && e.value.removeEventListener(
      "keydown",
      S
    );
  });
  const v = () => {
    const d = r.value.find(
      ($) => $.className.includes("ds-nav-mega-tab--active")
    );
    d && d.focus();
  }, w = (d, $ = null) => {
    d && $ ? $.focus() : d && !$ && v();
  }, C = async (d, $ = null) => {
    await at(), c(), w(d, $);
  }, F = E(() => t.value !== null), x = E(() => r.value.find(
    (d) => d.className.includes("ds-nav-mega-tab--active")
  )), R = E(() => {
    var d;
    if (F.value) {
      const $ = (d = x.value) == null ? void 0 : d.getAttribute("data-next-id");
      return document.querySelector(
        `.ds-nav-secondary-item[data-trigger-id='${$}']`
      );
    }
    return null;
  });
  return {
    focusableContent: n,
    focusableTabs: r,
    setLastFocusedElement: k,
    updateFocusableElements: C
  };
}
const Mp = ["aria-labelledby", "id"], Op = { class: "ds-nav-mega__content" }, Np = /* @__PURE__ */ W({
  __name: "ds-nav-mega",
  props: {
    itemLabel: {},
    itemId: {},
    megaNavColumns: {}
  },
  setup(e) {
    const t = ee("activeOverlayType", L("none")), r = ee("labels", {}), n = e, a = L(null), s = ee("activeMegaMenuId", L("")), i = E(() => t.value === "primaryMega" && (s == null ? void 0 : s.value) === n.itemId), { handleKeydown: l, hideBackdrop: o } = ms({
      itemLabel: n.itemLabel
    }), u = ee(
      "lastFocusedPrimaryNavItem",
      L(null)
    ), f = (h) => {
      typeof o == "function" && o();
    }, { updateFocusableElements: p } = ys(a);
    return le(i, async (h) => {
      h && a.value !== null ? p(!1) : u && u.value && (await at(), u.value.focus());
    }), (h, c) => we((m(), T("section", {
      "aria-labelledby": `button-${h.itemId}`,
      class: "ds-nav-mega",
      id: h.itemId,
      ref_key: "megaMenu",
      ref: a,
      onClick: c[0] || (c[0] = ct(() => {
      }, ["stop"])),
      onKeydown: c[1] || (c[1] = //@ts-ignore
      (...y) => O(l) && O(l)(...y))
    }, [
      D("div", Op, [
        B(Ie, {
          class: "ds-nav-mega-close",
          ariaLabel: O(r).megaMenuCloseButtonLabel ?? "Close menu",
          iconName: "button-close",
          clickHandler: f,
          variant: "tertiary"
        }, null, 8, ["ariaLabel"]),
        D("div", {
          class: G(["ds-nav-mega-panel ds-nav-mega-columns", `ds-nav-mega-columns--${h.megaNavColumns.length}`])
        }, [
          (m(!0), T(se, null, ve(h.megaNavColumns, (y, g) => (m(), T("div", {
            key: `panel-${h.itemId}-col-${g}`,
            class: G(["ds-nav-mega-column", `ds-nav-mega-column--${y.type}`])
          }, [
            B(vs, { megaNavColumn: y }, null, 8, ["megaNavColumn"])
          ], 2))), 128))
        ], 2)
      ])
    ], 40, Mp)), [
      [Se, i.value]
    ]);
  }
}), Fp = ["aria-label"], Dp = { class: "ds-nav-drilldown-item__label" }, Rp = ["href", "target"], xp = { class: "ds-nav-drilldown-item__label" }, Xs = "submenu", Hp = /* @__PURE__ */ W({
  __name: "ds-nav-drilldown-item",
  props: {
    isActive: { type: Boolean },
    level: { default: 0 },
    navItem: {}
  },
  setup(e) {
    const t = e, r = E(() => typeof t.navItem.children > "u" ? !1 : t.navItem.children.length > 0), n = E(() => !!(r.value && t.level < 2)), a = E(() => !!t.navItem.linkIsExternal), s = ee(
      "clickDrilldownNavItem",
      (l, o) => {
        console.warn("No click handler attached to", l, o);
      }
    ), i = ee("labels", { submenuLabel: Xs });
    return (l, o) => l.navItem && n.value ? (m(), T("button", {
      key: 0,
      "aria-label": `${l.navItem.text} ${O(i).submenuLabel || Xs}`,
      class: G(["ds-nav-drilldown-item", l.isActive ? "ds-nav-drilldown-item--active" : null]),
      onClick: o[0] || (o[0] = (u) => O(s)(l.navItem, l.level))
    }, [
      D("span", Dp, [
        B(Y, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: V(() => [
            K(U(l.navItem.text), 1)
          ]),
          _: 1
        })
      ]),
      n.value ? (m(), H(ae, {
        key: 0,
        class: "ds-nav-drilldown-item__chevron",
        size: "sm",
        iconName: "chevron-right"
      })) : M("", !0)
    ], 10, Fp)) : l.navItem && "linkUrl" in l.navItem && !r.value ? (m(), T("a", {
      key: 1,
      class: "ds-nav-drilldown-item",
      href: l.navItem.linkUrl,
      target: l.navItem.linkTarget
    }, [
      D("span", xp, [
        B(Y, {
          "text-type": "label-md",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: V(() => [
            K(U(l.navItem.text), 1)
          ]),
          _: 1
        }),
        a.value ? (m(), H(ae, {
          key: 0,
          class: "ds-nav-drilldown-item__external",
          iconName: "button-external-link",
          size: "xs"
        })) : M("", !0)
      ])
    ], 8, Rp)) : M("", !0);
  }
}), zp = ["aria-label"], Vp = { class: "ds-nav-drilldown__list" }, aa = /* @__PURE__ */ W({
  __name: "ds-nav-drilldown",
  props: {
    activeItems: {},
    item: {},
    level: {}
  },
  setup(e) {
    const t = e, r = E(() => t.activeItems[t.level]), n = E(
      () => {
        var i;
        return r.value ? (i = r.value) == null ? void 0 : i.itemId : null;
      }
    ), a = E(
      () => {
        var i;
        return (i = t.item) == null ? void 0 : i.children;
      }
    ), s = ee("labels", { submenuLabel: "submenu" });
    return (i, l) => (m(), H(ft, { name: "drillfade" }, {
      default: V(() => [
        i.item && a.value ? (m(), T("section", {
          key: 0,
          "aria-label": `${i.item.text} ${O(s).submenuLabel}`,
          class: G(["ds-nav-mega-column", `ds-nav-mega-column--level-${i.level}`])
        }, [
          D("ul", Vp, [
            (m(!0), T(se, null, ve(a.value, (o) => (m(), T("li", {
              class: "ds-nav-drilldown__list-item",
              key: o.itemId
            }, [
              o ? (m(), H(Hp, {
                key: 0,
                navItem: o,
                level: i.level,
                isActive: o.itemId === n.value
              }, null, 8, ["navItem", "level", "isActive"])) : M("", !0)
            ]))), 128))
          ])
        ], 10, zp)) : M("", !0)
      ]),
      _: 1
    }));
  }
}), Bp = ["aria-labelledby", "id"], jp = { class: "ds-nav-mega__content" }, qp = { class: "ds-nav-mega-panel" }, Wp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-drilldown",
  props: {
    item: {}
  },
  setup(e, { expose: t }) {
    const r = ee("activeOverlayType", L("none")), n = ee("labels", {}), a = L([]);
    _e("clickDrilldownNavItem", (S, v) => {
      var F;
      const w = ((F = a.value[v]) == null ? void 0 : F.itemId) === (S == null ? void 0 : S.itemId), C = a.value.slice(0, v);
      w || (C[v] = S), a.value = C, _(!1);
    });
    const i = e, l = L(null), o = L(!0), u = ee("activeMegaMenuId", L("")), f = E(() => r.value === "primaryMega" && (u == null ? void 0 : u.value) === i.item.itemId), p = E(() => typeof i.item.titleBlock < "u"), h = (S) => !S.children || S.children.length === 0 ? 0 : 1 + Math.max(...S.children.map(h)), c = E(() => h(i.item)), y = E(() => 4 - c.value - 1), g = E(() => {
      var S;
      return `drilldown--card-slots-${y.value} drilldown--cards-${((S = i.item.cards) == null ? void 0 : S.length) ?? "0"}`;
    }), { handleKeydown: b, hideBackdrop: k } = ms({
      itemLabel: i.item.text
    }), P = ee(
      "lastFocusedPrimaryNavItem",
      L(null)
    ), I = (S) => {
      typeof k == "function" && k();
    }, { updateFocusableElements: _ } = ys(l);
    return le(a, (S) => {
      S.length === 0 ? setTimeout(() => {
        o.value = !0;
      }, 200) : o.value = !1;
    }), le(f, async (S) => {
      S && l.value !== null ? _(!1) : P && P.value && (await at(), P.value.focus());
    }), t({
      activeItems: a,
      navDepth: c,
      dedicatedCardSlots: y
    }), (S, v) => {
      var w;
      return we((m(), T("section", {
        "aria-labelledby": `button-${S.item.itemId}`,
        class: "ds-nav-mega ds-nav-mega--drilldown",
        id: S.item.itemId,
        ref_key: "megaMenu",
        ref: l,
        onClick: v[0] || (v[0] = ct(() => {
        }, ["stop"])),
        onKeydown: v[1] || (v[1] = //@ts-ignore
        (...C) => O(b) && O(b)(...C))
      }, [
        D("div", jp, [
          B(Ie, {
            class: "ds-nav-mega-close",
            ariaLabel: O(n).megaMenuCloseButtonLabel ?? "Close menu",
            iconName: "button-close",
            clickHandler: I,
            variant: "tertiary"
          }, null, 8, ["ariaLabel"]),
          D("div", qp, [
            D("div", {
              class: G(["ds-nav-mega-drilldown-cols", g.value])
            }, [
              p.value ? (m(), T("div", {
                key: 0,
                class: G(["ds-nav-mega-column", `ds-nav-mega-column--${(w = S.item.titleBlock) == null ? void 0 : w.type}`])
              }, [
                S.item.titleBlock ? (m(), H(vs, {
                  key: 0,
                  megaNavColumn: S.item.titleBlock
                }, null, 8, ["megaNavColumn"])) : M("", !0)
              ], 2)) : M("", !0),
              B(aa, {
                activeItems: a.value,
                item: S.item,
                level: 0
              }, null, 8, ["activeItems", "item"]),
              we(B(aa, {
                activeItems: a.value,
                item: a.value[0],
                level: 1
              }, null, 8, ["activeItems", "item"]), [
                [Se, a.value.length]
              ]),
              we(B(aa, {
                activeItems: a.value,
                item: a.value[1],
                level: 2
              }, null, 8, ["activeItems", "item"]), [
                [Se, a.value.length === 2]
              ]),
              B(ft, {
                name: "card",
                appear: ""
              }, {
                default: V(() => [
                  S.item.cards && S.item.cards.length > 0 ? we((m(), H(yn, $e({
                    key: 0,
                    class: "ds-nav-card--1"
                  }, S.item.cards[0]), null, 16)), [
                    [Se, o.value || y.value === 1]
                  ]) : M("", !0)
                ]),
                _: 1
              }),
              B(ft, {
                name: "card",
                appear: ""
              }, {
                default: V(() => [
                  S.item.cards && S.item.cards.length > 1 ? we((m(), H(yn, $e({
                    key: 0,
                    class: "ds-nav-card--2"
                  }, S.item.cards[1]), null, 16)), [
                    [Se, o.value || y.value === 2]
                  ]) : M("", !0)
                ]),
                _: 1
              })
            ], 2)
          ])
        ])
      ], 40, Bp)), [
        [Se, f.value]
      ]);
    };
  }
}), Up = { class: "ds-nav-mega-tabs__nav-wrapper" }, Kp = { class: "ds-nav-mega-tabs__list" }, Yp = ["id", "data-itemid", "aria-controls", "data-next-id", "data-prev-id", "data-first-id", "data-last-id", "onClick"], Gp = ["id", "aria-labelledby", "aria-hidden"], Qp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-tabs",
  props: {
    activeTabLabel: {},
    itemLabel: {},
    isVisible: { type: Boolean },
    tabs: { default: () => [] }
  },
  setup(e) {
    const t = e, r = L(null), n = L([]), { handleKeydown: a, hideBackdrop: s } = ms({
      itemLabel: t.itemLabel
    }), { direction: i } = _l(r), l = L(null), o = L(null), { updateFocusableElements: u } = ys(o, l), f = (I) => {
      y.value !== I ? y.value = I : typeof s == "function" && s();
    }, p = (I) => {
      typeof s == "function" && s();
    }, h = ee("labels", {}), c = ee(
      "lastFocusedSecondaryNavItem",
      L(null)
    ), y = ee("activeTabId", L(null)), g = E(() => {
      let I = null;
      return n.value && (I = n.value.find(
        (_) => _.getAttribute("data-itemid") === y.value
      )), I;
    }), b = L({
      "--scale-factor": "0px",
      "--translate-x": "0px"
    }), k = (I) => {
      var _;
      return i.value === "rtl" ? l.value ? I.offsetLeft - ((_ = l.value) == null ? void 0 : _.offsetWidth) : 0 : I.offsetLeft;
    }, P = async () => {
      const I = g.value;
      await at(), await u(!0), b.value = {
        "--scale-factor": `${I == null ? void 0 : I.getBoundingClientRect().width}px`,
        "--translate-x": `${k(I)}px`
      };
    };
    return le(
      () => t.isVisible,
      async (I) => {
        I && await P(), I || c && c.value && (await at(), c.value.focus());
      }
    ), le(g, async (I) => {
      I && await P();
    }), (I, _) => (m(), T("div", {
      class: "ds-nav-mega-tabs",
      ref_key: "megaMenu",
      ref: r,
      onKeydown: _[0] || (_[0] = //@ts-ignore
      (...S) => O(a) && O(a)(...S)),
      style: Ce(b.value)
    }, [
      D("div", Up, [
        B(Ie, {
          class: "ds-nav-mega-close",
          ariaLabel: O(h).megaMenuCloseButtonLabel ?? "Close menu",
          iconName: "button-close",
          clickHandler: p,
          variant: "tertiary"
        }, null, 8, ["ariaLabel"]),
        D("div", {
          class: "ds-nav-mega-tabs__nav",
          ref_key: "tablist",
          ref: l
        }, [
          D("ul", Kp, [
            (m(!0), T(se, null, ve(I.tabs, ({ itemId: S, text: v }, w) => {
              var C, F, x, R;
              return m(), T("li", {
                class: "ds-nav-mega-tabs__list-item",
                key: `${S}-button`
              }, [
                D("button", {
                  id: `${S}-button`,
                  ref_for: !0,
                  ref_key: "tabButtons",
                  ref: n,
                  class: G([
                    "ds-nav-mega-tab",
                    O(y) === S ? "ds-nav-mega-tab--active" : ""
                  ]),
                  "data-itemid": S,
                  "aria-controls": `panel-${S}`,
                  "data-next-id": (C = I.tabs[(w + 1) % I.tabs.length]) == null ? void 0 : C.itemId,
                  "data-prev-id": (F = I.tabs[(w - 1 + I.tabs.length) % I.tabs.length]) == null ? void 0 : F.itemId,
                  "data-first-id": (x = I.tabs[0]) == null ? void 0 : x.itemId,
                  "data-last-id": (R = I.tabs[I.tabs.length - 1]) == null ? void 0 : R.itemId,
                  onClick: () => f(S)
                }, [
                  B(Y, {
                    class: "ds-nav-mega-tab__text",
                    "html-element": "span",
                    "text-type": "label-md"
                  }, {
                    default: V(() => [
                      K(U(v), 1)
                    ]),
                    _: 2
                  }, 1024),
                  B(ae, {
                    class: "ds-nav-mega-tab__icon",
                    iconName: "chevron-down",
                    size: "xs"
                  })
                ], 10, Yp)
              ]);
            }), 128))
          ])
        ], 512),
        _[1] || (_[1] = D("div", { class: "ds-nav-mega-tabs__indicator" }, [
          D("div", { class: "ds-nav-mega-tabs__active-line" })
        ], -1))
      ]),
      D("div", {
        class: "ds-nav-mega-tabs__panels",
        ref_key: "tabpanel",
        ref: o
      }, [
        (m(!0), T(se, null, ve(I.tabs, (S) => we((m(), T("section", {
          class: "ds-nav-mega-panel ds-nav-mega-columns",
          key: S.itemId,
          id: `panel-${S.itemId}`,
          "aria-labelledby": `trigger-${S.itemId}`,
          "aria-hidden": S.itemId !== O(y)
        }, [
          (m(!0), T(se, null, ve(S.megaNavColumns, (v, w) => (m(), T("div", {
            key: `panel-${S.itemId}-col-${w}`,
            class: G(["ds-nav-mega-column", `ds-nav-mega-column--${v.type}`])
          }, [
            B(vs, { megaNavColumn: v }, null, 8, ["megaNavColumn"])
          ], 2))), 128))
        ], 8, Gp)), [
          [Se, S.itemId === O(y)]
        ])), 128))
      ], 512)
    ], 36));
  }
}), Zp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-secondary",
  props: {
    itemLabel: {},
    navItems: {}
  },
  setup(e) {
    const t = ee("activeOverlayType", L("none")), r = E(() => t.value === "secondaryMega");
    return (n, a) => we((m(), T("div", {
      class: "ds-nav-mega ds-nav-mega--secondary",
      onClick: a[0] || (a[0] = ct(() => {
      }, ["stop"]))
    }, [
      B(Qp, {
        "is-visible": r.value,
        "item-label": n.itemLabel,
        tabs: n.navItems
      }, null, 8, ["is-visible", "item-label", "tabs"])
    ], 512)), [
      [Se, r.value]
    ]);
  }
}), Xp = { class: "ds-nav-mega-search__content" }, Jp = /* @__PURE__ */ W({
  __name: "ds-nav-mega-search",
  setup(e) {
    const t = ee("activeOverlayType", L("none"));
    return (r, n) => we((m(), T("div", {
      onClick: n[0] || (n[0] = ct(() => {
      }, ["stop"])),
      class: "ds-nav-mega-search"
    }, [
      D("div", Xp, [
        ie(r.$slots, "default")
      ])
    ], 512)), [
      [Se, O(t) === "search"]
    ]);
  }
});
function Cl(e, t, r, n) {
  const a = L(!1), s = L("0px"), i = L("unset"), l = E(() => {
    const h = [];
    return e.enableSticky && h.push(`${n}--sticky`), a.value && h.push(`${n}--show`), h;
  }), { y: o } = bd();
  let u = 0;
  le(o, () => {
    const h = document.documentElement.scrollHeight - window.innerHeight, c = Math.min(Math.max(o.value, 0), h);
    c >= u ? a.value = !1 : a.value = !0, u = c;
  });
  const p = (h) => `${h}px`;
  return t !== null && vn(t, (h) => {
    const c = h[0], { height: y } = c.contentRect;
    s.value = p(y);
  }), r !== null && vn(r, (h) => {
    const c = h[0], { height: y } = c.contentRect;
    y !== 0 && (i.value = p(y));
  }), he(() => {
    var h, c;
    t.value && (s.value = p(
      (h = t.value) == null ? void 0 : h.clientHeight
    )), r.value && (i.value = p(
      (c = r.value) == null ? void 0 : c.clientHeight
    ));
  }), {
    dynamicClasses: l,
    headerHeight: s,
    secondaryHeight: i
  };
}
const em = { class: "ds-header__inner" }, tm = { class: "ds-header__logo" }, rm = { class: "ds-header__tools" }, nm = { class: "ds-header__icons" }, am = {
  key: 0,
  class: "ds-header__cta"
}, sm = {
  key: 0,
  class: "ds-header__primary-stacked"
}, im = { class: "ds-header__inner" }, lm = { class: "ds-header__nav" }, om = /* @__PURE__ */ W({
  __name: "ds-header-desktop",
  props: {
    basketCount: {},
    basketFn: {},
    enableBasket: { type: Boolean },
    enableSearch: { type: Boolean },
    enableSticky: { type: Boolean, default: !0 },
    navItems: {},
    searchFn: {}
  },
  setup(e) {
    var xe;
    const t = e, r = L(0), n = L(null), a = L(null), s = L(!1), i = L(null), l = L(null), o = L(null), u = L("none"), f = L(null), p = L(null), h = L(null), c = L(0), y = L(!1), g = L(null), { dynamicClasses: b, headerHeight: k, secondaryHeight: P } = Cl(
      {
        enableSticky: t.enableSticky
      },
      g,
      a,
      "ds-header"
    ), I = E(() => `--header-top-height: ${k.value}; --secondary-height: ${P.value}`), _ = E(() => c.value < r.value), S = E(() => t.navItems.find((X) => X.isActive)), v = E(() => {
      const X = t.navItems.findIndex(
        (Ge) => {
          var lt;
          return Ge.itemId === ((lt = l.value) == null ? void 0 : lt.getAttribute("aria-controls"));
        }
      ), me = (t.navItems.length + X - 1) % t.navItems.length, ge = (X + 1) % t.navItems.length, He = t.navItems[me].itemId, mt = t.navItems[ge].itemId;
      return { prevItem: He, nextItem: mt };
    }), w = E(() => {
      var X;
      return S.value && S.value.type !== "mega" && S.value.type !== "drilldown" && ((X = S.value.children) == null ? void 0 : X.length) && S.value.children.length > 0;
    }), C = E(() => {
      var X, me;
      return w.value && ((X = S.value) == null ? void 0 : X.type) === "link" ? (me = S.value) == null ? void 0 : me.children : [];
    }), F = E(() => t.navItems.filter(
      (X) => X.type === "mega"
    )), x = E(() => t.navItems.filter(
      (X) => X.type === "drilldown"
    )), R = E(() => {
      const X = [...b.value];
      return w.value && X.push("ds-header--secondary"), u.value === "secondaryMega" && X.push("ds-header--secondary-expanded"), u.value === "primaryMega" && X.push("ds-header--mega"), X;
    }), d = (X) => {
      X.key === "Escape" && $();
    }, $ = () => {
      s.value = !1, A();
    }, A = () => {
      u.value = "none", o.value = null, i.value = null;
    }, z = () => {
      s.value = !0;
    }, N = (X, me) => {
      z(), o.value = X, u.value = "primaryMega", f.value = me.value;
    }, j = (X, me) => {
      o.value === X ? $() : (N(X, me), l.value = me.value);
    }, Q = (X, me) => {
      var ge;
      z(), o.value = ((ge = S.value) == null ? void 0 : ge.itemId) ?? null, i.value = X, u.value = "secondaryMega", me != null && me.value && (p.value = me.value);
    }, q = () => {
      u.value != "search" ? (z(), u.value = "search", t.searchFn && t.searchFn(!0)) : u.value === "search" && ($(), t.searchFn && t.searchFn(!1));
    }, Z = ee("labels", {}), re = ee("loggedIn", L(!1)), ne = ee("ctaButtons"), ye = ee("logo", {
      href: "/",
      altText: "Coloplast",
      imageSrc: "",
      clickHandler: () => {
      }
    }), Ae = () => {
      var X, me, ge;
      (X = n.value) != null && X.parentElement && ((ge = (me = n.value) == null ? void 0 : me.parentElement) == null ? void 0 : ge.getAttribute("data-sticky-mount")) === "true" && (y.value = !0);
    };
    return he(() => {
      var me;
      const X = (me = h.value) == null ? void 0 : me.querySelectorAll(".ds-nav-item");
      if (X && X.length) {
        let ge = 0;
        for (const He of X)
          ge += He.clientWidth;
        r.value = ge;
      }
      Ae();
    }), vn(h, (X) => {
      const me = X[0], { width: ge } = me.contentRect;
      c.value = ge;
    }), le(I, (X) => {
      y.value && n.value && n.value.parentElement && n.value.parentElement.setAttribute("style", X);
    }), _e("activeMegaMenuId", o), _e("activePrimaryId", (xe = S.value) == null ? void 0 : xe.itemId), _e("activeTabId", i), _e("activeOverlayType", u), _e("primaryNextPrev", v), _e("hideBackdrop", $), _e("showBackdrop", z), _e("togglePrimaryMegaNav", j), _e("openSecondaryMegaNav", Q), _e("lastFocusedPrimaryNavItem", f), _e("lastFocusedSecondaryNavItem", p), (X, me) => {
      var ge, He, mt, Ge, lt, Pt;
      return m(), T(se, null, [
        D("header", {
          class: G(["ds-header", R.value]),
          ref_key: "header",
          ref: n,
          onShowBackdrop: z,
          onKeydown: d,
          style: Ce(I.value)
        }, [
          D("div", {
            class: "ds-header__top",
            ref_key: "headerTop",
            ref: g
          }, [
            D("div", em, [
              D("div", tm, [
                B(Pl, Lu(Mu(O(ye))), null, 16)
              ]),
              D("div", {
                ref_key: "primaryInline",
                ref: h,
                class: "ds-header__primary-inline"
              }, [
                _.value ? M("", !0) : (m(), H(Zs, {
                  key: 0,
                  navItems: X.navItems
                }, null, 8, ["navItems"]))
              ], 512),
              D("div", rm, [
                D("div", nm, [
                  X.enableSearch ? (m(), H(Ie, {
                    key: 0,
                    class: "ds-header-search",
                    onClick: q,
                    ariaLabel: ((ge = O(Z)) == null ? void 0 : ge.searchButtonLabel) ?? "Search",
                    iconName: "button-search",
                    variant: "ghost-neutral"
                  }, null, 8, ["ariaLabel"])) : M("", !0),
                  X.enableBasket ? (m(), H(Ie, {
                    key: 1,
                    class: "ds-header-basket",
                    ariaLabel: ((He = O(Z)) == null ? void 0 : He.basketButtonLabel) ?? "Basket",
                    clickHandler: X.basketFn,
                    iconName: "button-shopping-basket",
                    "notification-count": X.basketCount,
                    variant: "ghost-neutral"
                  }, null, 8, ["ariaLabel", "clickHandler", "notification-count"])) : M("", !0)
                ]),
                O(ne) ? (m(), T("div", am, [
                  O(re) && ((mt = O(ne).myAccountButtonNavItem) != null && mt.initials) && ((Ge = O(ne).myAccountButtonNavItem) != null && Ge.initials.length) ? (m(), H(rp, {
                    key: 0,
                    ariaLabel: `'${O(ne).myAccountButtonNavItem.text} - ${O(ne).myAccountButtonInitials}`,
                    onClick: O(ne).myAccountButtonFn,
                    href: O(ne).myAccountButtonNavItem.linkUrl,
                    size: "md",
                    variant: "primary"
                  }, {
                    default: V(() => [
                      K(U(O(ne).myAccountButtonNavItem.initials), 1)
                    ]),
                    _: 1
                  }, 8, ["ariaLabel", "onClick", "href"])) : O(re) && ((lt = O(ne).myAccountButtonNavItem) != null && lt.text) ? (m(), H(Ee, {
                    key: 1,
                    href: O(ne).myAccountButtonNavItem.linkUrl,
                    onClick: O(ne).myAccountButtonFn,
                    size: "sm",
                    variant: "primary"
                  }, {
                    default: V(() => {
                      var Te;
                      return [
                        K(U((Te = O(ne).myAccountButtonNavItem) == null ? void 0 : Te.text), 1)
                      ];
                    }),
                    _: 1
                  }, 8, ["href", "onClick"])) : M("", !0),
                  !O(re) && O(ne).loginButtonLabel ? (m(), H(Ee, {
                    key: 2,
                    href: O(ne).loginButtonLink,
                    onClick: O(ne).loginButtonFn,
                    size: "sm",
                    variant: "primary"
                  }, {
                    default: V(() => [
                      K(U(O(ne).loginButtonLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["href", "onClick"])) : M("", !0)
                ])) : M("", !0)
              ]),
              _.value ? (m(), T("div", sm, [
                B(Zs, { navItems: X.navItems }, null, 8, ["navItems"])
              ])) : M("", !0)
            ])
          ], 512),
          w.value ? we((m(), T("div", {
            key: 0,
            class: "ds-header__bottom",
            ref_key: "secondary",
            ref: a
          }, [
            D("div", im, [
              D("div", lm, [
                B(hp, {
                  navItems: C.value ?? []
                }, null, 8, ["navItems"])
              ])
            ])
          ], 512)), [
            [Se, !s.value]
          ]) : M("", !0),
          we(D("div", {
            class: "ds-header__mega",
            id: "meganav",
            onClick: $
          }, [
            (m(!0), T(se, null, ve(F.value, (Te) => (m(), H(Np, {
              itemId: Te.itemId,
              itemLabel: Te.text,
              "mega-nav-columns": Te.megaNavColumns,
              key: Te.text
            }, null, 8, ["itemId", "itemLabel", "mega-nav-columns"]))), 128)),
            (m(!0), T(se, null, ve(x.value, (Te) => (m(), H(Wp, {
              item: Te,
              key: Te.text
            }, null, 8, ["item"]))), 128)),
            w.value ? (m(), H(Zp, {
              key: 0,
              itemLabel: ((Pt = S.value) == null ? void 0 : Pt.text) ?? "",
              navItems: C.value ?? []
            }, null, 8, ["itemLabel", "navItems"])) : M("", !0),
            B(Jp, null, {
              default: V(() => [
                ie(X.$slots, "searchDesktop")
              ]),
              _: 3
            })
          ], 512), [
            [Se, s.value]
          ])
        ], 38),
        (m(), H(rl, { to: "body" }, [
          we(D("div", {
            onClick: $,
            class: "ds-header-backdrop"
          }, null, 512), [
            [Se, s.value]
          ])
        ]))
      ], 64);
    };
  }
}), um = { class: "ds-header-mobile__bar" }, cm = {
  key: 0,
  class: "ds-header-mobile__logo"
}, fm = {
  key: 1,
  class: "ds-header-mobile__title-bar"
}, dm = { class: "ds-header-mobile__icons" }, pm = /* @__PURE__ */ W({
  __name: "ds-header-mobile-bar",
  props: {
    isTopLevel: { type: Boolean },
    logo: {},
    enableSearch: { type: Boolean },
    enableBasket: { type: Boolean },
    basketCount: {},
    basketFn: { type: Function },
    onSearchClick: { type: Function },
    onToggleClick: { type: Function },
    onBackClick: { type: Function },
    labels: {},
    menuState: {},
    menuButtonLabel: {}
  },
  setup(e) {
    return (t, r) => {
      var n, a, s;
      return m(), T("div", um, [
        t.isTopLevel ? (m(), T("div", cm, [
          B(Pl, $e(t.logo, { size: "sm" }), null, 16)
        ])) : (m(), T("div", fm, [
          B(Ie, {
            ariaLabel: ((n = t.labels) == null ? void 0 : n.mobileMenuBackButtonLabel) ?? "Back",
            "click-handler": t.onBackClick,
            variant: "secondary-neutral",
            size: "md",
            iconName: "button-chevron-left"
          }, null, 8, ["ariaLabel", "click-handler"])
        ])),
        D("div", dm, [
          t.enableSearch && t.isTopLevel ? (m(), H(Ie, {
            key: 0,
            class: "ds-header-mobile__icon-button",
            "click-handler": t.onSearchClick,
            ariaLabel: ((a = t.labels) == null ? void 0 : a.searchButtonLabel) ?? "Search",
            "data-testid": "searchButton",
            iconName: "button-search",
            variant: "ghost-neutral"
          }, null, 8, ["click-handler", "ariaLabel"])) : M("", !0),
          t.enableBasket && t.isTopLevel ? (m(), H(Ie, {
            key: 1,
            class: "ds-header-mobile__icon-button",
            ariaLabel: ((s = t.labels) == null ? void 0 : s.basketButtonLabel) ?? "Basket",
            clickHandler: t.basketFn,
            iconName: "button-shopping-basket",
            "notification-count": t.basketCount,
            variant: "ghost-neutral"
          }, null, 8, ["ariaLabel", "clickHandler", "notification-count"])) : M("", !0),
          B(Ie, {
            class: "ds-header-mobile__toggle",
            "click-handler": t.onToggleClick,
            ariaLabel: t.menuButtonLabel,
            iconName: t.menuState === "open" || t.menuState === "search" ? "button-close" : "button-menu",
            variant: "ghost-neutral"
          }, null, 8, ["click-handler", "ariaLabel", "iconName"])
        ])
      ]);
    };
  }
}), mm = ["aria-label"], vm = { class: "ds-nav-mobile-item__label" }, ym = ["href", "target"], hm = { class: "ds-nav-mobile-item__label" }, gm = {
  key: 2,
  class: "ds-nav-mobile-item ds-nav-mobile-item--section"
}, bm = { class: "ds-nav-mobile-item__label" }, _m = 3, Dt = /* @__PURE__ */ W({
  __name: "ds-nav-mobile-item",
  props: {
    isSectionPage: { type: Boolean, default: !1 },
    level: {},
    navItem: {}
  },
  setup(e) {
    const t = e, r = ee("labels", {}), n = r.submenuLabel ? r.submenuLabel : "submenu", a = E(() => t.navItem && "linkUrl" in t.navItem && t.navItem.linkUrl !== null && typeof t.navItem.linkUrl < "u"), s = E(() => !!("linkIsExternal" in t.navItem && t.navItem.linkIsExternal)), i = E(() => a.value ? t.isSectionPage ? !0 : !(!t.isSectionPage && l.value) : !1), l = E(() => {
      var c;
      return !!("children" in t.navItem && ((c = t.navItem.children) != null && c.length));
    }), o = E(() => {
      var c;
      return !!("megaNavColumns" in t.navItem && ((c = t.navItem) != null && c.megaNavColumns.length));
    }), u = E(() => o.value || l.value && t.level < _m), f = E(() => {
      const c = [];
      return t.isSectionPage && c.push("ds-nav-mobile-item--section"), t.navItem.isActive && c.push("ds-nav-mobile-item--active"), c;
    }), p = ee("navigateLevel", (c, y = 0) => {
      console.warn("navigateLevel not implemented", { navItem: c, level: y });
    }), h = E(() => t.isSectionPage && t.navItem.mobilePageLabel && t.navItem.mobilePageLabel || t.navItem.text);
    return (c, y) => c.navItem && u.value && !c.isSectionPage ? (m(), T("button", {
      key: 0,
      "aria-label": `${c.navItem.text} ${O(n)}`,
      class: "ds-nav-mobile-item",
      onClick: y[0] || (y[0] = (g) => O(p)(c.navItem, c.level + 1))
    }, [
      D("span", vm, [
        c.navItem.iconName ? (m(), H(ae, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          iconName: c.navItem.iconName
        }, null, 8, ["iconName"])) : M("", !0),
        c.navItem.initials ? (m(), H(Y, {
          key: 1,
          class: "ds-nav-mobile-item__initials",
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-sm"
        }, {
          default: V(() => [
            K(U(c.navItem.initials), 1)
          ]),
          _: 1
        })) : M("", !0),
        B(Y, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: V(() => [
            K(U(c.navItem.text), 1)
          ]),
          _: 1
        })
      ]),
      u.value ? (m(), H(ae, {
        key: 0,
        class: "ds-nav-mobile-item__chevron",
        size: "md",
        iconName: "chevron-right"
      })) : M("", !0)
    ], 8, mm)) : c.navItem && "linkUrl" in c.navItem && i.value ? (m(), T("a", {
      key: 1,
      class: G(["ds-nav-mobile-item", f.value]),
      href: c.navItem.linkUrl,
      target: c.navItem.linkTarget
    }, [
      D("span", hm, [
        c.navItem.iconName ? (m(), H(ae, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          iconName: c.navItem.iconName
        }, null, 8, ["iconName"])) : M("", !0),
        c.navItem.initials && !c.isSectionPage ? (m(), H(Y, {
          key: 1,
          class: "ds-nav-mobile-item__initials",
          "html-element": "span",
          "text-style": "medium",
          "text-type": "label-sm"
        }, {
          default: V(() => [
            K(U(c.navItem.initials), 1)
          ]),
          _: 1
        })) : M("", !0),
        B(Y, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: V(() => [
            K(U(h.value), 1)
          ]),
          _: 1
        }),
        !c.isSectionPage && s.value ? (m(), H(ae, {
          key: 2,
          class: "ds-nav-mobile-item__external",
          "icon-name": "button-external-link",
          size: "md"
        })) : M("", !0),
        c.isSectionPage ? (m(), H(ae, {
          key: 3,
          class: "ds-nav-mobile-item__navigate",
          "icon-name": "button-navigate-forward",
          size: "md"
        })) : M("", !0)
      ])
    ], 10, ym)) : c.navItem && c.isSectionPage ? (m(), T("div", gm, [
      D("span", bm, [
        c.navItem.iconName ? (m(), H(ae, {
          key: 0,
          class: "ds-nav-mobile-item__icon",
          size: "lg",
          iconName: c.navItem.iconName
        }, null, 8, ["iconName"])) : M("", !0),
        B(Y, {
          "text-type": "label-lg",
          "text-style": "medium",
          "html-element": "span"
        }, {
          default: V(() => [
            K(U(h.value), 1)
          ]),
          _: 1
        })
      ])
    ])) : M("", !0);
  }
}), $m = ["aria-label"], km = { class: "ds-nav-mobile__group" }, wm = {
  key: 0,
  class: "ds-nav-mobile__filter"
}, Sm = {
  key: 2,
  class: "ds-nav-mobile__cards"
}, sa = /* @__PURE__ */ W({
  __name: "ds-nav-mobile-level",
  props: {
    activeParent: {},
    level: {}
  },
  setup(e) {
    const t = e, r = [
      "link",
      "dropdown",
      "service",
      "drilldown",
      "popover"
    ], n = (u) => {
      var f;
      return !!u && r.includes(u.type) && "children" in u && !!((f = u.children) != null && f.length);
    }, a = E(() => n(t.activeParent) ? t.activeParent : null), s = L(""), i = E(() => {
      var u, f, p;
      return ((u = t.activeParent) == null ? void 0 : u.type) === "popover" && ((f = t.activeParent) != null && f.filterEnabled) ? t.activeParent.children.filter(
        (h) => {
          var c;
          return h.text.toLowerCase().indexOf(s.value.toLowerCase()) > -1 || h.textAlternative && ((c = h.textAlternative) == null ? void 0 : c.toLowerCase().indexOf(s.value.toLowerCase())) > -1;
        }
      ) : t.activeParent && "children" in t.activeParent ? (p = t.activeParent) == null ? void 0 : p.children : [];
    }), l = E(() => a.value !== null && "titleBlock" in a.value && typeof a.value.titleBlock < "u" && a.value.titleBlock !== null), o = E(() => {
      var u, f;
      if (l.value) {
        const p = a.value;
        return {
          itemId: `${p.itemId}-title`,
          linkUrl: ((u = p.titleBlock) == null ? void 0 : u.content.linkUrl) ?? "#",
          text: ((f = p.titleBlock) == null ? void 0 : f.content.linkText) ?? "",
          type: "link"
        };
      }
      return null;
    });
    return (u, f) => {
      const p = nl("FormKit");
      return m(), H(ft, { name: "persist" }, {
        default: V(() => {
          var h;
          return [
            u.activeParent ? (m(), T("div", {
              key: 0,
              class: G(`ds-nav-mobile__level ds-nav-mobile__level${u.level}`)
            }, [
              f[1] || (f[1] = D("div", { class: "ds-nav-mobile__title-bar" }, null, -1)),
              n(u.activeParent) ? (m(), T("section", {
                key: 0,
                "aria-label": u.activeParent.text,
                class: "ds-nav-mobile__nav"
              }, [
                o.value ? (m(), H(Dt, {
                  key: 0,
                  level: u.level,
                  navItem: o.value,
                  "is-section-page": !0
                }, null, 8, ["level", "navItem"])) : a.value !== null ? (m(), H(Dt, {
                  key: 1,
                  level: u.level,
                  navItem: a.value,
                  "is-section-page": !0
                }, null, 8, ["level", "navItem"])) : M("", !0),
                D("div", km, [
                  u.activeParent.type === "popover" && u.activeParent.filterEnabled ? (m(), T("div", wm, [
                    B(p, {
                      type: "search",
                      "prefix-icon": "search",
                      placeholder: u.activeParent.filterPlaceholder,
                      modelValue: s.value,
                      "onUpdate:modelValue": f[0] || (f[0] = (c) => s.value = c)
                    }, null, 8, ["placeholder", "modelValue"]),
                    u.activeParent.filterNoResultsLabel && i.value && i.value.length === 0 ? (m(), H(Y, {
                      key: 0,
                      class: "ds-nav-popover__no-results",
                      "html-element": "div",
                      "text-type": "label-sm"
                    }, {
                      default: V(() => [
                        K(U(u.activeParent.filterNoResultsLabel), 1)
                      ]),
                      _: 1
                    })) : M("", !0)
                  ])) : M("", !0),
                  (m(!0), T(se, null, ve(i.value, (c) => (m(), H(Dt, {
                    key: c.text,
                    level: u.level,
                    navItem: c
                  }, null, 8, ["level", "navItem"]))), 128))
                ]),
                "cards" in u.activeParent ? (m(), T("div", Sm, [
                  (m(!0), T(se, null, ve((h = u.activeParent.cards) == null ? void 0 : h.slice(0, 2), (c) => (m(), H(yn, $e({ ref_for: !0 }, c, {
                    key: c.title
                  }), null, 16))), 128))
                ])) : M("", !0)
              ], 8, $m)) : M("", !0)
            ], 2)) : M("", !0)
          ];
        }),
        _: 1
      });
    };
  }
}), Pm = {
  key: 0,
  class: "ds-nav-mobile-service"
}, Im = /* @__PURE__ */ W({
  __name: "ds-nav-mobile-service",
  setup(e) {
    const t = ee("loggedIn", !1), r = ee("countrySelector"), n = ee("ctaButtons"), a = ee("serviceNavItems", []), s = n && n.myAccountButtonNavItem ? {
      ...n.myAccountButtonNavItem,
      type: "service"
    } : null, i = E(
      () => {
        var l;
        if (r && "countryList" in r && "headline" in r)
          return {
            iconName: "globe",
            itemId: "select-country",
            children: (l = r == null ? void 0 : r.countryList) == null ? void 0 : l.map(
              (o, u) => ({
                itemId: o.language || `country-${u}`,
                linkUrl: o.url,
                text: o.name,
                type: "service"
              })
            ),
            text: r == null ? void 0 : r.headline,
            type: "service"
          };
      }
    );
    return (l, o) => {
      var u;
      return O(t) || O(a) && ((u = O(a)) != null && u.length) || i.value ? (m(), T("div", Pm, [
        O(t) && O(n) && O(s) ? (m(), H(Dt, {
          key: 0,
          level: 0,
          navItem: O(s)
        }, null, 8, ["navItem"])) : M("", !0),
        i.value ? (m(), H(Dt, {
          key: 1,
          level: 0,
          navItem: i.value
        }, null, 8, ["navItem"])) : M("", !0),
        (m(!0), T(se, null, ve(O(a), (f) => (m(), H(Dt, {
          level: 0,
          key: f == null ? void 0 : f.text,
          navItem: f
        }, null, 8, ["navItem"]))), 128))
      ])) : M("", !0);
    };
  }
}), Cm = { class: "ds-nav-mobile" }, Em = ["inert"], Am = { class: "ds-nav-mobile__nav" }, Tm = { class: "ds-nav-mobile__group" }, Lm = { class: "ds-nav-mobile__service" }, Mm = {
  key: 0,
  class: "ds-nav-mobile__cta"
}, Om = /* @__PURE__ */ W({
  __name: "ds-nav-mobile",
  props: {
    navItems: {}
  },
  setup(e) {
    const t = L(null), r = ee("mobileMenuLevel", L(0)), n = ee("activeItems", L([])), a = ee("ctaButtons"), s = ee("loggedIn", !1), i = E(
      () => (a == null ? void 0 : a.loginButtonLabel) || (a == null ? void 0 : a.logoutButtonLabel) || !1
    );
    return le(n.value, () => {
      t.value && t.value.scrollTo(0, 0);
    }), (l, o) => (m(), T("div", Cm, [
      D("div", {
        class: "ds-nav-mobile__scroll",
        ref_key: "scroll",
        ref: t
      }, [
        D("div", {
          class: G(["ds-nav-mobile__levels", `ds-nav-mobile__levels--level${O(r)}`])
        }, [
          D("div", {
            class: "ds-nav-mobile__level ds-nav-mobile__level0",
            inert: O(r) !== 0 ? "true" : void 0
          }, [
            D("div", Am, [
              D("div", Tm, [
                (m(!0), T(se, null, ve(l.navItems, (u) => (m(), H(Dt, {
                  level: 0,
                  key: u.text,
                  navItem: u
                }, null, 8, ["navItem"]))), 128))
              ])
            ]),
            D("div", Lm, [
              B(Im)
            ])
          ], 8, Em),
          B(sa, {
            activeParent: O(n)[0],
            inert: O(r) !== 1 ? "true" : void 0,
            level: 1
          }, null, 8, ["activeParent", "inert"]),
          B(sa, {
            activeParent: O(n)[1],
            inert: O(r) !== 2 ? "true" : void 0,
            level: 2
          }, null, 8, ["activeParent", "inert"]),
          B(sa, {
            activeParent: O(n)[2],
            inert: O(r) !== 3 ? "true" : void 0,
            level: 3
          }, null, 8, ["activeParent", "inert"])
        ], 2)
      ], 512),
      i.value && O(a) ? (m(), T("div", Mm, [
        B(bl, null, {
          default: V(() => [
            !O(s) && O(a).loginButtonLabel ? (m(), H(Ee, {
              key: 0,
              "click-handler": O(a).loginButtonFn,
              href: O(a).loginButtonLink,
              variant: "primary"
            }, {
              default: V(() => [
                K(U(O(a).loginButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["click-handler", "href"])) : M("", !0),
            O(s) && O(a).logoutButtonLabel ? (m(), H(Ee, {
              key: 1,
              "click-handler": O(a).logoutButtonFn,
              href: O(a).logoutButtonLink,
              variant: "secondary"
            }, {
              default: V(() => [
                K(U(O(a).logoutButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["click-handler", "href"])) : M("", !0)
          ]),
          _: 1
        })
      ])) : M("", !0)
    ]));
  }
}), Nm = (e, t) => e.flatMap(
  (r) => r.type === "linkList" ? [
    {
      itemId: `${t}-${r.content.categoryTitle}`,
      text: r.content.categoryTitle,
      linkUrl: void 0,
      type: "link",
      children: r.content.links.map((n) => ({
        itemId: `${t}-${n.linkText}`,
        linkUrl: n.linkUrl,
        linkIsExternal: n.linkIsExternal,
        linkTarget: n.linkTarget,
        text: n.linkText,
        type: "link"
      }))
    }
  ] : []
), Fm = (e) => (e == null ? void 0 : e.content.cards) ?? [], El = (e) => {
  const t = Nm(e.megaNavColumns, e.itemId), r = e.megaNavColumns.find(
    (a) => a.type === "titleBlock"
  ), n = e.megaNavColumns.find(
    (a) => a.type === "promo"
  );
  return {
    itemId: e.itemId,
    text: e.text,
    type: "drilldown",
    mobilePageLabel: "mobilePageLabel" in e ? e.mobilePageLabel : void 0,
    children: t,
    titleBlock: r,
    cards: Fm(n)
  };
}, Dm = (e) => El(e), Rm = (e) => El(e), xm = ["aria-label", "role"], Hm = {
  key: 0,
  class: "ds-header-mobile__nav"
}, zm = { class: "ds-header-mobile__search" }, Vm = /* @__PURE__ */ W({
  __name: "ds-header-mobile",
  props: {
    basketCount: {},
    basketFn: {},
    countrySelector: {},
    enableBasket: { type: Boolean },
    enableSearch: { type: Boolean },
    enableSticky: { type: Boolean, default: !0 },
    inertTargetSelector: {},
    navItems: {},
    searchFn: {}
  },
  setup(e) {
    const t = e, r = ee("logo", {
      href: "/",
      altText: "Coloplast",
      imageSrc: "",
      clickHandler: () => {
      }
    }), n = L(null), a = L(!1), s = L("closed"), { dynamicClasses: i, headerHeight: l } = Cl(
      {
        enableSticky: t.enableSticky
      },
      n,
      L(null),
      "ds-header-mobile"
    ), o = E(() => s.value !== "closed" ? "dialog" : void 0), u = E(() => `--header-height: ${l.value};`), f = E(() => s.value === "open" ? (_ == null ? void 0 : _.mobileMenuButtonCloseLabel) ?? "Close menu" : (_ == null ? void 0 : _.mobileMenuButtonOpenLabel) ?? "Open menu"), p = E(() => {
      const C = [];
      s.value === "open" && C.push("ds-header-mobile--open"), s.value === "search" && C.push("ds-header-mobile--search");
      for (const F of i.value)
        C.push(F);
      return C;
    }), h = E(() => t.navItems.map((C) => {
      var x;
      const F = { ...C };
      return F.type === "mega" ? Dm(F) : (F.type === "link" && ((x = F.children) != null && x.some((R) => R.type === "secondary")) && (F.children = F.children.map((R) => R.type === "secondary" ? Rm(
        R
      ) : R)), F);
    })), c = async (C) => {
      if (C.key === "Escape" && (s.value = "closed", b(), n.value)) {
        const F = n.value.querySelector(
          ".ds-header-mobile__toggle"
        );
        F && (await at(), F.focus());
      }
    }, y = () => {
      s.value !== "search" ? (s.value = "search", t.searchFn && t.searchFn(!0)) : s.value === "search" && (s.value = "closed", t.searchFn && t.searchFn(!1));
    }, g = () => {
      s.value === "closed" ? s.value = "open" : (s.value === "open" || s.value === "search") && (s.value = "closed"), b();
    }, b = () => {
      P.value = 0, k.value = [];
    }, k = L([]), P = L(0), I = (C, F = 0) => {
      k.value.length < F && C ? k.value.push(C) : k.value.pop(), P.value = F;
    }, _ = ee("labels", {}), S = _.mobileMenuLabel ? _.mobileMenuLabel : "Mobile menu";
    _e("navigateLevel", I), _e("mobileMenuLevel", P), _e("activeItems", k), _e("countrySelector", t.countrySelector);
    const v = () => {
      var C, F, x;
      (C = n.value) != null && C.parentElement && ((x = (F = n.value) == null ? void 0 : F.parentElement) == null ? void 0 : x.getAttribute("data-sticky-mount")) === "true" && (a.value = !0);
    }, w = (C) => {
      const F = document.querySelectorAll(
        t.inertTargetSelector
      );
      C ? F.forEach((x) => {
        x.setAttribute("inert", "true");
      }) : F.forEach((x) => {
        x.removeAttribute("inert");
      });
    };
    return he(() => {
      v();
    }), qe(() => {
      document.documentElement.classList.remove("ds-nav-open"), w(!1);
    }), le(s, (C) => {
      C === "open" || C === "search" ? (document.documentElement.classList.add("ds-nav-open"), w(!0)) : (document.documentElement.classList.remove("ds-nav-open"), w(!1));
    }), le(u, (C) => {
      a.value && n.value && n.value.parentElement && n.value.parentElement.setAttribute("style", C);
    }), (C, F) => (m(), T("header", {
      "aria-label": O(S),
      class: G(["ds-header-mobile", p.value]),
      role: o.value,
      ref_key: "header",
      ref: n,
      style: Ce(u.value),
      onKeydown: c
    }, [
      B(pm, {
        isTopLevel: P.value === 0,
        logo: O(r),
        enableSearch: C.enableSearch,
        enableBasket: C.enableBasket,
        basketCount: C.basketCount,
        basketFn: C.basketFn,
        onSearchClick: y,
        onToggleClick: g,
        onBackClick: () => I(null, P.value - 1),
        labels: O(_),
        menuState: s.value,
        menuButtonLabel: f.value
      }, null, 8, ["isTopLevel", "logo", "enableSearch", "enableBasket", "basketCount", "basketFn", "onBackClick", "labels", "menuState", "menuButtonLabel"]),
      s.value === "open" ? (m(), T("div", Hm, [
        B(Om, { navItems: h.value }, null, 8, ["navItems"])
      ])) : M("", !0),
      we(D("div", zm, [
        ie(C.$slots, "searchMobile")
      ], 512), [
        [Se, s.value === "search"]
      ])
    ], 46, xm));
  }
}), iS = /* @__PURE__ */ W({
  __name: "ds-header",
  props: {
    basketCount: { default: 0 },
    basketFn: {},
    ctaButtons: {},
    enableBasket: { type: Boolean, default: !0 },
    enableSearch: { type: Boolean, default: !0 },
    enableSticky: { type: Boolean, default: !0 },
    inertTargetSelector: { default: "body > main" },
    labels: {},
    logo: {},
    loggedIn: { type: Boolean, default: !1 },
    navItems: {},
    searchFn: {},
    serviceNavItems: {},
    countrySelector: {}
  },
  setup(e) {
    const t = e, r = L(!1);
    he(() => {
      r.value = !0;
    }), _e("ctaButtons", t.ctaButtons), _e("labels", t.labels), _e("loggedIn", t.loggedIn), _e("serviceNavItems", t.serviceNavItems), _e("logo", t.logo);
    const { isMobile: n } = Fe();
    return (a, s) => (m(), T(se, null, [
      !O(n) && r.value ? (m(), H(om, {
        key: 0,
        "basket-count": a.basketCount,
        "basket-fn": a.basketFn,
        "enable-basket": a.enableBasket,
        "enable-search": a.enableSearch,
        "enable-sticky": a.enableSticky,
        "nav-items": a.navItems,
        "search-fn": a.searchFn
      }, {
        searchDesktop: V(() => [
          ie(a.$slots, "searchDesktop")
        ]),
        _: 3
      }, 8, ["basket-count", "basket-fn", "enable-basket", "enable-search", "enable-sticky", "nav-items", "search-fn"])) : M("", !0),
      O(n) && r.value ? (m(), H(Vm, {
        key: 1,
        "basket-count": a.basketCount,
        "basket-fn": a.basketFn,
        "country-selector": a.countrySelector,
        "enable-basket": a.enableBasket,
        "enable-search": a.enableSearch,
        "inert-target-selector": a.inertTargetSelector,
        "nav-items": a.navItems,
        "search-fn": a.searchFn
      }, {
        searchMobile: V(() => [
          ie(a.$slots, "searchMobile")
        ]),
        _: 3
      }, 8, ["basket-count", "basket-fn", "country-selector", "enable-basket", "enable-search", "inert-target-selector", "nav-items", "search-fn"])) : M("", !0),
      r.value ? M("", !0) : ie(a.$slots, "default", { key: 2 })
    ], 64));
  }
});
var Al = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function Vn() {
  return Math.random().toString(36).substring(2, 15);
}
function Bm(e, t) {
  return [...e instanceof Set ? e : new Set(e)];
}
function be(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function nt(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return jm(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const a of n)
      if ((a in e || a in t) && e[a] !== t[a])
        return !1;
    for (const a in e)
      if (!(a in t) || e[a] !== t[a] && !r || r && !nt(e[a], t[a], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function jm(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function Qt(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function hn(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Pr(e) {
  return hn(e) || Array.isArray(e);
}
function ir(e) {
  if (hn(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(hn(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
var Ct = /* @__NO_SIDE_EFFECTS__ */ (e, t, r = !1, n = !1) => {
  if (t === null)
    return null;
  const a = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (be(t, s) && (t[s] !== void 0 || !n)) {
      if (r && Array.isArray(e[s]) && Array.isArray(t[s])) {
        a[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      ir(e[s]) && ir(t[s]) ? a[s] = /* @__PURE__ */ Ct(
        e[s],
        t[s],
        r,
        n
      ) : a[s] = t[s];
    } else
      a[s] = e[s];
  for (const s in t)
    !be(a, s) && t[s] !== void 0 && (a[s] = t[s]);
  return a;
};
function qm(e) {
  if (e[0] !== '"' && e[0] !== "'" || e[0] !== e[e.length - 1])
    return !1;
  const t = e[0];
  for (let r = 1; r < e.length; r++)
    if (e[r] === t && (r === 1 || e[r - 1] !== "\\") && r !== e.length - 1)
      return !1;
  return !0;
}
function Wm(e) {
  if (!e.length)
    return "";
  let t = "", r = "";
  for (let n = 0; n < e.length; n++) {
    const a = e.charAt(n);
    (a !== "\\" || r === "\\") && (t += a), r = a;
  }
  return t;
}
function jt(...e) {
  return e.reduce((t, r) => {
    const { value: n, name: a, modelValue: s, config: i, plugins: l, ...o } = r;
    return Object.assign(t, o);
  }, {});
}
function Um(e) {
  const t = [];
  let r = "", n = 0, a = "", s = "";
  for (let i = 0; i < e.length; i++) {
    const l = e.charAt(i);
    l === a && s !== "\\" ? a = "" : (l === "'" || l === '"') && !a && s !== "\\" ? a = l : l === "(" && !a ? n++ : l === ")" && !a && n--, l === "," && !a && n === 0 ? (t.push(r), r = "") : (l !== " " || a) && (r += l), s = l;
  }
  return r && t.push(r), t;
}
function Js(e, t) {
  const r = {}, n = t.filter((s) => s instanceof RegExp), a = new Set(t);
  for (const s in e)
    !a.has(s) && !n.some((i) => i.test(s)) && (r[s] = e[s]);
  return r;
}
function ei(e, t) {
  const r = {}, n = t.filter((a) => a instanceof RegExp);
  return t.forEach((a) => {
    a instanceof RegExp || (r[a] = e[a]);
  }), Object.keys(e).forEach((a) => {
    n.some((s) => s.test(a)) && (r[a] = e[a]);
  }), r;
}
function Zt(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, r) => r.toUpperCase()
  );
}
function Tl(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, r, n) => r + "-" + n.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function wa(e, t = Al) {
  if (e !== null && typeof e == "object") {
    let r;
    if (Array.isArray(e) ? r = [...e] : ir(e) && (r = { ...e }), r)
      return Ym(e, r, t), r;
  }
  return e;
}
function Lr(e, t = Al) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let r;
  Array.isArray(e) ? r = e.map((n) => typeof n == "object" ? Lr(n, t) : n) : r = Object.keys(e).reduce((n, a) => (n[a] = typeof e[a] == "object" ? Lr(e[a], t) : e[a], n), {});
  for (const n of t)
    n in e && Object.defineProperty(r, n, {
      enumerable: !1,
      value: e[n]
    });
  return r;
}
function xt(e) {
  return typeof e == "object" ? Lr(e) : e;
}
function Km(e, t) {
  if (!e || typeof e != "object")
    return null;
  const r = t.split(".");
  let n = e;
  for (const a in r) {
    const s = r[a];
    if (be(n, s) && (n = n[s]), +a === r.length - 1)
      return n;
    if (!n || typeof n != "object")
      return null;
  }
  return null;
}
function tt(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function lr(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function hs(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function Ym(e, t, r) {
  for (const n of r)
    n in e && Object.defineProperty(t, n, {
      enumerable: !1,
      value: e[n]
    });
  return t;
}
function Gm(e) {
  let t = !1;
  return (...r) => {
    if (!t)
      return t = !0, queueMicrotask(() => t = !1), e(...r);
  };
}
function Qm(e) {
  if (!(e === "false" || e === !1))
    return !0;
}
function gs() {
  const e = [];
  let t = 0;
  const r = (a) => e.push(a), n = (a) => {
    const s = e[t];
    return typeof s == "function" ? s(a, (i) => (t++, n(i))) : (t = 0, a);
  };
  return r.dispatch = n, r.unshift = (a) => e.unshift(a), r.remove = (a) => {
    const s = e.indexOf(a);
    s > -1 && e.splice(s, 1);
  }, r;
}
function Ll() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r;
  const n = (a, s) => {
    if (r) {
      r.set(s.name, [a, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((i) => {
      (s.origin === a || i.modifiers.includes("deep")) && i.listener(s);
    }), s.bubble && a.bubble(s);
  };
  return n.flush = () => {
    e.clear(), t.clear(), r == null || r.clear();
  }, n.on = (a, s, i = "push") => {
    const [l, ...o] = a.split("."), u = s.receipt || Vn(), f = {
      modifiers: o,
      event: l,
      listener: s,
      receipt: u
    };
    return e.has(l) ? e.get(l)[i](f) : e.set(l, [f]), t.has(u) ? t.get(u)[i](l) : t.set(u, [l]), u;
  }, n.off = (a) => {
    var s;
    t.has(a) && ((s = t.get(a)) == null || s.forEach((i) => {
      const l = e.get(i);
      Array.isArray(l) && e.set(
        i,
        l.filter((o) => o.receipt !== a)
      );
    }), t.delete(a));
  }, n.pause = (a) => {
    r || (r = /* @__PURE__ */ new Map()), a && a.walk((s) => s._e.pause());
  }, n.play = (a) => {
    if (!r)
      return;
    const s = r;
    r = void 0, s.forEach(([i, l]) => n(i, l)), a && a.walk((i) => i._e.play());
  }, n;
}
function Zm(e, t, r, n, a = !0, s) {
  return t._e(e, {
    payload: n,
    name: r,
    bubble: a,
    origin: e,
    meta: s
  }), e;
}
function Xm(e, t, r) {
  return Bn(e.parent) && e.parent._e(e.parent, r), e;
}
function Jm(e, t, r, n, a) {
  return t._e.on(r, n, a);
}
function ev(e, t, r) {
  return t._e.off(r), e;
}
var Ml = gs();
Ml((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var Ol = gs();
Ol((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const r = t(e);
  return console && typeof console.warn == "function" && console.warn(r.message), r;
});
function Br(e, t = {}) {
  Ol.dispatch({ code: e, data: t });
}
function Be(e, t = {}) {
  throw Error(Ml.dispatch({ code: e, data: t }).message);
}
function _t(e, t) {
  return {
    blocking: !1,
    key: Vn(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
var ti = {
  apply: iv,
  set: rv,
  remove: Nl,
  filter: av,
  reduce: sv,
  release: uv,
  touch: nv
};
function tv(e = !1) {
  const t = {};
  let r, n = e, a = [];
  const s = /* @__PURE__ */ new Map();
  let i;
  const l = new Proxy(t, {
    get(...o) {
      const [u, f] = o;
      return f === "buffer" ? n : f === "_b" ? a : f === "_m" ? s : f === "_r" ? i : be(ti, f) ? ti[f].bind(
        null,
        t,
        l,
        r
      ) : Reflect.get(...o);
    },
    set(o, u, f) {
      return u === "_n" ? (r = f, i === "__n" && Fl(r, l), !0) : u === "_b" ? (a = f, !0) : u === "buffer" ? (n = f, !0) : u === "_r" ? (i = f, !0) : (Be(101, r), !1);
    }
  });
  return l;
}
function rv(e, t, r, n) {
  if (t.buffer)
    return t._b.push([[n]]), t;
  if (e[n.key] !== n) {
    if (typeof n.value == "string" && n.meta.localize !== !1) {
      const s = n.value;
      n.value = r.t(n), n.value !== s && (n.meta.locale = r.props.locale);
    }
    const a = `message-${be(e, n.key) ? "updated" : "added"}`;
    e[n.key] = Object.freeze(
      r.hook.message.dispatch(n)
    ), r.emit(a, n);
  }
  return t;
}
function nv(e, t) {
  for (const r in e) {
    const n = { ...e[r] };
    t.set(n);
  }
}
function Nl(e, t, r, n) {
  if (be(e, n)) {
    const a = e[n];
    delete e[n], r.emit("message-removed", a);
  }
  return t.buffer === !0 && (t._b = t._b.filter((a) => (a[0] = a[0].filter((s) => s.key !== n), a[1] || a[0].length))), t;
}
function av(e, t, r, n, a) {
  for (const s in e) {
    const i = e[s];
    (!a || i.type === a) && !n(i) && Nl(e, t, r, s);
  }
}
function sv(e, t, r, n, a) {
  for (const s in e) {
    const i = e[s];
    a = n(a, i);
  }
  return a;
}
function iv(e, t, r, n, a) {
  if (Array.isArray(n)) {
    if (t.buffer) {
      t._b.push([n, a]);
      return;
    }
    const s = new Set(
      n.map((i) => (t.set(i), i.key))
    );
    typeof a == "string" ? t.filter(
      (i) => i.type !== a || s.has(i.key)
    ) : typeof a == "function" && t.filter((i) => !a(i) || s.has(i.key));
  } else
    for (const s in n) {
      const i = r.at(s);
      i ? i.store.apply(n[s], a) : ov(r, t, s, n[s], a);
    }
}
function lv(e, ...t) {
  const r = `${e.name}-set`, n = (a) => /* @__PURE__ */ _t({
    key: hs(a),
    type: "error",
    value: a,
    meta: { source: r, autoClear: !0 }
  });
  return t.filter((a) => !!a).map((a) => {
    if (typeof a == "string" && (a = [a]), Array.isArray(a))
      return a.map((s) => n(s));
    {
      const s = {};
      for (const i in a)
        Array.isArray(a[i]) ? s[i] = a[i].map(
          (l) => n(l)
        ) : s[i] = [n(a[i])];
      return s;
    }
  });
}
function ov(e, t, r, n, a) {
  var i;
  const s = t._m;
  s.has(r) || s.set(r, []), t._r || (t._r = Fl(e, t)), (i = s.get(r)) == null || i.push([n, a]);
}
function Fl(e, t) {
  return e.on(
    "child.deep",
    ({ payload: r }) => {
      t._m.forEach((n, a) => {
        e.at(a) === r && (n.forEach(([s, i]) => {
          r.store.apply(s, i);
        }), t._m.delete(a));
      }), t._m.size === 0 && t._r && (e.off(t._r), t._r = void 0);
    }
  );
}
function uv(e, t) {
  t.buffer = !1, t._b.forEach(([r, n]) => t.apply(r, n)), t._b = [];
}
function cv() {
  const e = {};
  let t;
  return {
    count: (...r) => fv(t, e, ...r),
    init(r) {
      t = r, r.on("message-added.deep", ri(e, 1)), r.on("message-removed.deep", ri(e, -1));
    },
    merge: (r) => ni(t, e, r),
    settled(r) {
      return be(e, r) ? e[r].promise : Promise.resolve();
    },
    unmerge: (r) => ni(t, e, r, !0),
    value(r) {
      return be(e, r) ? e[r].count : 0;
    }
  };
}
function fv(e, t, r, n, a = 0) {
  if (n = dv(n || r), !be(t, r)) {
    const s = {
      condition: n,
      count: 0,
      name: r,
      node: e,
      promise: Promise.resolve(),
      resolve: () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    };
    t[r] = s, a = e.store.reduce(
      (i, l) => i + s.condition(l) * 1,
      a
    ), e.each((i) => {
      i.ledger.count(s.name, s.condition), a += i.ledger.value(s.name);
    });
  }
  return Dl(t[r], a).promise;
}
function dv(e) {
  return typeof e == "function" ? e : (t) => t.type === e;
}
function Dl(e, t) {
  const r = e.count, n = e.count + t;
  return e.count = n, r === 0 && n !== 0 ? (e.node.emit(`unsettled:${e.name}`, e.count, !1), e.promise = new Promise((a) => e.resolve = a)) : r !== 0 && n === 0 && (e.node.emit(`settled:${e.name}`, e.count, !1), e.resolve()), e.node.emit(`count:${e.name}`, e.count, !1), e;
}
function ri(e, t) {
  return (r) => {
    for (const n in e) {
      const a = e[n];
      a.condition(r.payload) && Dl(a, t);
    }
  };
}
function ni(e, t, r, n = !1) {
  const a = e;
  for (const s in t) {
    const i = t[s].condition;
    n || r.ledger.count(s, i);
    const l = r.ledger.value(s) * (n ? -1 : 1);
    if (e) {
      do
        e.ledger.count(s, i, l), e = e.parent;
      while (e);
      e = a;
    }
  }
}
var bs = /* @__PURE__ */ new Map(), Zr = /* @__PURE__ */ new Map(), _s = Ll();
function pv(e) {
  e.props.id && (bs.set(e.props.id, e), Zr.set(e, e.props.id), _s(e, {
    payload: e,
    name: e.props.id,
    bubble: !1,
    origin: e
  }));
}
function mv(e) {
  if (Zr.has(e)) {
    const t = Zr.get(e);
    Zr.delete(e), bs.delete(t), _s(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function Rl(e) {
  return bs.get(e);
}
function vv(e, t) {
  return _s.on(e, t);
}
function ai(e, t, r) {
  let n = !0;
  return t in e.config._t ? n = !1 : e.emit(`config:${t}`, r, !1), t in e.props || (e.emit("prop", { prop: t, value: r }), e.emit(`prop:${t}`, r)), n;
}
function yv(e, t) {
  const r = (t || document).getElementById(e);
  if (r instanceof HTMLFormElement) {
    const n = new Event("submit", { cancelable: !0, bubbles: !0 });
    r.dispatchEvent(n);
    return;
  }
  Br(151, e);
}
function hv(e) {
  const t = (r) => {
    for (const n in r.store) {
      const a = r.store[n];
      a.type === "error" || a.type === "ui" && n === "incomplete" ? r.store.remove(n) : a.type === "state" && r.store.set({ ...a, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function gv(e, t) {
  const r = typeof e == "string" ? Rl(e) : e;
  if (r) {
    const n = (i) => {
      const l = xt(i.props.initial);
      return l !== void 0 ? l : i.type === "group" ? {} : i.type === "list" ? [] : void 0;
    };
    r._e.pause(r);
    const a = xt(t);
    return t && !Qt(t) && (r.props.initial = Pr(a) ? lr(a) : a, r.props._init = r.props.initial), r.input(n(r), !1), r.walk((i) => {
      i.type === "list" && i.sync || i.input(n(i), !1);
    }), r.input(
      Qt(a) && a ? a : n(r),
      !1
    ), r.type !== "input" && t && !Qt(t) && Pr(t) && r.walk((i) => {
      i.props.initial = Pr(i.value) ? lr(i.value) : i.value, i.props._init = i.props.initial;
    }), r._e.play(r), hv(r), r.emit("reset", r), r;
  }
  Br(152, e);
}
var bv = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${Tl(e)}`]: !0 })
}, xl = Symbol("index"), Sa = Symbol("removed"), Pa = Symbol("moved"), Hl = Symbol("inserted");
function _v(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Bn(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var Xr = (e, t, r) => {
  Be(102, [e, r]);
}, $v = {
  _c: ue(Bv, Xr, !1),
  add: ue(Nv),
  addProps: ue(Ov),
  address: ue(qv, Xr, !1),
  at: ue(Wv),
  bubble: ue(Xm),
  clearErrors: ue(ey),
  calm: ue(Tv),
  config: ue(!1),
  define: ue(Mv),
  disturb: ue(Av),
  destroy: ue(Lv),
  extend: ue(ry),
  hydrate: ue(Cv),
  index: ue(Vv, zv, !1),
  input: ue(Bl),
  each: ue(Rv),
  emit: ue(Zm),
  find: ue(Kv),
  on: ue(Jm),
  off: ue(ev),
  parent: ue(!1, Fv),
  plugins: ue(!1),
  remove: ue(Dv),
  root: ue(Gv, Xr, !1),
  reset: ue(Xv),
  resetConfig: ue(Hv),
  setErrors: ue(Jv),
  submit: ue(Zv),
  t: ue(Qv),
  use: ue($s),
  name: ue(jv, !1, !1),
  walk: ue(xv)
};
function kv() {
  return new Map(Object.entries($v));
}
function ue(e, t, r = !0) {
  return {
    get: e ? (n, a) => r ? (...s) => e(n, a, ...s) : e(n, a) : !1,
    set: t !== void 0 ? t : Xr.bind(null)
  };
}
function wv() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    get(t, r) {
      return e.has(r) || e.set(r, gs()), e.get(r);
    }
  });
}
var zl = 0, Sv = 0;
function Pv(e) {
  var t, r;
  return ((t = e.parent) == null ? void 0 : t.type) === "list" ? xl : e.name || `${((r = e.props) == null ? void 0 : r.type) || "input"}_${++zl}`;
}
function Vl(e) {
  return e.type === "group" ? lr(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? lr(Array.isArray(e.value) ? e.value : []) : e.value;
}
function Bl(e, t, r, n = !0) {
  return t._value = Iv(e, e.hook.input.dispatch(r)), e.emit("input", t._value), e.isCreated && e.type === "input" && nt(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), n ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    gn,
    e.props.delay,
    e,
    t
  )) : gn(e, t), t.settled);
}
function Iv(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && Be(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || Be(108, [e, t]);
      break;
  }
  return t;
}
function gn(e, t, r = !0, n = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && n && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), r && e.calm();
}
function jl(e, { name: t, value: r, from: n }) {
  if (!Object.isFrozen(e._value)) {
    if (_v(e)) {
      const a = r === Sa ? [] : r === Pa && typeof n == "number" ? e._value.splice(n, 1) : [r];
      e._value.splice(
        t,
        r === Pa || n === Hl ? 0 : 1,
        ...a
      );
      return;
    }
    r !== Sa ? e._value[t] = r : delete e._value[t];
  }
}
function Cv(e, t) {
  const r = t._value;
  return e.type === "list" && e.sync && Ev(e, t), t.children.forEach((n) => {
    if (typeof r == "object")
      if (n.name in r) {
        const a = n.type !== "input" || r[n.name] && typeof r[n.name] == "object" ? lr(r[n.name]) : r[n.name];
        if (!n.isSettled || (!Pr(a) || n.props.mergeStrategy) && nt(a, n._value))
          return;
        n.input(a, !1);
      } else
        (e.type !== "list" || typeof n.name == "number") && jl(t, { name: n.name, value: n.value }), r.__init || (n.type === "group" ? n.input({}, !1) : n.type === "list" ? n.input([], !1) : n.input(void 0, !1));
  }), e;
}
function Ev(e, t) {
  const r = e._value;
  if (!Array.isArray(r))
    return;
  const n = [], a = new Set(t.children), s = /* @__PURE__ */ new Map();
  r.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      n.push(t.children[o]), a.delete(t.children[o]);
    else {
      n.push(null);
      const u = s.get(l) || [];
      u.push(o), s.set(l, u);
    }
  }), a.size && s.size && a.forEach((l) => {
    if (s.has(l._value)) {
      const o = s.get(l._value), u = o.shift();
      n[u] = l, a.delete(l), o.length || s.delete(l._value);
    }
  });
  const i = [];
  for (s.forEach((l) => {
    i.push(...l);
  }); a.size && i.length; ) {
    const l = a.values().next().value, o = i.shift();
    if (o === void 0)
      break;
    n[o] = l, a.delete(l);
  }
  i.forEach((l, o) => {
    n[l] = iy({ value: o });
  }), a.size && a.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || ly(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = n;
}
function Av(e, t) {
  var r;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && ((r = e.parent) == null || r.disturb())), t._d++, e;
}
function Tv(e, t, r) {
  var n;
  if (r !== void 0 && e.type !== "input") {
    jl(t, r);
    const a = !!(e.config.mergeStrategy && e.config.mergeStrategy[r.name]);
    return gn(e, t, !0, a);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((n = e.parent) == null || n.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function Lv(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), mv(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const r in t.context)
    delete t.context[r];
  t.plugins.clear(), t.context = null;
}
function Mv(e, t, r) {
  t.type = r.type;
  const n = Lr(r);
  e.props.__propDefs = ql(
    e.props.__propDefs ?? [],
    (n == null ? void 0 : n.props) || []
  ), n.props = e.props.__propDefs, t.props.definition = n, t.value = t._value = Vl({
    type: e.type,
    value: t.value
  }), r.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = r.forceTypeProp), r.family && (t.props.family = r.family), r.features && r.features.forEach((a) => a(e)), r.props && e.addProps(r.props), e.emit("defined", r);
}
function Ov(e, t, r) {
  const n = Array.isArray(r) ? r : Object.keys(r), a = Array.isArray(r) ? {} : n.reduce((i, l) => ("default" in r[l] && (i[l] = r[l].default), i), {});
  if (e.props.attrs) {
    const i = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in i) {
      const u = Zt(o);
      n.includes(u) && (e.props[u] = i[o], delete i[o]);
    }
    Array.isArray(r) || n.forEach((o) => {
      "default" in r[o] && e.props[o] === void 0 && (e.props[o] = a[o]);
    });
    const l = xt(t._value);
    e.props.initial = e.type !== "input" ? lr(l) : l, e.props._emit = !0, e.props.attrs = i;
  }
  const s = ql(e.props.__propDefs ?? [], r);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", r), e;
}
function Ia(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] = {}, t), {}) : e;
}
function ql(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : Ct(Ia(e), Ia(t));
}
function Nv(e, t, r, n) {
  if (e.type === "input" && Be(100, e), r.parent && r.parent !== e && r.parent.remove(r), !t.children.includes(r)) {
    if (n !== void 0 && e.type === "list") {
      const a = t.children[n];
      a && "__FKP" in a ? (r._c.uid = a.uid, t.children.splice(n, 1, r)) : t.children.splice(n, 0, r), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: n,
        value: r.value,
        from: Hl
      });
    } else
      t.children.push(r);
    r.isSettled || e.disturb();
  }
  if (r.parent !== e) {
    if (r.parent = e, r.parent !== e)
      return e.remove(r), r.parent.add(r), e;
  } else
    r.use(e.plugins);
  return gn(e, t, !1), e.ledger.merge(r), e.emit("child", r), e;
}
function Fv(e, t, r, n) {
  return Bn(n) ? (e.parent && e.parent !== n && e.parent.remove(e), t.parent = n, e.resetConfig(), n.children.includes(e) ? e.use(n.plugins) : n.add(e), !0) : n === null ? (t.parent = null, !0) : !1;
}
function Dv(e, t, r) {
  const n = t.children.indexOf(r);
  if (n !== -1) {
    r.isSettled && e.disturb(), t.children.splice(n, 1);
    let a = tt(r.props.preserve), s = r.parent;
    for (; a === void 0 && s; )
      a = tt(s.props.preserve), s = s.parent;
    a ? e.calm() : e.calm({
      name: e.type === "list" ? n : r.name,
      value: Sa
    }), r.parent = null, r.config._rmn = r;
  }
  return e.ledger.unmerge(r), e.emit("childRemoved", r), e;
}
function Rv(e, t, r) {
  t.children.forEach((n) => !("__FKP" in n) && r(n));
}
function xv(e, t, r, n = !1, a = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const i = r(s);
    return n && i === !1 ? !0 : a && i === !1 ? !1 : s.walk(r, n, a);
  });
}
function Hv(e, t) {
  const r = e.parent || void 0;
  t.config = Wl(e.config._t, r), e.walk((n) => n.resetConfig());
}
function $s(e, t, r, n = !0, a = !0) {
  return Array.isArray(r) || r instanceof Set ? (r.forEach((s) => $s(e, t, s)), e) : (t.plugins.has(r) || (a && typeof r.library == "function" && r.library(e), n && r(e) !== !1 && (t.plugins.add(r), e.children.forEach((s) => s.use(r)))), e);
}
function zv(e, t, r, n) {
  if (Bn(e.parent)) {
    const a = e.parent.children, s = n >= a.length ? a.length - 1 : n < 0 ? 0 : n, i = a.indexOf(e);
    return i === -1 ? !1 : (a.splice(i, 1), a.splice(s, 0, e), e.parent.children = a, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: Pa, from: i }), !0);
  }
  return !1;
}
function Vv(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function Bv(e, t) {
  return t;
}
function jv(e, t) {
  var r;
  return ((r = e.parent) == null ? void 0 : r.type) === "list" ? e.index : t.name !== xl ? t.name : e.index;
}
function qv(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function Wv(e, t, r) {
  const n = typeof r == "string" ? r.split(e.config.delimiter) : r;
  if (!n.length)
    return;
  const a = n[0];
  let s = e.parent;
  for (s || (String(n[0]) === String(e.name) && n.shift(), s = e), a === "$parent" && n.shift(); s && n.length; ) {
    const i = n.shift();
    switch (i) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(i)
        ) || Uv(s, i);
    }
  }
  return s || void 0;
}
function Uv(e, t) {
  const r = String(t).match(/^(find)\((.*)\)$/);
  if (r) {
    const [, n, a] = r, s = a.split(",").map((i) => i.trim());
    switch (n) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function Kv(e, t, r, n) {
  return Yv(e, r, n);
}
function Yv(e, t, r = "name") {
  const n = typeof r == "string" ? (s) => s[r] == t : r, a = [e];
  for (; a.length; ) {
    const s = a.shift();
    if (!("__FKP" in s)) {
      if (n(s, t))
        return s;
      a.push(...s.children);
    }
  }
}
function Gv(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function Wl(e = {}, t) {
  let r;
  return new Proxy(e, {
    get(...n) {
      const a = n[1];
      if (a === "_t")
        return e;
      const s = Reflect.get(...n);
      if (s !== void 0)
        return s;
      if (t) {
        const i = t.config[a];
        if (i !== void 0)
          return i;
      }
      if (e.rootConfig && typeof a == "string") {
        const i = e.rootConfig[a];
        if (i !== void 0)
          return i;
      }
      return a === "delay" && (r == null ? void 0 : r.type) === "input" ? 20 : bv[a];
    },
    set(...n) {
      const a = n[1], s = n[2];
      if (a === "_n")
        return r = s, e.rootConfig && e.rootConfig._add(r), !0;
      if (a === "_rmn")
        return e.rootConfig && e.rootConfig._rm(r), r = void 0, !0;
      if (!nt(e[a], s, !1)) {
        const i = Reflect.set(...n);
        return r && (r.emit(`config:${a}`, s, !1), ai(r, a, s), r.walk((l) => ai(l, a, s), !1, !0)), i;
      }
      return !0;
    }
  });
}
function Qv(e, t, r, n = "ui") {
  const a = typeof r == "string" ? { key: r, value: r, type: n } : r, s = e.hook.text.dispatch(a);
  return e.emit("text", s, !1), s.value;
}
function Zv(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || Be(106, t), e = e.parent;
  } while (e);
  e.props.id && yv(e.props.id, e.props.__root);
}
function Xv(e, t, r) {
  return gv(e, r);
}
function Jv(e, t, r, n) {
  const a = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: r, childErrors: n });
  return lv(e, s.localErrors, s.childErrors).forEach(
    (i) => {
      e.store.apply(i, (l) => l.meta.source === a);
    }
  ), e;
}
function ey(e, t, r = !0, n) {
  return e.store.filter((a) => !(n === void 0 || a.meta.source === n), "error"), r && (n = n || `${e.name}-set`, e.walk((a) => {
    a.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === n));
  })), e;
}
function ty(e) {
  const t = {
    initial: typeof e == "object" ? xt(e) : e
  };
  let r, n = !0, a = {};
  return new Proxy(t, {
    get(...s) {
      var f, p, h, c;
      const [i, l] = s;
      let o;
      be(t, l) ? (o = Reflect.get(...s), (f = a[l]) != null && f.boolean && (o = Qm(o))) : r && typeof l == "string" && r.config[l] !== void 0 ? (o = r.config[l], l === "mergeStrategy" && (r == null ? void 0 : r.type) === "input" && hn(o) && r.name in o && (o = o[r.name])) : o = (p = a[l]) == null ? void 0 : p.default;
      const u = (h = a[l]) == null ? void 0 : h.getter;
      return (c = a[l]) != null && c.boolean && (o = !!o), u ? u(o, r) : o;
    },
    set(s, i, l, o) {
      var h;
      if (i === "_n")
        return r = l, !0;
      if (i === "_emit")
        return n = l, !0;
      let { prop: u, value: f } = r.hook.prop.dispatch({
        prop: i,
        value: l
      });
      const p = (h = a[u]) == null ? void 0 : h.setter;
      if (f = p ? p(f, r) : f, !nt(t[u], f, !1) || typeof f == "object") {
        const c = Reflect.set(s, u, f, o);
        return u === "__propDefs" && (a = Ia(f)), n && (r.emit("prop", { prop: u, value: f }), typeof u == "string" && r.emit(`prop:${u}`, f)), c;
      }
      return !0;
    }
  });
}
function ry(e, t, r, n) {
  return t.traps.set(r, n), e;
}
function ny(e, t) {
  if (e.props.definition)
    return e.define(e.props.definition);
  for (const r of t) {
    if (e.props.definition)
      return;
    typeof r.library == "function" && r.library(e);
  }
}
function ay(e) {
  const t = Vl(e), r = Wl(e.config || {}, e.parent);
  return {
    _d: 0,
    _e: Ll(),
    uid: Symbol(),
    _resolve: !1,
    _tmo: !1,
    _value: t,
    children: Bm(e.children || []),
    config: r,
    hook: wv(),
    isCreated: !1,
    isSettled: !0,
    ledger: cv(),
    name: Pv(e),
    parent: e.parent || null,
    plugins: /* @__PURE__ */ new Set(),
    props: ty(t),
    settled: Promise.resolve(t),
    store: tv(!0),
    sync: e.sync || !1,
    traps: kv(),
    type: e.type || "input",
    value: t
  };
}
function sy(e, t) {
  var n, a;
  const r = (n = t.props) == null ? void 0 : n.id;
  if (r || (a = t.props) == null || delete a.id, e.ledger.init(e.store._n = e.props._n = e.config._n = e), e.props._emit = !1, Object.assign(
    e.props,
    r ? {} : { id: `input_${Sv++}` },
    t.props ?? {}
  ), e.props._emit = !0, ny(
    e,
    /* @__PURE__ */ new Set([
      ...t.plugins || [],
      ...e.parent ? e.parent.plugins : []
    ])
  ), t.plugins)
    for (const s of t.plugins)
      $s(e, e._c, s, !0, !1);
  return e.each((s) => e.add(s)), e.parent && e.parent.add(e, t.index), e.type === "input" && e.children.length && Be(100, e), Bl(e, e._c, e._value, !1), e.store.release(), r && pv(e), e.emit("created", e), e.isCreated = !0, e;
}
function iy(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${zl++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function ly(e) {
  return "__FKP" in e;
}
function oy(e) {
  const t = e || {}, r = ay(t), n = new Proxy(r, {
    get(...a) {
      const [, s] = a;
      if (s === "__FKNode__")
        return !0;
      const i = r.traps.get(s);
      return i && i.get ? i.get(n, r) : Reflect.get(...a);
    },
    set(...a) {
      const [, s, i] = a, l = r.traps.get(s);
      return l && l.set ? l.set(n, r, s, i) : Reflect.set(...a);
    }
  });
  return sy(n, t);
}
function Ca(e) {
  return typeof e != "string" && be(e, "$el");
}
function Ea(e) {
  return typeof e != "string" && be(e, "$cmp");
}
function Ut(e) {
  return !e || typeof e == "string" ? !1 : be(e, "if") && be(e, "then");
}
function uy(e) {
  return typeof e != "string" && "$formkit" in e;
}
function cy(e) {
  if (typeof e == "string")
    return {
      $el: "text",
      children: e
    };
  if (uy(e)) {
    const {
      $formkit: t,
      for: r,
      if: n,
      children: a,
      bind: s,
      ...i
    } = e;
    return Object.assign(
      {
        $cmp: "FormKit",
        props: { ...i, type: t }
      },
      n ? { if: n } : {},
      r ? { for: r } : {},
      a ? { children: a } : {},
      s ? { bind: s } : {}
    );
  }
  return e;
}
function Je(e) {
  let t;
  const r = /* @__PURE__ */ new Set(), n = function(b, k) {
    return typeof b == "function" ? b(k) : b;
  }, a = [
    {
      "&&": (g, b, k) => n(g, k) && n(b, k),
      "||": (g, b, k) => n(g, k) || n(b, k)
    },
    {
      "===": (g, b, k) => n(g, k) === n(b, k),
      "!==": (g, b, k) => n(g, k) !== n(b, k),
      "==": (g, b, k) => n(g, k) == n(b, k),
      "!=": (g, b, k) => n(g, k) != n(b, k),
      ">=": (g, b, k) => n(g, k) >= n(b, k),
      "<=": (g, b, k) => n(g, k) <= n(b, k),
      ">": (g, b, k) => n(g, k) > n(b, k),
      "<": (g, b, k) => n(g, k) < n(b, k)
    },
    {
      "+": (g, b, k) => n(g, k) + n(b, k),
      "-": (g, b, k) => n(g, k) - n(b, k)
    },
    {
      "*": (g, b, k) => n(g, k) * n(b, k),
      "/": (g, b, k) => n(g, k) / n(b, k),
      "%": (g, b, k) => n(g, k) % n(b, k)
    }
  ], s = a.reduce((g, b) => g.concat(Object.keys(b)), []), i = new Set(s.map((g) => g.charAt(0)));
  function l(g, b, k, P) {
    const I = g.filter((_) => _.startsWith(b));
    return I.length ? I.find((_) => P.length >= k + _.length && P.substring(k, k + _.length) === _ ? _ : !1) : !1;
  }
  function o(g, b, k = 1) {
    let P = k ? b.substring(g + 1).trim() : b.substring(0, g).trim();
    if (!P.length)
      return -1;
    if (!k) {
      const _ = P.split("").reverse(), S = _.findIndex((v) => i.has(v));
      P = _.slice(S).join("");
    }
    const I = P[0];
    return a.findIndex((_) => {
      const S = Object.keys(_);
      return !!l(S, I, 0, P);
    });
  }
  function u(g, b) {
    let k = "";
    const P = b.length;
    let I = 0;
    for (let _ = g; _ < P; _++) {
      const S = b.charAt(_);
      if (S === "(")
        I++;
      else if (S === ")")
        I--;
      else if (I === 0 && S === " ")
        continue;
      if (I === 0 && l(s, S, _, b))
        return [k, _ - 1];
      k += S;
    }
    return [k, b.length - 1];
  }
  function f(g, b = 0) {
    const k = a[b], P = g.length, I = Object.keys(k);
    let _ = 0, S = !1, v = null, w = "", C = null, F, x = "", R = "", d = "", $ = "", A = 0;
    const z = (N, j) => {
      N ? d += j : w += j;
    };
    for (let N = 0; N < P; N++)
      if (x = R, R = g.charAt(N), (R === "'" || R === '"') && x !== "\\" && (_ === 0 && !S || _ && !$)) {
        _ ? $ = R : S = R, z(_, R);
        continue;
      } else if (S && (R !== S || x === "\\") || $ && (R !== $ || x === "\\")) {
        z(_, R);
        continue;
      } else if (S === R) {
        S = !1, z(_, R);
        continue;
      } else if ($ === R) {
        $ = !1, z(_, R);
        continue;
      } else {
        if (R === " ")
          continue;
        if (R === "(")
          _ === 0 ? A = N : d += R, _++;
        else if (R === ")")
          if (_--, _ === 0) {
            const j = typeof w == "string" && w.startsWith("$") ? w : void 0, Q = j && g.charAt(N + 1) === ".";
            let q = "";
            Q && ([q, N] = u(N + 2, g));
            const Z = v ? b : o(A, g, 0), re = o(N, g);
            Z === -1 && re === -1 ? (w = p(d, -1, j, q), typeof w == "string" && (w = d)) : v && (Z >= re || re === -1) && b === Z ? (C = v.bind(null, p(d, -1, j, q)), v = null, w = "") : re > Z && b === re ? w = p(d, -1, j, q) : w += `(${d})${Q ? `.${q}` : ""}`, d = "";
          } else
            d += R;
        else if (_ === 0 && (F = l(I, R, N, g))) {
          N === 0 && Be(103, [F, g]), N += F.length - 1, N === g.length - 1 && Be(104, [F, g]), v ? w && (C = v.bind(null, p(w, b)), v = k[F].bind(null, C), w = "") : C ? (v = k[F].bind(null, p(C, b)), C = null) : (v = k[F].bind(null, p(w, b)), w = "");
          continue;
        } else
          z(_, R);
      }
    return w && v && (v = v.bind(null, p(w, b))), v = !v && C ? C : v, !v && w && (v = (N, j) => typeof N == "function" ? N(j) : N, v = v.bind(null, p(w, b))), !v && !w && Be(105, g), v;
  }
  function p(g, b, k, P) {
    if (k) {
      const I = p(k, a.length);
      let _, S = P ? Je(`$${P}`) : !1;
      if (typeof I == "function") {
        const v = Um(String(g)).map(
          (w) => p(w, -1)
        );
        return (w) => {
          const C = I(w);
          return typeof C != "function" ? (Br(150, k), C) : (_ = C(
            ...v.map(
              (F) => typeof F == "function" ? F(w) : F
            )
          ), S && (S = S.provide((F) => {
            const x = t(F);
            return F.reduce(
              (d, $) => {
                if ($ === P || (P == null ? void 0 : P.startsWith(`${$}(`))) {
                  const z = Km(_, $);
                  d[$] = () => z;
                } else
                  d[$] = x[$];
                return d;
              },
              {}
            );
          })), S ? S() : _);
        };
      }
    } else if (typeof g == "string") {
      if (g === "true")
        return !0;
      if (g === "false")
        return !1;
      if (g === "undefined")
        return;
      if (qm(g))
        return Wm(g.substring(1, g.length - 1));
      if (!isNaN(+g))
        return Number(g);
      if (b < a.length - 1)
        return f(g, b + 1);
      if (g.startsWith("$")) {
        const I = g.substring(1);
        return r.add(I), function(S) {
          return I in S ? S[I]() : void 0;
        };
      }
      return g;
    }
    return g;
  }
  const h = f(
    e.startsWith("$:") ? e.substring(2) : e
  ), c = Array.from(r);
  function y(g) {
    return t = g, Object.assign(
      // @ts-ignore - @rollup/plugin-typescript doesn't like this
      h.bind(null, g(c)),
      { provide: y }
    );
  }
  return Object.assign(h, {
    provide: y
  });
}
function Jr(e, t, r) {
  return r ? typeof r == "string" ? r.split(" ").reduce(
    (a, s) => Object.assign(a, { [s]: !0 }),
    {}
  ) : typeof r == "function" ? Jr(
    e,
    t,
    r(t, e)
  ) : r : {};
}
function fy(e, t, ...r) {
  const n = r.reduce((a, s) => {
    if (!s)
      return ia(a);
    const { $reset: i, ...l } = s;
    return ia(i ? l : Object.assign(a, l));
  }, {});
  return Object.keys(
    e.hook.classes.dispatch({ property: t, classes: n }).classes
  ).filter((a) => n[a]).join(" ") || null;
}
function ia(e) {
  const t = "$remove:";
  let r = !1;
  const n = Object.keys(e).filter((a) => (e[a] && a.startsWith(t) && (r = !0), e[a]));
  return n.length > 1 && r && n.filter((s) => s.startsWith(t)).map((s) => {
    const i = s.substring(t.length);
    e[i] = !1, e[s] = !1;
  }), e;
}
var dy = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function Ul() {
  return Math.random().toString(36).substring(2, 15);
}
function Aa(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function jn(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return py(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const a of n)
      if ((a in e || a in t) && e[a] !== t[a])
        return !1;
    for (const a in e)
      if (!(a in t) || e[a] !== t[a] && !r || r && !jn(e[a], t[a], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function py(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function la(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function Ta(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function en(e) {
  return Ta(e) || Array.isArray(e);
}
function si(e) {
  if (Ta(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(Ta(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
var Kl = /* @__NO_SIDE_EFFECTS__ */ (e, t, r = !1, n = !1) => {
  if (t === null)
    return null;
  const a = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (Aa(t, s) && (t[s] !== void 0 || !n)) {
      if (r && Array.isArray(e[s]) && Array.isArray(t[s])) {
        a[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      si(e[s]) && si(t[s]) ? a[s] = /* @__PURE__ */ Kl(
        e[s],
        t[s],
        r,
        n
      ) : a[s] = t[s];
    } else
      a[s] = e[s];
  for (const s in t)
    !Aa(a, s) && t[s] !== void 0 && (a[s] = t[s]);
  return a;
};
function my(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, r) => r.toUpperCase()
  );
}
function vy(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, r, n) => r + "-" + n.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function bn(e, t = dy) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let r;
  Array.isArray(e) ? r = e.map((n) => typeof n == "object" ? bn(n, t) : n) : r = Object.keys(e).reduce((n, a) => (n[a] = typeof e[a] == "object" ? bn(e[a], t) : e[a], n), {});
  for (const n of t)
    n in e && Object.defineProperty(r, n, {
      enumerable: !1,
      value: e[n]
    });
  return r;
}
function La(e) {
  return typeof e == "object" ? bn(e) : e;
}
function ii(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function or(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function yy(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function Yl() {
  const e = [];
  let t = 0;
  const r = (a) => e.push(a), n = (a) => {
    const s = e[t];
    return typeof s == "function" ? s(a, (i) => (t++, n(i))) : (t = 0, a);
  };
  return r.dispatch = n, r.unshift = (a) => e.unshift(a), r.remove = (a) => {
    const s = e.indexOf(a);
    s > -1 && e.splice(s, 1);
  }, r;
}
function hy() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r;
  const n = (a, s) => {
    if (r) {
      r.set(s.name, [a, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((i) => {
      (s.origin === a || i.modifiers.includes("deep")) && i.listener(s);
    }), s.bubble && a.bubble(s);
  };
  return n.flush = () => {
    e.clear(), t.clear(), r == null || r.clear();
  }, n.on = (a, s, i = "push") => {
    const [l, ...o] = a.split("."), u = s.receipt || Ul(), f = {
      modifiers: o,
      event: l,
      listener: s,
      receipt: u
    };
    return e.has(l) ? e.get(l)[i](f) : e.set(l, [f]), t.has(u) ? t.get(u)[i](l) : t.set(u, [l]), u;
  }, n.off = (a) => {
    var s;
    t.has(a) && ((s = t.get(a)) == null || s.forEach((i) => {
      const l = e.get(i);
      Array.isArray(l) && e.set(
        i,
        l.filter((o) => o.receipt !== a)
      );
    }), t.delete(a));
  }, n.pause = (a) => {
    r || (r = /* @__PURE__ */ new Map()), a && a.walk((s) => s._e.pause());
  }, n.play = (a) => {
    if (!r)
      return;
    const s = r;
    r = void 0, s.forEach(([i, l]) => n(i, l)), a && a.walk((i) => i._e.play());
  }, n;
}
function gy(e, t, r, n, a = !0, s) {
  return t._e(e, {
    payload: n,
    name: r,
    bubble: a,
    origin: e,
    meta: s
  }), e;
}
function by(e, t, r) {
  return qn(e.parent) && e.parent._e(e.parent, r), e;
}
function _y(e, t, r, n, a) {
  return t._e.on(r, n, a);
}
function $y(e, t, r) {
  return t._e.off(r), e;
}
var Gl = Yl();
Gl((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var Ql = Yl();
Ql((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const r = t(e);
  return console && typeof console.warn == "function" && console.warn(r.message), r;
});
function Zl(e, t = {}) {
  Ql.dispatch({ code: e, data: t });
}
function Mr(e, t = {}) {
  throw Error(Gl.dispatch({ code: e, data: t }).message);
}
function ky(e, t) {
  return {
    blocking: !1,
    key: Ul(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
function wy(e, ...t) {
  const r = `${e.name}-set`, n = (a) => /* @__PURE__ */ ky({
    key: yy(a),
    type: "error",
    value: a,
    meta: { source: r, autoClear: !0 }
  });
  return t.filter((a) => !!a).map((a) => {
    if (typeof a == "string" && (a = [a]), Array.isArray(a))
      return a.map((s) => n(s));
    {
      const s = {};
      for (const i in a)
        Array.isArray(a[i]) ? s[i] = a[i].map(
          (l) => n(l)
        ) : s[i] = [n(a[i])];
      return s;
    }
  });
}
var Xl = /* @__PURE__ */ new Map(), oa = /* @__PURE__ */ new Map(), Sy = hy();
function Py(e) {
  if (oa.has(e)) {
    const t = oa.get(e);
    oa.delete(e), Xl.delete(t), Sy(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function Iy(e) {
  return Xl.get(e);
}
function li(e, t, r) {
  let n = !0;
  return t in e.config._t ? n = !1 : e.emit(`config:${t}`, r, !1), t in e.props || (e.emit("prop", { prop: t, value: r }), e.emit(`prop:${t}`, r)), n;
}
function Cy(e, t) {
  const r = (t || document).getElementById(e);
  if (r instanceof HTMLFormElement) {
    const n = new Event("submit", { cancelable: !0, bubbles: !0 });
    r.dispatchEvent(n);
    return;
  }
  Zl(151, e);
}
function Ey(e) {
  const t = (r) => {
    for (const n in r.store) {
      const a = r.store[n];
      a.type === "error" || a.type === "ui" && n === "incomplete" ? r.store.remove(n) : a.type === "state" && r.store.set({ ...a, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function Ay(e, t) {
  const r = typeof e == "string" ? Iy(e) : e;
  if (r) {
    const n = (i) => {
      const l = La(i.props.initial);
      return l !== void 0 ? l : i.type === "group" ? {} : i.type === "list" ? [] : void 0;
    };
    r._e.pause(r);
    const a = La(t);
    return t && !la(t) && (r.props.initial = en(a) ? or(a) : a, r.props._init = r.props.initial), r.input(n(r), !1), r.walk((i) => {
      i.type === "list" && i.sync || i.input(n(i), !1);
    }), r.input(
      la(a) && a ? a : n(r),
      !1
    ), r.type !== "input" && t && !la(t) && en(t) && r.walk((i) => {
      i.props.initial = en(i.value) ? or(i.value) : i.value, i.props._init = i.props.initial;
    }), r._e.play(r), Ey(r), r.emit("reset", r), r;
  }
  Zl(152, e);
}
var Ty = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${vy(e)}`]: !0 })
}, Ly = Symbol("index"), Ma = Symbol("removed"), Oa = Symbol("moved"), Jl = Symbol("inserted");
function My(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function qn(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var tn = (e, t, r) => {
  Mr(102, [e, r]);
};
ce(Xy, tn, !1), ce(qy), ce(jy), ce(eh, tn, !1), ce(th), ce(by), ce(fh), ce(zy), ce(!1), ce(By), ce(Hy), ce(Vy), ce(dh), ce(Ry), ce(Zy, Qy, !1), ce(Fy), ce(Ky), ce(gy), ce(nh), ce(_y), ce($y), ce(!1, Wy), ce(!1), ce(Uy), ce(sh, tn, !1), ce(uh), ce(Gy), ce(ch), ce(oh), ce(lh), ce(ro), ce(Jy, !1, !1), ce(Yy);
function ce(e, t, r = !0) {
  return {
    get: e ? (n, a) => r ? (...s) => e(n, a, ...s) : e(n, a) : !1,
    set: t !== void 0 ? t : tn.bind(null)
  };
}
var Oy = 0;
function Ny(e) {
  return e.type === "group" ? or(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? or(Array.isArray(e.value) ? e.value : []) : e.value;
}
function Fy(e, t, r, n = !0) {
  return t._value = Dy(e, e.hook.input.dispatch(r)), e.emit("input", t._value), e.isCreated && e.type === "input" && jn(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), n ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    _n,
    e.props.delay,
    e,
    t
  )) : _n(e, t), t.settled);
}
function Dy(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && Mr(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || Mr(108, [e, t]);
      break;
  }
  return t;
}
function _n(e, t, r = !0, n = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && n && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), r && e.calm();
}
function eo(e, { name: t, value: r, from: n }) {
  if (!Object.isFrozen(e._value)) {
    if (My(e)) {
      const a = r === Ma ? [] : r === Oa && typeof n == "number" ? e._value.splice(n, 1) : [r];
      e._value.splice(
        t,
        r === Oa || n === Jl ? 0 : 1,
        ...a
      );
      return;
    }
    r !== Ma ? e._value[t] = r : delete e._value[t];
  }
}
function Ry(e, t) {
  const r = t._value;
  return e.type === "list" && e.sync && xy(e, t), t.children.forEach((n) => {
    if (typeof r == "object")
      if (n.name in r) {
        const a = n.type !== "input" || r[n.name] && typeof r[n.name] == "object" ? or(r[n.name]) : r[n.name];
        if (!n.isSettled || (!en(a) || n.props.mergeStrategy) && jn(a, n._value))
          return;
        n.input(a, !1);
      } else
        (e.type !== "list" || typeof n.name == "number") && eo(t, { name: n.name, value: n.value }), r.__init || (n.type === "group" ? n.input({}, !1) : n.type === "list" ? n.input([], !1) : n.input(void 0, !1));
  }), e;
}
function xy(e, t) {
  const r = e._value;
  if (!Array.isArray(r))
    return;
  const n = [], a = new Set(t.children), s = /* @__PURE__ */ new Map();
  r.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      n.push(t.children[o]), a.delete(t.children[o]);
    else {
      n.push(null);
      const u = s.get(l) || [];
      u.push(o), s.set(l, u);
    }
  }), a.size && s.size && a.forEach((l) => {
    if (s.has(l._value)) {
      const o = s.get(l._value), u = o.shift();
      n[u] = l, a.delete(l), o.length || s.delete(l._value);
    }
  });
  const i = [];
  for (s.forEach((l) => {
    i.push(...l);
  }); a.size && i.length; ) {
    const l = a.values().next().value, o = i.shift();
    if (o === void 0)
      break;
    n[o] = l, a.delete(l);
  }
  i.forEach((l, o) => {
    n[l] = ph({ value: o });
  }), a.size && a.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || mh(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = n;
}
function Hy(e, t) {
  var r;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && ((r = e.parent) == null || r.disturb())), t._d++, e;
}
function zy(e, t, r) {
  var n;
  if (r !== void 0 && e.type !== "input") {
    eo(t, r);
    const a = !!(e.config.mergeStrategy && e.config.mergeStrategy[r.name]);
    return _n(e, t, !0, a);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((n = e.parent) == null || n.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function Vy(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), Py(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const r in t.context)
    delete t.context[r];
  t.plugins.clear(), t.context = null;
}
function By(e, t, r) {
  t.type = r.type;
  const n = bn(r);
  e.props.__propDefs = to(
    e.props.__propDefs ?? [],
    (n == null ? void 0 : n.props) || []
  ), n.props = e.props.__propDefs, t.props.definition = n, t.value = t._value = Ny({
    type: e.type,
    value: t.value
  }), r.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = r.forceTypeProp), r.family && (t.props.family = r.family), r.features && r.features.forEach((a) => a(e)), r.props && e.addProps(r.props), e.emit("defined", r);
}
function jy(e, t, r) {
  const n = Array.isArray(r) ? r : Object.keys(r), a = Array.isArray(r) ? {} : n.reduce((i, l) => ("default" in r[l] && (i[l] = r[l].default), i), {});
  if (e.props.attrs) {
    const i = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in i) {
      const u = my(o);
      n.includes(u) && (e.props[u] = i[o], delete i[o]);
    }
    Array.isArray(r) || n.forEach((o) => {
      "default" in r[o] && e.props[o] === void 0 && (e.props[o] = a[o]);
    });
    const l = La(t._value);
    e.props.initial = e.type !== "input" ? or(l) : l, e.props._emit = !0, e.props.attrs = i;
  }
  const s = to(e.props.__propDefs ?? [], r);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", r), e;
}
function oi(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] = {}, t), {}) : e;
}
function to(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : Kl(oi(e), oi(t));
}
function qy(e, t, r, n) {
  if (e.type === "input" && Mr(100, e), r.parent && r.parent !== e && r.parent.remove(r), !t.children.includes(r)) {
    if (n !== void 0 && e.type === "list") {
      const a = t.children[n];
      a && "__FKP" in a ? (r._c.uid = a.uid, t.children.splice(n, 1, r)) : t.children.splice(n, 0, r), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: n,
        value: r.value,
        from: Jl
      });
    } else
      t.children.push(r);
    r.isSettled || e.disturb();
  }
  if (r.parent !== e) {
    if (r.parent = e, r.parent !== e)
      return e.remove(r), r.parent.add(r), e;
  } else
    r.use(e.plugins);
  return _n(e, t, !1), e.ledger.merge(r), e.emit("child", r), e;
}
function Wy(e, t, r, n) {
  return qn(n) ? (e.parent && e.parent !== n && e.parent.remove(e), t.parent = n, e.resetConfig(), n.children.includes(e) ? e.use(n.plugins) : n.add(e), !0) : n === null ? (t.parent = null, !0) : !1;
}
function Uy(e, t, r) {
  const n = t.children.indexOf(r);
  if (n !== -1) {
    r.isSettled && e.disturb(), t.children.splice(n, 1);
    let a = ii(r.props.preserve), s = r.parent;
    for (; a === void 0 && s; )
      a = ii(s.props.preserve), s = s.parent;
    a ? e.calm() : e.calm({
      name: e.type === "list" ? n : r.name,
      value: Ma
    }), r.parent = null, r.config._rmn = r;
  }
  return e.ledger.unmerge(r), e.emit("childRemoved", r), e;
}
function Ky(e, t, r) {
  t.children.forEach((n) => !("__FKP" in n) && r(n));
}
function Yy(e, t, r, n = !1, a = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const i = r(s);
    return n && i === !1 ? !0 : a && i === !1 ? !1 : s.walk(r, n, a);
  });
}
function Gy(e, t) {
  const r = e.parent || void 0;
  t.config = ih(e.config._t, r), e.walk((n) => n.resetConfig());
}
function ro(e, t, r, n = !0, a = !0) {
  return Array.isArray(r) || r instanceof Set ? (r.forEach((s) => ro(e, t, s)), e) : (t.plugins.has(r) || (a && typeof r.library == "function" && r.library(e), n && r(e) !== !1 && (t.plugins.add(r), e.children.forEach((s) => s.use(r)))), e);
}
function Qy(e, t, r, n) {
  if (qn(e.parent)) {
    const a = e.parent.children, s = n >= a.length ? a.length - 1 : n < 0 ? 0 : n, i = a.indexOf(e);
    return i === -1 ? !1 : (a.splice(i, 1), a.splice(s, 0, e), e.parent.children = a, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: Oa, from: i }), !0);
  }
  return !1;
}
function Zy(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function Xy(e, t) {
  return t;
}
function Jy(e, t) {
  var r;
  return ((r = e.parent) == null ? void 0 : r.type) === "list" ? e.index : t.name !== Ly ? t.name : e.index;
}
function eh(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function th(e, t, r) {
  const n = typeof r == "string" ? r.split(e.config.delimiter) : r;
  if (!n.length)
    return;
  const a = n[0];
  let s = e.parent;
  for (s || (String(n[0]) === String(e.name) && n.shift(), s = e), a === "$parent" && n.shift(); s && n.length; ) {
    const i = n.shift();
    switch (i) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(i)
        ) || rh(s, i);
    }
  }
  return s || void 0;
}
function rh(e, t) {
  const r = String(t).match(/^(find)\((.*)\)$/);
  if (r) {
    const [, n, a] = r, s = a.split(",").map((i) => i.trim());
    switch (n) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function nh(e, t, r, n) {
  return ah(e, r, n);
}
function ah(e, t, r = "name") {
  const n = typeof r == "string" ? (s) => s[r] == t : r, a = [e];
  for (; a.length; ) {
    const s = a.shift();
    if (!("__FKP" in s)) {
      if (n(s, t))
        return s;
      a.push(...s.children);
    }
  }
}
function sh(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function ih(e = {}, t) {
  let r;
  return new Proxy(e, {
    get(...n) {
      const a = n[1];
      if (a === "_t")
        return e;
      const s = Reflect.get(...n);
      if (s !== void 0)
        return s;
      if (t) {
        const i = t.config[a];
        if (i !== void 0)
          return i;
      }
      if (e.rootConfig && typeof a == "string") {
        const i = e.rootConfig[a];
        if (i !== void 0)
          return i;
      }
      return a === "delay" && (r == null ? void 0 : r.type) === "input" ? 20 : Ty[a];
    },
    set(...n) {
      const a = n[1], s = n[2];
      if (a === "_n")
        return r = s, e.rootConfig && e.rootConfig._add(r), !0;
      if (a === "_rmn")
        return e.rootConfig && e.rootConfig._rm(r), r = void 0, !0;
      if (!jn(e[a], s, !1)) {
        const i = Reflect.set(...n);
        return r && (r.emit(`config:${a}`, s, !1), li(r, a, s), r.walk((l) => li(l, a, s), !1, !0)), i;
      }
      return !0;
    }
  });
}
function lh(e, t, r, n = "ui") {
  const a = typeof r == "string" ? { key: r, value: r, type: n } : r, s = e.hook.text.dispatch(a);
  return e.emit("text", s, !1), s.value;
}
function oh(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || Mr(106, t), e = e.parent;
  } while (e);
  e.props.id && Cy(e.props.id, e.props.__root);
}
function uh(e, t, r) {
  return Ay(e, r);
}
function ch(e, t, r, n) {
  const a = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: r, childErrors: n });
  return wy(e, s.localErrors, s.childErrors).forEach(
    (i) => {
      e.store.apply(i, (l) => l.meta.source === a);
    }
  ), e;
}
function fh(e, t, r = !0, n) {
  return e.store.filter((a) => !(n === void 0 || a.meta.source === n), "error"), r && (n = n || `${e.name}-set`, e.walk((a) => {
    a.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === n));
  })), e;
}
function dh(e, t, r, n) {
  return t.traps.set(r, n), e;
}
function ph(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${Oy++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function mh(e) {
  return "__FKP" in e;
}
var no = /* @__PURE__ */ new WeakSet();
function Wn(e, t) {
  const r = t || Object.assign(/* @__PURE__ */ new Map(), { active: !1 }), n = /* @__PURE__ */ new Map(), a = function(f) {
    var p;
    r.active && (r.has(e) || r.set(e, /* @__PURE__ */ new Set()), (p = r.get(e)) == null || p.add(f));
  }, s = function(f) {
    return new Proxy(f, {
      get(...p) {
        return typeof p[1] == "string" && a(`prop:${p[1]}`), Reflect.get(...p);
      }
    });
  }, i = function(f) {
    return new Proxy(f, {
      get(...p) {
        return p[1] === "value" ? (h) => (a(`count:${h}`), f.value(h)) : Reflect.get(...p);
      }
    });
  }, l = function(f, p) {
    return qn(f) ? Wn(f, r) : (p === "value" && a("commit"), p === "_value" && a("input"), p === "props" ? s(f) : p === "ledger" ? i(f) : (p === "children" && (a("child"), a("childRemoved")), f));
  }, {
    proxy: o,
    revoke: u
  } = Proxy.revocable(e, {
    get(...f) {
      switch (f[1]) {
        case "_node":
          return e;
        case "deps":
          return r;
        case "watch":
          return (h, c, y) => io(o, h, c, y);
        case "observe":
          return () => {
            const h = new Map(r);
            return r.clear(), r.active = !0, h;
          };
        case "stopObserve":
          return () => {
            const h = new Map(r);
            return r.active = !1, h;
          };
        case "receipts":
          return n;
        case "kill":
          return () => {
            so(n), no.add(f[2]), u();
          };
      }
      const p = Reflect.get(...f);
      return typeof p == "function" ? (...h) => {
        const c = p(...h);
        return l(c, f[1]);
      } : l(p, f[1]);
    }
  });
  return o;
}
function ao(e, [t, r], n, a) {
  t.forEach((s, i) => {
    s.forEach((l) => {
      e.receipts.has(i) || e.receipts.set(i, {});
      const o = e.receipts.get(i) ?? {};
      o[l] = o[l] ?? [], o[l].push(i.on(l, n, a)), e.receipts.set(i, o);
    });
  }), r.forEach((s, i) => {
    s.forEach((l) => {
      if (e.receipts.has(i)) {
        const o = e.receipts.get(i);
        o && Aa(o, l) && (o[l].map(i.off), delete o[l], e.receipts.set(i, o));
      }
    });
  });
}
function so(e) {
  e.forEach((t, r) => {
    for (const n in t)
      t[n].map(r.off);
  }), e.clear();
}
function io(e, t, r, n) {
  const a = (l) => {
    const o = e.stopObserve();
    ao(
      e,
      lo(s, o),
      () => io(e, t, r, n),
      n
    ), r && r(l);
  }, s = new Map(e.deps);
  e.observe();
  const i = t(e);
  i instanceof Promise ? i.then((l) => a(l)) : a(i);
}
function lo(e, t) {
  const r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return t.forEach((a, s) => {
    if (!e.has(s))
      r.set(s, a);
    else {
      const i = /* @__PURE__ */ new Set(), l = e.get(s);
      a.forEach(
        (o) => !(l != null && l.has(o)) && i.add(o)
      ), r.set(s, i);
    }
  }), e.forEach((a, s) => {
    if (!t.has(s))
      n.set(s, a);
    else {
      const i = /* @__PURE__ */ new Set(), l = t.get(s);
      a.forEach(
        (o) => !(l != null && l.has(o)) && i.add(o)
      ), n.set(s, i);
    }
  }), [r, n];
}
function ks(e) {
  return no.has(e);
}
function pt(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function ws(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return vh(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const a of n)
      if ((a in e || a in t) && e[a] !== t[a])
        return !1;
    for (const a in e)
      if (!(a in t) || e[a] !== t[a] && !r || r && !ws(e[a], t[a], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function vh(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function $n(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function yh(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function hh(e) {
  const t = `^${yh(e)}$`, r = {
    MM: "(0[1-9]|1[012])",
    M: "([1-9]|1[012])",
    DD: "([012][0-9]|3[01])",
    D: "([012]?[0-9]|3[01])",
    YYYY: "\\d{4}",
    YY: "\\d{2}"
  }, n = Object.keys(r);
  return new RegExp(
    n.reduce((a, s) => a.replace(s, r[s]), t)
  );
}
var oo = function({ value: t }) {
  return ["yes", "on", "1", 1, !0, "true"].includes(t);
};
oo.skipEmpty = !1;
var gh = oo, bh = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n > r;
}, _h = bh, $h = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n > r || n === r;
}, kh = $h, wh = function(e, t) {
  var a;
  if (!t)
    return !1;
  const r = Date.parse(String(e.value)), n = Date.parse(String((a = e.at(t)) == null ? void 0 : a.value));
  return isNaN(n) ? !0 : isNaN(r) ? !1 : r > n;
}, Sh = wh, Ph = function({ value: e }, t = "default") {
  const r = {
    default: new RegExp("^\\p{L}+$", "u"),
    latin: /^[a-z]+$/i
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Ih = Ph, Ch = function({ value: e }, t = "default") {
  const r = {
    default: /^[\p{L} ]+$/u,
    latin: /^[a-z ]+$/i
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Eh = Ch, Ah = function({ value: e }, t = "default") {
  const r = {
    default: /^[0-9\p{L}]+$/u,
    latin: /^[0-9a-z]+$/i
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Th = Ah, Lh = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n < r;
}, Mh = Lh, Oh = function(e, t) {
  var a;
  if (!t)
    return !1;
  const r = Date.parse(String(e.value)), n = Date.parse(String((a = e.at(t)) == null ? void 0 : a.value));
  return isNaN(n) ? !0 : isNaN(r) ? !1 : r < n;
}, Nh = Oh, Fh = function({ value: e }, t = !1) {
  const r = Date.parse(t || /* @__PURE__ */ new Date()), n = Date.parse(String(e));
  return isNaN(n) ? !1 : n < r || n === r;
}, Dh = Fh, Rh = function({ value: t }, r, n) {
  if (!isNaN(t) && !isNaN(r) && !isNaN(n)) {
    const a = 1 * t;
    r = Number(r), n = Number(n);
    const [s, i] = r <= n ? [r, n] : [n, r];
    return a >= 1 * s && a <= 1 * i;
  }
  return !1;
}, xh = Rh, ui = /(_confirm(?:ed)?)$/, Hh = function(t, r, n = "loose") {
  var s;
  r || (r = ui.test(t.name) ? t.name.replace(ui, "") : `${t.name}_confirm`);
  const a = (s = t.at(r)) == null ? void 0 : s.value;
  return n === "strict" ? t.value === a : t.value == a;
}, zh = Hh, Vh = function({ value: e }, t = "default") {
  const r = {
    default: new RegExp("\\p{L}", "u"),
    latin: /[a-z]/i
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Bh = Vh, jh = function({ value: e }, t = "default") {
  const r = {
    default: /[\p{L} ]/u,
    latin: /[a-z ]/i
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, qh = jh, Wh = function({ value: e }, t = "default") {
  const r = {
    default: /[0-9\p{L}]/u,
    latin: /[0-9a-z]/i
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Uh = Wh, Kh = function({ value: e }, t = "default") {
  const r = {
    default: new RegExp("\\p{Ll}", "u"),
    latin: /[a-z]/
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Yh = Kh, Gh = function({ value: t }) {
  return /[0-9]/.test(String(t));
}, Qh = Gh, Zh = function({ value: e }) {
  return /[!-/:-@[-`{-~]/.test(String(e));
}, Xh = Zh, Jh = function({ value: e }, t = "default") {
  const r = {
    default: new RegExp("\\p{Lu}", "u"),
    latin: /[A-Z]/
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, eg = Jh, tg = function({ value: t }, r, n) {
  r = r instanceof Date ? r.getTime() : Date.parse(r), n = n instanceof Date ? n.getTime() : Date.parse(n);
  const a = t instanceof Date ? t.getTime() : Date.parse(String(t));
  if (r && !n)
    n = r, r = Date.now();
  else if (!r || !a)
    return !1;
  return a >= r && a <= n;
}, rg = tg, ng = function({ value: t }, r) {
  return r && typeof r == "string" ? hh(r).test(String(t)) : !isNaN(Date.parse(String(t)));
}, ag = ng, sg = function({ value: t }) {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(String(t));
}, ig = sg, lg = function({ value: t }, ...r) {
  return typeof t == "string" && r.length ? r.some((n) => t.endsWith(n)) : typeof t == "string" && r.length === 0;
}, og = lg, ug = function({ value: t }, ...r) {
  return r.some((n) => typeof n == "object" ? ws(n, t) : n == t);
}, cg = ug, fg = function({ value: t }, r = 0, n = 1 / 0) {
  r = parseInt(r), n = isNaN(parseInt(n)) ? 1 / 0 : parseInt(n);
  const a = r <= n ? r : n, s = n >= r ? n : r;
  if (typeof t == "string" || Array.isArray(t))
    return t.length >= a && t.length <= s;
  if (t && typeof t == "object") {
    const i = Object.keys(t).length;
    return i >= a && i <= s;
  }
  return !1;
}, dg = fg, pg = function({ value: e }, t = "default") {
  const r = {
    default: new RegExp("^\\p{Ll}+$", "u"),
    allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
    allow_numeric: /^[0-9\p{Ll}]+$/u,
    allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
    latin: /^[a-z]+$/
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, mg = pg, vg = function({ value: t }, ...r) {
  return r.some((n) => (typeof n == "string" && n.substr(0, 1) === "/" && n.substr(-1) === "/" && (n = new RegExp(n.substr(1, n.length - 2))), n instanceof RegExp ? n.test(String(t)) : n === t));
}, yg = vg, hg = function({ value: t }, r = 10) {
  return Array.isArray(t) ? t.length <= r : Number(t) <= Number(r);
}, gg = hg, bg = function({ value: t }, r = 1) {
  return Array.isArray(t) ? t.length >= r : Number(t) >= Number(r);
}, _g = bg, $g = function({ value: t }, ...r) {
  return !r.some((n) => typeof n == "object" ? ws(n, t) : n === t);
}, kg = $g, wg = function({ value: t }) {
  return !isNaN(t);
}, Sg = wg, uo = function(e, ...t) {
  return $n(e.value) ? t.map((n) => {
    var a;
    return (a = e.at(n)) == null ? void 0 : a.value;
  }).some((n) => !$n(n)) : !0;
};
uo.skipEmpty = !1;
var Pg = uo, co = function({ value: t }, r = "default") {
  return r === "trim" && typeof t == "string" ? !$n(t.trim()) : !$n(t);
};
co.skipEmpty = !1;
var Ig = co, Cg = function({ value: t }, ...r) {
  return typeof t == "string" && r.length ? r.some((n) => t.startsWith(n)) : typeof t == "string" && r.length === 0;
}, Eg = Cg, Ag = function({ value: e }) {
  return /^[!-/:-@[-`{-~]+$/.test(String(e));
}, Tg = Ag, Lg = function({ value: e }, t = "default") {
  const r = {
    default: new RegExp("^\\p{Lu}+$", "u"),
    latin: /^[A-Z]+$/
  }, n = pt(r, t) ? t : "default";
  return r[n].test(String(e));
}, Mg = Lg, Og = function({ value: t }, ...r) {
  try {
    const n = r.length ? r : ["http:", "https:"], a = new URL(String(t));
    return n.includes(a.protocol);
  } catch {
    return !1;
  }
}, Ng = Og;
const Fg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accepted: gh,
  alpha: Ih,
  alpha_spaces: Eh,
  alphanumeric: Th,
  between: xh,
  confirm: zh,
  contains_alpha: Bh,
  contains_alpha_spaces: qh,
  contains_alphanumeric: Uh,
  contains_lowercase: Yh,
  contains_numeric: Qh,
  contains_symbol: Xh,
  contains_uppercase: eg,
  date_after: _h,
  date_after_node: Sh,
  date_after_or_equal: kh,
  date_before: Mh,
  date_before_node: Nh,
  date_before_or_equal: Dh,
  date_between: rg,
  date_format: ag,
  email: ig,
  ends_with: og,
  is: cg,
  length: dg,
  lowercase: mg,
  matches: yg,
  max: gg,
  min: _g,
  not: kg,
  number: Sg,
  require_one: Pg,
  required: Ig,
  starts_with: Eg,
  symbol: Tg,
  uppercase: Mg,
  url: Ng
}, Symbol.toStringTag, { value: "Module" }));
var Dg = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function Un() {
  return Math.random().toString(36).substring(2, 15);
}
function Et(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function ur(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return Rg(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const a of n)
      if ((a in e || a in t) && e[a] !== t[a])
        return !1;
    for (const a in e)
      if (!(a in t) || e[a] !== t[a] && !r || r && !ur(e[a], t[a], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function Rg(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function Ir(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function Na(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function rn(e) {
  return Na(e) || Array.isArray(e);
}
function ci(e) {
  if (Na(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(Na(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
var fo = /* @__NO_SIDE_EFFECTS__ */ (e, t, r = !1, n = !1) => {
  if (t === null)
    return null;
  const a = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (Et(t, s) && (t[s] !== void 0 || !n)) {
      if (r && Array.isArray(e[s]) && Array.isArray(t[s])) {
        a[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      ci(e[s]) && ci(t[s]) ? a[s] = /* @__PURE__ */ fo(
        e[s],
        t[s],
        r,
        n
      ) : a[s] = t[s];
    } else
      a[s] = e[s];
  for (const s in t)
    !Et(a, s) && t[s] !== void 0 && (a[s] = t[s]);
  return a;
};
function xg(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, r) => r.toUpperCase()
  );
}
function Hg(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, r, n) => r + "-" + n.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function Or(e, t = Dg) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let r;
  Array.isArray(e) ? r = e.map((n) => typeof n == "object" ? Or(n, t) : n) : r = Object.keys(e).reduce((n, a) => (n[a] = typeof e[a] == "object" ? Or(e[a], t) : e[a], n), {});
  for (const n of t)
    n in e && Object.defineProperty(r, n, {
      enumerable: !1,
      value: e[n]
    });
  return r;
}
function Nt(e) {
  return typeof e == "object" ? Or(e) : e;
}
function fi(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function cr(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function zg(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function po() {
  const e = [];
  let t = 0;
  const r = (a) => e.push(a), n = (a) => {
    const s = e[t];
    return typeof s == "function" ? s(a, (i) => (t++, n(i))) : (t = 0, a);
  };
  return r.dispatch = n, r.unshift = (a) => e.unshift(a), r.remove = (a) => {
    const s = e.indexOf(a);
    s > -1 && e.splice(s, 1);
  }, r;
}
function Vg() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r;
  const n = (a, s) => {
    if (r) {
      r.set(s.name, [a, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((i) => {
      (s.origin === a || i.modifiers.includes("deep")) && i.listener(s);
    }), s.bubble && a.bubble(s);
  };
  return n.flush = () => {
    e.clear(), t.clear(), r == null || r.clear();
  }, n.on = (a, s, i = "push") => {
    const [l, ...o] = a.split("."), u = s.receipt || Un(), f = {
      modifiers: o,
      event: l,
      listener: s,
      receipt: u
    };
    return e.has(l) ? e.get(l)[i](f) : e.set(l, [f]), t.has(u) ? t.get(u)[i](l) : t.set(u, [l]), u;
  }, n.off = (a) => {
    var s;
    t.has(a) && ((s = t.get(a)) == null || s.forEach((i) => {
      const l = e.get(i);
      Array.isArray(l) && e.set(
        i,
        l.filter((o) => o.receipt !== a)
      );
    }), t.delete(a));
  }, n.pause = (a) => {
    r || (r = /* @__PURE__ */ new Map()), a && a.walk((s) => s._e.pause());
  }, n.play = (a) => {
    if (!r)
      return;
    const s = r;
    r = void 0, s.forEach(([i, l]) => n(i, l)), a && a.walk((i) => i._e.play());
  }, n;
}
function Bg(e, t, r, n, a = !0, s) {
  return t._e(e, {
    payload: n,
    name: r,
    bubble: a,
    origin: e,
    meta: s
  }), e;
}
function jg(e, t, r) {
  return Ss(e.parent) && e.parent._e(e.parent, r), e;
}
function qg(e, t, r, n, a) {
  return t._e.on(r, n, a);
}
function Wg(e, t, r) {
  return t._e.off(r), e;
}
var mo = po();
mo((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var vo = po();
vo((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const r = t(e);
  return console && typeof console.warn == "function" && console.warn(r.message), r;
});
function yo(e, t = {}) {
  vo.dispatch({ code: e, data: t });
}
function Nr(e, t = {}) {
  throw Error(mo.dispatch({ code: e, data: t }).message);
}
function Fr(e, t) {
  return {
    blocking: !1,
    key: Un(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
function Ug(e, ...t) {
  const r = `${e.name}-set`, n = (a) => /* @__PURE__ */ Fr({
    key: zg(a),
    type: "error",
    value: a,
    meta: { source: r, autoClear: !0 }
  });
  return t.filter((a) => !!a).map((a) => {
    if (typeof a == "string" && (a = [a]), Array.isArray(a))
      return a.map((s) => n(s));
    {
      const s = {};
      for (const i in a)
        Array.isArray(a[i]) ? s[i] = a[i].map(
          (l) => n(l)
        ) : s[i] = [n(a[i])];
      return s;
    }
  });
}
var ho = /* @__PURE__ */ new Map(), ua = /* @__PURE__ */ new Map(), Kg = Vg();
function Yg(e) {
  if (ua.has(e)) {
    const t = ua.get(e);
    ua.delete(e), ho.delete(t), Kg(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function Gg(e) {
  return ho.get(e);
}
function di(e, t, r) {
  let n = !0;
  return t in e.config._t ? n = !1 : e.emit(`config:${t}`, r, !1), t in e.props || (e.emit("prop", { prop: t, value: r }), e.emit(`prop:${t}`, r)), n;
}
function Qg(e, t) {
  const r = (t || document).getElementById(e);
  if (r instanceof HTMLFormElement) {
    const n = new Event("submit", { cancelable: !0, bubbles: !0 });
    r.dispatchEvent(n);
    return;
  }
  yo(151, e);
}
function Zg(e) {
  const t = (r) => {
    for (const n in r.store) {
      const a = r.store[n];
      a.type === "error" || a.type === "ui" && n === "incomplete" ? r.store.remove(n) : a.type === "state" && r.store.set({ ...a, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function Xg(e, t) {
  const r = typeof e == "string" ? Gg(e) : e;
  if (r) {
    const n = (i) => {
      const l = Nt(i.props.initial);
      return l !== void 0 ? l : i.type === "group" ? {} : i.type === "list" ? [] : void 0;
    };
    r._e.pause(r);
    const a = Nt(t);
    return t && !Ir(t) && (r.props.initial = rn(a) ? cr(a) : a, r.props._init = r.props.initial), r.input(n(r), !1), r.walk((i) => {
      i.type === "list" && i.sync || i.input(n(i), !1);
    }), r.input(
      Ir(a) && a ? a : n(r),
      !1
    ), r.type !== "input" && t && !Ir(t) && rn(t) && r.walk((i) => {
      i.props.initial = rn(i.value) ? cr(i.value) : i.value, i.props._init = i.props.initial;
    }), r._e.play(r), Zg(r), r.emit("reset", r), r;
  }
  yo(152, e);
}
var Jg = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${Hg(e)}`]: !0 })
}, eb = Symbol("index"), Fa = Symbol("removed"), Da = Symbol("moved"), go = Symbol("inserted");
function tb(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Ss(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var nn = (e, t, r) => {
  Nr(102, [e, r]);
};
fe($b, nn, !1), fe(pb), fe(db), fe(wb, nn, !1), fe(Sb), fe(jg), fe(Nb), fe(ub), fe(!1), fe(fb), fe(ob), fe(cb), fe(Fb), fe(ib), fe(_b, bb, !1), fe(ab), fe(yb), fe(Bg), fe(Ib), fe(qg), fe(Wg), fe(!1, mb), fe(!1), fe(vb), fe(Eb, nn, !1), fe(Mb), fe(gb), fe(Ob), fe(Lb), fe(Tb), fe($o), fe(kb, !1, !1), fe(hb);
function fe(e, t, r = !0) {
  return {
    get: e ? (n, a) => r ? (...s) => e(n, a, ...s) : e(n, a) : !1,
    set: t !== void 0 ? t : nn.bind(null)
  };
}
var rb = 0;
function nb(e) {
  return e.type === "group" ? cr(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? cr(Array.isArray(e.value) ? e.value : []) : e.value;
}
function ab(e, t, r, n = !0) {
  return t._value = sb(e, e.hook.input.dispatch(r)), e.emit("input", t._value), e.isCreated && e.type === "input" && ur(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), n ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    kn,
    e.props.delay,
    e,
    t
  )) : kn(e, t), t.settled);
}
function sb(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && Nr(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || Nr(108, [e, t]);
      break;
  }
  return t;
}
function kn(e, t, r = !0, n = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && n && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), r && e.calm();
}
function bo(e, { name: t, value: r, from: n }) {
  if (!Object.isFrozen(e._value)) {
    if (tb(e)) {
      const a = r === Fa ? [] : r === Da && typeof n == "number" ? e._value.splice(n, 1) : [r];
      e._value.splice(
        t,
        r === Da || n === go ? 0 : 1,
        ...a
      );
      return;
    }
    r !== Fa ? e._value[t] = r : delete e._value[t];
  }
}
function ib(e, t) {
  const r = t._value;
  return e.type === "list" && e.sync && lb(e, t), t.children.forEach((n) => {
    if (typeof r == "object")
      if (n.name in r) {
        const a = n.type !== "input" || r[n.name] && typeof r[n.name] == "object" ? cr(r[n.name]) : r[n.name];
        if (!n.isSettled || (!rn(a) || n.props.mergeStrategy) && ur(a, n._value))
          return;
        n.input(a, !1);
      } else
        (e.type !== "list" || typeof n.name == "number") && bo(t, { name: n.name, value: n.value }), r.__init || (n.type === "group" ? n.input({}, !1) : n.type === "list" ? n.input([], !1) : n.input(void 0, !1));
  }), e;
}
function lb(e, t) {
  const r = e._value;
  if (!Array.isArray(r))
    return;
  const n = [], a = new Set(t.children), s = /* @__PURE__ */ new Map();
  r.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      n.push(t.children[o]), a.delete(t.children[o]);
    else {
      n.push(null);
      const u = s.get(l) || [];
      u.push(o), s.set(l, u);
    }
  }), a.size && s.size && a.forEach((l) => {
    if (s.has(l._value)) {
      const o = s.get(l._value), u = o.shift();
      n[u] = l, a.delete(l), o.length || s.delete(l._value);
    }
  });
  const i = [];
  for (s.forEach((l) => {
    i.push(...l);
  }); a.size && i.length; ) {
    const l = a.values().next().value, o = i.shift();
    if (o === void 0)
      break;
    n[o] = l, a.delete(l);
  }
  i.forEach((l, o) => {
    n[l] = Db({ value: o });
  }), a.size && a.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || Rb(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = n;
}
function ob(e, t) {
  var r;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && ((r = e.parent) == null || r.disturb())), t._d++, e;
}
function ub(e, t, r) {
  var n;
  if (r !== void 0 && e.type !== "input") {
    bo(t, r);
    const a = !!(e.config.mergeStrategy && e.config.mergeStrategy[r.name]);
    return kn(e, t, !0, a);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((n = e.parent) == null || n.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function cb(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), Yg(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const r in t.context)
    delete t.context[r];
  t.plugins.clear(), t.context = null;
}
function fb(e, t, r) {
  t.type = r.type;
  const n = Or(r);
  e.props.__propDefs = _o(
    e.props.__propDefs ?? [],
    (n == null ? void 0 : n.props) || []
  ), n.props = e.props.__propDefs, t.props.definition = n, t.value = t._value = nb({
    type: e.type,
    value: t.value
  }), r.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = r.forceTypeProp), r.family && (t.props.family = r.family), r.features && r.features.forEach((a) => a(e)), r.props && e.addProps(r.props), e.emit("defined", r);
}
function db(e, t, r) {
  const n = Array.isArray(r) ? r : Object.keys(r), a = Array.isArray(r) ? {} : n.reduce((i, l) => ("default" in r[l] && (i[l] = r[l].default), i), {});
  if (e.props.attrs) {
    const i = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in i) {
      const u = xg(o);
      n.includes(u) && (e.props[u] = i[o], delete i[o]);
    }
    Array.isArray(r) || n.forEach((o) => {
      "default" in r[o] && e.props[o] === void 0 && (e.props[o] = a[o]);
    });
    const l = Nt(t._value);
    e.props.initial = e.type !== "input" ? cr(l) : l, e.props._emit = !0, e.props.attrs = i;
  }
  const s = _o(e.props.__propDefs ?? [], r);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", r), e;
}
function pi(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] = {}, t), {}) : e;
}
function _o(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : fo(pi(e), pi(t));
}
function pb(e, t, r, n) {
  if (e.type === "input" && Nr(100, e), r.parent && r.parent !== e && r.parent.remove(r), !t.children.includes(r)) {
    if (n !== void 0 && e.type === "list") {
      const a = t.children[n];
      a && "__FKP" in a ? (r._c.uid = a.uid, t.children.splice(n, 1, r)) : t.children.splice(n, 0, r), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: n,
        value: r.value,
        from: go
      });
    } else
      t.children.push(r);
    r.isSettled || e.disturb();
  }
  if (r.parent !== e) {
    if (r.parent = e, r.parent !== e)
      return e.remove(r), r.parent.add(r), e;
  } else
    r.use(e.plugins);
  return kn(e, t, !1), e.ledger.merge(r), e.emit("child", r), e;
}
function mb(e, t, r, n) {
  return Ss(n) ? (e.parent && e.parent !== n && e.parent.remove(e), t.parent = n, e.resetConfig(), n.children.includes(e) ? e.use(n.plugins) : n.add(e), !0) : n === null ? (t.parent = null, !0) : !1;
}
function vb(e, t, r) {
  const n = t.children.indexOf(r);
  if (n !== -1) {
    r.isSettled && e.disturb(), t.children.splice(n, 1);
    let a = fi(r.props.preserve), s = r.parent;
    for (; a === void 0 && s; )
      a = fi(s.props.preserve), s = s.parent;
    a ? e.calm() : e.calm({
      name: e.type === "list" ? n : r.name,
      value: Fa
    }), r.parent = null, r.config._rmn = r;
  }
  return e.ledger.unmerge(r), e.emit("childRemoved", r), e;
}
function yb(e, t, r) {
  t.children.forEach((n) => !("__FKP" in n) && r(n));
}
function hb(e, t, r, n = !1, a = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const i = r(s);
    return n && i === !1 ? !0 : a && i === !1 ? !1 : s.walk(r, n, a);
  });
}
function gb(e, t) {
  const r = e.parent || void 0;
  t.config = Ab(e.config._t, r), e.walk((n) => n.resetConfig());
}
function $o(e, t, r, n = !0, a = !0) {
  return Array.isArray(r) || r instanceof Set ? (r.forEach((s) => $o(e, t, s)), e) : (t.plugins.has(r) || (a && typeof r.library == "function" && r.library(e), n && r(e) !== !1 && (t.plugins.add(r), e.children.forEach((s) => s.use(r)))), e);
}
function bb(e, t, r, n) {
  if (Ss(e.parent)) {
    const a = e.parent.children, s = n >= a.length ? a.length - 1 : n < 0 ? 0 : n, i = a.indexOf(e);
    return i === -1 ? !1 : (a.splice(i, 1), a.splice(s, 0, e), e.parent.children = a, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: Da, from: i }), !0);
  }
  return !1;
}
function _b(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function $b(e, t) {
  return t;
}
function kb(e, t) {
  var r;
  return ((r = e.parent) == null ? void 0 : r.type) === "list" ? e.index : t.name !== eb ? t.name : e.index;
}
function wb(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function Sb(e, t, r) {
  const n = typeof r == "string" ? r.split(e.config.delimiter) : r;
  if (!n.length)
    return;
  const a = n[0];
  let s = e.parent;
  for (s || (String(n[0]) === String(e.name) && n.shift(), s = e), a === "$parent" && n.shift(); s && n.length; ) {
    const i = n.shift();
    switch (i) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(i)
        ) || Pb(s, i);
    }
  }
  return s || void 0;
}
function Pb(e, t) {
  const r = String(t).match(/^(find)\((.*)\)$/);
  if (r) {
    const [, n, a] = r, s = a.split(",").map((i) => i.trim());
    switch (n) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function Ib(e, t, r, n) {
  return Cb(e, r, n);
}
function Cb(e, t, r = "name") {
  const n = typeof r == "string" ? (s) => s[r] == t : r, a = [e];
  for (; a.length; ) {
    const s = a.shift();
    if (!("__FKP" in s)) {
      if (n(s, t))
        return s;
      a.push(...s.children);
    }
  }
}
function Eb(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function Ab(e = {}, t) {
  let r;
  return new Proxy(e, {
    get(...n) {
      const a = n[1];
      if (a === "_t")
        return e;
      const s = Reflect.get(...n);
      if (s !== void 0)
        return s;
      if (t) {
        const i = t.config[a];
        if (i !== void 0)
          return i;
      }
      if (e.rootConfig && typeof a == "string") {
        const i = e.rootConfig[a];
        if (i !== void 0)
          return i;
      }
      return a === "delay" && (r == null ? void 0 : r.type) === "input" ? 20 : Jg[a];
    },
    set(...n) {
      const a = n[1], s = n[2];
      if (a === "_n")
        return r = s, e.rootConfig && e.rootConfig._add(r), !0;
      if (a === "_rmn")
        return e.rootConfig && e.rootConfig._rm(r), r = void 0, !0;
      if (!ur(e[a], s, !1)) {
        const i = Reflect.set(...n);
        return r && (r.emit(`config:${a}`, s, !1), di(r, a, s), r.walk((l) => di(l, a, s), !1, !0)), i;
      }
      return !0;
    }
  });
}
function Tb(e, t, r, n = "ui") {
  const a = typeof r == "string" ? { key: r, value: r, type: n } : r, s = e.hook.text.dispatch(a);
  return e.emit("text", s, !1), s.value;
}
function Lb(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || Nr(106, t), e = e.parent;
  } while (e);
  e.props.id && Qg(e.props.id, e.props.__root);
}
function Mb(e, t, r) {
  return Xg(e, r);
}
function Ob(e, t, r, n) {
  const a = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: r, childErrors: n });
  return Ug(e, s.localErrors, s.childErrors).forEach(
    (i) => {
      e.store.apply(i, (l) => l.meta.source === a);
    }
  ), e;
}
function Nb(e, t, r = !0, n) {
  return e.store.filter((a) => !(n === void 0 || a.meta.source === n), "error"), r && (n = n || `${e.name}-set`, e.walk((a) => {
    a.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === n));
  })), e;
}
function Fb(e, t, r, n) {
  return t.traps.set(r, n), e;
}
function Db(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${rb++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function Rb(e) {
  return "__FKP" in e;
}
var Ra = /* @__PURE__ */ Fr({
  type: "state",
  blocking: !0,
  visible: !1,
  value: !0,
  key: "validating"
});
function xb(e = {}) {
  return function(r) {
    let n = Nt(r.props.validationRules || {}), a = { ...e, ...n };
    const s = { input: Un(), rerun: null, isPassing: !0 };
    let i = Nt(r.props.validation);
    r.on("prop:validation", ({ payload: o }) => l(o, n)), r.on(
      "prop:validationRules",
      ({ payload: o }) => l(i, o)
    );
    function l(o, u) {
      var f;
      ur(Object.keys(n || {}), Object.keys(u || {})) && ur(i, o) || (n = Nt(u), i = Nt(o), a = { ...e, ...n }, (f = r.props.parsedRules) == null || f.forEach((p) => {
        ko(p), so(p.observer.receipts), p.observer.kill();
      }), r.store.filter(() => !1, "validation"), r.props.parsedRules = vi(o, a, r), s.isPassing = !0, xa(r, r.props.parsedRules, s));
    }
    r.props.parsedRules = vi(i, a, r), xa(r, r.props.parsedRules, s);
  };
}
function xa(e, t, r) {
  ks(e) || (r.input = Un(), e.store.set(
    /* @__PURE__ */ Fr({
      key: "failing",
      value: !r.isPassing,
      visible: !1
    })
  ), r.isPassing = !0, e.store.filter((n) => !n.meta.removeImmediately, "validation"), t.forEach(
    (n) => n.debounce && clearTimeout(n.timer)
  ), t.length && (e.store.set(Ra), Ha(0, t, r, !1, () => {
    e.store.remove(Ra.key), e.store.set(
      /* @__PURE__ */ Fr({
        key: "failing",
        value: !r.isPassing,
        visible: !1
      })
    );
  })));
}
function Ha(e, t, r, n, a) {
  const s = t[e];
  if (!s)
    return a();
  const i = s.observer;
  if (ks(i))
    return;
  const l = r.input;
  s.state = null;
  function o(u, f) {
    if (r.input !== l)
      return;
    r.isPassing = r.isPassing && !!f, s.queued = !1;
    const p = i.stopObserve(), h = lo(s.deps, p);
    if (ao(
      i,
      h,
      function() {
        try {
          i.store.set(Ra);
        } catch {
        }
        s.queued = !0, r.rerun && clearTimeout(r.rerun), r.rerun = setTimeout(
          xa,
          0,
          i,
          t,
          r
        );
      },
      "unshift"
      // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
    ), s.deps = p, s.state = f, f === !1 ? zb(s, n || u) : ko(s), t.length > e + 1) {
      const c = t[e + 1];
      (f || c.force || !c.skipEmpty) && c.state === null && (c.queued = !0), Ha(e + 1, t, r, n || u, a);
    } else
      a();
  }
  (!Ir(i.value) || !s.skipEmpty) && (r.isPassing || s.force) ? s.queued ? Hb(s, i, (u) => {
    u instanceof Promise ? u.then((f) => o(!0, f)) : o(!1, u);
  }) : Ha(e + 1, t, r, n, a) : Ir(i.value) && s.skipEmpty && r.isPassing ? (i.observe(), i.value, o(!1, r.isPassing)) : o(!1, null);
}
function Hb(e, t, r) {
  e.debounce ? e.timer = setTimeout(() => {
    t.observe(), r(e.rule(t, ...e.args));
  }, e.debounce) : (t.observe(), r(e.rule(t, ...e.args)));
}
function ko(e) {
  const t = `rule_${e.name}`;
  e.messageObserver && (e.messageObserver = e.messageObserver.kill()), Et(e.observer.store, t) && e.observer.store.remove(t);
}
function zb(e, t) {
  const r = e.observer;
  ks(r) || (e.messageObserver || (e.messageObserver = Wn(r._node)), e.messageObserver.watch(
    (n) => Bb(
      n,
      e
    ),
    (n) => {
      const a = Vb(r, e, n), s = /* @__PURE__ */ Fr({
        blocking: e.blocking,
        key: `rule_${e.name}`,
        meta: {
          /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */
          messageKey: e.name,
          /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */
          removeImmediately: t,
          /**
           * Determines if this message should be passed to localization.
           */
          localize: !a,
          /**
           * The arguments that will be passed to the validation rules
           */
          i18nArgs: n
        },
        type: "validation",
        value: a || "This field is not valid."
      });
      r.store.set(s);
    }
  ));
}
function Vb(e, t, r) {
  const n = e.props.validationMessages && Et(e.props.validationMessages, t.name) ? e.props.validationMessages[t.name] : void 0;
  return typeof n == "function" ? n(...r) : n;
}
function Bb(e, t) {
  return [
    {
      node: e,
      name: wo(e),
      args: t.args
    }
  ];
}
function wo(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
var So = "(?:[\\*+?()0-9]+)", Po = "[a-zA-Z][a-zA-Z0-9_]+", jb = new RegExp(
  `^(${So}?${Po})(?:\\:(.*)+)?$`,
  "i"
), qb = new RegExp(`^(${So})(${Po})$`, "i"), Wb = /([\*+?]+)?(\(\d+\))([\*+?]+)?/, mi = /\(\d+\)/, Ub = {
  blocking: !0,
  debounce: 0,
  force: !1,
  skipEmpty: !0,
  name: ""
};
function vi(e, t, r) {
  return e ? (typeof e == "string" ? Kb(e) : Or(e)).reduce((a, s) => {
    let i = s.shift();
    const l = {};
    if (typeof i == "string") {
      const [o, u] = Gb(i);
      Et(t, o) && (i = t[o], Object.assign(l, u));
    }
    return typeof i == "function" && a.push({
      observer: Wn(r),
      rule: i,
      args: s,
      timer: 0,
      state: null,
      queued: !0,
      deps: /* @__PURE__ */ new Map(),
      ...Ub,
      ...Qb(l, i)
    }), a;
  }, []) : [];
}
function Kb(e) {
  return e.split("|").reduce((t, r) => {
    const n = Yb(r);
    return n && t.push(n), t;
  }, []);
}
function Yb(e) {
  const t = e.trim();
  if (t) {
    const r = t.match(jb);
    if (r && typeof r[1] == "string") {
      const n = r[1].trim(), a = r[2] && typeof r[2] == "string" ? r[2].split(",").map((s) => s.trim()) : [];
      return [n, ...a];
    }
  }
  return !1;
}
function Gb(e) {
  const t = e.match(qb);
  if (!t)
    return [e, { name: e }];
  const r = {
    "*": { force: !0 },
    "+": { skipEmpty: !1 },
    "?": { blocking: !1 }
  }, [, n, a] = t, s = mi.test(n) ? n.match(Wb) || [] : [, n];
  return [
    a,
    [s[1], s[2], s[3]].reduce(
      (i, l) => (l && (mi.test(l) ? i.debounce = parseInt(l.substr(1, l.length - 1)) : l.split("").forEach(
        (o) => Et(r, o) && Object.assign(i, r[o])
      )), i),
      { name: a }
    )
  ];
}
function Qb(e, t) {
  return e.name || (e.name = t.ruleName || t.name), ["skipEmpty", "force", "debounce", "blocking"].reduce(
    (r, n) => (Et(t, n) && !Et(r, n) && Object.assign(r, {
      [n]: t[n]
    }), r),
    e
  );
}
function wn(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function oe(e) {
  return e[0].toUpperCase() + e.substr(1);
}
function yi(e, t = "or") {
  return e.reduce((r, n, a) => (r += n, a <= e.length - 2 && e.length > 2 && (r += ", "), a === e.length - 2 && (r += `${e.length === 2 ? " " : ""}${t} `), r), "");
}
function Yr(e) {
  const t = typeof e == "string" ? new Date(Date.parse(e)) : e;
  return t instanceof Date ? new Intl.DateTimeFormat(void 0, {
    dateStyle: "medium",
    timeZone: "UTC"
  }).format(t) : "(unknown)";
}
function Zb(e, t) {
  return Number(e) >= Number(t) ? [t, e] : [e, t];
}
var Xb = {
  /**
   * Shown on a button for adding additional items.
   */
  add: "Add",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Remove",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Remove all",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Sorry, not all fields are filled out correctly.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Submit",
  /**
   * Shown when no files are selected.
   */
  noFiles: "No file chosen",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Move up",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Move down",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Loading...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Load more",
  /**
   * Show on buttons that navigate state forward
   */
  next: "Next",
  /**
   * Show on buttons that navigate state backward
   */
  prev: "Previous",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Add all values",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Add selected values",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Remove all values",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Remove selected values",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choose date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Change date",
  /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */
  summaryHeader: "There were errors in your form.",
  /*
   * Shown when there is something to close
   */
  close: "Close",
  /**
   * Shown when there is something to open.
   */
  open: "Open"
}, Jb = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Please accept the ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${oe(e)} must be after ${Yr(t[0])}.` : `${oe(e)} must be in the future.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${oe(e)} can only contain alphabetical characters.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${oe(e)} can only contain letters and numbers.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${oe(e)} can only contain letters and spaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${oe(e)} must contain alphabetical characters.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${oe(e)} must contain letters or numbers.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${oe(e)} must contain letters or spaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${oe(e)} must contain a symbol.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${oe(e)} must contain an uppercase letter.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${oe(e)} must contain a lowercase letter.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${oe(e)} must contain numbers.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${oe(e)} must be a symbol.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${oe(e)} can only contain uppercase letters.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e, args: t }) {
    let r = "";
    return Array.isArray(t) && t.length && (t[0] === "allow_non_alpha" && (r = ", numbers and symbols"), t[0] === "allow_numeric" && (r = " and numbers"), t[0] === "allow_numeric_dashes" && (r = ", numbers and dashes")), `${oe(e)} can only contain lowercase letters${r}.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${oe(e)} must be before ${Yr(t[0])}.` : `${oe(e)} must be in the past.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "This field was configured incorrectly and can’t be submitted.";
    const [r, n] = Zb(t[0], t[1]);
    return `${oe(e)} must be between ${r} and ${n}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${oe(e)} does not match.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${oe(e)} is not a valid date, please use the format ${t[0]}` : "This field was configured incorrectly and can’t be submitted";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${oe(e)} must be between ${Yr(t[0])} and ${Yr(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Please enter a valid email address.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${oe(e)} doesn’t end with ${yi(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${oe(e)} is not an allowed value.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, r = 1 / 0] }) {
    const n = Number(t) <= Number(r) ? t : r, a = Number(r) >= Number(t) ? r : t;
    return n == 1 && a === 1 / 0 ? `${oe(e)} must be at least one character.` : n == 0 && a ? `${oe(e)} must be less than or equal to ${a} characters.` : n === a ? `${oe(e)} should be ${a} characters long.` : n && a === 1 / 0 ? `${oe(e)} must be greater than or equal to ${n} characters.` : `${oe(e)} must be between ${n} and ${a} characters.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${oe(e)} is not an allowed value.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: r }) {
    return Array.isArray(t) ? `Cannot have more than ${r[0]} ${e}.` : `${oe(e)} must be no more than ${r[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${oe(e)} must be of the type: ${t[0]}` : "No file formats allowed.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: r }) {
    return Array.isArray(t) ? `Cannot have fewer than ${r[0]} ${e}.` : `${oe(e)} must be at least ${r[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” is not an allowed ${e}.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${oe(e)} must be a number.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: r }) => {
    const n = r.map((a) => {
      const s = t.at(a);
      return s ? wo(s) : !1;
    }).filter((a) => !!a);
    return n.unshift(e), `${n.join(" or ")} is required.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${oe(e)} is required.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${oe(e)} doesn’t start with ${yi(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Please enter a valid URL.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "The selected date is invalid."
}, e_ = { ui: Xb, validation: Jb }, hi = /* @__PURE__ */ new Set();
function t_(e) {
  return function(r) {
    hi.add(r), r.on("destroying", () => hi.delete(r));
    let n = gi(r.config.locale, e), a = n ? e[n] : {};
    r.on("prop:locale", ({ payload: s }) => {
      n = gi(s, e), a = n ? e[n] : {}, r.store.touch();
    }), r.on("prop:label", () => r.store.touch()), r.on("prop:validationLabel", () => r.store.touch()), r.hook.text((s, i) => {
      var o, u;
      const l = ((o = s.meta) == null ? void 0 : o.messageKey) || s.key;
      if (wn(a, s.type) && wn(a[s.type], l)) {
        const f = a[s.type][l];
        typeof f == "function" ? s.value = Array.isArray((u = s.meta) == null ? void 0 : u.i18nArgs) ? f(...s.meta.i18nArgs) : f(s) : s.value = f;
      }
      return i(s);
    });
  };
}
function gi(e, t) {
  if (wn(t, e))
    return e;
  const [r] = e.split("-");
  if (wn(t, r))
    return r;
  for (const n in t)
    return n;
  return !1;
}
function r_(...e) {
  const t = e.reduce(
    (n, a) => Ct(n, a),
    {}
  ), r = () => {
  };
  return r.library = function(n) {
    const a = Zt(n.props.type);
    be(t, a) && n.define(t[a]);
  }, r;
}
var n_ = [
  "classes",
  "config",
  "delay",
  "errors",
  "id",
  "index",
  "inputErrors",
  "library",
  "modelValue",
  "onUpdate:modelValue",
  "name",
  "number",
  "parent",
  "plugins",
  "sectionsSchema",
  "type",
  "validation",
  "validationLabel",
  "validationMessages",
  "validationRules",
  // Runtime event props:
  "onInput",
  "onInputRaw",
  "onUpdate:modelValue",
  "onNode",
  "onSubmit",
  "onSubmitInvalid",
  "onSubmitRaw"
];
function Kn(e) {
  return e && typeof e == "object" && "group" in e && Array.isArray(e.options);
}
function Io(e, t = { count: 1 }) {
  return Array.isArray(e) ? e.map(
    (r) => {
      if (typeof r == "string" || typeof r == "number")
        return {
          label: String(r),
          value: String(r)
        };
      if (typeof r == "object") {
        if ("group" in r)
          return r.options = Io(r.options || [], t), r;
        "value" in r && typeof r.value != "string" && Object.assign(r, {
          value: `__mask_${t.count++}`,
          __original: r.value
        });
      }
      return r;
    }
  ) : Object.keys(e).map((r) => ({
    label: e[r],
    value: r
  }));
}
function Ht(e, t, r = !1) {
  if (Array.isArray(e)) {
    for (const n of e)
      if (!(typeof n != "object" && n)) {
        if (Kn(n)) {
          const a = Ht(n.options, t, !0);
          if (a !== void 0)
            return a;
        } else if (t == n.value)
          return "__original" in n ? n.__original : n.value;
      }
  }
  return r ? void 0 : t;
}
function fr(e, t) {
  return e === null && t === void 0 || e === void 0 && t === null ? !1 : e == t ? !0 : ir(e) && ir(t) ? nt(e, t) : !1;
}
function Ps(e) {
  e.hook.prop((t, r) => {
    var n;
    return t.prop === "options" && (typeof t.value == "function" ? (e.props.optionsLoader = t.value, t.value = []) : ((n = e.props)._normalizeCounter ?? (n._normalizeCounter = { count: 1 }), t.value = Io(t.value, e.props._normalizeCounter))), r(t);
  });
}
// @__NO_SIDE_EFFECTS__
function te(e, t, r = !1) {
  return (...n) => {
    const a = (s) => {
      const i = !t || typeof t == "string" ? { $el: t } : t();
      return (Ca(i) || Ea(i)) && (i.meta ? i.meta.section = e : i.meta = { section: e }, n.length && !i.children && (i.children = [
        ...n.map(
          (l) => typeof l == "function" ? l(s) : l
        )
      ]), Ca(i) && (i.attrs = {
        class: `$classes.${e}`,
        ...i.attrs || {}
      })), {
        if: `$slots.${e}`,
        then: `$slots.${e}`,
        else: e in s ? /* @__PURE__ */ _r(i, s[e]) : i
      };
    };
    return a._s = e, r ? /* @__PURE__ */ a_(a) : a;
  };
}
// @__NO_SIDE_EFFECTS__
function a_(e) {
  return (t) => [e(t)];
}
function Sn(e) {
  return !!(e && typeof e == "object" && ("$el" in e || "$cmp" in e || "$formkit" in e));
}
// @__NO_SIDE_EFFECTS__
function _r(e, t = {}) {
  return typeof e == "string" ? Sn(t) || typeof t == "string" ? t : e : Array.isArray(e) ? Sn(t) ? t : e : Ct(e, t);
}
var s_ = /* @__PURE__ */ te("actions", () => ({
  $el: "div",
  if: "$actions"
})), Pn = /* @__PURE__ */ te("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    name: "$node.props.altName || $node.name",
    disabled: "$option.attrs.disabled || $disabled",
    onInput: "$handlers.toggleChecked",
    checked: "$fns.eq($_value, $onValue)",
    onBlur: "$handlers.blur",
    value: "$: true",
    id: "$id",
    "aria-describedby": {
      if: "$options.length",
      then: {
        if: "$option.help",
        then: '$: "help-" + $option.attrs.id',
        else: void 0
      },
      else: {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }
})), Co = /* @__PURE__ */ te("optionHelp", () => ({
  $el: "div",
  if: "$option.help",
  attrs: {
    id: '$: "help-" + $option.attrs.id'
  }
})), In = /* @__PURE__ */ te("inner", "span"), Cn = /* @__PURE__ */ te("label", "span"), Eo = /* @__PURE__ */ te("option", () => ({
  $el: "li",
  for: ["option", "$options"],
  attrs: {
    "data-disabled": "$option.attrs.disabled || $disabled || undefined"
  }
})), Ao = /* @__PURE__ */ te("options", "ul"), En = /* @__PURE__ */ te("wrapper", () => ({
  $el: "label",
  attrs: {
    "data-disabled": {
      if: "$options.length",
      then: void 0,
      else: "$disabled || undefined"
    },
    "data-checked": {
      if: "$options == undefined",
      then: "$fns.eq($_value, $onValue) || undefined",
      else: "$fns.isChecked($option.value) || undefined"
    }
  }
})), i_ = /* @__PURE__ */ te("input", () => ({
  $el: "button",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    id: "$id"
  }
})), l_ = /* @__PURE__ */ te("default", null), An = /* @__PURE__ */ te("decorator", () => ({
  $el: "span",
  attrs: {
    "aria-hidden": "true"
  }
})), To = /* @__PURE__ */ te("fieldset", () => ({
  $el: "fieldset",
  attrs: {
    id: "$id",
    "aria-describedby": {
      if: "$help",
      then: '$: "help-" + $id',
      else: void 0
    }
  }
})), o_ = /* @__PURE__ */ te("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "file",
    disabled: "$disabled",
    name: "$node.name",
    onChange: "$handlers.files",
    onBlur: "$handlers.blur",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), u_ = /* @__PURE__ */ te("fileItem", () => ({
  $el: "li",
  for: ["file", "$value"]
})), c_ = /* @__PURE__ */ te("fileList", () => ({
  $el: "ul",
  if: "$value.length",
  attrs: {
    "data-has-multiple": "$_hasMultipleFiles"
  }
})), f_ = /* @__PURE__ */ te("fileName", () => ({
  $el: "span",
  attrs: {
    class: "$classes.fileName"
  }
})), bi = /* @__PURE__ */ te("fileRemove", () => ({
  $el: "button",
  attrs: {
    type: "button",
    onClick: "$handlers.resetFiles"
  }
})), d_ = /* @__PURE__ */ te("form", () => ({
  $el: "form",
  bind: "$attrs",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    id: "$id",
    name: "$node.name",
    onSubmit: "$handlers.submit",
    "data-loading": "$state.loading || undefined"
  }
})), Is = /* @__PURE__ */ te("wrapper", null, !0), $t = /* @__PURE__ */ te("help", () => ({
  $el: "div",
  if: "$help",
  attrs: {
    id: '$: "help-" + $id'
  }
})), Pe = (e, t) => (/* @__PURE__ */ te(`${e}Icon`, () => {
  const r = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$${e}Icon && $${r}`,
    $el: `${t || "span"}`,
    attrs: {
      class: `$classes.${e}Icon + " " + $classes.icon`,
      innerHTML: `$${r}`,
      onClick: `$handlers.iconClick(${e})`,
      role: `$fns.iconRole(${e})`,
      tabindex: `$fns.iconRole(${e}) === "button" && "0" || undefined`,
      for: {
        if: `${t === "label"}`,
        then: "$id"
      }
    }
  };
}))(), Yn = /* @__PURE__ */ te("inner", "div"), Gn = /* @__PURE__ */ te("label", () => ({
  $el: "label",
  if: "$label",
  attrs: {
    for: "$id"
  }
})), Lo = /* @__PURE__ */ te("legend", () => ({
  $el: "legend",
  if: "$label"
})), Tt = /* @__PURE__ */ te("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), Lt = /* @__PURE__ */ te("messages", () => ({
  $el: "ul",
  if: "$defaultMessagePlacement && $fns.length($messages)"
})), p_ = /* @__PURE__ */ te("noFiles", () => ({
  $el: "span",
  if: "$value == null || $value.length == 0"
})), m_ = /* @__PURE__ */ te("optGroup", () => ({
  $el: "optgroup",
  bind: "$option.attrs",
  attrs: {
    label: "$option.group"
  }
})), _i = /* @__PURE__ */ te("option", () => ({
  $el: "option",
  bind: "$option.attrs",
  attrs: {
    class: "$classes.option",
    value: "$option.value",
    selected: "$fns.isSelected($option)"
  }
})), $i = /* @__PURE__ */ te("options", () => ({
  $el: null,
  if: "$options.length",
  for: ["option", "$option.options || $options"]
})), Bt = /* @__PURE__ */ te("outer", () => ({
  $el: "div",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    key: "$id",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-has-multiple": "$_hasMultipleFiles",
    "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
    "data-empty": "$state.empty || undefined",
    "data-complete": "$state.complete || undefined",
    "data-invalid": "$state.invalid || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
    "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
    "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
    "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
  }
})), kt = /* @__PURE__ */ te("prefix", null), v_ = /* @__PURE__ */ te("input", () => ({
  $el: "select",
  bind: "$attrs",
  attrs: {
    id: "$id",
    "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
    disabled: "$disabled",
    class: "$classes.input",
    name: "$node.name",
    onChange: "$handlers.onChange",
    onInput: "$handlers.selectInput",
    onBlur: "$handlers.blur",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), y_ = /* @__PURE__ */ te("submit", () => ({
  $cmp: "FormKit",
  bind: "$submitAttrs",
  props: {
    type: "submit",
    label: "$submitLabel"
  }
})), wt = /* @__PURE__ */ te("suffix", null), Mo = /* @__PURE__ */ te("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), h_ = /* @__PURE__ */ te("input", () => ({
  $el: "textarea",
  bind: "$attrs",
  attrs: {
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  },
  children: "$initialValue"
})), jr = /* @__PURE__ */ te("wrapper", "div"), g_ = 0;
function Oo(e) {
  (e.type === "group" || e.type === "list") && e.plugins.add(b_);
}
function b_(e) {
  e.props.type === "radio" && (e.addProps(["altName"]), e.props.altName = `${e.name}_${g_++}`);
}
function No(e) {
  return function(t, r) {
    return t.prop === "options" && Array.isArray(t.value) && (t.value = t.value.map((n) => {
      var a;
      return (a = n.attrs) != null && a.id ? n : Ct(n, {
        attrs: {
          id: `${e.props.id}-option-${hs(String(n.value))}`
        }
      });
    }), e.props.type === "checkbox" && !Array.isArray(e.value) && (e.isCreated ? e.input([], !1) : e.on("created", () => {
      Array.isArray(e.value) || e.input([], !1);
    }))), r(t);
  };
}
function __(e, t) {
  const r = t.target;
  if (r instanceof HTMLInputElement) {
    const n = Array.isArray(e.props.options) ? Ht(e.props.options, r.value) : r.value;
    Array.isArray(e.props.options) && e.props.options.length ? Array.isArray(e._value) ? e._value.some((a) => fr(n, a)) ? e.input(
      e._value.filter(
        (a) => !fr(n, a)
      )
    ) : e.input([...e._value, n]) : e.input([n]) : r.checked ? e.input(e.props.onValue) : e.input(e.props.offValue);
  }
}
function $_(e, t) {
  var r, n;
  return (r = e.context) == null || r.value, (n = e.context) == null || n._value, Array.isArray(e._value) ? e._value.some(
    (a) => fr(Ht(e.props.options, t), a)
  ) : !1;
}
function k_(e) {
  e.on("created", () => {
    var t, r;
    (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = __.bind(null, e)), (r = e.context) != null && r.fns && (e.context.fns.isChecked = $_.bind(null, e)), be(e.props, "onValue") || (e.props.onValue = !0), be(e.props, "offValue") || (e.props.offValue = !1);
  }), e.hook.prop(No(e));
}
function Xt(e, t) {
  return (r) => {
    r.props[`${e}Icon`] === void 0 && (r.props[`${e}Icon`] = t.startsWith("<svg") ? t : `default:${t}`);
  };
}
function Cs(e) {
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = tt(e.props.disabled), e.config.disabled = tt(e.props.disabled));
  }), e.hook.prop(({ prop: t, value: r }, n) => (r = t === "disabled" ? tt(r) : r, n({ prop: t, value: r }))), e.on("prop:disabled", ({ payload: t }) => {
    e.config.disabled = tt(t);
  });
}
function an(e, t) {
  return (r) => {
    r.store.set(
      /* @__PURE__ */ _t({
        key: e,
        type: "ui",
        value: t || e,
        meta: {
          localize: !0,
          i18nArgs: [r]
        }
      })
    );
  };
}
var ca = typeof window < "u";
function Fo(e) {
  e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover") && e.target.removeAttribute("data-file-hover");
}
function ki(e, t) {
  t.target instanceof HTMLInputElement ? e === "dragover" && t.target.setAttribute("data-file-hover", "true") : t.preventDefault(), e === "drop" && Fo(t);
}
function w_(e) {
  an("noFiles", "Select file")(e), an("removeAll", "Remove all")(e), an("remove")(e), e.addProps(["_hasMultipleFiles"]), ca && (window._FormKit_File_Drop || (window.addEventListener(
    "dragover",
    ki.bind(null, "dragover")
  ), window.addEventListener("drop", ki.bind(null, "drop")), window.addEventListener("dragleave", Fo), window._FormKit_File_Drop = !0)), e.hook.input((t, r) => r(Array.isArray(t) ? t : [])), e.on("input", ({ payload: t }) => {
    e.props._hasMultipleFiles = Array.isArray(t) && t.length > 1 ? !0 : void 0;
  }), e.on("reset", () => {
    if (e.props.id && ca) {
      const t = document.getElementById(e.props.id);
      t && (t.value = "");
    }
  }), e.on("created", () => {
    Array.isArray(e.value) || e.input([], !1), e.context && (e.context.handlers.resetFiles = (t) => {
      if (t.preventDefault(), e.input([]), e.props.id && ca) {
        const r = document.getElementById(e.props.id);
        r && (r.value = ""), r == null || r.focus();
      }
    }, e.context.handlers.files = (t) => {
      var n, a;
      const r = [];
      if (t.target instanceof HTMLInputElement && t.target.files) {
        for (let s = 0; s < t.target.files.length; s++) {
          let i;
          (i = t.target.files.item(s)) && r.push({ name: i.name, file: i });
        }
        e.input(r);
      }
      e.context && (e.context.files = r), typeof ((n = e.props.attrs) == null ? void 0 : n.onChange) == "function" && ((a = e.props.attrs) == null || a.onChange(t));
    });
  });
}
var wi = /* @__PURE__ */ _t({
  key: "loading",
  value: !0,
  visible: !1
});
async function S_(e, t) {
  const r = Math.random();
  if (e.props._submitNonce = r, t.preventDefault(), await e.settled, e.ledger.value("validating") && (e.store.set(wi), await e.ledger.settled("validating"), e.store.remove("loading"), e.props._submitNonce !== r))
    return;
  const n = (a) => a.store.set(
    /* @__PURE__ */ _t({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
  if (e.walk(n), n(e), e.emit("submit-raw"), typeof e.props.onSubmitRaw == "function" && e.props.onSubmitRaw(t, e), e.ledger.value("blocking"))
    typeof e.props.onSubmitInvalid == "function" && e.props.onSubmitInvalid(e), e.props.incompleteMessage !== !1 && Do(e);
  else if (typeof e.props.onSubmit == "function") {
    const a = e.props.onSubmit(
      e.hook.submit.dispatch(Lr(e.value)),
      e
    );
    if (a instanceof Promise) {
      const s = e.props.disabled === void 0 && e.props.submitBehavior !== "live";
      s && (e.props.disabled = !0), e.store.set(wi), await a, s && (e.props.disabled = !1), e.store.remove("loading");
    }
  } else
    t.target instanceof HTMLFormElement && t.target.submit();
}
function Do(e) {
  e.store.set(
    /* @__PURE__ */ _t({
      blocking: !1,
      key: "incomplete",
      meta: {
        localize: e.props.incompleteMessage === void 0,
        i18nArgs: [{ node: e }],
        showAsMessage: !0
      },
      type: "ui",
      value: e.props.incompleteMessage || "Form incomplete."
    })
  );
}
function P_(e) {
  var t;
  e.props.isForm = !0, e.ledger.count("validating", (r) => r.key === "validating"), (t = e.props).submitAttrs ?? (t.submitAttrs = {
    disabled: e.props.disabled
  }), e.on("prop:disabled", ({ payload: r }) => {
    e.props.submitAttrs = { ...e.props.submitAttrs, disabled: r };
  }), e.on("created", () => {
    var r;
    (r = e.context) != null && r.handlers && (e.context.handlers.submit = S_.bind(null, e)), be(e.props, "actions") || (e.props.actions = !0);
  }), e.on("prop:incompleteMessage", () => {
    e.store.incomplete && Do(e);
  }), e.on("settled:blocking", () => e.store.remove("incomplete"));
}
function I_(e) {
  e.props.ignore === void 0 && (e.props.ignore = !0, e.parent = null);
}
function C_(e) {
  e.on("created", () => {
    e.context && (e.context.initialValue = e.value || "");
  });
}
function Ro(e) {
  if (typeof e.props.number > "u")
    return;
  const t = ["number", "range", "hidden"].includes(e.props.type);
  e.hook.input((r, n) => {
    if (r === "")
      return n(void 0);
    const a = e.props.number === "integer" ? parseInt(r) : parseFloat(r);
    return Number.isFinite(a) ? n(a) : n(t ? void 0 : r);
  });
}
function E_(e, t) {
  t.target instanceof HTMLInputElement && e.input(Ht(e.props.options, t.target.value));
}
function A_(e, t) {
  var r, n;
  return (r = e.context) == null || r.value, (n = e.context) == null || n._value, fr(Ht(e.props.options, t), e._value);
}
function T_(e) {
  e.on("created", () => {
    var t, r;
    Array.isArray(e.props.options) || Br(350, {
      node: e,
      inputType: "radio"
    }), (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = E_.bind(null, e)), (r = e.context) != null && r.fns && (e.context.fns.isChecked = A_.bind(null, e));
  }), e.hook.prop(No(e));
}
function L_(e, t) {
  if (Kn(t))
    return !1;
  e.context && e.context.value;
  const r = "__original" in t ? t.__original : t.value;
  return Array.isArray(e._value) ? e._value.some((n) => fr(n, r)) : (e._value === void 0 || e._value === null && !xo(e.props.options, null)) && t.attrs && t.attrs["data-is-placeholder"] ? !0 : fr(r, e._value);
}
function xo(e, t) {
  return e.some((r) => Kn(r) ? xo(r.options, t) : ("__original" in r ? r.__original : r.value) === t);
}
async function M_(e, t) {
  var r;
  typeof ((r = e.props.attrs) == null ? void 0 : r.onChange) == "function" && (await new Promise((n) => setTimeout(n, 0)), await e.settled, e.props.attrs.onChange(t));
}
function O_(e, t) {
  const r = t.target, n = r.hasAttribute("multiple") ? Array.from(r.selectedOptions).map(
    (a) => Ht(e.props.options, a.value)
  ) : Ht(e.props.options, r.value);
  e.input(n);
}
function Si(e, t) {
  return e.some(
    (r) => r.attrs && r.attrs["data-is-placeholder"]
  ) ? e : [
    {
      label: t,
      value: "",
      attrs: {
        hidden: !0,
        disabled: !0,
        "data-is-placeholder": "true"
      }
    },
    ...e
  ];
}
function Ho(e) {
  const t = e.length > 0 ? e[0] : void 0;
  if (t)
    return Kn(t) ? Ho(t.options) : "__original" in t ? t.__original : t.value;
}
function N_(e) {
  e.on("created", () => {
    var r, n, a;
    const t = tt((r = e.props.attrs) == null ? void 0 : r.multiple);
    !t && e.props.placeholder && Array.isArray(e.props.options) && (e.hook.prop(({ prop: s, value: i }, l) => (s === "options" && (i = Si(i, e.props.placeholder)), l({ prop: s, value: i }))), e.props.options = Si(
      e.props.options,
      e.props.placeholder
    )), t ? e.value === void 0 && e.input([], !1) : e.context && !e.context.options && (e.props.attrs = Object.assign({}, e.props.attrs, {
      value: e._value
    }), e.on("input", ({ payload: s }) => {
      e.props.attrs = Object.assign({}, e.props.attrs, {
        value: s
      });
    })), (n = e.context) != null && n.handlers && (e.context.handlers.selectInput = O_.bind(null, e), e.context.handlers.onChange = M_.bind(null, e)), (a = e.context) != null && a.fns && (e.context.fns.isSelected = L_.bind(null, e), e.context.fns.showPlaceholder = (s, i) => {
      if (!Array.isArray(e.props.options))
        return !1;
      const l = e.props.options.some(
        (o) => {
          if (o.attrs && "data-is-placeholder" in o.attrs)
            return !1;
          const u = "__original" in o ? o.__original : o.value;
          return nt(s, u);
        }
      );
      return i && !l ? !0 : void 0;
    });
  }), e.hook.input((t, r) => {
    var n, a, s;
    return !e.props.placeholder && t === void 0 && Array.isArray((n = e.props) == null ? void 0 : n.options) && e.props.options.length && !tt((s = (a = e.props) == null ? void 0 : a.attrs) == null ? void 0 : s.multiple) && (t = Ho(e.props.options)), r(t);
  });
}
// @__NO_SIDE_EFFECTS__
function za(e) {
  return !!(Ut(e) && e.if && e.if.startsWith("$slots.") && typeof e.then == "string" && e.then.startsWith("$slots.") && "else" in e);
}
// @__NO_SIDE_EFFECTS__
function yt(e, t, r) {
  const n = (a) => {
    const s = t(a);
    if (r || Sn(s) && "if" in s || /* @__PURE__ */ za(s)) {
      const i = {
        if: e,
        then: s
      };
      return r && (i.else = r(a)), i;
    } else /* @__PURE__ */ za(s) ? Object.assign(s.else, { if: e }) : Sn(s) && Object.assign(s, { if: e });
    return s;
  };
  return n._s = Vn(), n;
}
// @__NO_SIDE_EFFECTS__
function Jt(e, t) {
  const r = (n) => {
    const a = e({});
    return /* @__PURE__ */ za(a) ? (Array.isArray(a.else) || (a.else = /* @__PURE__ */ _r(
      /* @__PURE__ */ _r(a.else, t),
      e._s ? n[e._s] : {}
    )), a) : /* @__PURE__ */ _r(
      /* @__PURE__ */ _r(a, t),
      e._s ? n[e._s] : {}
    );
  };
  return r._s = e._s, r;
}
var Pi = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value")),
    /* @__PURE__ */ jr(
      /* @__PURE__ */ i_(
        /* @__PURE__ */ Pe("prefix"),
        /* @__PURE__ */ kt(),
        /* @__PURE__ */ l_("$label || $ui.submit.value"),
        /* @__PURE__ */ wt(),
        /* @__PURE__ */ Pe("suffix")
      )
    ),
    /* @__PURE__ */ $t("$help")
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "button",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [an("submit"), I_],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: "h6st4epl3j8"
}, F_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ yt(
      "$options == undefined",
      /**
       * Single checkbox structure.
       */
      /* @__PURE__ */ En(
        /* @__PURE__ */ In(/* @__PURE__ */ kt(), /* @__PURE__ */ Pn(), /* @__PURE__ */ An(/* @__PURE__ */ Pe("decorator")), /* @__PURE__ */ wt()),
        /* @__PURE__ */ Jt(/* @__PURE__ */ Cn("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi checkbox structure.
       */
      /* @__PURE__ */ To(
        /* @__PURE__ */ Lo("$label"),
        /* @__PURE__ */ $t("$help"),
        /* @__PURE__ */ Ao(
          /* @__PURE__ */ Eo(
            /* @__PURE__ */ En(
              /* @__PURE__ */ In(
                /* @__PURE__ */ kt(),
                /* @__PURE__ */ Jt(/* @__PURE__ */ Pn(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ An(/* @__PURE__ */ Pe("decorator")),
                /* @__PURE__ */ wt()
              ),
              /* @__PURE__ */ Jt(/* @__PURE__ */ Cn("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ Co("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ yt("$options == undefined && $help", /* @__PURE__ */ $t("$help")),
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [
    Ps,
    k_,
    Xt("decorator", "checkboxDecorator")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, D_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ jr(
      /* @__PURE__ */ Gn("$label"),
      /* @__PURE__ */ Yn(
        /* @__PURE__ */ Pe("prefix", "label"),
        /* @__PURE__ */ kt(),
        /* @__PURE__ */ o_(),
        /* @__PURE__ */ c_(
          /* @__PURE__ */ u_(
            /* @__PURE__ */ Pe("fileItem"),
            /* @__PURE__ */ f_("$file.name"),
            /* @__PURE__ */ yt(
              "$value.length === 1",
              /* @__PURE__ */ bi(
                /* @__PURE__ */ Pe("fileRemove"),
                '$ui.remove.value + " " + $file.name'
              )
            )
          )
        ),
        /* @__PURE__ */ yt("$value.length > 1", /* @__PURE__ */ bi("$ui.removeAll.value")),
        /* @__PURE__ */ p_(/* @__PURE__ */ Pe("noFiles"), "$ui.noFiles.value"),
        /* @__PURE__ */ wt(),
        /* @__PURE__ */ Pe("suffix")
      )
    ),
    /* @__PURE__ */ $t("$help"),
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [
    w_,
    Xt("fileItem", "fileItem"),
    Xt("fileRemove", "fileRemove"),
    Xt("noFiles", "noFiles")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "9kqc4852fv8"
}, R_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ d_(
    "$slots.default",
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value")),
    /* @__PURE__ */ s_(/* @__PURE__ */ y_())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "actions",
    "submit",
    "submitLabel",
    "submitAttrs",
    "submitBehavior",
    "incompleteMessage"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [P_, Cs],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "5bg016redjo"
}, x_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Is("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Cs, Oo]
}, H_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Mo(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Ro]
}, z_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Is("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "list",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["sync", "dynamic"],
  /**
   * Additional features that should be added to your input
   */
  features: [Cs, Oo]
}, V_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Is(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: []
}, B_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ yt(
      "$options == undefined",
      /**
       * Single radio structure.
       */
      /* @__PURE__ */ En(
        /* @__PURE__ */ In(/* @__PURE__ */ kt(), /* @__PURE__ */ Pn(), /* @__PURE__ */ An(/* @__PURE__ */ Pe("decorator")), /* @__PURE__ */ wt()),
        /* @__PURE__ */ Jt(/* @__PURE__ */ Cn("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi radio structure.
       */
      /* @__PURE__ */ To(
        /* @__PURE__ */ Lo("$label"),
        /* @__PURE__ */ $t("$help"),
        /* @__PURE__ */ Ao(
          /* @__PURE__ */ Eo(
            /* @__PURE__ */ En(
              /* @__PURE__ */ In(
                /* @__PURE__ */ kt(),
                /* @__PURE__ */ Jt(/* @__PURE__ */ Pn(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ An(/* @__PURE__ */ Pe("decorator")),
                /* @__PURE__ */ wt()
              ),
              /* @__PURE__ */ Jt(/* @__PURE__ */ Cn("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ Co("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ yt("$options == undefined && $help", /* @__PURE__ */ $t("$help")),
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [Ps, T_, Xt("decorator", "radioDecorator")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, j_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ jr(
      /* @__PURE__ */ Gn("$label"),
      /* @__PURE__ */ Yn(
        /* @__PURE__ */ Pe("prefix"),
        /* @__PURE__ */ kt(),
        /* @__PURE__ */ v_(
          /* @__PURE__ */ yt(
            "$slots.default",
            () => "$slots.default",
            /* @__PURE__ */ $i(
              /* @__PURE__ */ yt(
                "$option.group",
                /* @__PURE__ */ m_(/* @__PURE__ */ $i(/* @__PURE__ */ _i("$option.label"))),
                /* @__PURE__ */ _i("$option.label")
              )
            )
          )
        ),
        /* @__PURE__ */ yt("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ Pe("select")),
        /* @__PURE__ */ wt(),
        /* @__PURE__ */ Pe("suffix")
      )
    ),
    /* @__PURE__ */ $t("$help"),
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "placeholder", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [Ps, N_, Xt("select", "select")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "cb119h43krg"
}, q_ = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ jr(
      /* @__PURE__ */ Gn("$label"),
      /* @__PURE__ */ Yn(
        /* @__PURE__ */ Pe("prefix", "label"),
        /* @__PURE__ */ kt(),
        /* @__PURE__ */ h_(),
        /* @__PURE__ */ wt(),
        /* @__PURE__ */ Pe("suffix")
      )
    ),
    /* @__PURE__ */ $t("$help"),
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [C_],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "b1n0td79m9g"
}, De = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Bt(
    /* @__PURE__ */ jr(
      /* @__PURE__ */ Gn("$label"),
      /* @__PURE__ */ Yn(
        /* @__PURE__ */ Pe("prefix", "label"),
        /* @__PURE__ */ kt(),
        /* @__PURE__ */ Mo(),
        /* @__PURE__ */ wt(),
        /* @__PURE__ */ Pe("suffix")
      )
    ),
    /* @__PURE__ */ $t("$help"),
    /* @__PURE__ */ Lt(/* @__PURE__ */ Tt("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [Ro],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "c3cc4kflsg"
}, W_ = {
  button: Pi,
  submit: Pi,
  checkbox: F_,
  file: D_,
  form: R_,
  group: x_,
  hidden: H_,
  list: z_,
  meta: V_,
  radio: B_,
  select: j_,
  textarea: q_,
  text: De,
  color: De,
  date: De,
  datetimeLocal: De,
  email: De,
  month: De,
  number: De,
  password: De,
  search: De,
  tel: De,
  time: De,
  url: De,
  week: De,
  range: De
}, U_ = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function zo() {
  return Math.random().toString(36).substring(2, 15);
}
function Ii(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Qn(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return K_(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const a of n)
      if ((a in e || a in t) && e[a] !== t[a])
        return !1;
    for (const a in e)
      if (!(a in t) || e[a] !== t[a] && !r || r && !Qn(e[a], t[a], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function K_(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function fa(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function Va(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function sn(e) {
  return Va(e) || Array.isArray(e);
}
function Ci(e) {
  if (Va(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(Va(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
var Vo = /* @__NO_SIDE_EFFECTS__ */ (e, t, r = !1, n = !1) => {
  if (t === null)
    return null;
  const a = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (Ii(t, s) && (t[s] !== void 0 || !n)) {
      if (r && Array.isArray(e[s]) && Array.isArray(t[s])) {
        a[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      Ci(e[s]) && Ci(t[s]) ? a[s] = /* @__PURE__ */ Vo(
        e[s],
        t[s],
        r,
        n
      ) : a[s] = t[s];
    } else
      a[s] = e[s];
  for (const s in t)
    !Ii(a, s) && t[s] !== void 0 && (a[s] = t[s]);
  return a;
};
function Y_(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, r) => r.toUpperCase()
  );
}
function G_(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, r, n) => r + "-" + n.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function Tn(e, t = U_) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let r;
  Array.isArray(e) ? r = e.map((n) => typeof n == "object" ? Tn(n, t) : n) : r = Object.keys(e).reduce((n, a) => (n[a] = typeof e[a] == "object" ? Tn(e[a], t) : e[a], n), {});
  for (const n of t)
    n in e && Object.defineProperty(r, n, {
      enumerable: !1,
      value: e[n]
    });
  return r;
}
function Ba(e) {
  return typeof e == "object" ? Tn(e) : e;
}
function Ei(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function dr(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function Q_(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function Bo() {
  const e = [];
  let t = 0;
  const r = (a) => e.push(a), n = (a) => {
    const s = e[t];
    return typeof s == "function" ? s(a, (i) => (t++, n(i))) : (t = 0, a);
  };
  return r.dispatch = n, r.unshift = (a) => e.unshift(a), r.remove = (a) => {
    const s = e.indexOf(a);
    s > -1 && e.splice(s, 1);
  }, r;
}
function Z_() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r;
  const n = (a, s) => {
    if (r) {
      r.set(s.name, [a, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((i) => {
      (s.origin === a || i.modifiers.includes("deep")) && i.listener(s);
    }), s.bubble && a.bubble(s);
  };
  return n.flush = () => {
    e.clear(), t.clear(), r == null || r.clear();
  }, n.on = (a, s, i = "push") => {
    const [l, ...o] = a.split("."), u = s.receipt || zo(), f = {
      modifiers: o,
      event: l,
      listener: s,
      receipt: u
    };
    return e.has(l) ? e.get(l)[i](f) : e.set(l, [f]), t.has(u) ? t.get(u)[i](l) : t.set(u, [l]), u;
  }, n.off = (a) => {
    var s;
    t.has(a) && ((s = t.get(a)) == null || s.forEach((i) => {
      const l = e.get(i);
      Array.isArray(l) && e.set(
        i,
        l.filter((o) => o.receipt !== a)
      );
    }), t.delete(a));
  }, n.pause = (a) => {
    r || (r = /* @__PURE__ */ new Map()), a && a.walk((s) => s._e.pause());
  }, n.play = (a) => {
    if (!r)
      return;
    const s = r;
    r = void 0, s.forEach(([i, l]) => n(i, l)), a && a.walk((i) => i._e.play());
  }, n;
}
function X_(e, t, r, n, a = !0, s) {
  return t._e(e, {
    payload: n,
    name: r,
    bubble: a,
    origin: e,
    meta: s
  }), e;
}
function J_(e, t, r) {
  return Es(e.parent) && e.parent._e(e.parent, r), e;
}
function e$(e, t, r, n, a) {
  return t._e.on(r, n, a);
}
function t$(e, t, r) {
  return t._e.off(r), e;
}
var jo = Bo();
jo((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var qo = Bo();
qo((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const r = t(e);
  return console && typeof console.warn == "function" && console.warn(r.message), r;
});
function Wo(e, t = {}) {
  qo.dispatch({ code: e, data: t });
}
function Dr(e, t = {}) {
  throw Error(jo.dispatch({ code: e, data: t }).message);
}
function r$(e, t) {
  return {
    blocking: !1,
    key: zo(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
function n$(e, ...t) {
  const r = `${e.name}-set`, n = (a) => /* @__PURE__ */ r$({
    key: Q_(a),
    type: "error",
    value: a,
    meta: { source: r, autoClear: !0 }
  });
  return t.filter((a) => !!a).map((a) => {
    if (typeof a == "string" && (a = [a]), Array.isArray(a))
      return a.map((s) => n(s));
    {
      const s = {};
      for (const i in a)
        Array.isArray(a[i]) ? s[i] = a[i].map(
          (l) => n(l)
        ) : s[i] = [n(a[i])];
      return s;
    }
  });
}
var Uo = /* @__PURE__ */ new Map(), da = /* @__PURE__ */ new Map(), a$ = Z_();
function s$(e) {
  if (da.has(e)) {
    const t = da.get(e);
    da.delete(e), Uo.delete(t), a$(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function i$(e) {
  return Uo.get(e);
}
function Ai(e, t, r) {
  let n = !0;
  return t in e.config._t ? n = !1 : e.emit(`config:${t}`, r, !1), t in e.props || (e.emit("prop", { prop: t, value: r }), e.emit(`prop:${t}`, r)), n;
}
function l$(e, t) {
  const r = (t || document).getElementById(e);
  if (r instanceof HTMLFormElement) {
    const n = new Event("submit", { cancelable: !0, bubbles: !0 });
    r.dispatchEvent(n);
    return;
  }
  Wo(151, e);
}
function o$(e) {
  const t = (r) => {
    for (const n in r.store) {
      const a = r.store[n];
      a.type === "error" || a.type === "ui" && n === "incomplete" ? r.store.remove(n) : a.type === "state" && r.store.set({ ...a, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function u$(e, t) {
  const r = typeof e == "string" ? i$(e) : e;
  if (r) {
    const n = (i) => {
      const l = Ba(i.props.initial);
      return l !== void 0 ? l : i.type === "group" ? {} : i.type === "list" ? [] : void 0;
    };
    r._e.pause(r);
    const a = Ba(t);
    return t && !fa(t) && (r.props.initial = sn(a) ? dr(a) : a, r.props._init = r.props.initial), r.input(n(r), !1), r.walk((i) => {
      i.type === "list" && i.sync || i.input(n(i), !1);
    }), r.input(
      fa(a) && a ? a : n(r),
      !1
    ), r.type !== "input" && t && !fa(t) && sn(t) && r.walk((i) => {
      i.props.initial = sn(i.value) ? dr(i.value) : i.value, i.props._init = i.props.initial;
    }), r._e.play(r), o$(r), r.emit("reset", r), r;
  }
  Wo(152, e);
}
var c$ = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${G_(e)}`]: !0 })
}, f$ = Symbol("index"), ja = Symbol("removed"), qa = Symbol("moved"), Ko = Symbol("inserted");
function d$(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Es(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var ln = (e, t, r) => {
  Dr(102, [e, r]);
};
de(M$, ln, !1), de(S$), de(w$), de(N$, ln, !1), de(F$), de(J_), de(W$), de(_$), de(!1), de(k$), de(b$), de($$), de(U$), de(h$), de(L$, T$, !1), de(v$), de(C$), de(X_), de(R$), de(e$), de(t$), de(!1, P$), de(!1), de(I$), de(H$, ln, !1), de(j$), de(A$), de(q$), de(B$), de(V$), de(Qo), de(O$, !1, !1), de(E$);
function de(e, t, r = !0) {
  return {
    get: e ? (n, a) => r ? (...s) => e(n, a, ...s) : e(n, a) : !1,
    set: t !== void 0 ? t : ln.bind(null)
  };
}
var p$ = 0;
function m$(e) {
  return e.type === "group" ? dr(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? dr(Array.isArray(e.value) ? e.value : []) : e.value;
}
function v$(e, t, r, n = !0) {
  return t._value = y$(e, e.hook.input.dispatch(r)), e.emit("input", t._value), e.isCreated && e.type === "input" && Qn(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), n ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    Ln,
    e.props.delay,
    e,
    t
  )) : Ln(e, t), t.settled);
}
function y$(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && Dr(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || Dr(108, [e, t]);
      break;
  }
  return t;
}
function Ln(e, t, r = !0, n = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && n && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), r && e.calm();
}
function Yo(e, { name: t, value: r, from: n }) {
  if (!Object.isFrozen(e._value)) {
    if (d$(e)) {
      const a = r === ja ? [] : r === qa && typeof n == "number" ? e._value.splice(n, 1) : [r];
      e._value.splice(
        t,
        r === qa || n === Ko ? 0 : 1,
        ...a
      );
      return;
    }
    r !== ja ? e._value[t] = r : delete e._value[t];
  }
}
function h$(e, t) {
  const r = t._value;
  return e.type === "list" && e.sync && g$(e, t), t.children.forEach((n) => {
    if (typeof r == "object")
      if (n.name in r) {
        const a = n.type !== "input" || r[n.name] && typeof r[n.name] == "object" ? dr(r[n.name]) : r[n.name];
        if (!n.isSettled || (!sn(a) || n.props.mergeStrategy) && Qn(a, n._value))
          return;
        n.input(a, !1);
      } else
        (e.type !== "list" || typeof n.name == "number") && Yo(t, { name: n.name, value: n.value }), r.__init || (n.type === "group" ? n.input({}, !1) : n.type === "list" ? n.input([], !1) : n.input(void 0, !1));
  }), e;
}
function g$(e, t) {
  const r = e._value;
  if (!Array.isArray(r))
    return;
  const n = [], a = new Set(t.children), s = /* @__PURE__ */ new Map();
  r.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      n.push(t.children[o]), a.delete(t.children[o]);
    else {
      n.push(null);
      const u = s.get(l) || [];
      u.push(o), s.set(l, u);
    }
  }), a.size && s.size && a.forEach((l) => {
    if (s.has(l._value)) {
      const o = s.get(l._value), u = o.shift();
      n[u] = l, a.delete(l), o.length || s.delete(l._value);
    }
  });
  const i = [];
  for (s.forEach((l) => {
    i.push(...l);
  }); a.size && i.length; ) {
    const l = a.values().next().value, o = i.shift();
    if (o === void 0)
      break;
    n[o] = l, a.delete(l);
  }
  i.forEach((l, o) => {
    n[l] = K$({ value: o });
  }), a.size && a.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || Y$(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = n;
}
function b$(e, t) {
  var r;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && ((r = e.parent) == null || r.disturb())), t._d++, e;
}
function _$(e, t, r) {
  var n;
  if (r !== void 0 && e.type !== "input") {
    Yo(t, r);
    const a = !!(e.config.mergeStrategy && e.config.mergeStrategy[r.name]);
    return Ln(e, t, !0, a);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((n = e.parent) == null || n.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function $$(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), s$(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const r in t.context)
    delete t.context[r];
  t.plugins.clear(), t.context = null;
}
function k$(e, t, r) {
  t.type = r.type;
  const n = Tn(r);
  e.props.__propDefs = Go(
    e.props.__propDefs ?? [],
    (n == null ? void 0 : n.props) || []
  ), n.props = e.props.__propDefs, t.props.definition = n, t.value = t._value = m$({
    type: e.type,
    value: t.value
  }), r.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = r.forceTypeProp), r.family && (t.props.family = r.family), r.features && r.features.forEach((a) => a(e)), r.props && e.addProps(r.props), e.emit("defined", r);
}
function w$(e, t, r) {
  const n = Array.isArray(r) ? r : Object.keys(r), a = Array.isArray(r) ? {} : n.reduce((i, l) => ("default" in r[l] && (i[l] = r[l].default), i), {});
  if (e.props.attrs) {
    const i = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in i) {
      const u = Y_(o);
      n.includes(u) && (e.props[u] = i[o], delete i[o]);
    }
    Array.isArray(r) || n.forEach((o) => {
      "default" in r[o] && e.props[o] === void 0 && (e.props[o] = a[o]);
    });
    const l = Ba(t._value);
    e.props.initial = e.type !== "input" ? dr(l) : l, e.props._emit = !0, e.props.attrs = i;
  }
  const s = Go(e.props.__propDefs ?? [], r);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", r), e;
}
function Ti(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] = {}, t), {}) : e;
}
function Go(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : Vo(Ti(e), Ti(t));
}
function S$(e, t, r, n) {
  if (e.type === "input" && Dr(100, e), r.parent && r.parent !== e && r.parent.remove(r), !t.children.includes(r)) {
    if (n !== void 0 && e.type === "list") {
      const a = t.children[n];
      a && "__FKP" in a ? (r._c.uid = a.uid, t.children.splice(n, 1, r)) : t.children.splice(n, 0, r), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: n,
        value: r.value,
        from: Ko
      });
    } else
      t.children.push(r);
    r.isSettled || e.disturb();
  }
  if (r.parent !== e) {
    if (r.parent = e, r.parent !== e)
      return e.remove(r), r.parent.add(r), e;
  } else
    r.use(e.plugins);
  return Ln(e, t, !1), e.ledger.merge(r), e.emit("child", r), e;
}
function P$(e, t, r, n) {
  return Es(n) ? (e.parent && e.parent !== n && e.parent.remove(e), t.parent = n, e.resetConfig(), n.children.includes(e) ? e.use(n.plugins) : n.add(e), !0) : n === null ? (t.parent = null, !0) : !1;
}
function I$(e, t, r) {
  const n = t.children.indexOf(r);
  if (n !== -1) {
    r.isSettled && e.disturb(), t.children.splice(n, 1);
    let a = Ei(r.props.preserve), s = r.parent;
    for (; a === void 0 && s; )
      a = Ei(s.props.preserve), s = s.parent;
    a ? e.calm() : e.calm({
      name: e.type === "list" ? n : r.name,
      value: ja
    }), r.parent = null, r.config._rmn = r;
  }
  return e.ledger.unmerge(r), e.emit("childRemoved", r), e;
}
function C$(e, t, r) {
  t.children.forEach((n) => !("__FKP" in n) && r(n));
}
function E$(e, t, r, n = !1, a = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const i = r(s);
    return n && i === !1 ? !0 : a && i === !1 ? !1 : s.walk(r, n, a);
  });
}
function A$(e, t) {
  const r = e.parent || void 0;
  t.config = z$(e.config._t, r), e.walk((n) => n.resetConfig());
}
function Qo(e, t, r, n = !0, a = !0) {
  return Array.isArray(r) || r instanceof Set ? (r.forEach((s) => Qo(e, t, s)), e) : (t.plugins.has(r) || (a && typeof r.library == "function" && r.library(e), n && r(e) !== !1 && (t.plugins.add(r), e.children.forEach((s) => s.use(r)))), e);
}
function T$(e, t, r, n) {
  if (Es(e.parent)) {
    const a = e.parent.children, s = n >= a.length ? a.length - 1 : n < 0 ? 0 : n, i = a.indexOf(e);
    return i === -1 ? !1 : (a.splice(i, 1), a.splice(s, 0, e), e.parent.children = a, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: qa, from: i }), !0);
  }
  return !1;
}
function L$(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function M$(e, t) {
  return t;
}
function O$(e, t) {
  var r;
  return ((r = e.parent) == null ? void 0 : r.type) === "list" ? e.index : t.name !== f$ ? t.name : e.index;
}
function N$(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function F$(e, t, r) {
  const n = typeof r == "string" ? r.split(e.config.delimiter) : r;
  if (!n.length)
    return;
  const a = n[0];
  let s = e.parent;
  for (s || (String(n[0]) === String(e.name) && n.shift(), s = e), a === "$parent" && n.shift(); s && n.length; ) {
    const i = n.shift();
    switch (i) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(i)
        ) || D$(s, i);
    }
  }
  return s || void 0;
}
function D$(e, t) {
  const r = String(t).match(/^(find)\((.*)\)$/);
  if (r) {
    const [, n, a] = r, s = a.split(",").map((i) => i.trim());
    switch (n) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function R$(e, t, r, n) {
  return x$(e, r, n);
}
function x$(e, t, r = "name") {
  const n = typeof r == "string" ? (s) => s[r] == t : r, a = [e];
  for (; a.length; ) {
    const s = a.shift();
    if (!("__FKP" in s)) {
      if (n(s, t))
        return s;
      a.push(...s.children);
    }
  }
}
function H$(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function z$(e = {}, t) {
  let r;
  return new Proxy(e, {
    get(...n) {
      const a = n[1];
      if (a === "_t")
        return e;
      const s = Reflect.get(...n);
      if (s !== void 0)
        return s;
      if (t) {
        const i = t.config[a];
        if (i !== void 0)
          return i;
      }
      if (e.rootConfig && typeof a == "string") {
        const i = e.rootConfig[a];
        if (i !== void 0)
          return i;
      }
      return a === "delay" && (r == null ? void 0 : r.type) === "input" ? 20 : c$[a];
    },
    set(...n) {
      const a = n[1], s = n[2];
      if (a === "_n")
        return r = s, e.rootConfig && e.rootConfig._add(r), !0;
      if (a === "_rmn")
        return e.rootConfig && e.rootConfig._rm(r), r = void 0, !0;
      if (!Qn(e[a], s, !1)) {
        const i = Reflect.set(...n);
        return r && (r.emit(`config:${a}`, s, !1), Ai(r, a, s), r.walk((l) => Ai(l, a, s), !1, !0)), i;
      }
      return !0;
    }
  });
}
function V$(e, t, r, n = "ui") {
  const a = typeof r == "string" ? { key: r, value: r, type: n } : r, s = e.hook.text.dispatch(a);
  return e.emit("text", s, !1), s.value;
}
function B$(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || Dr(106, t), e = e.parent;
  } while (e);
  e.props.id && l$(e.props.id, e.props.__root);
}
function j$(e, t, r) {
  return u$(e, r);
}
function q$(e, t, r, n) {
  const a = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: r, childErrors: n });
  return n$(e, s.localErrors, s.childErrors).forEach(
    (i) => {
      e.store.apply(i, (l) => l.meta.source === a);
    }
  ), e;
}
function W$(e, t, r = !0, n) {
  return e.store.filter((a) => !(n === void 0 || a.meta.source === n), "error"), r && (n = n || `${e.name}-set`, e.walk((a) => {
    a.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === n));
  })), e;
}
function U$(e, t, r, n) {
  return t.traps.set(r, n), e;
}
function K$(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${p$++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function Y$(e) {
  return "__FKP" in e;
}
var Mn = "1.6.9", rt = void 0, ot = null, On, Zo = !1, $r = !1, G$ = /* @__PURE__ */ new Promise((e) => {
  On = () => {
    Zo = !0, e();
  };
}), ht = typeof window < "u" && typeof fetch < "u";
rt = ht ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var Yt = {}, pa = {};
function Q$(e, t, r, n) {
  t && Object.assign(Yt, t), ht && !$r && (rt != null && rt.getPropertyValue("--formkit-theme")) ? (On(), $r = !0) : e && !$r && ht ? Z$(e) : !$r && ht && On();
  const a = function(i) {
    var l, o;
    i.addProps(["iconLoader", "iconLoaderUrl"]), i.props.iconHandler = Li(
      (l = i.props) != null && l.iconLoader ? i.props.iconLoader : n,
      (o = i.props) != null && o.iconLoaderUrl ? i.props.iconLoaderUrl : r
    ), ek(i, i.props.iconHandler), i.on("created", () => {
      var u, f;
      (u = i == null ? void 0 : i.context) != null && u.handlers && (i.context.handlers.iconClick = (p) => {
        const h = `on${p.charAt(0).toUpperCase()}${p.slice(1)}IconClick`, c = i.props[h];
        if (c && typeof c == "function")
          return (y) => c(i, y);
      }), (f = i == null ? void 0 : i.context) != null && f.fns && (i.context.fns.iconRole = (p) => {
        const h = `on${p.charAt(0).toUpperCase()}${p.slice(1)}IconClick`;
        return typeof i.props[h] == "function" ? "button" : null;
      });
    });
  };
  return a.iconHandler = Li(n, r), a;
}
function Z$(e) {
  if (!(!e || !ht || typeof getComputedStyle != "function") && ($r = !0, ot = document.getElementById("formkit-theme"), e && // if we have a window object
  ht && // we don't have an existing theme OR the theme being set up is different
  (!(rt != null && rt.getPropertyValue("--formkit-theme")) && !ot || ot != null && ot.getAttribute("data-theme") && (ot == null ? void 0 : ot.getAttribute("data-theme")) !== e))) {
    const r = `https://cdn.jsdelivr.net/npm/@formkit/themes@${Mn.startsWith("__") ? "latest" : Mn}/dist/${e}/theme.css`, n = document.createElement("link");
    n.type = "text/css", n.rel = "stylesheet", n.id = "formkit-theme", n.setAttribute("data-theme", e), n.onload = () => {
      rt = getComputedStyle(document.documentElement), On();
    }, document.head.appendChild(n), n.href = r, ot && ot.remove();
  }
}
function Li(e, t) {
  return (r) => {
    if (typeof r != "string")
      return;
    if (r.startsWith("<svg"))
      return r;
    const n = r.startsWith("default:");
    r = n ? r.split(":")[1] : r;
    const a = r in Yt;
    let s;
    if (a)
      return Yt[r];
    if (!pa[r]) {
      if (s = X$(r), s = ht && typeof s > "u" ? Promise.resolve(s) : s, s instanceof Promise)
        pa[r] = s.then((i) => !i && typeof r == "string" && !n ? s = typeof e == "function" ? e(r) : J$(r, t) : i).then((i) => (typeof r == "string" && (Yt[n ? `default:${r}` : r] = i), i));
      else if (typeof s == "string")
        return Yt[n ? `default:${r}` : r] = s, s;
    }
    return pa[r];
  };
}
function X$(e) {
  if (ht)
    return Zo ? Mi(e) : G$.then(() => Mi(e));
}
function Mi(e) {
  const t = rt == null ? void 0 : rt.getPropertyValue(`--fk-icon-${e}`);
  if (t) {
    const r = atob(t);
    if (r.startsWith("<svg"))
      return Yt[e] = r, r;
  }
}
function J$(e, t) {
  const r = Mn.startsWith("__") ? "latest" : Mn, n = typeof t == "function" ? t(e) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${r}/dist/icons/${e}.svg`;
  if (ht)
    return fetch(`${n}`).then(async (a) => {
      const s = await a.text();
      if (s.startsWith("<svg"))
        return s;
    }).catch((a) => {
      console.error(a);
    });
}
function ek(e, t) {
  const r = /^[a-zA-Z-]+(?:-icon|Icon)$/;
  Object.keys(e.props).filter((a) => r.test(a)).forEach((a) => tk(e, t, a));
}
function tk(e, t, r) {
  const n = e.props[r], a = t(n), s = `_raw${r.charAt(0).toUpperCase()}${r.slice(1)}`, i = `on${r.charAt(0).toUpperCase()}${r.slice(1)}Click`;
  if (e.addProps([s, i]), e.on(`prop:${r}`, rk), a instanceof Promise)
    return a.then((l) => {
      e.props[s] = l;
    });
  e.props[s] = a;
}
function rk(e) {
  var i;
  const t = e.origin, r = e.payload, n = (i = t == null ? void 0 : t.props) == null ? void 0 : i.iconHandler, a = e.name.split(":")[1], s = `_raw${a.charAt(0).toUpperCase()}${a.slice(1)}`;
  if (n && typeof n == "function") {
    const l = n(r);
    if (l instanceof Promise)
      return l.then((o) => {
        t.props[s] = o;
      });
    t.props[s] = l;
  }
}
var nk = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function Xo() {
  return Math.random().toString(36).substring(2, 15);
}
function Oi(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Zn(e, t, r = !0, n = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return ak(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const a of n)
      if ((a in e || a in t) && e[a] !== t[a])
        return !1;
    for (const a in e)
      if (!(a in t) || e[a] !== t[a] && !r || r && !Zn(e[a], t[a], r, n))
        return !1;
    return !0;
  }
  return !1;
}
function ak(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function ma(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const r in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function Wa(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function on(e) {
  return Wa(e) || Array.isArray(e);
}
function Ni(e) {
  if (Wa(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(Wa(r) === !1 || r.hasOwnProperty("isPrototypeOf") === !1);
}
var Jo = /* @__NO_SIDE_EFFECTS__ */ (e, t, r = !1, n = !1) => {
  if (t === null)
    return null;
  const a = {};
  if (typeof t == "string")
    return t;
  for (const s in e)
    if (Oi(t, s) && (t[s] !== void 0 || !n)) {
      if (r && Array.isArray(e[s]) && Array.isArray(t[s])) {
        a[s] = e[s].concat(t[s]);
        continue;
      }
      if (t[s] === void 0)
        continue;
      Ni(e[s]) && Ni(t[s]) ? a[s] = /* @__PURE__ */ Jo(
        e[s],
        t[s],
        r,
        n
      ) : a[s] = t[s];
    } else
      a[s] = e[s];
  for (const s in t)
    !Oi(a, s) && t[s] !== void 0 && (a[s] = t[s]);
  return a;
};
function sk(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, r) => r.toUpperCase()
  );
}
function ik(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, r, n) => r + "-" + n.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function Nn(e, t = nk) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let r;
  Array.isArray(e) ? r = e.map((n) => typeof n == "object" ? Nn(n, t) : n) : r = Object.keys(e).reduce((n, a) => (n[a] = typeof e[a] == "object" ? Nn(e[a], t) : e[a], n), {});
  for (const n of t)
    n in e && Object.defineProperty(r, n, {
      enumerable: !1,
      value: e[n]
    });
  return r;
}
function Ua(e) {
  return typeof e == "object" ? Nn(e) : e;
}
function Fi(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function pr(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function lk(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function eu() {
  const e = [];
  let t = 0;
  const r = (a) => e.push(a), n = (a) => {
    const s = e[t];
    return typeof s == "function" ? s(a, (i) => (t++, n(i))) : (t = 0, a);
  };
  return r.dispatch = n, r.unshift = (a) => e.unshift(a), r.remove = (a) => {
    const s = e.indexOf(a);
    s > -1 && e.splice(s, 1);
  }, r;
}
function ok() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r;
  const n = (a, s) => {
    if (r) {
      r.set(s.name, [a, s]);
      return;
    }
    e.has(s.name) && e.get(s.name).forEach((i) => {
      (s.origin === a || i.modifiers.includes("deep")) && i.listener(s);
    }), s.bubble && a.bubble(s);
  };
  return n.flush = () => {
    e.clear(), t.clear(), r == null || r.clear();
  }, n.on = (a, s, i = "push") => {
    const [l, ...o] = a.split("."), u = s.receipt || Xo(), f = {
      modifiers: o,
      event: l,
      listener: s,
      receipt: u
    };
    return e.has(l) ? e.get(l)[i](f) : e.set(l, [f]), t.has(u) ? t.get(u)[i](l) : t.set(u, [l]), u;
  }, n.off = (a) => {
    var s;
    t.has(a) && ((s = t.get(a)) == null || s.forEach((i) => {
      const l = e.get(i);
      Array.isArray(l) && e.set(
        i,
        l.filter((o) => o.receipt !== a)
      );
    }), t.delete(a));
  }, n.pause = (a) => {
    r || (r = /* @__PURE__ */ new Map()), a && a.walk((s) => s._e.pause());
  }, n.play = (a) => {
    if (!r)
      return;
    const s = r;
    r = void 0, s.forEach(([i, l]) => n(i, l)), a && a.walk((i) => i._e.play());
  }, n;
}
function uk(e, t, r, n, a = !0, s) {
  return t._e(e, {
    payload: n,
    name: r,
    bubble: a,
    origin: e,
    meta: s
  }), e;
}
function ck(e, t, r) {
  return Ls(e.parent) && e.parent._e(e.parent, r), e;
}
function fk(e, t, r, n, a) {
  return t._e.on(r, n, a);
}
function dk(e, t, r) {
  return t._e.off(r), e;
}
var As = eu();
As((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var Ts = eu();
Ts((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const r = t(e);
  return console && typeof console.warn == "function" && console.warn(r.message), r;
});
function tu(e, t = {}) {
  Ts.dispatch({ code: e, data: t });
}
function Rr(e, t = {}) {
  throw Error(As.dispatch({ code: e, data: t }).message);
}
function pk(e, t) {
  return {
    blocking: !1,
    key: Xo(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
function mk(e, ...t) {
  const r = `${e.name}-set`, n = (a) => /* @__PURE__ */ pk({
    key: lk(a),
    type: "error",
    value: a,
    meta: { source: r, autoClear: !0 }
  });
  return t.filter((a) => !!a).map((a) => {
    if (typeof a == "string" && (a = [a]), Array.isArray(a))
      return a.map((s) => n(s));
    {
      const s = {};
      for (const i in a)
        Array.isArray(a[i]) ? s[i] = a[i].map(
          (l) => n(l)
        ) : s[i] = [n(a[i])];
      return s;
    }
  });
}
var ru = /* @__PURE__ */ new Map(), va = /* @__PURE__ */ new Map(), vk = ok();
function yk(e) {
  if (va.has(e)) {
    const t = va.get(e);
    va.delete(e), ru.delete(t), vk(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function hk(e) {
  return ru.get(e);
}
function Di(e, t, r) {
  let n = !0;
  return t in e.config._t ? n = !1 : e.emit(`config:${t}`, r, !1), t in e.props || (e.emit("prop", { prop: t, value: r }), e.emit(`prop:${t}`, r)), n;
}
function gk(e, t) {
  const r = (t || document).getElementById(e);
  if (r instanceof HTMLFormElement) {
    const n = new Event("submit", { cancelable: !0, bubbles: !0 });
    r.dispatchEvent(n);
    return;
  }
  tu(151, e);
}
function bk(e) {
  const t = (r) => {
    for (const n in r.store) {
      const a = r.store[n];
      a.type === "error" || a.type === "ui" && n === "incomplete" ? r.store.remove(n) : a.type === "state" && r.store.set({ ...a, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function _k(e, t) {
  const r = typeof e == "string" ? hk(e) : e;
  if (r) {
    const n = (i) => {
      const l = Ua(i.props.initial);
      return l !== void 0 ? l : i.type === "group" ? {} : i.type === "list" ? [] : void 0;
    };
    r._e.pause(r);
    const a = Ua(t);
    return t && !ma(t) && (r.props.initial = on(a) ? pr(a) : a, r.props._init = r.props.initial), r.input(n(r), !1), r.walk((i) => {
      i.type === "list" && i.sync || i.input(n(i), !1);
    }), r.input(
      ma(a) && a ? a : n(r),
      !1
    ), r.type !== "input" && t && !ma(t) && on(t) && r.walk((i) => {
      i.props.initial = on(i.value) ? pr(i.value) : i.value, i.props._init = i.props.initial;
    }), r._e.play(r), bk(r), r.emit("reset", r), r;
  }
  tu(152, e);
}
var $k = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${ik(e)}`]: !0 })
}, kk = Symbol("index"), Ka = Symbol("removed"), Ya = Symbol("moved"), nu = Symbol("inserted");
function wk(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Ls(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var un = (e, t, r) => {
  Rr(102, [e, r]);
};
pe(jk, un, !1), pe(Fk), pe(Nk), pe(Wk, un, !1), pe(Uk), pe(ck), pe(rw), pe(Lk), pe(!1), pe(Ok), pe(Tk), pe(Mk), pe(nw), pe(Ek), pe(Bk, Vk, !1), pe(Ik), pe(xk), pe(uk), pe(Yk), pe(fk), pe(dk), pe(!1, Dk), pe(!1), pe(Rk), pe(Qk, un, !1), pe(ew), pe(zk), pe(tw), pe(Jk), pe(Xk), pe(iu), pe(qk, !1, !1), pe(Hk);
function pe(e, t, r = !0) {
  return {
    get: e ? (n, a) => r ? (...s) => e(n, a, ...s) : e(n, a) : !1,
    set: t !== void 0 ? t : un.bind(null)
  };
}
var Sk = 0;
function Pk(e) {
  return e.type === "group" ? pr(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? pr(Array.isArray(e.value) ? e.value : []) : e.value;
}
function Ik(e, t, r, n = !0) {
  return t._value = Ck(e, e.hook.input.dispatch(r)), e.emit("input", t._value), e.isCreated && e.type === "input" && Zn(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), n ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    Fn,
    e.props.delay,
    e,
    t
  )) : Fn(e, t), t.settled);
}
function Ck(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && Rr(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || Rr(108, [e, t]);
      break;
  }
  return t;
}
function Fn(e, t, r = !0, n = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && n && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), r && e.calm();
}
function au(e, { name: t, value: r, from: n }) {
  if (!Object.isFrozen(e._value)) {
    if (wk(e)) {
      const a = r === Ka ? [] : r === Ya && typeof n == "number" ? e._value.splice(n, 1) : [r];
      e._value.splice(
        t,
        r === Ya || n === nu ? 0 : 1,
        ...a
      );
      return;
    }
    r !== Ka ? e._value[t] = r : delete e._value[t];
  }
}
function Ek(e, t) {
  const r = t._value;
  return e.type === "list" && e.sync && Ak(e, t), t.children.forEach((n) => {
    if (typeof r == "object")
      if (n.name in r) {
        const a = n.type !== "input" || r[n.name] && typeof r[n.name] == "object" ? pr(r[n.name]) : r[n.name];
        if (!n.isSettled || (!on(a) || n.props.mergeStrategy) && Zn(a, n._value))
          return;
        n.input(a, !1);
      } else
        (e.type !== "list" || typeof n.name == "number") && au(t, { name: n.name, value: n.value }), r.__init || (n.type === "group" ? n.input({}, !1) : n.type === "list" ? n.input([], !1) : n.input(void 0, !1));
  }), e;
}
function Ak(e, t) {
  const r = e._value;
  if (!Array.isArray(r))
    return;
  const n = [], a = new Set(t.children), s = /* @__PURE__ */ new Map();
  r.forEach((l, o) => {
    if (t.children[o] && t.children[o]._value === l)
      n.push(t.children[o]), a.delete(t.children[o]);
    else {
      n.push(null);
      const u = s.get(l) || [];
      u.push(o), s.set(l, u);
    }
  }), a.size && s.size && a.forEach((l) => {
    if (s.has(l._value)) {
      const o = s.get(l._value), u = o.shift();
      n[u] = l, a.delete(l), o.length || s.delete(l._value);
    }
  });
  const i = [];
  for (s.forEach((l) => {
    i.push(...l);
  }); a.size && i.length; ) {
    const l = a.values().next().value, o = i.shift();
    if (o === void 0)
      break;
    n[o] = l, a.delete(l);
  }
  i.forEach((l, o) => {
    n[l] = aw({ value: o });
  }), a.size && a.forEach((l) => {
    if (!("__FKP" in l)) {
      const o = l._c.parent;
      if (!o || sw(o))
        return;
      o.ledger.unmerge(l), l._c.parent = null, l.destroy();
    }
  }), t.children = n;
}
function Tk(e, t) {
  var r;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((n) => {
    t._resolve = n;
  }), e.parent && ((r = e.parent) == null || r.disturb())), t._d++, e;
}
function Lk(e, t, r) {
  var n;
  if (r !== void 0 && e.type !== "input") {
    au(t, r);
    const a = !!(e.config.mergeStrategy && e.config.mergeStrategy[r.name]);
    return Fn(e, t, !0, a);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((n = e.parent) == null || n.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function Mk(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), yk(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const r in t.context)
    delete t.context[r];
  t.plugins.clear(), t.context = null;
}
function Ok(e, t, r) {
  t.type = r.type;
  const n = Nn(r);
  e.props.__propDefs = su(
    e.props.__propDefs ?? [],
    (n == null ? void 0 : n.props) || []
  ), n.props = e.props.__propDefs, t.props.definition = n, t.value = t._value = Pk({
    type: e.type,
    value: t.value
  }), r.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = r.forceTypeProp), r.family && (t.props.family = r.family), r.features && r.features.forEach((a) => a(e)), r.props && e.addProps(r.props), e.emit("defined", r);
}
function Nk(e, t, r) {
  const n = Array.isArray(r) ? r : Object.keys(r), a = Array.isArray(r) ? {} : n.reduce((i, l) => ("default" in r[l] && (i[l] = r[l].default), i), {});
  if (e.props.attrs) {
    const i = { ...e.props.attrs };
    e.props._emit = !1;
    for (const o in i) {
      const u = sk(o);
      n.includes(u) && (e.props[u] = i[o], delete i[o]);
    }
    Array.isArray(r) || n.forEach((o) => {
      "default" in r[o] && e.props[o] === void 0 && (e.props[o] = a[o]);
    });
    const l = Ua(t._value);
    e.props.initial = e.type !== "input" ? pr(l) : l, e.props._emit = !0, e.props.attrs = i;
  }
  const s = su(e.props.__propDefs ?? [], r);
  return e.props.definition && (e.props.definition.props = s), e.props.__propDefs = s, e.emit("added-props", r), e;
}
function Ri(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] = {}, t), {}) : e;
}
function su(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : Jo(Ri(e), Ri(t));
}
function Fk(e, t, r, n) {
  if (e.type === "input" && Rr(100, e), r.parent && r.parent !== e && r.parent.remove(r), !t.children.includes(r)) {
    if (n !== void 0 && e.type === "list") {
      const a = t.children[n];
      a && "__FKP" in a ? (r._c.uid = a.uid, t.children.splice(n, 1, r)) : t.children.splice(n, 0, r), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: n,
        value: r.value,
        from: nu
      });
    } else
      t.children.push(r);
    r.isSettled || e.disturb();
  }
  if (r.parent !== e) {
    if (r.parent = e, r.parent !== e)
      return e.remove(r), r.parent.add(r), e;
  } else
    r.use(e.plugins);
  return Fn(e, t, !1), e.ledger.merge(r), e.emit("child", r), e;
}
function Dk(e, t, r, n) {
  return Ls(n) ? (e.parent && e.parent !== n && e.parent.remove(e), t.parent = n, e.resetConfig(), n.children.includes(e) ? e.use(n.plugins) : n.add(e), !0) : n === null ? (t.parent = null, !0) : !1;
}
function Rk(e, t, r) {
  const n = t.children.indexOf(r);
  if (n !== -1) {
    r.isSettled && e.disturb(), t.children.splice(n, 1);
    let a = Fi(r.props.preserve), s = r.parent;
    for (; a === void 0 && s; )
      a = Fi(s.props.preserve), s = s.parent;
    a ? e.calm() : e.calm({
      name: e.type === "list" ? n : r.name,
      value: Ka
    }), r.parent = null, r.config._rmn = r;
  }
  return e.ledger.unmerge(r), e.emit("childRemoved", r), e;
}
function xk(e, t, r) {
  t.children.forEach((n) => !("__FKP" in n) && r(n));
}
function Hk(e, t, r, n = !1, a = !1) {
  t.children.some((s) => {
    if ("__FKP" in s)
      return !1;
    const i = r(s);
    return n && i === !1 ? !0 : a && i === !1 ? !1 : s.walk(r, n, a);
  });
}
function zk(e, t) {
  const r = e.parent || void 0;
  t.config = Zk(e.config._t, r), e.walk((n) => n.resetConfig());
}
function iu(e, t, r, n = !0, a = !0) {
  return Array.isArray(r) || r instanceof Set ? (r.forEach((s) => iu(e, t, s)), e) : (t.plugins.has(r) || (a && typeof r.library == "function" && r.library(e), n && r(e) !== !1 && (t.plugins.add(r), e.children.forEach((s) => s.use(r)))), e);
}
function Vk(e, t, r, n) {
  if (Ls(e.parent)) {
    const a = e.parent.children, s = n >= a.length ? a.length - 1 : n < 0 ? 0 : n, i = a.indexOf(e);
    return i === -1 ? !1 : (a.splice(i, 1), a.splice(s, 0, e), e.parent.children = a, e.parent.type === "list" && e.parent.disturb().calm({ name: s, value: Ya, from: i }), !0);
  }
  return !1;
}
function Bk(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function jk(e, t) {
  return t;
}
function qk(e, t) {
  var r;
  return ((r = e.parent) == null ? void 0 : r.type) === "list" ? e.index : t.name !== kk ? t.name : e.index;
}
function Wk(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function Uk(e, t, r) {
  const n = typeof r == "string" ? r.split(e.config.delimiter) : r;
  if (!n.length)
    return;
  const a = n[0];
  let s = e.parent;
  for (s || (String(n[0]) === String(e.name) && n.shift(), s = e), a === "$parent" && n.shift(); s && n.length; ) {
    const i = n.shift();
    switch (i) {
      case "$root":
        s = e.root;
        break;
      case "$parent":
        s = s.parent;
        break;
      case "$self":
        s = e;
        break;
      default:
        s = s.children.find(
          (l) => !("__FKP" in l) && String(l.name) === String(i)
        ) || Kk(s, i);
    }
  }
  return s || void 0;
}
function Kk(e, t) {
  const r = String(t).match(/^(find)\((.*)\)$/);
  if (r) {
    const [, n, a] = r, s = a.split(",").map((i) => i.trim());
    switch (n) {
      case "find":
        return e.find(s[0], s[1]);
      default:
        return;
    }
  }
}
function Yk(e, t, r, n) {
  return Gk(e, r, n);
}
function Gk(e, t, r = "name") {
  const n = typeof r == "string" ? (s) => s[r] == t : r, a = [e];
  for (; a.length; ) {
    const s = a.shift();
    if (!("__FKP" in s)) {
      if (n(s, t))
        return s;
      a.push(...s.children);
    }
  }
}
function Qk(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function Zk(e = {}, t) {
  let r;
  return new Proxy(e, {
    get(...n) {
      const a = n[1];
      if (a === "_t")
        return e;
      const s = Reflect.get(...n);
      if (s !== void 0)
        return s;
      if (t) {
        const i = t.config[a];
        if (i !== void 0)
          return i;
      }
      if (e.rootConfig && typeof a == "string") {
        const i = e.rootConfig[a];
        if (i !== void 0)
          return i;
      }
      return a === "delay" && (r == null ? void 0 : r.type) === "input" ? 20 : $k[a];
    },
    set(...n) {
      const a = n[1], s = n[2];
      if (a === "_n")
        return r = s, e.rootConfig && e.rootConfig._add(r), !0;
      if (a === "_rmn")
        return e.rootConfig && e.rootConfig._rm(r), r = void 0, !0;
      if (!Zn(e[a], s, !1)) {
        const i = Reflect.set(...n);
        return r && (r.emit(`config:${a}`, s, !1), Di(r, a, s), r.walk((l) => Di(l, a, s), !1, !0)), i;
      }
      return !0;
    }
  });
}
function Xk(e, t, r, n = "ui") {
  const a = typeof r == "string" ? { key: r, value: r, type: n } : r, s = e.hook.text.dispatch(a);
  return e.emit("text", s, !1), s.value;
}
function Jk(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || Rr(106, t), e = e.parent;
  } while (e);
  e.props.id && gk(e.props.id, e.props.__root);
}
function ew(e, t, r) {
  return _k(e, r);
}
function tw(e, t, r, n) {
  const a = `${e.name}-set`, s = e.hook.setErrors.dispatch({ localErrors: r, childErrors: n });
  return mk(e, s.localErrors, s.childErrors).forEach(
    (i) => {
      e.store.apply(i, (l) => l.meta.source === a);
    }
  ), e;
}
function rw(e, t, r = !0, n) {
  return e.store.filter((a) => !(n === void 0 || a.meta.source === n), "error"), r && (n = n || `${e.name}-set`, e.walk((a) => {
    a.store.filter((s) => !(s.type === "error" && s.meta && s.meta.source === n));
  })), e;
}
function nw(e, t, r, n) {
  return t.traps.set(r, n), e;
}
function aw(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${Sk++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function sw(e) {
  return "__FKP" in e;
}
var xi = {
  /**
   * FormKit errors:
   */
  100: ({ data: e }) => `Only groups, lists, and forms can have children (${e.name}).`,
  101: ({ data: e }) => `You cannot directly modify the store (${e.name}). See: https://formkit.com/advanced/core#message-store`,
  102: ({
    data: [e, t]
  }) => `You cannot directly assign node.${t} (${e.name})`,
  103: ({ data: [e] }) => `Schema expressions cannot start with an operator (${e})`,
  104: ({ data: [e, t] }) => `Schema expressions cannot end with an operator (${e} in "${t}")`,
  105: ({ data: e }) => `Invalid schema expression: ${e}`,
  106: ({ data: e }) => `Cannot submit because (${e}) is not in a form.`,
  107: ({ data: [e, t] }) => `Cannot set ${e.name} to non object value: ${t}`,
  108: ({ data: [e, t] }) => `Cannot set ${e.name} to non array value: ${t}`,
  /**
   * Input specific errors:
   */
  300: ({ data: [e] }) => `Cannot set behavior prop to overscroll (on ${e.name} input) when options prop is a function.`,
  /**
   * FormKit vue errors:
   */
  600: ({ data: e }) => `Unknown input type${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} ("${e.name}")`,
  601: ({ data: e }) => `Input definition${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} is missing a schema or component property (${e.name}).`
}, Hi = {
  /**
   * Core warnings:
   */
  150: ({ data: e }) => `Schema function "${e}()" is not a valid function.`,
  151: ({ data: e }) => `No form element with id: ${e}`,
  152: ({ data: e }) => `No input element with id: ${e}`,
  /**
   * Input specific warnings:
   */
  350: ({
    data: { node: e, inputType: t }
  }) => `Invalid options prop for ${e.name} input (${t}). See https://formkit.com/inputs/${t}`,
  /**
   * Vue warnings:
   */
  650: 'Schema "$get()" must use the id of an input to access.',
  651: ({ data: e }) => `Cannot setErrors() on "${e}" because no such id exists.`,
  652: ({ data: e }) => `Cannot clearErrors() on "${e}" because no such id exists.`,
  /**
   * Deprecation warnings:
   */
  800: ({ data: e }) => `${e} is deprecated.`
}, iw = (e, t) => {
  if (e.code in xi) {
    const r = xi[e.code];
    e.message = typeof r == "function" ? r(e) : r;
  }
  return t(e);
}, zi = !1;
function lw() {
  zi || (As(iw), Ts(ow), zi = !0);
}
var ow = (e, t) => {
  if (e.code in Hi) {
    const r = Hi[e.code];
    e.message = typeof r == "function" ? r(e) : r;
  }
  return t(e);
}, uw = Object.defineProperty, cw = Object.getOwnPropertyNames, lu = (e, t) => function() {
  return e && (t = (0, e[cw(e)[0]])(e = 0)), t;
}, fw = (e, t) => {
  for (var r in t)
    uw(e, r, { get: t[r], enumerable: !0 });
}, Vi, ou, uu = lu({
  "packages/vue/src/bindings.ts"() {
    Vi = function(t) {
      t.ledger.count("blocking", (d) => d.blocking);
      const r = L(!t.ledger.value("blocking"));
      t.ledger.count("errors", (d) => d.type === "error");
      const n = L(!!t.ledger.value("errors"));
      let a = !1;
      at(() => {
        a = !0;
      });
      const s = It(
        t.store.reduce((d, $) => ($.visible && (d[$.key] = $), d), {})
      ), i = L(
        t.props.validationVisibility || (t.props.type === "checkbox" ? "dirty" : "blur")
      );
      t.on("prop:validationVisibility", ({ payload: d }) => {
        i.value = d;
      });
      const l = L(i.value === "live"), o = L(!1), u = (d) => {
        o.value = (d ?? []).some(
          ($) => $.name === "required"
        );
      };
      u(t.props.parsedRules), t.on("prop:parsedRules", ({ payload: d }) => u(d));
      const f = L(t.children.map((d) => d.uid)), p = E(() => {
        if (!w.state)
          return !1;
        if (w.state.submitted)
          return !0;
        if (!l.value && !w.state.settled)
          return !1;
        switch (i.value) {
          case "live":
            return !0;
          case "blur":
            return w.state.blurred;
          case "dirty":
            return w.state.dirty;
          default:
            return !1;
        }
      }), h = E(() => w.state.failing && p.value), c = E(() => w && y.value ? r.value && !n.value : w.state.dirty && !Qt(w.value)), y = L(
        Array.isArray(t.props.parsedRules) && t.props.parsedRules.length > 0
      );
      t.on("prop:parsedRules", ({ payload: d }) => {
        y.value = Array.isArray(d) && d.length > 0;
      });
      const g = E(() => {
        const d = {};
        for (const $ in s) {
          const A = s[$];
          (A.type !== "validation" || p.value) && (d[$] = A);
        }
        return d;
      }), b = It(
        t.store.reduce((d, $) => ($.type === "ui" && $.visible && (d[$.key] = $), d), {})
      ), k = E(() => !w.state.failing), P = It({}), I = new Proxy(P, {
        get(...d) {
          if (!t)
            return "";
          const [$, A] = d;
          let z = Reflect.get(...d);
          return !z && typeof A == "string" && !be($, A) && !A.startsWith("__v") && Wn(t).watch((j) => {
            const Q = typeof j.config.rootClasses == "function" ? j.config.rootClasses(A, j) : {}, q = j.config.classes ? Jr(A, j, j.config.classes[A]) : {}, Z = Jr(
              A,
              j,
              j.props[`_${A}Class`]
            ), re = Jr(
              A,
              j,
              j.props[`${A}Class`]
            );
            z = fy(
              j,
              A,
              Q,
              q,
              Z,
              re
            ), $[A] = z ?? "";
          }), z;
        }
      });
      t.on("prop:rootClasses", () => {
        const d = Object.keys(P);
        for (const $ of d)
          delete P[$];
      });
      const _ = E(() => {
        if (!t)
          return;
        const d = [];
        w.help && d.push(`help-${t.props.id}`);
        for (const $ in g.value)
          d.push(`${t.props.id}-${$}`);
        return d.length ? d.join(" ") : void 0;
      }), S = L(t.value), v = L(t.value), w = It({
        _value: v,
        attrs: t.props.attrs,
        disabled: t.props.disabled,
        describedBy: _,
        fns: {
          length: (d) => Object.keys(d).length,
          number: (d) => Number(d),
          string: (d) => String(d),
          json: (d) => JSON.stringify(d),
          eq: nt
        },
        handlers: {
          blur: (d) => {
            t && (t.store.set(
              /* @__PURE__ */ _t({ key: "blurred", visible: !1, value: !0 })
            ), typeof t.props.attrs.onBlur == "function" && t.props.attrs.onBlur(d));
          },
          touch: () => {
            var A;
            const d = w.dirtyBehavior === "compare";
            if ((A = t.store.dirty) != null && A.value && !d)
              return;
            const $ = !nt(t.props._init, t._value);
            !$ && !d || t.store.set(
              /* @__PURE__ */ _t({ key: "dirty", visible: !1, value: $ })
            );
          },
          DOMInput: (d) => {
            t.input(d.target.value), t.emit("dom-input-event", d);
          }
        },
        help: t.props.help,
        id: t.props.id,
        items: f,
        label: t.props.label,
        messages: g,
        didMount: !1,
        node: Ja(t),
        options: t.props.options,
        defaultMessagePlacement: !0,
        slots: t.props.__slots,
        state: {
          blurred: !1,
          complete: c,
          dirty: !1,
          empty: Qt(S),
          submitted: !1,
          settled: t.isSettled,
          valid: r,
          invalid: h,
          errors: n,
          rules: y,
          validationVisible: p,
          required: o,
          failing: !1,
          passing: k
        },
        type: t.props.type,
        family: t.props.family,
        ui: b,
        value: S,
        classes: I
      });
      t.on("created", () => {
        nt(w.value, t.value) || (v.value = t.value, S.value = t.value, Ur(S), Ur(v)), (async () => (await t.settled, t && (t.props._init = xt(t.value))))();
      }), t.on("mounted", () => {
        w.didMount = !0;
      }), t.on("settled", ({ payload: d }) => {
        w.state.settled = d;
      });
      function C(d) {
        (Array.isArray(d) ? d : Object.keys(d)).forEach((A) => {
          A = Zt(A), be(w, A) || (w[A] = t.props[A]), t.on(`prop:${A}`, ({ payload: z }) => {
            w[A] = z;
          });
        });
      }
      C((() => {
        const d = [
          "__root",
          "help",
          "label",
          "disabled",
          "options",
          "type",
          "attrs",
          "preserve",
          "preserveErrors",
          "id",
          "dirtyBehavior"
        ], $ = /^[a-zA-Z-]+(?:-icon|Icon)$/, A = Object.keys(t.props).filter((z) => $.test(z));
        return d.concat(A);
      })());
      function x(d) {
        d.props && C(d.props);
      }
      t.props.definition && x(t.props.definition), t.on("added-props", ({ payload: d }) => C(d)), t.on("input", ({ payload: d }) => {
        t.type !== "input" && !pn(d) && !Hs(d) ? v.value = wa(d) : (v.value = d, Ur(v));
      }), t.on("commitRaw", ({ payload: d }) => {
        t.type !== "input" && !pn(d) && !Hs(d) ? S.value = v.value = wa(d) : (S.value = v.value = d, Ur(S)), t.emit("modelUpdated");
      }), t.on("commit", ({ payload: d }) => {
        var $;
        if ((!w.state.dirty || w.dirtyBehavior === "compare") && t.isCreated && a)
          if (!(($ = t.store.validating) != null && $.value))
            w.handlers.touch();
          else {
            const A = t.on("message-removed", ({ payload: z }) => {
              z.key === "validating" && (w.handlers.touch(), t.off(A));
            });
          }
        c && t.type === "input" && n.value && !tt(t.props.preserveErrors) && t.store.filter(
          (A) => {
            var z;
            return !(A.type === "error" && ((z = A.meta) == null ? void 0 : z.autoClear) === !0);
          }
        ), t.type === "list" && t.sync && (f.value = t.children.map((A) => A.uid)), w.state.empty = Qt(d);
      });
      const R = async (d) => {
        d.type === "ui" && d.visible && !d.meta.showAsMessage ? b[d.key] = d : d.visible ? s[d.key] = d : d.type === "state" && (w.state[d.key] = !!d.value);
      };
      t.on("message-added", (d) => R(d.payload)), t.on("message-updated", (d) => R(d.payload)), t.on("message-removed", ({ payload: d }) => {
        delete b[d.key], delete s[d.key], delete w.state[d.key];
      }), t.on("settled:blocking", () => {
        r.value = !0;
      }), t.on("unsettled:blocking", () => {
        r.value = !1;
      }), t.on("settled:errors", () => {
        n.value = !1;
      }), t.on("unsettled:errors", () => {
        n.value = !0;
      }), le(p, (d) => {
        d && (l.value = !0);
      }), t.context = w, t.emit("context", t, !1), t.on("destroyed", () => {
        t.context = void 0, t = null;
      });
    }, ou = Vi;
  }
}), dw = {};
fw(dw, {
  defaultConfig: () => cu
});
var cu, pw = lu({
  "packages/vue/src/defaultConfig.ts"() {
    uu(), cu = (e = {}) => {
      lw();
      const {
        rules: t = {},
        locales: r = {},
        inputs: n = {},
        messages: a = {},
        locale: s = void 0,
        theme: i = void 0,
        iconLoaderUrl: l = void 0,
        iconLoader: o = void 0,
        icons: u = {},
        ...f
      } = e, p = xb({
        ...Fg,
        ...t || {}
      }), h = t_(
        Ct({ en: e_, ...r || {} }, a)
      ), c = r_(W_, n), y = Q$(i, u, l, o);
      return Ct(
        {
          plugins: [c, y, ou, h, p],
          ...s ? { config: { locale: s } } : {}
        },
        f || {},
        !0
      );
    };
  }
}), mw = typeof window > "u", ya = /* @__PURE__ */ new Map();
function vw(e, t) {
  var r;
  !mw || !e || (ya.has(e) || ya.set(e, /* @__PURE__ */ new Set()), (r = ya.get(e)) == null || r.add(t));
}
var fu = typeof window > "u", Cr = {}, er = {}, Oe, vt = /* @__PURE__ */ new WeakMap(), yw = "__raw__", hw = /[a-zA-Z0-9\-][cC]lass$/;
function gw(e, t) {
  const r = L(null);
  if (e === "get") {
    const a = {};
    return r.value = bw.bind(null, a), r;
  }
  const n = e.split(".");
  return Ke(() => {
    r.value = Ms(
      pn(t) ? t.value : t,
      n
    );
  }), r;
}
function Ms(e, t) {
  if (Array.isArray(e)) {
    for (const a of e) {
      const s = a !== !1 && Ms(a, t);
      if (s !== void 0)
        return s;
    }
    return;
  }
  let r, n = e;
  for (const a in t) {
    const s = t[a];
    if (typeof n != "object" || n === null) {
      r = void 0;
      break;
    }
    const i = n[s];
    if (Number(a) === t.length - 1 && i !== void 0) {
      r = typeof i == "function" ? i.bind(n) : i;
      break;
    }
    n = i;
  }
  return r;
}
function bw(e, t) {
  if (typeof t != "string")
    return Br(650);
  if (t in e || (e[t] = L(void 0)), e[t].value === void 0) {
    e[t].value = null;
    const r = Rl(t);
    r && (e[t].value = r.context), vv(t, ({ payload: n }) => {
      e[t].value = Bn(n) ? n.context : n;
    });
  }
  return e[t].value;
}
function Bi(e, t, r) {
  function n(c, y) {
    const g = p(Je(y.if), { if: !0 }), b = u(c, y.then), k = y.else ? u(c, y.else) : null;
    return [g, b, k];
  }
  function a(c, y) {
    var P, I;
    const g = p(Je(c.if));
    let b = () => y, k = () => y;
    return typeof c.then == "object" ? k = s(c.then, void 0) : typeof c.then == "string" && ((P = c.then) != null && P.startsWith("$")) ? k = p(Je(c.then)) : k = () => c.then, be(c, "else") && (typeof c.else == "object" ? b = s(c.else) : typeof c.else == "string" && ((I = c.else) != null && I.startsWith("$")) ? b = p(Je(c.else)) : b = () => c.else), () => g() ? k() : b();
  }
  function s(c, y, g = {}) {
    const b = new Set(Object.keys(c || {})), k = y ? p(Je(y)) : () => ({}), P = [
      (I) => {
        const _ = k();
        for (const S in _)
          b.has(S) || (I[S] = _[S]);
      }
    ];
    if (c) {
      if (Ut(c))
        return a(
          c,
          g
        );
      for (let I in c) {
        const _ = c[I];
        let S;
        const v = typeof _ == "string";
        I.startsWith(yw) ? (I = I.substring(7), S = () => _) : v && _.startsWith("$") && _.length > 1 && !(_.startsWith("$reset") && hw.test(I)) ? S = p(Je(_)) : typeof _ == "object" && Ut(_) ? S = a(_, void 0) : typeof _ == "object" && ir(_) ? S = s(_) : S = () => _, P.push((w) => {
          w[I] = S();
        });
      }
    }
    return () => {
      const I = Array.isArray(c) ? [] : {};
      return P.forEach((_) => _(I)), I;
    };
  }
  function i(c, y) {
    let g = null, b = () => null, k = !1, P = null, I = null, _ = null, S = !1;
    const v = cy(y);
    if (Ca(v) ? (g = v.$el, b = v.$el !== "text" ? s(v.attrs, v.bind) : () => null) : Ea(v) ? (typeof v.$cmp == "string" ? be(c, v.$cmp) ? g = c[v.$cmp] : (g = v.$cmp, S = !0) : g = v.$cmp, b = s(v.props, v.bind)) : Ut(v) && ([k, P, I] = n(c, v)), !Ut(v) && "if" in v ? k = p(Je(v.if)) : !Ut(v) && g === null && (k = () => !0), "children" in v && v.children)
      if (typeof v.children == "string")
        if (v.children.startsWith("$slots."))
          g = g === "text" ? "slot" : g, P = p(Je(v.children));
        else if (v.children.startsWith("$") && v.children.length > 1) {
          const w = p(Je(v.children));
          P = () => String(w());
        } else
          P = () => String(v.children);
      else if (Array.isArray(v.children))
        P = u(c, v.children);
      else {
        const [w, C, F] = n(c, v.children);
        P = (x) => w && w() ? C && C(x) : F && F(x);
      }
    if (Ea(v))
      if (P) {
        const w = P;
        P = (C) => ({
          default(F, x) {
            var $, A, z, N;
            const R = Oe;
            x && (Oe = x), F && (($ = vt.get(Oe)) == null || $.unshift(F)), C && ((A = vt.get(Oe)) == null || A.unshift(C));
            const d = w(C);
            return F && ((z = vt.get(Oe)) == null || z.shift()), C && ((N = vt.get(Oe)) == null || N.shift()), Oe = R, d;
          }
        }), P.slot = !0;
      } else
        P = () => ({});
    if ("for" in v && v.for) {
      const w = v.for.length === 3 ? v.for[2] : v.for[1];
      _ = [
        typeof w == "string" && w.startsWith("$") ? p(Je(w)) : () => w,
        v.for[0],
        v.for.length === 3 ? String(v.for[1]) : null
      ];
    }
    return [k, g, b, P, I, _, S];
  }
  function l(c, y) {
    const g = c(y), b = Oe;
    return Object.keys(g).reduce((k, P) => {
      const I = g && g[P];
      return k[P] = (_) => I && I(_, b) || null, k;
    }, {});
  }
  function o(c, y) {
    const [g, b, k, P, I, _, S] = i(c, y);
    let v = (w) => {
      if (g && b === null && P)
        return g() ? P(w) : I && I(w);
      if (b && (!g || g())) {
        if (b === "text" && P)
          return K(String(P()));
        if (b === "slot" && P)
          return P(w);
        const C = S ? nl(b) : b, F = P != null && P.slot ? l(P, w) : null;
        return ba(
          C,
          k(),
          F || (P ? P(w) : [])
        );
      }
      return typeof I == "function" ? I(w) : I;
    };
    if (_) {
      const w = v, [C, F, x] = _;
      v = () => {
        const R = C(), d = Number.isFinite(R) ? Array(Number(R)).fill(0).map((N, j) => j) : R, $ = [];
        if (typeof d != "object")
          return null;
        const A = vt.get(Oe) || [], z = Array.isArray(d);
        for (const N in d) {
          if (z && N in Array.prototype)
            continue;
          const j = Object.defineProperty(
            {
              ...A.reduce(
                (Q, q) => Q.__idata ? { ...Q, ...q } : q,
                {}
              ),
              [F]: d[N],
              ...x !== null ? { [x]: z ? Number(N) : N } : {}
            },
            "__idata",
            { enumerable: !1, value: !0 }
          );
          A.unshift(j), $.push(w.bind(null, j)()), A.shift();
        }
        return $;
      };
    }
    return v;
  }
  function u(c, y) {
    if (Array.isArray(y)) {
      const b = y.map(o.bind(null, c));
      return (k) => b.map((P) => P(k));
    }
    const g = o(c, y);
    return (b) => g(b);
  }
  const f = [];
  function p(c, y = {}) {
    const g = /* @__PURE__ */ new WeakMap();
    return f.push((b, k) => {
      g.set(
        k,
        c.provide((P) => b(P, y))
      );
    }), () => g.get(Oe)();
  }
  function h(c, y) {
    r ?? (r = pu(t));
    const [g, b] = be(Cr, r) ? Cr[r] : [u(e, t), f];
    return fu || (er[r] ?? (er[r] = 0), er[r]++, Cr[r] = [g, b]), b.forEach((k) => {
      k(c, y);
    }), () => (Oe = y, g());
  }
  return h;
}
function du(e, t) {
  const r = vt.get(Oe) || [];
  let n;
  return r.length && (n = Ms(r, e.split("."))), n === void 0 ? t : n;
}
function _w(e, t) {
  return new Proxy(e, {
    get(...r) {
      let n;
      const a = r[1];
      if (typeof a == "string") {
        const s = Oe;
        Oe = t, n = du(a, void 0), Oe = s;
      }
      return n !== void 0 ? n : Reflect.get(...r);
    }
  });
}
function ji(e, t, r) {
  return e(
    (n, a = {}) => n.reduce((s, i) => {
      if (i.startsWith("slots.")) {
        const l = i.substring(6), o = () => t.slots && be(t.slots, l) && typeof t.slots[l] == "function";
        if (a.if)
          s[i] = o;
        else if (t.slots) {
          const u = _w(t, r);
          s[i] = () => o() ? t.slots[l](u) : null;
        }
      } else {
        const l = gw(i, t);
        s[i] = () => du(i, l.value);
      }
      return s;
    }, {}),
    r
  );
}
function qi(e, t, r) {
  if (t ?? (t = pu(e)), er[t]--, er[t] === 0) {
    delete er[t];
    const [, n] = Cr[t];
    delete Cr[t], n.length = 0;
  }
  vt.delete(r);
}
function pu(e) {
  return JSON.stringify(e, (t, r) => typeof r == "function" ? r.toString() : r);
}
var $w = /* @__PURE__ */ W({
  name: "FormKitSchema",
  props: {
    schema: {
      type: [Array, Object],
      required: !0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    library: {
      type: Object,
      default: () => ({})
    },
    memoKey: {
      type: String,
      required: !1
    }
  },
  emits: ["mounted"],
  setup(e, t) {
    var u;
    const r = Ar();
    let n = {};
    vt.set(n, []);
    const a = { FormKit: Ja(vu), ...e.library };
    let s = Bi(a, e.schema, e.memoKey), i, l;
    fu || le(
      () => e.schema,
      (f, p) => {
        var c;
        const h = n;
        n = {}, vt.set(n, []), s = Bi(a, e.schema, e.memoKey), i = ji(s, l, n), f === p && ((c = r == null ? void 0 : r.proxy) == null ? void 0 : c.$forceUpdate).call(c), qi(e.schema, e.memoKey, h);
      },
      { deep: !0 }
    ), Ke(() => {
      l = Object.assign(It(e.data ?? {}), {
        slots: t.slots
      }), t.slots, i = ji(s, l, n);
    });
    function o() {
      qi(e.schema, e.memoKey, n), l && (l.node && l.node.destroy(), l.slots = null, l = null), i = null;
    }
    return he(() => t.emit("mounted")), Xa(o), vw((u = Ar()) == null ? void 0 : u.appContext.app, o), () => i ? i() : null;
  }
}), kw = typeof window > "u", Wi = Symbol("FormKitParent"), ww = Symbol("FormKitComponentCallback");
function Sw(e, t) {
  const r = Tw(e, t);
  if (r.props.definition || Be(600, r), r.props.definition.component)
    return () => {
      var u;
      return ba(
        (u = r.props.definition) == null ? void 0 : u.component,
        {
          context: r.context
        },
        { ...t.slots }
      );
    };
  const n = L([]);
  let a = r.props.definition.schemaMemoKey;
  const s = () => {
    var f, p;
    const u = (p = (f = r.props) == null ? void 0 : f.definition) == null ? void 0 : p.schema;
    u || Be(601, r), typeof u == "function" ? (n.value = u({ ...e.sectionsSchema || {} }), (a && e.sectionsSchema || "memoKey" in u && typeof u.memoKey == "string") && (a = (a ?? (u == null ? void 0 : u.memoKey)) + JSON.stringify(e.sectionsSchema))) : n.value = u;
  };
  s(), kw || r.on("schema", () => {
    a += "♻️", s();
  }), t.emit("node", r);
  const i = r.props.definition.library, l = {
    FormKit: Ja(mu),
    ...i,
    ...e.library ?? {}
  };
  function o() {
    r.emit("mounted");
  }
  return t.expose({ node: r }), () => ba(
    $w,
    {
      schema: n.value,
      data: r.context,
      onMounted: o,
      library: l,
      memoKey: a
    },
    { ...t.slots }
  );
}
var mu = /* @__PURE__ */ W(
  Sw,
  {
    props: n_,
    inheritAttrs: !1
  }
), vu = mu, Pw = Symbol(), Iw = Symbol.for("FormKitOptions"), Cw = typeof window < "u", ha = [
  // Boolean props
  "ignore",
  "disabled",
  "preserve",
  // String props
  "help",
  "label",
  /^preserve(-e|E)rrors/,
  /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
  /^[a-zA-Z-]+(?:-class|Class)$/,
  "prefixIcon",
  "suffixIcon",
  /^[a-zA-Z-]+(?:-icon|Icon)$/
], Ew = ["disabled", "ignore", "preserve"];
function Ui(e, t) {
  t.classes && Object.keys(t.classes).forEach(
    (r) => {
      typeof r == "string" && (e.props[`_${r}Class`] = t.classes[r], Pr(t.classes[r]) && r === "inner" && Object.values(t.classes[r]));
    }
  );
}
function Aw(e) {
  return e ? ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
    (r, n) => {
      const a = `on${n}`;
      return a in e && typeof e[a] == "function" && (r[a] = e[a]), r;
    },
    {}
  ) : {};
}
function Tw(e, t, r = {}) {
  const n = Object.assign({}, ee(Iw) || {}, r), a = ee(Pw, L(Cw ? document : void 0)), s = ee(ww, () => {
  }), i = Ar(), l = Aw(i == null ? void 0 : i.vnode.props), o = ["modelValue", "model-value"].some(
    (v) => v in ((i == null ? void 0 : i.vnode.props) ?? {})
  );
  let u = !1;
  he(() => {
    u = !0;
  });
  const f = e.modelValue !== void 0 ? e.modelValue : xt(t.attrs.value);
  function p() {
    const v = {
      ...jt(e),
      ...l,
      type: e.type ?? "text",
      __root: a.value,
      __slots: t.slots
    }, w = Js(jt(t.attrs), ha);
    w.key || (w.key = Vn()), v.attrs = w;
    const C = ei(jt(t.attrs), ha);
    for (const x in C)
      Ew.includes(x) && C[x] === "" && (C[x] = !0), v[Zt(x)] = C[x];
    const F = { props: {} };
    return Ui(F, e), Object.assign(v, F.props), typeof v.type != "string" && (v.definition = v.type, delete v.type), v;
  }
  const h = p(), c = h.ignore ? null : e.parent || ee(Wi, null), y = oy(
    Ct(
      n || {},
      {
        name: e.name || void 0,
        value: f,
        parent: c,
        plugins: (n.plugins || []).concat(e.plugins ?? []),
        config: e.config || {},
        props: h,
        index: e.index,
        sync: !!tt(t.attrs.sync || t.attrs.dynamic)
      },
      !1,
      !0
    )
  );
  s(y), y.props.definition || Be(600, y);
  const g = L(
    new Set(
      Array.isArray(y.props.__propDefs) ? y.props.__propDefs : Object.keys(y.props.__propDefs ?? {})
    )
  );
  y.on(
    "added-props",
    ({ payload: v }) => {
      (Array.isArray(v) ? v : Object.keys(v ?? {})).forEach((C) => g.value.add(C));
    }
  );
  const b = E(
    () => ha.concat([...g.value]).reduce((v, w) => (typeof w == "string" ? (v.push(Zt(w)), v.push(Tl(w))) : v.push(w), v), [])
  );
  Ke(() => Ui(y, e));
  const k = jt(e);
  for (const v in k)
    le(
      () => e[v],
      () => {
        e[v] !== void 0 && (y.props[v] = e[v]);
      }
    );
  Ke(() => {
    y.props.__root = a.value;
  });
  const P = /* @__PURE__ */ new Set(), I = jt(t.attrs);
  Ke(() => {
    _(ei(I, b.value));
  });
  function _(v) {
    P.forEach((w) => {
      w(), P.delete(w);
    });
    for (const w in v) {
      const C = Zt(w);
      P.add(
        le(
          () => t.attrs[w],
          () => {
            y.props[C] = t.attrs[w];
          }
        )
      );
    }
  }
  if (Ke(() => {
    const v = Js(jt(t.attrs), b.value);
    "multiple" in v && (v.multiple = tt(v.multiple)), typeof v.onBlur == "function" && (v.onBlur = Gm(v.onBlur)), y.props.attrs = Object.assign({}, y.props.attrs || {}, v);
  }), Ke(() => {
    const v = (e.errors ?? []).map(
      (w) => /* @__PURE__ */ _t({
        key: hs(w),
        type: "error",
        value: w,
        meta: { source: "prop" }
      })
    );
    y.store.apply(
      v,
      (w) => w.type === "error" && w.meta.source === "prop"
    );
  }), y.type !== "input") {
    const v = `${y.name}-prop`;
    Ke(() => {
      const w = e.inputErrors ?? {}, C = Object.keys(w);
      C.length || y.clearErrors(!0, v);
      const F = C.reduce((x, R) => {
        let d = w[R];
        return typeof d == "string" && (d = [d]), Array.isArray(d) && (x[R] = d.map(
          ($) => /* @__PURE__ */ _t({
            key: $,
            type: "error",
            value: $,
            meta: { source: v }
          })
        )), x;
      }, {});
      y.store.apply(
        F,
        (x) => x.type === "error" && x.meta.source === v
      );
    });
  }
  Ke(() => Object.assign(y.config, e.config)), y.type !== "input" && _e(Wi, y);
  let S;
  return y.on("modelUpdated", () => {
    var v, w;
    t.emit("inputRaw", (v = y.context) == null ? void 0 : v.value, y), u && t.emit("input", (w = y.context) == null ? void 0 : w.value, y), o && y.context && (S = xt(y.value), t.emit("update:modelValue", wa(y.value)));
  }), o && (le(
    al(e, "modelValue"),
    (v) => {
      nt(S, v) || y.input(v, !1);
    },
    { deep: !0 }
  ), y.value !== f && y.emit("modelUpdated")), qe(() => y.destroy()), y;
}
var Lw = /* @__PURE__ */ te("messages", () => ({
  $el: "ul",
  if: "$fns.length($messages)"
})), Mw = /* @__PURE__ */ te("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
}));
Lw(Mw("$message.value"));
var Ow = /* @__PURE__ */ te("summary", () => ({
  $el: "div",
  attrs: {
    "aria-live": "polite"
  }
})), Nw = /* @__PURE__ */ te("summaryInner", () => ({
  $el: "div",
  if: "$summaries.length && $showSummaries"
})), Fw = /* @__PURE__ */ te("messages", () => ({
  $el: "ul",
  if: "$summaries.length && $showSummaries"
})), Dw = /* @__PURE__ */ te("message", () => ({
  $el: "li",
  for: ["summary", "$summaries"],
  attrs: {
    key: "$summary.key",
    "data-message-type": "$summary.type"
  }
})), Rw = /* @__PURE__ */ te("summaryHeader", () => ({
  $el: "h2",
  attrs: {
    id: "$id"
  }
})), xw = /* @__PURE__ */ te("messageLink", () => ({
  $el: "a",
  attrs: {
    id: "$summary.key",
    href: '$: "#" + $summary.id',
    onClick: "$jumpLink"
  }
}));
Ow(
  Nw(
    Rw("$summaryHeader"),
    Fw(Dw(xw("$summary.message")))
  )
);
pw();
uu();
function Hw({
  container: e,
  button: t,
  popoverState: r
}) {
  const n = L(!0), a = L(!0), s = () => {
    if (!t.value || !e.value) return;
    const i = t.value.getBoundingClientRect();
    e.value.style.setProperty(
      "--anchor-bottom",
      `${i.bottom}px`
    ), e.value.style.setProperty(
      "--anchor-right",
      `${i.right}px`
    );
  };
  return he(() => {
    n.value = typeof HTMLElement.prototype.showPopover == "function", a.value = CSS.supports(
      "inset-block-start: anchor(bottom)"
    ), n.value || zn(e, () => {
      r.value = "closed";
    }), a.value || (s(), window.addEventListener("resize", s));
  }), qe(() => {
    window.removeEventListener("resize", s);
  }), {
    supportsPopoverApi: n,
    supportsAnchorPositioning: a
  };
}
const zw = ["data-popover-fallback", "data-popover-state"], Vw = ["popovertarget"], Bw = ["id"], jw = { class: "ds-nav-popover__scroll" }, qw = {
  key: 0,
  class: "ds-nav-popover__filter"
}, Ww = {
  key: 1,
  class: "ds-nav-popover__list"
}, Uw = ["href", "target"], Kw = /* @__PURE__ */ W({
  __name: "ds-nav-popover",
  props: {
    autoFocusFilter: { type: Boolean, default: !0 },
    item: {}
  },
  setup(e) {
    const t = e, r = L("closed"), n = L(""), a = L(), s = L(), i = E(() => `ds-nav-popover__button--${r.value}`), l = E(() => t.item.children.filter(
      (p) => {
        var h;
        return p.text.toLowerCase().indexOf(n.value.toLowerCase()) > -1 || p.textAlternative && ((h = p.textAlternative) == null ? void 0 : h.toLowerCase().indexOf(n.value.toLowerCase())) > -1;
      }
    )), o = async (p) => {
      r.value = p.newState;
    }, { supportsPopoverApi: u } = Hw({
      container: a,
      button: s,
      popoverState: r
    }), f = () => {
      u.value || (r.value = r.value === "open" ? "closed" : "open");
    };
    return (p, h) => (m(), T("div", {
      class: "ds-nav-popover",
      "data-popover-fallback": O(u) ? void 0 : !0,
      "data-popover-state": O(u) ? void 0 : r.value,
      "data-testid": "popover-container",
      ref_key: "container",
      ref: a
    }, [
      D("button", $e(p.item.attributes, {
        onClick: f,
        class: ["ds-nav-popover__button", i.value],
        popovertarget: `popover-${p.item.itemId}`,
        ref_key: "button",
        ref: s,
        type: "button"
      }), [
        p.item.iconName ? (m(), H(ae, {
          key: 0,
          "icon-name": p.item.iconName,
          size: "xs"
        }, null, 8, ["icon-name"])) : M("", !0),
        B(Y, {
          "text-type": "label-sm",
          "html-element": "span"
        }, {
          default: V(() => [
            K(U(p.item.text), 1)
          ]),
          _: 1
        }),
        B(ae, {
          class: "ds-nav-popover__button-icon",
          "icon-name": "button-chevron-down",
          size: "xs"
        })
      ], 16, Vw),
      D("div", {
        id: `popover-${p.item.itemId}`,
        "data-testid": "popover",
        popover: "auto",
        class: "ds-nav-popover__popover",
        onBeforetoggle: o
      }, [
        D("div", jw, [
          p.item.filterEnabled ? (m(), T("div", qw, [
            B(O(vu), {
              type: "search",
              "prefix-icon": "search",
              placeholder: p.item.filterPlaceholder,
              autofocus: p.autoFocusFilter,
              modelValue: n.value,
              "onUpdate:modelValue": h[0] || (h[0] = (c) => n.value = c)
            }, null, 8, ["placeholder", "autofocus", "modelValue"])
          ])) : M("", !0),
          l.value.length ? (m(), T("ul", Ww, [
            (m(!0), T(se, null, ve(l.value, (c) => (m(), T("li", {
              key: c.itemId,
              class: "ds-nav-popover__item"
            }, [
              D("a", {
                class: G([
                  "ds-nav-popover__link",
                  c.isActive ? "ds-nav-popover__link--active" : ""
                ]),
                href: c.linkUrl,
                target: c.linkTarget
              }, [
                B(Y, {
                  class: "ds-nav-popover__link-text",
                  "html-element": "span",
                  "text-type": "label-md"
                }, {
                  default: V(() => [
                    K(U(c.text), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 10, Uw)
            ]))), 128))
          ])) : p.item.filterNoResultsLabel ? (m(), H(Y, {
            key: 2,
            class: "ds-nav-popover__no-results",
            "html-element": "div",
            "text-type": "label-sm"
          }, {
            default: V(() => [
              K(U(p.item.filterNoResultsLabel), 1)
            ]),
            _: 1
          })) : M("", !0)
        ])
      ], 40, Bw)
    ], 8, zw));
  }
}), Yw = ["aria-label"], Gw = {
  key: 0,
  class: "ds-nav-service__list"
}, Qw = ["href"], lS = /* @__PURE__ */ W({
  __name: "ds-nav-service",
  props: {
    ariaLabel: { default: "Service navigation" },
    autoFocusFilter: { type: Boolean, default: !0 },
    items: {}
  },
  setup(e) {
    const t = L(!1), { isMobile: r } = Fe();
    return he(() => {
      t.value = !0;
    }), (n, a) => t.value && !O(r) ? (m(), T("nav", {
      key: 0,
      class: "ds-nav-service",
      "aria-label": n.ariaLabel
    }, [
      n.items && n.items.length ? (m(), T("ul", Gw, [
        (m(!0), T(se, null, ve(n.items, (s) => (m(), T("li", {
          key: s.itemId,
          class: "ds-nav-service__item"
        }, [
          s.type === "service" ? (m(), T("a", $e({
            key: 0,
            ref_for: !0
          }, s.attributes, {
            class: "ds-nav-service__link",
            href: s.linkUrl
          }), [
            s.iconName ? (m(), H(ae, {
              key: 0,
              "icon-name": s.iconName,
              size: "xs"
            }, null, 8, ["icon-name"])) : M("", !0),
            B(Y, {
              "text-type": "label-sm",
              "html-element": "span"
            }, {
              default: V(() => [
                K(U(s.text), 1)
              ]),
              _: 2
            }, 1024)
          ], 16, Qw)) : s.type === "popover" ? (m(), H(Kw, {
            key: 1,
            "auto-focus-filter": n.autoFocusFilter,
            item: s
          }, null, 8, ["auto-focus-filter", "item"])) : M("", !0)
        ]))), 128))
      ])) : M("", !0)
    ], 8, Yw)) : ie(n.$slots, "default", { key: 1 });
  }
}), Zw = { class: "ds-underscore" }, Xw = /* @__PURE__ */ W({
  __name: "ds-underscore",
  setup(e) {
    return (t, r) => (m(), T("span", Zw));
  }
}), Jw = ["innerHTML"], oS = /* @__PURE__ */ W({
  __name: "ds-page-header",
  props: {
    title: {},
    text: {}
  },
  setup(e) {
    return (t, r) => (m(), H(xn, {
      "padding-bottom": "close",
      class: "ds-page-header"
    }, {
      default: V(() => [
        B(Y, {
          class: "ds-page-header__title",
          "text-style": "medium",
          "text-type": "heading-8xl",
          "html-element": "h1"
        }, {
          default: V(() => [
            K(U(t.title), 1),
            B(Xw)
          ]),
          _: 1
        }),
        t.text ? (m(), H(Y, {
          key: 0,
          class: "ds-page-header__text",
          "text-type": "heading-xl"
        }, {
          default: V(() => [
            D("span", { innerHTML: t.text }, null, 8, Jw)
          ]),
          _: 1
        })) : M("", !0)
      ]),
      _: 1
    }));
  }
}), e0 = {
  key: 0,
  class: "ds-pagination"
}, t0 = ["aria-label"], r0 = { class: "ds-pagination__list" }, n0 = { class: "ds-visually-hidden" }, a0 = {
  key: 1,
  class: "ds-pagination__truncator"
}, qt = 1, s0 = 2, Ki = "...", uS = /* @__PURE__ */ W({
  __name: "ds-pagination",
  props: {
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    totalResults: {},
    labelNext: { default: "Next" },
    labelPage: { default: "page" },
    labelPagination: { default: "Pagination" },
    labelPrevious: { default: "Previous" },
    labelResults: { default: "{startRange} - {endRange} of {total} results" },
    navigationHandler: { type: Function, default: void 0 },
    navigationPreventDefault: { type: Boolean, default: !0 },
    urlStructure: { default: window.location.pathname + "?page={page}" }
  },
  setup(e) {
    const t = e;
    if (typeof t.totalResults != "number" || typeof t.pageSize != "number" || typeof t.currentPage != "number")
      throw new Error(
        "Ensure you're using number type values for totalResults, pageSize and currentPage"
      );
    const r = (v) => {
      t.navigationPreventDefault && v.preventDefault();
    }, n = (v) => v > 0 && v <= g.value, a = (v, w) => {
      if (r(v), n(w)) {
        if (t.navigationHandler)
          try {
            t.navigationHandler(w);
          } catch (C) {
            console.error(C, "Error calling navigationHandler");
            return;
          }
        o.value = w;
      }
    }, s = (v) => {
      a(v, u.value - 1);
    }, i = (v) => {
      a(v, u.value + 1);
    };
    let l = !1;
    const o = L(t.currentPage);
    le(
      () => t.currentPage,
      (v) => {
        o.value = v;
      },
      { immediate: !0 }
    );
    const u = E(() => o.value < qt ? qt : o.value > g.value ? g.value : o.value), f = E(() => u.value > qt ? u.value - 1 : qt), p = E(() => u.value < g.value ? u.value + 1 : g.value), h = E(
      () => t.pageSize * (u.value - 1) + 1
    ), c = E(
      () => t.pageSize * u.value < t.totalResults ? t.pageSize * u.value : t.totalResults
    ), y = E(
      () => `${t.labelResults.replace("{startRange}", h.value.toString()).replace("{endRange}", c.value.toString()).replace("{total}", t.totalResults.toString())}`
    ), g = E(() => Math.ceil(t.totalResults / t.pageSize));
    let b = E(() => k.value ? 5 : 9);
    const { isMobile: k } = Fe(), P = (v, w, C, F, x) => {
      for (x = Number(Math.min(x, F)); v.length < x; ) {
        const R = w - C, d = w + C;
        R >= qt && v.unshift(R), d <= F && v.length < x && v.push(d), C++;
      }
      return v;
    }, I = (v, w, C) => {
      if (w < C) return v;
      const F = [...v];
      return F[0] = qt, F[F.length - 1] = w, F[1] !== s0 && (F[1] = Ki), F[F.length - 2] !== w - 1 && (F[F.length - 2] = Ki), F;
    }, _ = (v, w, C) => I(
      P(
        [v],
        v,
        1,
        w,
        C
      ),
      w,
      C
    ), S = E(() => _(
      u.value,
      g.value,
      b.value
    ));
    return l = !0, (v, w) => v.totalResults && g.value > 1 ? (m(), T("div", e0, [
      O(l) ? M("", !0) : ie(v.$slots, "default", { key: 0 }),
      O(l) ? (m(), T("nav", {
        key: 1,
        "aria-label": v.labelPagination,
        class: "ds-pagination__nav"
      }, [
        B(O(Ie), {
          iconName: "button-chevron-left",
          ariaLabel: v.labelPrevious,
          clickHandler: s,
          disabled: u.value === 1,
          href: v.urlStructure.replace(
            "{page}",
            f.value.toString()
          ),
          size: "sm",
          variant: "secondary"
        }, null, 8, ["ariaLabel", "disabled", "href"]),
        D("ul", r0, [
          (m(!0), T(se, null, ve(S.value, (C, F) => (m(), T("li", {
            key: typeof C == "number" ? C : `trunc-${F}`
          }, [
            typeof C == "number" ? (m(), H(O(Ee), {
              key: 0,
              class: "ds-pagination__num",
              "aria-current": C === u.value ? !0 : null,
              padding: "padding-compact",
              selected: C === u.value,
              href: v.urlStructure.replace("{page}", C.toString()),
              onClick: (x) => a(x, C),
              variant: "link"
            }, {
              default: V(() => [
                D("span", n0, U(v.labelPage), 1),
                K(" " + U(C), 1)
              ]),
              _: 2
            }, 1032, ["aria-current", "selected", "href", "onClick"])) : M("", !0),
            C === "..." ? (m(), T("div", a0, " … ")) : M("", !0)
          ]))), 128))
        ]),
        B(O(Ie), {
          iconName: "button-chevron-right",
          ariaLabel: v.labelNext,
          clickHandler: i,
          disabled: u.value === g.value,
          href: v.urlStructure.replace("{page}", p.value.toString()),
          size: "sm",
          variant: "secondary"
        }, null, 8, ["ariaLabel", "disabled", "href"])
      ], 8, t0)) : M("", !0),
      B(O(Y), {
        "aria-live": "polite",
        "html-element": "div",
        textType: "label-sm",
        class: "ds-pagination__results"
      }, {
        default: V(() => [
          K(U(y.value), 1)
        ]),
        _: 1
      })
    ])) : M("", !0);
  }
}), i0 = {
  key: 0,
  class: "ds-progress-dots",
  "aria-hidden": "true"
}, cS = /* @__PURE__ */ W({
  __name: "ds-progress-dots",
  props: {
    numberOfItems: {},
    activeIndex: { default: 0 }
  },
  setup(e) {
    return (t, r) => t.numberOfItems > 1 ? (m(), T("div", i0, [
      (m(!0), T(se, null, ve(t.numberOfItems, (n, a) => (m(), T("div", {
        key: a,
        class: G([
          "ds-progress-dots__dot",
          t.activeIndex === a ? "ds-progress-dots__dot--active" : void 0
        ])
      }, null, 2))), 128))
    ])) : M("", !0);
  }
}), l0 = ["aria-label", "disabled"], o0 = ["min", "max", "disabled", "aria-label", "value", "id"], u0 = ["aria-label", "disabled"], fS = /* @__PURE__ */ W({
  __name: "ds-quantity-selector",
  props: {
    background: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !0 },
    min: { default: 0 },
    max: { default: 99 },
    debounceDuration: { default: 200 },
    modelValue: {},
    id: {},
    ariaLabelInput: {},
    ariaLabelDecreaseQuantity: {},
    ariaLabelIncreaseQuantity: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const r = e, n = t, a = L(null), s = E(() => ({
      "ds-quantity-selector": !0,
      "ds-quantity-selector--background": r.background,
      "ds-quantity-selector--disabled": r.disabled,
      "ds-quantity-selector--outline": r.outline
    })), i = () => {
      f(r.modelValue - 1);
    }, l = () => {
      f(r.modelValue + 1);
    }, o = (p) => {
      const h = p.target, c = Number(h.value.replace(/\D/g, "")), y = parseInt(c.toString(), 10);
      f(y);
    }, u = cs((p) => {
      n("change", p);
    }, r.debounceDuration), f = (p) => {
      const h = Math.max(
        r.min,
        Math.min(r.max, p || r.min)
      );
      a.value !== null && h !== p && (a.value.value = `${h}`), n("update:modelValue", h), u(h);
    };
    return (p, h) => (m(), T("div", {
      class: G(s.value)
    }, [
      D("button", {
        "aria-label": p.ariaLabelDecreaseQuantity,
        class: "ds-quantity-selector__button ds-quantity-selector__button--decrease",
        disabled: p.modelValue <= p.min || p.disabled,
        type: "button",
        onClick: ct(i, ["prevent"])
      }, [
        B(O(ae), { "icon-name": "subtract" })
      ], 8, l0),
      D("input", {
        min: p.min,
        max: p.max,
        step: "1",
        class: "ds-quantity-selector__input",
        disabled: p.disabled,
        onInput: o,
        "aria-label": p.ariaLabelInput,
        "aria-live": "polite",
        type: "number",
        autocomplete: "off",
        value: p.modelValue,
        ref_key: "inputEl",
        ref: a,
        id: p.id
      }, null, 40, o0),
      D("button", {
        "aria-label": p.ariaLabelIncreaseQuantity,
        class: "ds-quantity-selector__button ds-quantity-selector__button--increase",
        disabled: p.modelValue >= p.max || p.disabled,
        type: "button",
        onClick: ct(l, ["prevent"])
      }, [
        B(O(ae), { "icon-name": "add" })
      ], 8, u0)
    ], 2));
  }
}), c0 = {
  class: "ds-scroll-progress-bar",
  "aria-hidden": "true"
}, dS = /* @__PURE__ */ W({
  __name: "ds-scroll-progress-bar",
  props: {
    scrollContainerRef: {}
  },
  setup(e) {
    const t = e, r = L(0), n = L(0), a = L(0), s = E(
      () => a.value / n.value
    );
    let i = new ResizeObserver(() => {
      l(), o();
    });
    const l = () => {
      var h, c;
      n.value = ((h = t.scrollContainerRef) == null ? void 0 : h.scrollWidth) ?? 0, a.value = ((c = t.scrollContainerRef) == null ? void 0 : c.clientWidth) ?? 0;
    }, o = () => {
      t.scrollContainerRef && (r.value = Math.abs(t.scrollContainerRef.scrollLeft) ?? 0);
    }, u = wl(
      () => {
        o();
      },
      100,
      !0
    );
    le(
      () => t.scrollContainerRef,
      (h, c) => {
        c && c.removeEventListener("scroll", () => {
          u();
        }), h && (i.observe(h), h.addEventListener(
          "scroll",
          () => {
            u();
          },
          {
            passive: !0
          }
        ));
      },
      { immediate: !0 }
    ), qe(() => {
      t.scrollContainerRef && t.scrollContainerRef.removeEventListener("scroll", () => {
        u();
      });
    });
    const f = E(() => {
      if (!t.scrollContainerRef || s.value === 1) return 0;
      let h = Math.min(
        r.value / n.value + s.value,
        1
      );
      return h > 0.98 ? 1 : h;
    }), p = E(() => ({
      "--progress-scale-factor": f.value.toString()
    }));
    return (h, c) => (m(), T("div", c0, [
      D("div", {
        style: Ce(p.value),
        class: "ds-scroll-progress-bar__bar"
      }, null, 4)
    ]));
  }
}), f0 = ["aria-hidden", "aria-live", "aria-label"], d0 = {
  class: "ds-spinner__content",
  "aria-hidden": "true"
}, p0 = ["innerHTML"], pS = /* @__PURE__ */ W({
  __name: "ds-spinner",
  props: {
    accessibilityLabel: { default: "Loading" },
    accessibilityLabelCompleted: { default: "Completed" },
    displayMode: { default: "default" },
    label: { default: null },
    status: { default: "hidden" }
  },
  setup(e) {
    const t = e, r = L(null), n = E(() => t.status === "loading" ? t.label && t.label.trim() !== "" ? t.label : t.accessibilityLabel : t.status === "completed" ? t.accessibilityLabelCompleted : "");
    return (a, s) => (m(), T(se, null, [
      D("output", {
        class: "ds-spinner-status",
        "aria-hidden": a.status === "hidden",
        "aria-live": a.status === "loading" ? "assertive" : "polite",
        "aria-label": n.value
      }, null, 8, f0),
      a.status === "loading" ? (m(), T("div", {
        key: 0,
        class: G(["ds-spinner", a.displayMode === "solid" ? "--solid" : null])
      }, [
        D("div", d0, [
          B(ll),
          a.label ? (m(), H(Y, {
            key: 0,
            "html-element": "p",
            "text-style": "medium",
            "text-type": "heading-md",
            class: "ds-spinner__label"
          }, {
            default: V(() => [
              D("span", {
                innerHTML: a.label,
                ref_key: "textLabel",
                ref: r
              }, null, 8, p0)
            ]),
            _: 1
          })) : M("", !0)
        ])
      ], 2)) : M("", !0)
    ], 64));
  }
}), m0 = (e) => /^[+-]?\d+(\.\d+)?$/.test(`${e}`), Ga = (e) => m0(e) ? `${e}px` : typeof e > "u" ? "auto" : e, Xn = /* @__PURE__ */ W({
  __name: "ds-skeleton-element",
  props: {
    additionalClasses: { default: "" },
    aspectRatio: {},
    height: {},
    width: {}
  },
  setup(e) {
    const t = e, r = E(() => {
      let n = {};
      return t.height && (n = {
        ...n,
        "--skeleton-height": `${Ga(t.height)}`
      }), t.width && (n = {
        ...n,
        "--skeleton-width": `${Ga(t.width)}`
      }), t.aspectRatio && (n = {
        ...n,
        "--skeleton-aspect-ratio": `${t.aspectRatio}`
      }), n;
    });
    return (n, a) => (m(), T("div", {
      class: G(["ds-skeleton-element", n.additionalClasses]),
      style: Ce(r.value)
    }, null, 6));
  }
}), mS = /* @__PURE__ */ W({
  __name: "ds-skeleton-box",
  props: {
    additionalClasses: { default: "" },
    aspectRatio: {},
    height: {},
    presetHeight: {},
    width: {}
  },
  setup(e) {
    const t = e, r = () => {
      switch (t.presetHeight) {
        case "small":
          return 56;
        case "medium":
          return 88;
        case "large":
          return 124;
        case "full":
          return 215;
        default:
          return;
      }
    }, n = E(() => t.height ? t.height : r());
    return (a, s) => (m(), H(Xn, {
      class: G(["ds-skeleton-box", a.additionalClasses]),
      "additional-classes": a.additionalClasses,
      "aspect-ratio": a.aspectRatio,
      height: n.value,
      width: a.width
    }, null, 8, ["class", "additional-classes", "aspect-ratio", "height", "width"]));
  }
}), vS = /* @__PURE__ */ W({
  __name: "ds-skeleton-button",
  props: {
    additionalClasses: { default: "" },
    height: {},
    presetHeight: {},
    width: {}
  },
  setup(e) {
    const t = e, r = () => {
      switch (t.presetHeight) {
        case "small":
        case "icon-small":
          return 34;
        case "medium":
        case "icon-medium":
          return 46;
        default:
          return;
      }
    }, n = E(() => {
      if (t.presetHeight === "icon-medium" || t.presetHeight === "icon-small")
        return 1;
    }), a = E(() => t.height ? t.height : r()), s = E(() => {
      if (t.width) return t.width;
      if (t.presetHeight === "icon-medium" || t.presetHeight === "icon-small")
        return "auto";
    });
    return (i, l) => (m(), H(Xn, {
      class: G(["ds-skeleton-button", i.additionalClasses]),
      "additional-classes": i.additionalClasses,
      "aspect-ratio": n.value,
      height: a.value,
      width: s.value
    }, null, 8, ["class", "additional-classes", "aspect-ratio", "height", "width"]));
  }
}), yS = /* @__PURE__ */ W({
  __name: "ds-skeleton-circle",
  props: {
    additionalClasses: { default: "" },
    diameter: {},
    presetDiameter: {}
  },
  setup(e) {
    const t = e, r = () => {
      switch (t.presetDiameter) {
        case "small":
          return 24;
        case "medium":
          return 40;
        case "large":
          return 72;
        default:
          return;
      }
    }, n = E(() => t.diameter ? t.diameter : r());
    return (a, s) => (m(), H(Xn, {
      class: G(["ds-skeleton-circle", a.additionalClasses]),
      aspectRatio: 1,
      height: n.value,
      width: n.value
    }, null, 8, ["class", "height", "width"]));
  }
}), yu = {
  elevation: "default",
  padding: "none"
}, hu = /* @__PURE__ */ W({
  __name: "ds-surface",
  props: /* @__PURE__ */ sl({
    elevation: {},
    padding: {}
  }, {
    ...yu
  }),
  setup(e) {
    const t = e, r = E(() => `ds-surface--${t.elevation}`), n = E(() => `ds-surface--pad-${t.padding}`);
    return (a, s) => (m(), T("div", {
      class: G(["ds-surface", [r.value, n.value]])
    }, [
      ie(a.$slots, "default")
    ], 2));
  }
}), hS = /* @__PURE__ */ W({
  __name: "ds-skeleton-surface",
  props: /* @__PURE__ */ sl({
    elevation: {},
    padding: {}
  }, {
    ...yu
  }),
  setup(e) {
    const t = e;
    return (r, n) => (m(), H(hu, $e({ class: "ds-skeleton-surface" }, t), {
      default: V(() => [
        ie(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), gS = /* @__PURE__ */ W({
  __name: "ds-skeleton-text-line",
  props: {
    additionalClasses: { default: "" },
    height: {},
    presetHeight: {},
    width: { default: "100%" }
  },
  setup(e) {
    const t = e, r = () => {
      switch (t.presetHeight) {
        case "small":
          return 12;
        case "medium":
          return 16;
        case "large":
          return 24;
        default:
          return;
      }
    }, n = E(() => t.height ? t.height : r());
    return (a, s) => (m(), H(Xn, {
      class: G(["ds-skeleton-text", a.additionalClasses]),
      "additional-classes": a.additionalClasses,
      height: n.value,
      width: a.width
    }, null, 8, ["class", "additional-classes", "height", "width"]));
  }
}), bS = /* @__PURE__ */ W({
  __name: "ds-skeleton-wrapper",
  setup(e) {
    var a;
    const t = L(null);
    let r = L((a = t == null ? void 0 : t.value) == null ? void 0 : a.offsetWidth);
    vn(t, (s) => {
      const i = s[0];
      r.value = i.contentRect.width;
    });
    const n = E(() => typeof r.value < "u" ? {
      "--skeleton-container-width": `${Ga(r.value)}`
    } : {});
    return (s, i) => (m(), T("div", {
      class: "ds-skeleton",
      style: Ce(n.value),
      "data-testid": "skeleton",
      ref_key: "container",
      ref: t,
      "aria-hidden": "true"
    }, [
      ie(s.$slots, "default")
    ], 4));
  }
}), v0 = ["innerHTML"], y0 = ["innerHTML"], h0 = /* @__PURE__ */ W({
  __name: "ds-fact",
  props: {
    brandIconName: {},
    stat: {},
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    return (t, r) => (m(), T("article", {
      class: G(["ds-fact", `ds-fact--${t.variant}`])
    }, [
      t.stat ? (m(), H(Y, {
        key: 0,
        class: "ds-fact__stat",
        "html-element": "h3",
        "text-type": "heading-4xl",
        "text-style": "regular"
      }, {
        default: V(() => [
          D("span", { innerHTML: t.stat }, null, 8, v0)
        ]),
        _: 1
      })) : M("", !0),
      t.brandIconName ? (m(), H(ol, {
        key: 1,
        class: "ds-fact__icon",
        "icon-name": t.brandIconName,
        size: "sm",
        mode: t.variant
      }, null, 8, ["icon-name", "mode"])) : M("", !0),
      B(Y, {
        class: "ds-fact__text",
        "html-element": "p",
        "text-type": "body-xs",
        "text-style": "regular"
      }, {
        default: V(() => [
          D("span", { innerHTML: t.text }, null, 8, y0)
        ]),
        _: 1
      })
    ], 2));
  }
}), g0 = {
  key: 0,
  class: "ds-tag__dot"
}, gu = /* @__PURE__ */ W({
  __name: "ds-tag",
  props: {
    dot: { type: Boolean, default: !0 },
    text: {},
    type: { default: "ghost" }
  },
  setup(e) {
    const t = e;
    return (r, n) => (m(), H(Y, {
      class: G(["ds-tag", `ds-tag--${t.type}`]),
      "html-element": "p",
      "text-type": "body-sm",
      "text-style": "medium"
    }, {
      default: V(() => [
        r.dot ? (m(), T("span", g0)) : M("", !0),
        K(U(r.text), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), b0 = ["src", "alt"], bu = /* @__PURE__ */ W({
  __name: "ds-sticky-media",
  props: {
    stackingIndex: {},
    isActive: { type: Boolean },
    imageAlt: {},
    imageSrc: {},
    mediaFocalPoint: { default: "center" }
  },
  setup(e) {
    const t = e, r = E(() => {
      const n = [];
      return t.mediaFocalPoint !== "center" && n.push(`--object-position: ${t.mediaFocalPoint};`), n;
    });
    return (n, a) => (m(), T("div", {
      class: G(["ds-sticky-media", { "is-visible": n.isActive }]),
      style: Ce({
        zIndex: `${n.stackingIndex}`
      })
    }, [
      n.imageSrc ? (m(), T("img", {
        key: 0,
        class: "ds-sticky-media__image",
        src: n.imageSrc,
        alt: n.imageAlt,
        style: Ce(r.value)
      }, null, 12, b0)) : M("", !0)
    ], 6));
  }
}), _0 = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  "2xl": 1400
}, $0 = (e = ["sm", "md", "lg", "xl", "2xl"]) => {
  const t = It(
    {}
  ), r = {}, n = {};
  return he(() => {
    e.forEach((a) => {
      const s = _0[a], i = window.matchMedia(`(min-width: ${s}px)`);
      r[a] = i, t[a] = i.matches;
      const l = (o) => {
        t[a] = o.matches;
      };
      n[a] = l, i.addEventListener("change", l);
    });
  }), qe(() => {
    e.forEach((a) => {
      const s = r[a], i = n[a];
      s && i && s.removeEventListener("change", i);
    });
  }), t;
}, k0 = { class: "ds-sticky-panel__content" }, w0 = { class: "ds-sticky-panel__content-top" }, S0 = {
  key: 0,
  class: "ds-sticky-panel__content-bottom"
}, P0 = "button-external-link", I0 = "button-navigate-forward", C0 = /* @__PURE__ */ W({
  __name: "ds-sticky-panel",
  props: {
    activeBgColour: {},
    activeIndex: {},
    bgColour: {},
    facts: {},
    index: { default: 0 },
    linkIsExternal: { type: Boolean, default: !1 },
    linkText: {},
    linkUrl: {},
    numberOfPanels: { default: 0 },
    mediaFocalPoint: { default: "center" },
    tag: {},
    title: {},
    text: {},
    image: {},
    imageAlt: {}
  },
  setup(e) {
    const t = e, r = $0(["xl"]), n = E(() => t.linkIsExternal ? P0 : I0), a = E(() => r.xl ? t.activeBgColour === "inverse" ? "inverse" : "default" : t.bgColour === "inverse" ? "inverse" : "default"), s = E(() => r.xl ? t.activeBgColour === "inverse" ? "link-inverted" : "link" : t.bgColour === "inverse" ? "link-inverted" : "link"), i = E(() => {
      const u = [];
      return t.activeIndex === t.index && u.push("ds-sticky-panel--active"), u.push(`ds-sticky-panel--bg-${t.bgColour}`), u;
    }), l = E(() => t.index), o = E(() => t.numberOfPanels - t.index);
    return (u, f) => (m(), H(xn, {
      class: G(["ds-sticky-panel", i.value]),
      style: Ce({
        zIndex: `${l.value}`
      })
    }, {
      default: V(() => {
        var p;
        return [
          D("div", k0, [
            D("div", w0, [
              O(r).xl ? M("", !0) : (m(), H(bu, {
                key: 0,
                "image-alt": u.imageAlt,
                "image-src": u.image,
                "is-active": !0,
                "stacking-index": o.value,
                "media-focal-point": u.mediaFocalPoint
              }, null, 8, ["image-alt", "image-src", "stacking-index", "media-focal-point"])),
              u.tag ? (m(), H(gu, {
                key: 1,
                class: "ds-sticky-panel__tag",
                text: u.tag
              }, null, 8, ["text"])) : M("", !0),
              B(Y, {
                class: "ds-sticky-panel__title",
                "html-element": "h2",
                "text-type": "heading-5xl",
                "text-style": "medium"
              }, {
                default: V(() => [
                  K(U(u.title), 1)
                ]),
                _: 1
              }),
              B(Y, {
                class: "ds-sticky-panel__text",
                "text-type": "body-md",
                "text-style": "regular"
              }, {
                default: V(() => [
                  K(U(u.text), 1)
                ]),
                _: 1
              }),
              u.linkText ? (m(), H(Ee, {
                key: 2,
                variant: s.value,
                href: u.linkUrl,
                "icon-end": n.value,
                target: u.linkIsExternal ? "_blank" : void 0
              }, {
                default: V(() => [
                  K(U(u.linkText), 1)
                ]),
                _: 1
              }, 8, ["variant", "href", "icon-end", "target"])) : M("", !0)
            ]),
            (p = u.facts) != null && p.length ? (m(), T("div", S0, [
              (m(!0), T(se, null, ve(u.facts, (h) => (m(), H(h0, {
                key: h.text,
                stat: h.stat,
                "brand-icon-name": h.brandIconName,
                variant: a.value,
                text: h.text
              }, null, 8, ["stat", "brand-icon-name", "variant", "text"]))), 128))
            ])) : M("", !0)
          ])
        ];
      }),
      _: 1
    }, 8, ["class", "style"]));
  }
}), E0 = {
  key: 0,
  class: "ds-sticky-panels__media"
}, A0 = 0.1, T0 = 0.8, _S = /* @__PURE__ */ W({
  __name: "ds-sticky-panels",
  props: {
    panels: { default: () => [] },
    scrollSnap: { default: "mandatory" },
    stickyHeaderOffset: { default: 0 }
  },
  setup(e) {
    const t = e, { isMobile: r } = Fe(), { isMobile: n } = Fe(1200), a = L(null), s = L(null), i = L(null), l = L([]), o = L(0), u = L(!1), f = L(!1), p = L(!1), h = E(
      () => u.value && f.value && p.value
    ), { directions: c } = fs(window), y = ["inverse", "decorative-2-subtle", "decorative-3-muted"], g = E(() => y[o.value % y.length]), b = E(() => !c.bottom && o.value === 0 || !c.top && o.value === l.value.length - 1 ? !1 : h.value), k = E(() => {
      const v = [`ds-sticky-panels--bg-${g.value}`];
      return b.value && !n.value && v.push("ds-sticky-panels--active"), t.scrollSnap && !n.value && v.push(`ds-sticky-panels--scroll-snap-${t.scrollSnap}`), v;
    }), P = (v, w) => {
      if (v) {
        const C = (v == null ? void 0 : v.$el) ?? v;
        l.value[w] = C;
      }
    }, I = () => {
      let v = 0, w = o.value, C = null;
      for (let F = 0; F < l.value.length; F += 1) {
        const x = l.value[F], R = x.getBoundingClientRect(), $ = (Math.min(R.bottom, window.innerHeight) - Math.max(R.top, 0)) / R.height;
        $ >= A0 && $ > v && (v = $, w = F, C = x, o.value = w);
      }
      C && C.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, _ = window.matchMedia("(min-width: 1200px)"), S = (v) => {
      v.matches && I();
    };
    return he(() => {
      s.value && Kt(
        s,
        ([v]) => {
          u.value = !v.isIntersecting;
        },
        { threshold: [0] }
      ), i.value && Kt(
        i,
        ([v]) => {
          f.value = !v.isIntersecting;
        },
        { threshold: [0] }
      ), a.value && Kt(
        a,
        ([v]) => {
          p.value = v.isIntersecting;
        },
        { threshold: [0] }
      ), l.value.forEach((v, w) => {
        Kt(
          v,
          ([C]) => {
            h.value && C.isIntersecting && (o.value = w);
          },
          { threshold: T0 }
        );
      }), _.addEventListener("change", S);
    }), qe(() => {
      _.removeEventListener("change", S);
    }), le(n, async (v) => {
      v === !1 && await at(() => {
        I();
      });
    }), le(b, () => {
      u.value === !1 && f.value === !0 && (o.value = 0), f.value === !1 && u.value === !0 && (o.value = l.value.length - 1);
    }), (v, w) => (m(), T("div", {
      class: G(["ds-sticky-panels", k.value]),
      style: Ce(`--sticky-header-offset: ${v.stickyHeaderOffset}px`),
      ref_key: "containerRef",
      ref: a
    }, [
      D("div", {
        class: "ds-sticky-panels__bg-top",
        ref_key: "bgPanelTopRef",
        ref: s
      }, null, 512),
      B(xn, { class: "ds-sticky-panels__bg" }, {
        default: V(() => [
          (m(), T(se, null, ve(y, (C, F) => D("div", {
            key: `${C}-${F}`,
            class: G(["ds-sticky-panels__bg-layer", { "is-visible": F === o.value }]),
            style: Ce({ backgroundColor: `var(--ds-color-bg-${C})` })
          }, null, 6)), 64)),
          O(r) ? M("", !0) : (m(), T("div", E0, [
            (m(!0), T(se, null, ve(v.panels, (C, F) => (m(), H(bu, {
              isActive: o.value === F,
              key: C.image,
              imageAlt: C.imageAlt,
              imageSrc: C.image,
              "stacking-index": v.panels.length - F,
              mediaFocalPoint: C.mediaFocalPoint
            }, null, 8, ["isActive", "imageAlt", "imageSrc", "stacking-index", "mediaFocalPoint"]))), 128))
          ]))
        ]),
        _: 1
      }),
      (m(!0), T(se, null, ve(v.panels, (C, F) => (m(), H(C0, {
        key: C.title,
        ref_for: !0,
        ref: (x) => P(x, F),
        activeIndex: o.value,
        activeBgColour: g.value,
        "bg-colour": y[F % y.length],
        facts: C.facts,
        inlineMedia: O(r),
        "link-is-external": C.linkIsExternal,
        linkText: C.linkText,
        linkUrl: C.linkUrl,
        mediaFocalPoint: C.mediaFocalPoint,
        tag: C.tag,
        title: C.title,
        text: C.text,
        image: C.image,
        imageAlt: C.imageAlt,
        index: F,
        numberOfPanels: v.panels.length,
        class: G({ "is-above": F < o.value })
      }, null, 8, ["activeIndex", "activeBgColour", "bg-colour", "facts", "inlineMedia", "link-is-external", "linkText", "linkUrl", "mediaFocalPoint", "tag", "title", "text", "image", "imageAlt", "index", "numberOfPanels", "class"]))), 128)),
      D("div", {
        class: "ds-sticky-panels__bg-bottom",
        ref_key: "bgPanelBottomRef",
        ref: i
      }, null, 512)
    ], 6));
  }
}), $S = /* @__PURE__ */ W({
  __name: "ds-table",
  props: {
    caption: {},
    hideCaption: { type: Boolean, default: !1 },
    width: { default: "auto" }
  },
  setup(e) {
    const t = e, r = L(!1), n = L(0), a = E(() => {
      let N = [];
      return N.push(
        t.width === "full" ? "ds-table--full" : "ds-table--auto"
      ), r.value && N.push("ds-table--row-headers"), t.hideCaption && N.push("ds-table--hide-caption"), n.value < 3 ? N.push("ds-table--responsive-simple") : N.push("ds-table--responsive-stacked"), N;
    }), s = L(null);
    let i, l, o, u, f, p, h, c, y, g, b, k, P, I, _ = [];
    Ke(() => {
      var j;
      const N = (j = s.value) == null ? void 0 : j.querySelector(".ds-table__caption");
      N && (N.innerHTML = t.caption ?? "");
    });
    const v = ["class", "style", ...[
      "align",
      "bgcolor",
      "border",
      "cellpadding",
      "cellspacing",
      "frame",
      "rules",
      "summary",
      "width"
    ]];
    he(() => {
      if (s.value !== null)
        try {
          w(), u && (F(), A(), z(), C(), s.value.replaceChild(
            o,
            l
          ), n.value = s.value.querySelectorAll("thead > tr > th").length);
        } catch {
          console.error(
            "Failed to process table, you're seeing an unmodified table"
          );
        }
    });
    const w = () => {
      i = document.createDocumentFragment(), s.value !== null && (l = s.value.querySelector("table"), o = l ? l.cloneNode(!0) : null, o && (i.appendChild(o), u = i.querySelector("table"), f = i.querySelector("thead"), c = i.querySelector("tbody"), b = i.querySelectorAll("tr"), k = i.querySelectorAll("th"), P = i.querySelectorAll("td"), g = i.querySelectorAll("colgroup"), y = i.querySelectorAll("col"), p = i.querySelector("tfoot"), h = i.querySelector("caption"), I = i.querySelectorAll("p"), _ = [
        u,
        f,
        c,
        p,
        h,
        ...b,
        ...k,
        ...P,
        ...g,
        ...y,
        ...I
      ]));
    }, C = () => {
      u == null || u.classList.add("ds-table__table"), f == null || f.querySelectorAll("th").forEach((j) => {
        j.classList.add("ds-text-heading-xl", "ds-text--medium");
      });
      const N = c == null ? void 0 : c.querySelectorAll("th");
      N == null || N.forEach((j) => {
        j.classList.add("ds-text-body-md", "ds-text--medium");
      }), P == null || P.forEach((j) => {
        j.classList.add("ds-text-body-md", "ds-text--regular");
      }), h && h.classList.add("ds-table__caption", "ds-text-heading-xl"), N != null && N.length && (r.value = !0);
    }, F = () => {
      _.filter((N) => N !== null).forEach((N) => {
        if (N.hasAttribute("style")) {
          const j = N.getAttribute("style") || "", Q = new Map(
            j.split(";").map(
              (re) => re.trim().split(":")
            )
          ), q = [
            "vertical-align",
            "text-align",
            "font-weight",
            "font-style"
          ], Z = Array.from(Q).filter(([re]) => q.includes(re.trim())).map(([re, ne]) => `${re}: ${ne}`).join("; ");
          N.removeAttribute("style"), Z && N.setAttribute("style", Z);
        }
        v.forEach((j) => {
          j !== "style" && N.removeAttribute(j);
        });
      });
    }, x = (N) => {
      const j = N.parentNode, Q = document.createElement("th");
      Q.innerHTML = N.innerHTML, j == null || j.replaceChild(Q, N);
    }, R = () => {
      const N = u == null ? void 0 : u.querySelector(
        "tr:first-child:has(td strong), tr:first-child:has(td b)"
      );
      N && (N == null ? void 0 : N.querySelectorAll("td")).forEach((q) => {
        x(q);
      });
      const j = u == null ? void 0 : u.querySelectorAll(
        "td:first-child:has(strong, b)"
      );
      j && j.forEach((Q) => {
        x(Q);
      });
    }, d = () => {
      !h && t.caption && (h = u == null ? void 0 : u.createCaption()), h && t.caption && (h.innerHTML = t.caption);
    }, $ = () => {
      if (!f) {
        const N = u == null ? void 0 : u.querySelector(
          "tr:first-child:has(th)"
        );
        if (N) {
          const j = N.parentNode, Q = j == null ? void 0 : j.removeChild(N);
          f = u == null ? void 0 : u.createTHead(), f && Q && f.appendChild(Q), k = u == null ? void 0 : u.querySelectorAll("th");
        }
      }
    }, A = () => {
      R(), $(), d();
    }, z = () => {
      const N = f == null ? void 0 : f.querySelectorAll("th");
      N == null || N.forEach((Q) => Q.scope = "col");
      const j = c == null ? void 0 : c.querySelectorAll("th");
      if (j == null || j.forEach((Q) => Q.scope = "row"), N) {
        const Q = [...N].map((Z) => Z.textContent ?? ""), q = c == null ? void 0 : c.querySelectorAll("tr");
        q && Q && [...q].map((Z) => {
          [...Z.childNodes].map((re, ne) => {
            re.setAttribute("data-col-header", Q[ne]);
          });
        });
      }
    };
    return (N, j) => (m(), T("div", {
      class: G(["ds-table", a.value]),
      ref_key: "table",
      ref: s
    }, [
      ie(N.$slots, "default")
    ], 2));
  }
}), L0 = ["aria-labelledby", "id"], M0 = /* @__PURE__ */ W({
  __name: "ds-tab",
  props: {
    name: {},
    id: {}
  },
  setup(e) {
    const t = e, r = ee("activeTab"), n = E(() => t.id === (r == null ? void 0 : r.value));
    return (a, s) => we((m(), T("div", {
      "aria-labelledby": `${a.id}-button`,
      role: "tabpanel",
      id: a.id,
      class: "ds-tab-panel"
    }, [
      ie(a.$slots, "default")
    ], 8, L0)), [
      [Se, n.value]
    ]);
  }
}), Jn = (e) => {
  const t = document.getElementById(e);
  t == null || t.focus();
}, O0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.nextId}`;
  Jn(t);
}, N0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.prevId}`;
  Jn(t);
}, F0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.lastId}`;
  Jn(t);
}, D0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.firstId}`;
  Jn(t);
}, R0 = {
  ArrowUp: N0,
  ArrowDown: O0,
  Home: D0,
  End: F0
}, Yi = (e) => {
  const t = R0[e.key];
  if (t) {
    const r = document.activeElement;
    t(r), e.stopPropagation(), e.preventDefault();
  }
}, x0 = /* @__PURE__ */ W({
  __name: "ds-tabs-menu",
  props: {
    accessibleButtonLabel: {},
    hiddenItems: {},
    setActive: {}
  },
  setup(e) {
    const t = L(null);
    zn(t, () => l.value = !1);
    const r = e, n = St("tab-menu"), a = () => {
      l.value = !l.value;
    }, s = (u) => {
      typeof u < "u" && (l.value = !1, r.setActive(u));
    }, i = E(
      () => l.value ? "ds-tabs-menu--active" : null
    ), l = L(!1), o = E(() => {
      const u = [];
      return r.hiddenItems && r.hiddenItems.forEach((f) => {
        var h;
        const p = {
          id: `${f == null ? void 0 : f.id}-hidden`,
          panelId: (h = f == null ? void 0 : f.dataset) == null ? void 0 : h.id,
          text: f == null ? void 0 : f.dataset.label
        };
        u.push(p);
      }), u;
    });
    return (u, f) => {
      var p;
      return m(), T("div", {
        class: G(["ds-tabs-menu", i.value]),
        ref_key: "menu",
        ref: t
      }, [
        B(Ie, {
          "aria-haspopup": "",
          "aria-expanded": l.value,
          "aria-controls": O(n),
          ariaLabel: u.accessibleButtonLabel,
          clickHandler: a,
          "data-next-id": (p = o.value[0]) == null ? void 0 : p.id,
          onKeydown: O(Yi),
          size: "sm",
          variant: "ghost-neutral",
          iconName: "button-more",
          type: "button"
        }, null, 8, ["aria-expanded", "aria-controls", "ariaLabel", "data-next-id", "onKeydown"]),
        B(hu, {
          class: "ds-tabs-menu__content",
          id: O(n),
          elevation: "overlay",
          padding: "popover",
          role: "menu"
        }, {
          default: V(() => [
            (m(!0), T(se, null, ve(o.value, (h, c) => {
              var y, g, b, k, P, I;
              return m(), H(Ee, {
                key: h.id,
                id: `${h.id}`,
                onClick: (_) => s(h == null ? void 0 : h.panelId),
                onKeydown: O(Yi),
                "data-next-id": (y = o.value[(c + 1) % o.value.length]) == null ? void 0 : y.id,
                "data-prev-id": (k = o.value[(c + ((g = o.value) == null ? void 0 : g.length) - 1) % ((b = o.value) == null ? void 0 : b.length)]) == null ? void 0 : k.id,
                "data-last-id": (P = o.value[o.value.length - 1]) == null ? void 0 : P.id,
                "data-first-id": (I = o.value[0]) == null ? void 0 : I.id,
                "data-index": c,
                role: "menuitem",
                variant: "link-neutral"
              }, {
                default: V(() => [
                  K(U(h.text), 1)
                ]),
                _: 2
              }, 1032, ["id", "onClick", "onKeydown", "data-next-id", "data-prev-id", "data-last-id", "data-first-id", "data-index"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["id"])
      ], 2);
    };
  }
}), ea = (e) => {
  const t = document.getElementById(e);
  t == null || t.focus();
}, H0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.nextId}-button`;
  ea(t);
}, z0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.prevId}-button`;
  ea(t);
}, V0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.lastId}-button`;
  ea(t);
}, B0 = (e) => {
  var r;
  const t = `${(r = e == null ? void 0 : e.dataset) == null ? void 0 : r.firstId}-button`;
  ea(t);
}, j0 = {
  ArrowLeft: z0,
  ArrowRight: H0,
  Home: B0,
  End: V0
}, Gi = (e) => {
  const t = j0[e.key];
  if (t) {
    const r = document.activeElement;
    t(r), e.stopPropagation(), e.preventDefault();
  }
};
function q0(e, t, r) {
  let n = null;
  he(() => {
    n = new IntersectionObserver(
      (a) => {
        a.forEach((s) => {
          s.intersectionRatio < 1 ? r(s.target.id, !1) : r(s.target.id, !0);
        });
      },
      {
        root: t.value,
        threshold: [0, 1]
      }
    ), e.value.forEach((a) => {
      n == null || n.observe(a);
    });
  }), qe(() => {
    n == null || n.disconnect();
  });
}
function W0(e, t, r) {
  const n = (o, u = !0) => {
    const f = s(e, o);
    u ? (l(t, f), i(r, o)) : (l(r, f), i(t, o)), r.value.sort(a), t.value.sort(a);
  }, a = (o, u) => Number(o.dataset.index) - Number(u.dataset.index), s = (o, u) => o.value.find((f) => (f == null ? void 0 : f.id) === u), i = (o, u) => {
    const f = o.value.findIndex((p) => (p == null ? void 0 : p.id) === u);
    f > -1 && o.value.splice(f, 1);
  }, l = (o, u) => {
    u && !o.value.includes(u) && o.value.push(u);
  };
  return {
    moveItemById: n
  };
}
const U0 = {
  key: 0,
  class: "ds-tabs__nav-wrapper"
}, K0 = ["data-next-id", "data-prev-id", "data-last-id", "data-first-id", "data-index", "data-label", "data-id", "id", "aria-controls", "aria-selected", "tabIndex", "onClick"], Y0 = {
  key: 1,
  class: "ds-tabs__panels"
}, G0 = {
  key: 2,
  class: "ds-tabs__panels"
}, Q0 = ["innerHTML"], kS = /* @__PURE__ */ W({
  __name: "ds-tabs",
  props: {
    overflowMenuButtonLabel: {},
    tabs: {}
  },
  setup(e) {
    const t = e, r = Ou(), n = (R) => typeof R.type == "symbol" && Array.isArray(R.children), a = (R) => {
      var d, $;
      return typeof R.type == "object" && "props" in R && !!((d = R.props) != null && d.id) && !!(($ = R.props) != null && $.name);
    }, s = (R) => R.flatMap((d) => i(d)), i = (R) => R != null && R.type ? n(R) ? s(R.children) : a(R) ? [
      {
        id: R.props.id,
        name: R.props.name,
        content: R
        // Preserve the full VNode
      }
    ] : [] : [], l = E(() => {
      if (!r.default) return [];
      const R = r.default();
      return s(R);
    }), o = E(() => t.tabs && t.tabs.length > 0 ? t.tabs : l.value), u = () => {
      if (!S.value) return;
      const R = document.getElementById(`${g.value}-button`);
      R && R.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }, f = (R) => {
      R instanceof HTMLElement && !p.value.includes(R) && p.value.push(R), R instanceof HTMLElement && R.id === `${g.value}-button` && (k.value = R);
    }, p = L([]), h = L([]), c = L([]), y = E(() => o.value.map((R) => ({
      id: R.id,
      name: R.name
    }))), g = L(""), b = L(null), k = L(null), P = Gs(b, { threshold: 0 }), I = Gs(k, {
      scrollTarget: b,
      threshold: 1
    }), { moveItemById: _ } = W0(p, h, c);
    q0(p, b, _);
    const S = E(() => c.value.length > 0), v = E(
      () => S.value ? "ds-tabs--overflow" : null
    ), w = (R, d, $) => {
      const A = [];
      return R === d && A.push("ds-tab--active"), $.find((z) => z.id === `${R}-button`) && A.push("ds-tab--hidden"), A;
    }, C = (R) => {
      g.value = R, _(g.value, !0), u();
    };
    _e("activeTab", g);
    const F = E(() => o.value.length > 0), x = E(() => o.value.length > 1);
    return Ke(() => {
      !g.value && y.value.length > 0 && (g.value = y.value[0].id);
    }), le([S, P, I], () => {
      S.value && P.value && !I.value && k.value && at(() => {
        k.value.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      });
    }), (R, d) => F.value ? (m(), T("div", {
      key: 0,
      class: G(["ds-tabs", v.value])
    }, [
      x.value ? (m(), T("div", U0, [
        D("div", {
          class: "ds-tabs__nav",
          role: "tablist",
          ref_key: "tablist",
          ref: b
        }, [
          (m(!0), T(se, null, ve(y.value, ({ name: $, id: A }, z) => (m(), T("button", {
            "data-next-id": y.value[(z + 1) % y.value.length].id,
            "data-prev-id": y.value[(z + y.value.length - 1) % y.value.length].id,
            "data-last-id": y.value[y.value.length - 1].id,
            "data-first-id": y.value[0].id,
            "data-index": z,
            "data-label": $,
            "data-id": A,
            id: `${A}-button`,
            class: G(["ds-tab", w(A, g.value, c.value)]),
            "aria-controls": A,
            "aria-selected": A === g.value,
            tabIndex: A !== g.value ? "-1" : void 0,
            key: `${A}-button`,
            ref_for: !0,
            ref: (N) => {
              f(N), A === g.value && N && k.value && "value" in k.value && (k.value.value = N);
            },
            role: "tab",
            onClick: (N) => C(A),
            onKeydown: d[0] || (d[0] = //@ts-ignore
            (...N) => O(Gi) && O(Gi)(...N))
          }, [
            B(Y, {
              class: "ds-tab__text",
              "html-element": "span",
              "text-style": "medium",
              "text-type": "label-md"
            }, {
              default: V(() => [
                K(U($), 1)
              ]),
              _: 2
            }, 1024)
          ], 42, K0))), 128))
        ], 512),
        S.value ? (m(), H(x0, {
          key: 0,
          "accessible-button-label": R.overflowMenuButtonLabel,
          hiddenItems: c.value,
          setActive: C
        }, null, 8, ["accessible-button-label", "hiddenItems"])) : M("", !0)
      ])) : M("", !0),
      l.value && l.value.length ? (m(), T("div", Y0, [
        ie(R.$slots, "default")
      ])) : (m(), T("div", G0, [
        (m(!0), T(se, null, ve(R.tabs, ($) => (m(), H(M0, {
          key: $.id,
          id: $.id,
          name: $.name
        }, {
          default: V(() => [
            D("div", {
              innerHTML: $.content
            }, null, 8, Q0)
          ]),
          _: 2
        }, 1032, ["id", "name"]))), 128))
      ]))
    ], 2)) : M("", !0);
  }
}), Z0 = ["innerHTML"], X0 = /* @__PURE__ */ W({
  __name: "ds-glyph",
  props: {
    glyph: {},
    size: { default: "inherit" }
  },
  setup(e) {
    const t = e, r = {
      "left-double-quote": "&ldquo;",
      underscore: "&lowbar;"
    }, n = E(() => {
      const s = r[t.glyph];
      return s || (console.error(`Glyph "${t.glyph}" not found in glyphMap.`), "");
    }), a = E(() => {
      const s = [`ds-glyph--${t.glyph}`];
      return t.size !== "inherit" && s.push(`ds-glyph--${t.size}`), s;
    });
    return (s, i) => (m(), T("span", {
      class: G(["ds-glyph", a.value]),
      innerHTML: n.value
    }, null, 10, Z0));
  }
}), J0 = { class: "ds-testimonial__image-wrapper" }, e1 = ["src", "alt"], t1 = { class: "ds-testimonial__content" }, r1 = { class: "ds-testimonial__quote-wrapper" }, n1 = { class: "ds-testimonial__quote" }, wS = /* @__PURE__ */ W({
  __name: "ds-testimonial",
  props: {
    imageAltText: {},
    imageUrl: {},
    order: { default: "default" },
    testimonialText: {},
    testimonialName: {},
    testimonialRole: {},
    testimonialProduct: {}
  },
  setup(e) {
    const t = e, r = E(() => {
      let a = [];
      return t.testimonialRole && a.push(t.testimonialRole), t.testimonialProduct && a.push(t.testimonialProduct), a.join(" | ");
    }), n = E(() => {
      const a = [];
      return t.order !== "default" && a.push(`ds-testimonial--order-${t.order}`), a;
    });
    return (a, s) => (m(), H(Jd, {
      "columns-md": 2,
      class: G(["ds-testimonial", n.value])
    }, {
      default: V(() => [
        D("div", J0, [
          D("img", {
            class: "ds-testimonial__image",
            src: a.imageUrl,
            alt: a.imageAltText
          }, null, 8, e1)
        ]),
        D("figure", t1, [
          D("div", r1, [
            D("blockquote", n1, [
              B(Y, {
                "html-element": "q",
                "text-type": "heading-4xl",
                class: "ds-testimonial__text"
              }, {
                default: V(() => [
                  K(U(a.testimonialText), 1)
                ]),
                _: 1
              })
            ])
          ]),
          D("figcaption", null, [
            a.testimonialName ? (m(), H(Y, {
              key: 0,
              "html-element": "p",
              "text-type": "body-md",
              "text-style": "medium",
              class: "ds-testimonial__name"
            }, {
              default: V(() => [
                K(U(a.testimonialName), 1),
                B(X0, { glyph: "underscore" })
              ]),
              _: 1
            })) : M("", !0),
            r.value ? (m(), H(Y, {
              key: 1,
              "html-element": "p",
              "text-type": "body-md",
              "text-style": "regular",
              class: "ds-testimonial__role"
            }, {
              default: V(() => [
                K(U(r.value), 1)
              ]),
              _: 1
            })) : M("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), a1 = {
  key: 0,
  role: "alert",
  class: "ds-toast__inner"
}, s1 = { class: "ds-toast__content" }, i1 = {
  key: 3,
  class: "ds-toast__countdown-track"
}, SS = /* @__PURE__ */ W({
  __name: "ds-toast",
  props: {
    actionText: {},
    actionFn: {},
    closeButtonAriaLabel: { default: "Close" },
    closeOnActionClick: { type: Boolean, default: !0 },
    description: {},
    showIcon: { type: Boolean, default: !0 },
    showCountdown: { type: Boolean, default: !1 },
    timeout: { default: 0 },
    variant: { default: "default" }
  },
  setup(e) {
    const t = e, r = (c) => {
      t.actionFn && (t.actionFn(c), t.closeOnActionClick && p());
    }, n = L(!1), a = L(t.timeout), s = L(!1), i = L(null), l = L(!1), o = E(() => {
      const c = ["ds-toast"];
      return c.push(`ds-toast--${t.variant}`), s.value === !1 && n.value === !1 && c.push("ds-toast--initial"), t.showCountdown && c.push("ds-toast--countdown"), l.value ? c.push("ds-toast--multiline") : c.push("ds-toast--singleline"), c;
    });
    let u = 0, f = 0;
    const p = () => {
      n.value = !1, u = window.setTimeout(() => {
        h();
      }, 500);
    }, h = () => {
      s.value = !0;
    };
    return he(() => {
      n.value = !0;
      const c = Number(a.value) + 1100;
      a.value > 0 && (f = window.setTimeout(() => {
        p();
      }, c));
    }), qe(() => {
      window.clearTimeout(u), window.clearTimeout(f);
    }), le(n, async () => {
      if (l.value === !0) return;
      await at();
      const c = i.value;
      c && c.scrollHeight > c.offsetHeight && (l.value = !0);
    }), (c, y) => s.value ? M("", !0) : (m(), T("div", {
      key: 0,
      class: G(o.value),
      "data-testid": "toast"
    }, [
      B(ft, {
        class: "ds-toast__transition",
        name: "toast",
        "enter-from-class": "toast-enter-from",
        "enter-to-class": "toast-enter-to",
        "leave-from-class": "toast-leave-from",
        "leave-to-class": "toast-leave-to"
      }, {
        default: V(() => [
          n.value ? (m(), T("div", a1, [
            c.showIcon ? (m(), H(ae, {
              key: 0,
              class: "ds-toast__icon",
              iconName: "information-circle",
              size: "md"
            })) : M("", !0),
            D("div", s1, [
              c.description ? (m(), H(Y, {
                key: 0,
                "html-element": "div",
                "text-type": "body-lg",
                "text-style": "regular",
                class: "ds-toast__description"
              }, {
                default: V(() => [
                  D("div", {
                    ref_key: "textElem",
                    ref: i
                  }, U(c.description), 513)
                ]),
                _: 1
              })) : M("", !0)
            ]),
            c.actionText ? (m(), H(Ee, {
              key: 1,
              clickHandler: r,
              size: "sm",
              variant: "functional"
            }, {
              default: V(() => [
                K(U(c.actionText), 1)
              ]),
              _: 1
            })) : M("", !0),
            M("", !0),
            c.showCountdown ? (m(), T("div", i1, [
              D("div", {
                class: "ds-toast__countdown-bar",
                style: Ce({ animationDuration: `${a.value / 1e3}s` })
              }, null, 4)
            ])) : M("", !0)
          ])) : M("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), l1 = ["data-show"], o1 = ["aria-label"], u1 = ["role"], c1 = ["innerHTML"], f1 = ["href", "target"], PS = /* @__PURE__ */ W({
  __name: "ds-toggletip",
  props: {
    accessibleButtonLabel: {},
    iconName: { default: "information-circle" },
    iconSize: { default: "md" },
    linkTarget: {},
    linkText: {},
    linkUrl: {},
    placement: { default: "auto" },
    strategy: { default: "absolute" },
    text: {},
    title: {},
    titleElement: { default: "h3" }
  },
  setup(e) {
    const t = e, r = L(null), n = L(null), a = L(null);
    zn(r, () => {
      i.value = !1;
    });
    const { toggle: s, isOpen: i } = gl({
      targetNode: n,
      tooltipNode: a,
      placement: t.placement,
      strategy: t.strategy
    }), l = E(() => i.value ? "status" : void 0);
    return (o, u) => (m(), T("div", {
      class: "ds-tooltip",
      "data-show": O(i),
      ref_key: "container",
      ref: r
    }, [
      o.iconName ? (m(), T("button", {
        key: 0,
        ref_key: "target",
        ref: n,
        class: "ds-tooltip__target",
        "aria-label": o.accessibleButtonLabel,
        onClick: u[0] || (u[0] = //@ts-ignore
        (...f) => O(s) && O(s)(...f))
      }, [
        B(ae, {
          "icon-name": o.iconName,
          size: o.iconSize
        }, null, 8, ["icon-name", "size"])
      ], 8, o1)) : M("", !0),
      D("div", {
        ref_key: "tooltip",
        ref: a,
        class: "ds-tooltip__tooltip"
      }, [
        D("div", {
          class: "ds-tooltip__content",
          role: l.value
        }, [
          o.title ? (m(), H(Er(o.titleElement), {
            key: 0,
            class: "ds-tooltip__title"
          }, {
            default: V(() => [
              K(U(o.title), 1)
            ]),
            _: 1
          })) : M("", !0),
          B(Y, {
            "text-type": "label-sm",
            "html-element": "div"
          }, {
            default: V(() => [
              D("div", { innerHTML: o.text }, null, 8, c1)
            ]),
            _: 1
          }),
          o.linkText && o.linkUrl ? (m(), T("a", {
            key: 1,
            class: "ds-tooltip__link",
            href: o.linkUrl,
            target: o.linkTarget
          }, U(o.linkText), 9, f1)) : M("", !0)
        ], 8, u1),
        u[1] || (u[1] = D("div", {
          class: "ds-tooltip__arrow",
          "data-popper-arrow": ""
        }, null, -1))
      ], 512)
    ], 8, l1));
  }
});
/*! @vimeo/player v2.25.0 | (c) 2024 Vimeo | MIT License | https://github.com/vimeo/player.js */
function Qi(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qi(Object(r), !0).forEach(function(n) {
      cn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qi(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Me() {
  Me = function() {
    return e;
  };
  var e = {}, t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(d, $, A) {
    d[$] = A.value;
  }, a = typeof Symbol == "function" ? Symbol : {}, s = a.iterator || "@@iterator", i = a.asyncIterator || "@@asyncIterator", l = a.toStringTag || "@@toStringTag";
  function o(d, $, A) {
    return Object.defineProperty(d, $, {
      value: A,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), d[$];
  }
  try {
    o({}, "");
  } catch {
    o = function($, A, z) {
      return $[A] = z;
    };
  }
  function u(d, $, A, z) {
    var N = $ && $.prototype instanceof h ? $ : h, j = Object.create(N.prototype), Q = new F(z || []);
    return n(j, "_invoke", {
      value: S(d, A, Q)
    }), j;
  }
  function f(d, $, A) {
    try {
      return {
        type: "normal",
        arg: d.call($, A)
      };
    } catch (z) {
      return {
        type: "throw",
        arg: z
      };
    }
  }
  e.wrap = u;
  var p = {};
  function h() {
  }
  function c() {
  }
  function y() {
  }
  var g = {};
  o(g, s, function() {
    return this;
  });
  var b = Object.getPrototypeOf, k = b && b(b(x([])));
  k && k !== t && r.call(k, s) && (g = k);
  var P = y.prototype = h.prototype = Object.create(g);
  function I(d) {
    ["next", "throw", "return"].forEach(function($) {
      o(d, $, function(A) {
        return this._invoke($, A);
      });
    });
  }
  function _(d, $) {
    function A(N, j, Q, q) {
      var Z = f(d[N], d, j);
      if (Z.type !== "throw") {
        var re = Z.arg, ne = re.value;
        return ne && typeof ne == "object" && r.call(ne, "__await") ? $.resolve(ne.__await).then(function(ye) {
          A("next", ye, Q, q);
        }, function(ye) {
          A("throw", ye, Q, q);
        }) : $.resolve(ne).then(function(ye) {
          re.value = ye, Q(re);
        }, function(ye) {
          return A("throw", ye, Q, q);
        });
      }
      q(Z.arg);
    }
    var z;
    n(this, "_invoke", {
      value: function(N, j) {
        function Q() {
          return new $(function(q, Z) {
            A(N, j, q, Z);
          });
        }
        return z = z ? z.then(Q, Q) : Q();
      }
    });
  }
  function S(d, $, A) {
    var z = "suspendedStart";
    return function(N, j) {
      if (z === "executing") throw new Error("Generator is already running");
      if (z === "completed") {
        if (N === "throw") throw j;
        return R();
      }
      for (A.method = N, A.arg = j; ; ) {
        var Q = A.delegate;
        if (Q) {
          var q = v(Q, A);
          if (q) {
            if (q === p) continue;
            return q;
          }
        }
        if (A.method === "next") A.sent = A._sent = A.arg;
        else if (A.method === "throw") {
          if (z === "suspendedStart") throw z = "completed", A.arg;
          A.dispatchException(A.arg);
        } else A.method === "return" && A.abrupt("return", A.arg);
        z = "executing";
        var Z = f(d, $, A);
        if (Z.type === "normal") {
          if (z = A.done ? "completed" : "suspendedYield", Z.arg === p) continue;
          return {
            value: Z.arg,
            done: A.done
          };
        }
        Z.type === "throw" && (z = "completed", A.method = "throw", A.arg = Z.arg);
      }
    };
  }
  function v(d, $) {
    var A = $.method, z = d.iterator[A];
    if (z === void 0) return $.delegate = null, A === "throw" && d.iterator.return && ($.method = "return", $.arg = void 0, v(d, $), $.method === "throw") || A !== "return" && ($.method = "throw", $.arg = new TypeError("The iterator does not provide a '" + A + "' method")), p;
    var N = f(z, d.iterator, $.arg);
    if (N.type === "throw") return $.method = "throw", $.arg = N.arg, $.delegate = null, p;
    var j = N.arg;
    return j ? j.done ? ($[d.resultName] = j.value, $.next = d.nextLoc, $.method !== "return" && ($.method = "next", $.arg = void 0), $.delegate = null, p) : j : ($.method = "throw", $.arg = new TypeError("iterator result is not an object"), $.delegate = null, p);
  }
  function w(d) {
    var $ = {
      tryLoc: d[0]
    };
    1 in d && ($.catchLoc = d[1]), 2 in d && ($.finallyLoc = d[2], $.afterLoc = d[3]), this.tryEntries.push($);
  }
  function C(d) {
    var $ = d.completion || {};
    $.type = "normal", delete $.arg, d.completion = $;
  }
  function F(d) {
    this.tryEntries = [{
      tryLoc: "root"
    }], d.forEach(w, this), this.reset(!0);
  }
  function x(d) {
    if (d) {
      var $ = d[s];
      if ($) return $.call(d);
      if (typeof d.next == "function") return d;
      if (!isNaN(d.length)) {
        var A = -1, z = function N() {
          for (; ++A < d.length; ) if (r.call(d, A)) return N.value = d[A], N.done = !1, N;
          return N.value = void 0, N.done = !0, N;
        };
        return z.next = z;
      }
    }
    return {
      next: R
    };
  }
  function R() {
    return {
      value: void 0,
      done: !0
    };
  }
  return c.prototype = y, n(P, "constructor", {
    value: y,
    configurable: !0
  }), n(y, "constructor", {
    value: c,
    configurable: !0
  }), c.displayName = o(y, l, "GeneratorFunction"), e.isGeneratorFunction = function(d) {
    var $ = typeof d == "function" && d.constructor;
    return !!$ && ($ === c || ($.displayName || $.name) === "GeneratorFunction");
  }, e.mark = function(d) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(d, y) : (d.__proto__ = y, o(d, l, "GeneratorFunction")), d.prototype = Object.create(P), d;
  }, e.awrap = function(d) {
    return {
      __await: d
    };
  }, I(_.prototype), o(_.prototype, i, function() {
    return this;
  }), e.AsyncIterator = _, e.async = function(d, $, A, z, N) {
    N === void 0 && (N = Promise);
    var j = new _(u(d, $, A, z), N);
    return e.isGeneratorFunction($) ? j : j.next().then(function(Q) {
      return Q.done ? Q.value : j.next();
    });
  }, I(P), o(P, l, "Generator"), o(P, s, function() {
    return this;
  }), o(P, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(d) {
    var $ = Object(d), A = [];
    for (var z in $) A.push(z);
    return A.reverse(), function N() {
      for (; A.length; ) {
        var j = A.pop();
        if (j in $) return N.value = j, N.done = !1, N;
      }
      return N.done = !0, N;
    };
  }, e.values = x, F.prototype = {
    constructor: F,
    reset: function(d) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(C), !d) for (var $ in this) $.charAt(0) === "t" && r.call(this, $) && !isNaN(+$.slice(1)) && (this[$] = void 0);
    },
    stop: function() {
      this.done = !0;
      var d = this.tryEntries[0].completion;
      if (d.type === "throw") throw d.arg;
      return this.rval;
    },
    dispatchException: function(d) {
      if (this.done) throw d;
      var $ = this;
      function A(Z, re) {
        return j.type = "throw", j.arg = d, $.next = Z, re && ($.method = "next", $.arg = void 0), !!re;
      }
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var N = this.tryEntries[z], j = N.completion;
        if (N.tryLoc === "root") return A("end");
        if (N.tryLoc <= this.prev) {
          var Q = r.call(N, "catchLoc"), q = r.call(N, "finallyLoc");
          if (Q && q) {
            if (this.prev < N.catchLoc) return A(N.catchLoc, !0);
            if (this.prev < N.finallyLoc) return A(N.finallyLoc);
          } else if (Q) {
            if (this.prev < N.catchLoc) return A(N.catchLoc, !0);
          } else {
            if (!q) throw new Error("try statement without catch or finally");
            if (this.prev < N.finallyLoc) return A(N.finallyLoc);
          }
        }
      }
    },
    abrupt: function(d, $) {
      for (var A = this.tryEntries.length - 1; A >= 0; --A) {
        var z = this.tryEntries[A];
        if (z.tryLoc <= this.prev && r.call(z, "finallyLoc") && this.prev < z.finallyLoc) {
          var N = z;
          break;
        }
      }
      N && (d === "break" || d === "continue") && N.tryLoc <= $ && $ <= N.finallyLoc && (N = null);
      var j = N ? N.completion : {};
      return j.type = d, j.arg = $, N ? (this.method = "next", this.next = N.finallyLoc, p) : this.complete(j);
    },
    complete: function(d, $) {
      if (d.type === "throw") throw d.arg;
      return d.type === "break" || d.type === "continue" ? this.next = d.arg : d.type === "return" ? (this.rval = this.arg = d.arg, this.method = "return", this.next = "end") : d.type === "normal" && $ && (this.next = $), p;
    },
    finish: function(d) {
      for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
        var A = this.tryEntries[$];
        if (A.finallyLoc === d) return this.complete(A.completion, A.afterLoc), C(A), p;
      }
    },
    catch: function(d) {
      for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
        var A = this.tryEntries[$];
        if (A.tryLoc === d) {
          var z = A.completion;
          if (z.type === "throw") {
            var N = z.arg;
            C(A);
          }
          return N;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(d, $, A) {
      return this.delegate = {
        iterator: x(d),
        resultName: $,
        nextLoc: A
      }, this.method === "next" && (this.arg = void 0), p;
    }
  }, e;
}
function Xi(e, t, r, n, a, s, i) {
  try {
    var l = e[s](i), o = l.value;
  } catch (u) {
    r(u);
    return;
  }
  l.done ? t(o) : Promise.resolve(o).then(n, a);
}
function Ot(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, a) {
      var s = e.apply(t, r);
      function i(o) {
        Xi(s, n, a, i, l, "next", o);
      }
      function l(o) {
        Xi(s, n, a, i, l, "throw", o);
      }
      i(void 0);
    });
  };
}
function _u(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function d1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wu(n.key), n);
  }
}
function $u(e, t, r) {
  return t && d1(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function cn(e, t, r) {
  return t = wu(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function p1(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Hr(e, t);
}
function xr(e) {
  return xr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, xr(e);
}
function Hr(e, t) {
  return Hr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Hr(e, t);
}
function ku() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function fn(e, t, r) {
  return ku() ? fn = Reflect.construct.bind() : fn = function(a, s, i) {
    var l = [null];
    l.push.apply(l, s);
    var o = Function.bind.apply(a, l), u = new o();
    return i && Hr(u, i.prototype), u;
  }, fn.apply(null, arguments);
}
function m1(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Qa(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Qa = function(n) {
    if (n === null || !m1(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n)) return t.get(n);
      t.set(n, a);
    }
    function a() {
      return fn(n, arguments, xr(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Hr(a, n);
  }, Qa(e);
}
function dn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function v1(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dn(e);
}
function y1(e) {
  var t = ku();
  return function() {
    var n = xr(e), a;
    if (t) {
      var s = xr(this).constructor;
      a = Reflect.construct(n, arguments, s);
    } else
      a = n.apply(this, arguments);
    return v1(this, a);
  };
}
function h1(e, t) {
  if (typeof e != "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function wu(e) {
  var t = h1(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Su = typeof global < "u" && {}.toString.call(global) === "[object global]";
function Ji(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function g1(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function b1(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function zt(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function Pu(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function _1(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), r = (t && t[1] || "").replace("player.", ""), n = [".videoji.hk", ".vimeo.work", ".videoji.cn"], a = 0, s = n; a < s.length; a++) {
    var i = s[a];
    if (r.endsWith(i))
      return r;
  }
  return "vimeo.com";
}
function Iu() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, r = e.url, n = t || r;
  if (!n)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (b1(n))
    return "https://vimeo.com/".concat(n);
  if (zt(n))
    return n.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(n, "” is not a vimeo.com url."));
}
var el = function(t, r, n) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", i = typeof r == "string" ? [r] : r;
  return i.forEach(function(l) {
    t[a](l, n);
  }), {
    cancel: function() {
      return i.forEach(function(o) {
        return t[s](o, n);
      });
    }
  };
}, $1 = typeof Array.prototype.indexOf < "u", k1 = typeof window < "u" && typeof window.postMessage < "u";
if (!Su && (!$1 || !k1))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var tr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function w1(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, r = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch {
    }
  }(), n = function(s, i, l) {
    r ? Object.defineProperty(s, i, {
      configurable: !0,
      writable: !0,
      value: l
    }) : s[i] = l;
  };
  e.WeakMap = function() {
    function s() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (n(this, "_id", l("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    n(s.prototype, "delete", function(u) {
      if (i(this, "delete"), !a(u))
        return !1;
      var f = u[this._id];
      return f && f[0] === u ? (delete u[this._id], !0) : !1;
    }), n(s.prototype, "get", function(u) {
      if (i(this, "get"), !!a(u)) {
        var f = u[this._id];
        if (f && f[0] === u)
          return f[1];
      }
    }), n(s.prototype, "has", function(u) {
      if (i(this, "has"), !a(u))
        return !1;
      var f = u[this._id];
      return !!(f && f[0] === u);
    }), n(s.prototype, "set", function(u, f) {
      if (i(this, "set"), !a(u))
        throw new TypeError("Invalid value used as weak map key");
      var p = u[this._id];
      return p && p[0] === u ? (p[1] = f, this) : (n(u, this._id, [u, f]), this);
    });
    function i(u, f) {
      if (!a(u) || !t.call(u, "_id"))
        throw new TypeError(f + " method called on incompatible receiver " + typeof u);
    }
    function l(u) {
      return u + "_" + o() + "." + o();
    }
    function o() {
      return Math.random().toString().substring(2);
    }
    return n(s, "_polyfill", !0), s;
  }();
  function a(s) {
    return Object(s) === s;
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : tr);
var Ue = w1(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(r, n, a) {
    n[r] = n[r] || a(), e.exports && (e.exports = n[r]);
  })("Promise", tr, function() {
    var r, n, a, s = Object.prototype.toString, i = typeof setImmediate < "u" ? function(I) {
      return setImmediate(I);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), r = function(I, _, S, v) {
        return Object.defineProperty(I, _, {
          value: S,
          writable: !0,
          configurable: v !== !1
        });
      };
    } catch {
      r = function(_, S, v) {
        return _[S] = v, _;
      };
    }
    a = /* @__PURE__ */ function() {
      var I, _, S;
      function v(w, C) {
        this.fn = w, this.self = C, this.next = void 0;
      }
      return {
        add: function(C, F) {
          S = new v(C, F), _ ? _.next = S : I = S, _ = S, S = void 0;
        },
        drain: function() {
          var C = I;
          for (I = _ = n = void 0; C; )
            C.fn.call(C.self), C = C.next;
        }
      };
    }();
    function l(P, I) {
      a.add(P, I), n || (n = i(a.drain));
    }
    function o(P) {
      var I, _ = typeof P;
      return P != null && (_ == "object" || _ == "function") && (I = P.then), typeof I == "function" ? I : !1;
    }
    function u() {
      for (var P = 0; P < this.chain.length; P++)
        f(this, this.state === 1 ? this.chain[P].success : this.chain[P].failure, this.chain[P]);
      this.chain.length = 0;
    }
    function f(P, I, _) {
      var S, v;
      try {
        I === !1 ? _.reject(P.msg) : (I === !0 ? S = P.msg : S = I.call(void 0, P.msg), S === _.promise ? _.reject(TypeError("Promise-chain cycle")) : (v = o(S)) ? v.call(S, _.resolve, _.reject) : _.resolve(S));
      } catch (w) {
        _.reject(w);
      }
    }
    function p(P) {
      var I, _ = this;
      if (!_.triggered) {
        _.triggered = !0, _.def && (_ = _.def);
        try {
          (I = o(P)) ? l(function() {
            var S = new y(_);
            try {
              I.call(P, function() {
                p.apply(S, arguments);
              }, function() {
                h.apply(S, arguments);
              });
            } catch (v) {
              h.call(S, v);
            }
          }) : (_.msg = P, _.state = 1, _.chain.length > 0 && l(u, _));
        } catch (S) {
          h.call(new y(_), S);
        }
      }
    }
    function h(P) {
      var I = this;
      I.triggered || (I.triggered = !0, I.def && (I = I.def), I.msg = P, I.state = 2, I.chain.length > 0 && l(u, I));
    }
    function c(P, I, _, S) {
      for (var v = 0; v < I.length; v++)
        (function(C) {
          P.resolve(I[C]).then(function(x) {
            _(C, x);
          }, S);
        })(v);
    }
    function y(P) {
      this.def = P, this.triggered = !1;
    }
    function g(P) {
      this.promise = P, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function b(P) {
      if (typeof P != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var I = new g(this);
      this.then = function(S, v) {
        var w = {
          success: typeof S == "function" ? S : !0,
          failure: typeof v == "function" ? v : !1
        };
        return w.promise = new this.constructor(function(F, x) {
          if (typeof F != "function" || typeof x != "function")
            throw TypeError("Not a function");
          w.resolve = F, w.reject = x;
        }), I.chain.push(w), I.state !== 0 && l(u, I), w.promise;
      }, this.catch = function(S) {
        return this.then(void 0, S);
      };
      try {
        P.call(void 0, function(S) {
          p.call(I, S);
        }, function(S) {
          h.call(I, S);
        });
      } catch (_) {
        h.call(I, _);
      }
    }
    var k = r(
      {},
      "constructor",
      b,
      /*configurable=*/
      !1
    );
    return b.prototype = k, r(
      k,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), r(b, "resolve", function(I) {
      var _ = this;
      return I && typeof I == "object" && I.__NPO__ === 1 ? I : new _(function(v, w) {
        if (typeof v != "function" || typeof w != "function")
          throw TypeError("Not a function");
        v(I);
      });
    }), r(b, "reject", function(I) {
      return new this(function(S, v) {
        if (typeof S != "function" || typeof v != "function")
          throw TypeError("Not a function");
        v(I);
      });
    }), r(b, "all", function(I) {
      var _ = this;
      return s.call(I) != "[object Array]" ? _.reject(TypeError("Not an array")) : I.length === 0 ? _.resolve([]) : new _(function(v, w) {
        if (typeof v != "function" || typeof w != "function")
          throw TypeError("Not a function");
        var C = I.length, F = Array(C), x = 0;
        c(_, I, function(d, $) {
          F[d] = $, ++x === C && v(F);
        }, w);
      });
    }), r(b, "race", function(I) {
      var _ = this;
      return s.call(I) != "[object Array]" ? _.reject(TypeError("Not an array")) : new _(function(v, w) {
        if (typeof v != "function" || typeof w != "function")
          throw TypeError("Not a function");
        c(_, I, function(F, x) {
          v(x);
        }, w);
      });
    }), b;
  });
}), gt = /* @__PURE__ */ new WeakMap();
function br(e, t, r) {
  var n = gt.get(e.element) || {};
  t in n || (n[t] = []), n[t].push(r), gt.set(e.element, n);
}
function Dn(e, t) {
  var r = gt.get(e.element) || {};
  return r[t] || [];
}
function Rn(e, t, r) {
  var n = gt.get(e.element) || {};
  if (!n[t])
    return !0;
  if (!r)
    return n[t] = [], gt.set(e.element, n), !0;
  var a = n[t].indexOf(r);
  return a !== -1 && n[t].splice(a, 1), gt.set(e.element, n), n[t] && n[t].length === 0;
}
function S1(e, t) {
  var r = Dn(e, t);
  if (r.length < 1)
    return !1;
  var n = r.shift();
  return Rn(e, t, n), n;
}
function P1(e, t) {
  var r = gt.get(e);
  gt.set(t, r), gt.delete(e);
}
function ta(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function Mt(e, t, r) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var n = {
      method: t
    };
    r !== void 0 && (n.value = r);
    var a = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    a >= 8 && a < 10 && (n = JSON.stringify(n)), e.element.contentWindow.postMessage(n, e.origin);
  }
}
function I1(e, t) {
  t = ta(t);
  var r = [], n;
  if (t.event) {
    if (t.event === "error") {
      var a = Dn(e, t.data.method);
      a.forEach(function(i) {
        var l = new Error(t.data.message);
        l.name = t.data.name, i.reject(l), Rn(e, t.data.method, i);
      });
    }
    r = Dn(e, "event:".concat(t.event)), n = t.data;
  } else if (t.method) {
    var s = S1(e, t.method);
    s && (r.push(s), n = t.value);
  }
  r.forEach(function(i) {
    try {
      if (typeof i == "function") {
        i.call(e, n);
        return;
      }
      i.resolve(n);
    } catch {
    }
  });
}
var C1 = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function Cu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return C1.reduce(function(r, n) {
    var a = e.getAttribute("data-vimeo-".concat(n));
    return (a || a === "") && (r[n] = a === "" ? 1 : a), r;
  }, t);
}
function Os(e, t) {
  var r = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var n = document.createElement("div");
  return n.innerHTML = r, t.appendChild(n.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function Eu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(n, a) {
    if (!zt(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var s = _1(e), i = "https://".concat(s, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var l in t)
      t.hasOwnProperty(l) && (i += "&".concat(l, "=").concat(encodeURIComponent(t[l])));
    var o = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    o.open("GET", i, !0), o.onload = function() {
      if (o.status === 404) {
        a(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (o.status === 403) {
        a(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var u = JSON.parse(o.responseText);
        if (u.domain_status_code === 403) {
          Os(u, r), a(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        n(u);
      } catch (f) {
        a(f);
      }
    }, o.onerror = function() {
      var u = o.status ? " (".concat(o.status, ")") : "";
      a(new Error("There was an error fetching the embed code from Vimeo".concat(u, ".")));
    }, o.send();
  });
}
function E1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), r = function(a) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(a));
  };
  t.forEach(function(n) {
    try {
      if (n.getAttribute("data-vimeo-defer") !== null)
        return;
      var a = Cu(n), s = Iu(a);
      Eu(s, a, n).then(function(i) {
        return Os(i, n);
      }).catch(r);
    } catch (i) {
      r(i);
    }
  });
}
function A1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(n) {
      if (zt(n.origin) && !(!n.data || n.data.event !== "spacechange")) {
        for (var a = e.querySelectorAll("iframe"), s = 0; s < a.length; s++)
          if (a[s].contentWindow === n.source) {
            var i = a[s].parentElement;
            i.style.paddingBottom = "".concat(n.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function T1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(n) {
      if (zt(n.origin)) {
        var a = ta(n.data);
        if (!(!a || a.event !== "ready"))
          for (var s = e.querySelectorAll("iframe"), i = 0; i < s.length; i++) {
            var l = s[i], o = l.contentWindow === n.source;
            if (Pu(l.src) && o) {
              var u = new Ns(l);
              u.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function L1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(a) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(a));
    }, r = function(a) {
      if (zt(a.origin)) {
        var s = ta(a.data);
        if (!(!s || s.event !== "ready"))
          for (var i = e.querySelectorAll("iframe"), l = function() {
            var f = i[o], p = f.contentWindow === a.source;
            if (Pu(f.src) && p) {
              var h = new Ns(f);
              h.getVideoId().then(function(c) {
                var y = new RegExp("[?&]vimeo_t_".concat(c, "=([^&#]*)")).exec(window.location.href);
                if (y && y[1]) {
                  var g = decodeURI(y[1]);
                  h.setCurrentTime(g);
                }
              }).catch(t);
            }
          }, o = 0; o < i.length; o++)
            l();
      }
    };
    window.addEventListener("message", r);
  }
}
function M1() {
  var e = function() {
    for (var n, a = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], s = 0, i = a.length, l = {}; s < i; s++)
      if (n = a[s], n && n[1] in document) {
        for (s = 0; s < n.length; s++)
          l[a[0][s]] = n[s];
        return l;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, r = {
    request: function(a) {
      return new Promise(function(s, i) {
        var l = function u() {
          r.off("fullscreenchange", u), s();
        };
        r.on("fullscreenchange", l), a = a || document.documentElement;
        var o = a[e.requestFullscreen]();
        o instanceof Promise && o.then(l).catch(i);
      });
    },
    exit: function() {
      return new Promise(function(a, s) {
        if (!r.isFullscreen) {
          a();
          return;
        }
        var i = function o() {
          r.off("fullscreenchange", o), a();
        };
        r.on("fullscreenchange", i);
        var l = document[e.exitFullscreen]();
        l instanceof Promise && l.then(i).catch(s);
      });
    },
    on: function(a, s) {
      var i = t[a];
      i && document.addEventListener(i, s);
    },
    off: function(a, s) {
      var i = t[a];
      i && document.removeEventListener(i, s);
    }
  };
  return Object.defineProperties(r, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), r;
}
var O1 = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, N1 = /* @__PURE__ */ function(e) {
  p1(r, e);
  var t = y1(r);
  function r(n, a) {
    var s, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 ? arguments[3] : void 0;
    return _u(this, r), s = t.call(this), cn(dn(s), "logger", void 0), cn(dn(s), "speedAdjustment", 0), cn(dn(s), "adjustSpeed", /* @__PURE__ */ function() {
      var o = Ot(/* @__PURE__ */ Me().mark(function u(f, p) {
        var h;
        return Me().wrap(function(y) {
          for (; ; ) switch (y.prev = y.next) {
            case 0:
              if (s.speedAdjustment !== p) {
                y.next = 2;
                break;
              }
              return y.abrupt("return");
            case 2:
              return y.next = 4, f.getPlaybackRate();
            case 4:
              return y.t0 = y.sent, y.t1 = s.speedAdjustment, y.t2 = y.t0 - y.t1, y.t3 = p, h = y.t2 + y.t3, s.log("New playbackRate:  ".concat(h)), y.next = 12, f.setPlaybackRate(h);
            case 12:
              s.speedAdjustment = p;
            case 13:
            case "end":
              return y.stop();
          }
        }, u);
      }));
      return function(u, f) {
        return o.apply(this, arguments);
      };
    }()), s.logger = l, s.init(a, n, Zi(Zi({}, O1), i)), s;
  }
  return $u(r, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var n = Ot(/* @__PURE__ */ Me().mark(function s(i, l, o) {
        var u = this, f, p, h;
        return Me().wrap(function(y) {
          for (; ; ) switch (y.prev = y.next) {
            case 0:
              return y.next = 2, this.waitForTOReadyState(i, "open");
            case 2:
              if (o.role !== "viewer") {
                y.next = 10;
                break;
              }
              return y.next = 5, this.updatePlayer(i, l, o);
            case 5:
              f = el(i, "change", function() {
                return u.updatePlayer(i, l, o);
              }), p = this.maintainPlaybackPosition(i, l, o), this.addEventListener("disconnect", function() {
                p.cancel(), f.cancel();
              }), y.next = 14;
              break;
            case 10:
              return y.next = 12, this.updateTimingObject(i, l);
            case 12:
              h = el(l, ["seeked", "play", "pause", "ratechange"], function() {
                return u.updateTimingObject(i, l);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return h.cancel();
              });
            case 14:
            case "end":
              return y.stop();
          }
        }, s, this);
      }));
      function a(s, i, l) {
        return n.apply(this, arguments);
      }
      return a;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var n = Ot(/* @__PURE__ */ Me().mark(function s(i, l) {
        return Me().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.t0 = i, u.next = 3, l.getCurrentTime();
            case 3:
              return u.t1 = u.sent, u.next = 6, l.getPaused();
            case 6:
              if (!u.sent) {
                u.next = 10;
                break;
              }
              u.t2 = 0, u.next = 13;
              break;
            case 10:
              return u.next = 12, l.getPlaybackRate();
            case 12:
              u.t2 = u.sent;
            case 13:
              u.t3 = u.t2, u.t4 = {
                position: u.t1,
                velocity: u.t3
              }, u.t0.update.call(u.t0, u.t4);
            case 16:
            case "end":
              return u.stop();
          }
        }, s);
      }));
      function a(s, i) {
        return n.apply(this, arguments);
      }
      return a;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var n = Ot(/* @__PURE__ */ Me().mark(function s(i, l, o) {
        var u, f, p;
        return Me().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (u = i.query(), f = u.position, p = u.velocity, typeof f == "number" && l.setCurrentTime(f), typeof p != "number") {
                c.next = 25;
                break;
              }
              if (p !== 0) {
                c.next = 11;
                break;
              }
              return c.next = 6, l.getPaused();
            case 6:
              if (c.t0 = c.sent, c.t0 !== !1) {
                c.next = 9;
                break;
              }
              l.pause();
            case 9:
              c.next = 25;
              break;
            case 11:
              if (!(p > 0)) {
                c.next = 25;
                break;
              }
              return c.next = 14, l.getPaused();
            case 14:
              if (c.t1 = c.sent, c.t1 !== !0) {
                c.next = 19;
                break;
              }
              return c.next = 18, l.play().catch(/* @__PURE__ */ function() {
                var y = Ot(/* @__PURE__ */ Me().mark(function g(b) {
                  return Me().wrap(function(P) {
                    for (; ; ) switch (P.prev = P.next) {
                      case 0:
                        if (!(b.name === "NotAllowedError" && o.autoPlayMuted)) {
                          P.next = 5;
                          break;
                        }
                        return P.next = 3, l.setMuted(!0);
                      case 3:
                        return P.next = 5, l.play().catch(function(I) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", I);
                        });
                      case 5:
                      case "end":
                        return P.stop();
                    }
                  }, g);
                }));
                return function(g) {
                  return y.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(i, l, o);
            case 19:
              return c.next = 21, l.getPlaybackRate();
            case 21:
              if (c.t2 = c.sent, c.t3 = p, c.t2 === c.t3) {
                c.next = 25;
                break;
              }
              l.setPlaybackRate(p);
            case 25:
            case "end":
              return c.stop();
          }
        }, s, this);
      }));
      function a(s, i, l) {
        return n.apply(this, arguments);
      }
      return a;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(a, s, i) {
      var l = this, o = i.allowedDrift, u = i.maxAllowedDrift, f = i.minCheckInterval, p = i.maxRateAdjustment, h = i.maxTimeToCatchUp, c = Math.min(h, Math.max(f, u)) * 1e3, y = /* @__PURE__ */ function() {
        var b = Ot(/* @__PURE__ */ Me().mark(function k() {
          var P, I, _, S, v;
          return Me().wrap(function(C) {
            for (; ; ) switch (C.prev = C.next) {
              case 0:
                if (C.t0 = a.query().velocity === 0, C.t0) {
                  C.next = 6;
                  break;
                }
                return C.next = 4, s.getPaused();
              case 4:
                C.t1 = C.sent, C.t0 = C.t1 === !0;
              case 6:
                if (!C.t0) {
                  C.next = 8;
                  break;
                }
                return C.abrupt("return");
              case 8:
                return C.t2 = a.query().position, C.next = 11, s.getCurrentTime();
              case 11:
                if (C.t3 = C.sent, P = C.t2 - C.t3, I = Math.abs(P), l.log("Drift: ".concat(P)), !(I > u)) {
                  C.next = 22;
                  break;
                }
                return C.next = 18, l.adjustSpeed(s, 0);
              case 18:
                s.setCurrentTime(a.query().position), l.log("Resync by currentTime"), C.next = 29;
                break;
              case 22:
                if (!(I > o)) {
                  C.next = 29;
                  break;
                }
                return _ = I / h, S = p, v = _ < S ? (S - _) / 2 : S, C.next = 28, l.adjustSpeed(s, v * Math.sign(P));
              case 28:
                l.log("Resync by playbackRate");
              case 29:
              case "end":
                return C.stop();
            }
          }, k);
        }));
        return function() {
          return b.apply(this, arguments);
        };
      }(), g = setInterval(function() {
        return y();
      }, c);
      return {
        cancel: function() {
          return clearInterval(g);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(a) {
      var s;
      (s = this.logger) === null || s === void 0 || s.call(this, "TimingSrcConnector: ".concat(a));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(a, s) {
        return new Promise(function(i) {
          var l = function o() {
            a.readyState === s ? i() : a.addEventListener("readystatechange", o, {
              once: !0
            });
          };
          l();
        });
      }
    )
  }]), r;
}(/* @__PURE__ */ Qa(EventTarget)), Wt = /* @__PURE__ */ new WeakMap(), ga = /* @__PURE__ */ new WeakMap(), Re = {}, Ns = /* @__PURE__ */ function() {
  function e(t) {
    var r = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (_u(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document < "u" && typeof t == "string" && (t = document.getElementById(t)), !g1(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var a = t.querySelector("iframe");
      a && (t = a);
    }
    if (t.nodeName === "IFRAME" && !zt(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (Wt.has(t))
      return Wt.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var s = new Ue(function(l, o) {
      if (r._onMessage = function(p) {
        if (!(!zt(p.origin) || r.element.contentWindow !== p.source)) {
          r.origin === "*" && (r.origin = p.origin);
          var h = ta(p.data), c = h && h.event === "error", y = c && h.data && h.data.method === "ready";
          if (y) {
            var g = new Error(h.data.message);
            g.name = h.data.name, o(g);
            return;
          }
          var b = h && h.event === "ready", k = h && h.method === "ping";
          if (b || k) {
            r.element.setAttribute("data-ready", "true"), l();
            return;
          }
          I1(r, h);
        }
      }, r._window.addEventListener("message", r._onMessage), r.element.nodeName !== "IFRAME") {
        var u = Cu(t, n), f = Iu(u);
        Eu(f, u, t).then(function(p) {
          var h = Os(p, t);
          return r.element = h, r._originalElement = t, P1(t, h), Wt.set(r.element, r), p;
        }).catch(o);
      }
    });
    if (ga.set(this, s), Wt.set(this.element, this), this.element.nodeName === "IFRAME" && Mt(this, "ping"), Re.isEnabled) {
      var i = function() {
        return Re.exit();
      };
      this.fullscreenchangeHandler = function() {
        Re.isFullscreen ? br(r, "event:exitFullscreen", i) : Rn(r, "event:exitFullscreen", i), r.ready().then(function() {
          Mt(r, "fullscreenchange", Re.isFullscreen);
        });
      }, Re.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return $u(e, [{
    key: "callMethod",
    value: function(r) {
      var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new Ue(function(s, i) {
        return n.ready().then(function() {
          br(n, r, {
            resolve: s,
            reject: i
          }), Mt(n, r, a);
        }).catch(i);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(r) {
      var n = this;
      return new Ue(function(a, s) {
        return r = Ji(r, "get"), n.ready().then(function() {
          br(n, r, {
            resolve: a,
            reject: s
          }), Mt(n, r);
        }).catch(s);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(r, n) {
      var a = this;
      return new Ue(function(s, i) {
        if (r = Ji(r, "set"), n == null)
          throw new TypeError("There must be a value to set.");
        return a.ready().then(function() {
          br(a, r, {
            resolve: s,
            reject: i
          }), Mt(a, r, n);
        }).catch(i);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(r, n) {
      if (!r)
        throw new TypeError("You must pass an event name.");
      if (!n)
        throw new TypeError("You must pass a callback function.");
      if (typeof n != "function")
        throw new TypeError("The callback must be a function.");
      var a = Dn(this, "event:".concat(r));
      a.length === 0 && this.callMethod("addEventListener", r).catch(function() {
      }), br(this, "event:".concat(r), n);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(r, n) {
      if (!r)
        throw new TypeError("You must pass an event name.");
      if (n && typeof n != "function")
        throw new TypeError("The callback must be a function.");
      var a = Rn(this, "event:".concat(r), n);
      a && this.callMethod("removeEventListener", r).catch(function(s) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(r) {
      return this.callMethod("loadVideo", r);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var r = ga.get(this) || new Ue(function(n, a) {
        a(new Error("Unknown player. Probably unloaded."));
      });
      return Ue.resolve(r);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: r,
        data: n
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(r) {
      return this.callMethod("removeCuePoint", r);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(r, n) {
      if (!r)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: r,
        kind: n
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return Re.isEnabled ? Re.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return Re.isEnabled ? Re.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return Re.isEnabled ? Ue.resolve(Re.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var r = this;
      return new Ue(function(n) {
        if (ga.delete(r), Wt.delete(r.element), r._originalElement && (Wt.delete(r._originalElement), r._originalElement.removeAttribute("data-vimeo-initialized")), r.element && r.element.nodeName === "IFRAME" && r.element.parentNode && (r.element.parentNode.parentNode && r._originalElement && r._originalElement !== r.element.parentNode ? r.element.parentNode.parentNode.removeChild(r.element.parentNode) : r.element.parentNode.removeChild(r.element)), r.element && r.element.nodeName === "DIV" && r.element.parentNode) {
          r.element.removeAttribute("data-vimeo-initialized");
          var a = r.element.querySelector("iframe");
          a && a.parentNode && (a.parentNode.parentNode && r._originalElement && r._originalElement !== a.parentNode ? a.parentNode.parentNode.removeChild(a.parentNode) : a.parentNode.removeChild(a));
        }
        r._window.removeEventListener("message", r._onMessage), Re.isEnabled && Re.off("fullscreenchange", r.fullscreenchangeHandler), n();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(r) {
      return this.set("autopause", r);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(r) {
      return this.set("cameraProps", r);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return Ue.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(r) {
      return this.set("color", r);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(r) {
      if (!Array.isArray(r))
        return new Ue(function(s, i) {
          return i(new TypeError("Argument must be an array."));
        });
      var n = new Ue(function(s) {
        return s(null);
      }), a = [r[0] ? this.set("colorOne", r[0]) : n, r[1] ? this.set("colorTwo", r[1]) : n, r[2] ? this.set("colorThree", r[2]) : n, r[3] ? this.set("colorFour", r[3]) : n];
      return Ue.all(a);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(r) {
      return this.set("currentTime", r);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(r) {
      return this.set("loop", r);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(r) {
      return this.set("muted", r);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(r) {
      return this.set("playbackRate", r);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(r) {
      return this.set("quality", r);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(r) {
      return this.set("volume", r);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = Ot(/* @__PURE__ */ Me().mark(function n(a, s) {
        var i = this, l;
        return Me().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (a) {
                u.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return u.next = 4, this.ready();
            case 4:
              return l = new N1(this, a, s), Mt(this, "notifyTimingObjectConnect"), l.addEventListener("disconnect", function() {
                return Mt(i, "notifyTimingObjectDisconnect");
              }), u.abrupt("return", l);
            case 8:
            case "end":
              return u.stop();
          }
        }, n, this);
      }));
      function r(n, a) {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }]), e;
}();
Su || (Re = M1(), E1(), A1(), T1(), L1());
function F1(e) {
  var t = e.player, r = e.event, n = e.emit;
  t.on(r, function(a) {
    return n(r, a, t);
  });
}
var D1 = ["play", "playing", "pause", "ended", "timeupdate", "progress", "seeking", "seeked", "texttrackchange", "chapterchange", "cuechange", "cuepoint", "volumechange", "playbackratechange", "bufferstart", "bufferend", "error", "loaded", "durationchange", "fullscreenchange", "qualitychange", "camerachange", "resize"], Za = {
  name: "VimeoPlayer",
  props: {
    playerHeight: {
      type: Number,
      default: 320
    },
    playerWidth: {
      type: Number,
      default: 640
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    },
    videoId: {
      type: String,
      default: ""
    },
    videoUrl: {
      type: String,
      default: ""
    },
    loop: {
      type: Boolean,
      default: !1
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    eventsToEmit: {
      type: Array,
      default: function() {
        return D1;
      }
    }
  },
  setup: function(t, r) {
    var n = r.emit, a, s = L(null), i = Nu(t), l = i.videoId, o = i.videoUrl;
    !t.videoId && !t.videoUrl && console.warn("[VueVimeoPlayer: You mist provide at least a videoId or a videoUrl prop]");
    var u = function(k) {
      var P = k.id, I = k.url, _ = {
        width: t.playerWidth,
        height: t.playerHeight,
        loop: t.loop,
        autoplay: t.autoplay,
        controls: t.controls
      };
      return O(I) && (_.url = O(I)), O(P) && (_.id = O(P)), Object.assign(_, t.options);
    }, f = function() {
      return a.play();
    }, p = function() {
      return a.pause();
    }, h = function() {
      return a.setVolume(0);
    }, c = function() {
      var k = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.5;
      return a.setVolume(k);
    }, y = function() {
      a.ready().then(function() {
        n("ready", a);
      }).catch(function(k) {
        n("error", k, a);
      }), t.eventsToEmit.forEach(function(k) {
        return F1({
          player: a,
          event: k,
          emit: n
        });
      });
    };
    he(function() {
      a = new Ns(s.value, u({
        id: t.videoId,
        url: t.videoUrl
      })), y();
    }), qe(function() {
      return a.unload();
    }), le(l, function(b) {
      return a.loadVideo(u({
        id: b
      }));
    }), le(o, function(b) {
      return a.loadVideo(u({
        url: b
      }));
    }), le(al(t, "controls"), function() {
      return a.loadVideo(u({
        url: o,
        id: l
      }));
    });
    var g = function(k) {
      return a.loadVideo(u({
        id: k
      }));
    };
    return {
      update: g,
      play: f,
      pause: p,
      mute: h,
      unmute: c,
      elementRef: s,
      player: a
    };
  }
}, R1 = {
  ref: "elementRef"
};
function x1(e, t, r, n, a, s) {
  return m(), T(
    "div",
    R1,
    null,
    512
    /* NEED_PATCH */
  );
}
Za.render = x1;
const H1 = ["data-state"], z1 = { class: "ds-video-takeover__container" }, V1 = ["inert"], B1 = { class: "ds-video-takeover__testimonial" }, j1 = ["inert"], q1 = ["src"], W1 = ["inert"], IS = /* @__PURE__ */ W({
  __name: "ds-video-takeover",
  props: {
    ariaLabelPlay: { default: "Play" },
    ariaLabelPause: { default: "Pause" },
    ariaLabelClose: { default: "Close" },
    buttonText: {},
    posterImageSrc: {},
    quoteName: {},
    quoteRole: {},
    quoteText: {},
    videoFullVimeoUrl: {},
    videoBgVimeoUrl: {}
  },
  setup(e) {
    const t = L(null), r = L(!1), n = L(!1), a = L(null), s = L(null), i = L(!1), l = L(!1), o = L("bg"), u = L(
      null
    ), f = L("play"), p = L(0), h = L("pause"), c = L(!1), y = (q, Z, re, ne) => {
      const ye = [];
      return q && ye.push("ds-video-takeover__video-wrapper--ready"), Z === re && ye.push("ds-video-takeover__video-wrapper--active"), ne && ye.push("ds-video-takeover__video-wrapper--hide-poster"), ye;
    }, g = E(
      () => y(
        l.value,
        "bg",
        o.value,
        c.value
      )
    ), b = E(
      () => y(
        i.value,
        "full",
        o.value,
        c.value
      )
    ), k = () => {
      i.value = !0;
    }, P = async () => {
      l.value = !0;
    }, I = () => {
      c.value === !1 && (c.value = !0);
    }, _ = [];
    let S = !1;
    const v = async () => {
      if (!S) {
        S = !0;
        try {
          for (; _.length > 0; ) {
            const q = _.shift();
            if (!q) break;
            await q();
          }
        } catch (q) {
          console.error("Action failed", q);
        } finally {
          S = !1;
        }
      }
    }, w = (q) => {
      _.push(q), v();
    };
    he(() => {
      window.addEventListener("keydown", Q);
    }), Xa(() => {
      window.removeEventListener("keydown", Q);
    }), Kt(
      t,
      ([q]) => {
        r.value = (q == null ? void 0 : q.isIntersecting) || !1;
      },
      { threshold: 0.75 }
    );
    const C = async (q, Z = 1e3) => new Promise((re, ne) => {
      let ye = setTimeout(() => {
        console.warn("Vimeo play() timed out"), ne(new Error("Vimeo play() timed out"));
      }, Z);
      q.play().then(() => {
        clearTimeout(ye), re();
      }).catch((Ae) => {
        clearTimeout(ye), ne(Ae);
      });
    }), F = async (q, Z = 500) => new Promise((re, ne) => {
      let ye = setTimeout(() => {
        console.warn("Vimeo pause() timed out"), ne(new Error("Vimeo pause() timed out"));
      }, Z);
      q.pause().then(() => {
        clearTimeout(ye), re();
      }).catch((Ae) => {
        clearTimeout(ye), ne(Ae);
      });
    }), x = async (q = !0) => {
      w(async () => {
        try {
          s.value && "play" in s.value && await C(s.value);
        } catch (Z) {
          console.error(Z);
        }
        A(!0), q && (f.value = "play");
      });
    }, R = async (q = !0) => {
      w(async () => {
        try {
          s.value && "pause" in s.value && await F(s.value);
        } catch (Z) {
          console.error(Z);
        }
        A(!1), q && (f.value = "pause");
      });
    }, d = () => {
      o.value = "full";
    }, $ = (q) => {
      p.value = q.percent;
    }, A = (q) => {
      var Z;
      (Z = u.value) == null || Z.setButtonState(q);
    }, z = async () => {
      var q;
      a.value && ((q = a.value) == null || q.pause()), o.value = "bg", f.value !== "pause" && await x(!1);
    }, N = async () => {
      var q;
      await R(!1), (q = a.value) == null || q.pause(), o.value = "bg";
    }, j = async () => {
      var q, Z, re;
      await R(!1), (q = a.value) == null || q.mute(), (Z = a.value) == null || Z.play(), (re = a.value) == null || re.unmute();
    }, Q = (q) => {
      q.key === "Escape" && o.value === "full" && z();
    };
    return le(r, async (q) => {
      s.value && (q ? (n.value = !0, z()) : N());
    }), le(o, (q) => {
      q === "full" && j();
    }), (q, Z) => (m(), T("div", {
      class: "ds-video-takeover",
      "data-state": r.value ? "visible" : "hidden",
      "data-testid": "videotakeover",
      ref_key: "takeoverRef",
      ref: t
    }, [
      B(xn, {
        background: "neutral",
        class: "ds-video-takeover__block"
      }, {
        default: V(() => [
          D("div", z1, [
            B(ft, { name: "content" }, {
              default: V(() => [
                we(D("div", {
                  class: "ds-video-takeover__content",
                  inert: o.value === "full"
                }, [
                  D("blockquote", B1, [
                    q.quoteText ? (m(), H(Y, {
                      key: 0,
                      class: "ds-video-takeover__quote",
                      "text-style": "medium",
                      "text-type": "heading-2xl"
                    }, {
                      default: V(() => [
                        K(U(q.quoteText), 1)
                      ]),
                      _: 1
                    })) : M("", !0),
                    q.quoteName ? (m(), H(Y, {
                      key: 1,
                      class: "ds-video-takeover__name",
                      "text-style": "medium",
                      "text-type": "heading-lg"
                    }, {
                      default: V(() => [
                        K(U(q.quoteName), 1)
                      ]),
                      _: 1
                    })) : M("", !0),
                    q.quoteRole ? (m(), H(Y, {
                      key: 2,
                      class: "ds-video-takeover__role",
                      "text-type": "body-xs"
                    }, {
                      default: V(() => [
                        K(U(q.quoteRole), 1)
                      ]),
                      _: 1
                    })) : M("", !0)
                  ]),
                  B(Ee, {
                    "icon-start": "button-play",
                    variant: "primary-inverted",
                    "click-handler": d,
                    "data-testid": "watchButton"
                  }, {
                    default: V(() => [
                      K(U(q.buttonText), 1)
                    ]),
                    _: 1
                  })
                ], 8, V1), [
                  [Se, r.value && o.value === "bg"]
                ])
              ]),
              _: 1
            }),
            B(ft, { name: "content" }, {
              default: V(() => [
                q.videoBgVimeoUrl ? we((m(), H(zf, {
                  key: 0,
                  class: "ds-video-takeover__progress-button",
                  "aria-label-play": q.ariaLabelPlay,
                  playHandler: (re) => x(),
                  "aria-label-pause": q.ariaLabelPause,
                  initialState: h.value,
                  progress: p.value,
                  pauseHandler: (re) => R(),
                  ref_key: "progressButton",
                  ref: u
                }, null, 8, ["aria-label-play", "playHandler", "aria-label-pause", "initialState", "progress", "pauseHandler"])), [
                  [Se, r.value && o.value === "bg"]
                ]) : M("", !0)
              ]),
              _: 1
            }),
            D("div", {
              class: G(["ds-video-takeover__video-wrapper ds-video-takeover__video-wrapper--bg", g.value]),
              "data-testid": "video-wrapper-bg",
              inert: o.value === "full",
              style: Ce(`--poster-img: url(${q.posterImageSrc})`)
            }, [
              Z[0] || (Z[0] = D("div", { class: "ds-video-takeover__video-overlay" }, null, -1)),
              q.videoBgVimeoUrl ? (m(), H(O(Za), {
                key: 0,
                "data-testid": "video-bg-player",
                tabindex: "-1",
                class: "ds-video-takeover__video",
                ref_key: "vimeoBgPlayer",
                ref: s,
                onReady: P,
                onPlaying: I,
                onTimeupdate: $,
                videoUrl: `${q.videoBgVimeoUrl}`,
                options: {
                  autopause: !0,
                  autoplay: !1,
                  controls: !1,
                  dnt: !0,
                  loop: !0,
                  muted: !0
                }
              }, null, 8, ["videoUrl"])) : M("", !0),
              q.posterImageSrc ? (m(), T("img", {
                key: 1,
                class: "ds-video-takeover__poster-img",
                src: q.posterImageSrc,
                alt: ""
              }, null, 8, q1)) : M("", !0)
            ], 14, j1),
            D("div", {
              class: G(["ds-video-takeover__video-wrapper ds-video-takeover__video-wrapper--full", b.value]),
              "data-testid": "video-wrapper-full",
              inert: o.value === "bg"
            }, [
              B(Ie, {
                class: "ds-video-takeover__close",
                "click-handler": z,
                ariaLabel: q.ariaLabelClose,
                "icon-name": "button-close",
                variant: "ghost-inverted"
              }, null, 8, ["ariaLabel"]),
              B(O(Za), {
                class: "ds-video-takeover__vimeo",
                ref_key: "vimeoPlayer",
                ref: a,
                onReady: k,
                videoUrl: `${q.videoFullVimeoUrl}`,
                options: {
                  autopause: !0,
                  background: !1,
                  controls: !0,
                  dnt: !0,
                  loop: !1,
                  muted: !0,
                  autoplay: !1
                }
              }, null, 8, ["videoUrl"])
            ], 10, W1)
          ])
        ]),
        _: 1
      })
    ], 8, H1));
  }
}), CS = [
  "accept",
  "capture",
  "labelAddFilesButton",
  "labelDropFiles",
  "labelRemove",
  "labelTapToAdd",
  "listMode",
  "maxFileSize",
  "multiple",
  "validationMessageFileSize",
  "validationMessageDuplicate",
  "validationMessageType"
];
export {
  K1 as DsAccordion,
  Y1 as DsAccordionItem,
  Wu as DsAlert,
  Uu as DsBadge,
  G1 as DsBanner,
  Z1 as DsBannerLg,
  Q1 as DsBannerMd,
  G1 as DsBannerSm,
  X1 as DsBannerXl,
  xn as DsBlock,
  ol as DsBrandIcon,
  J1 as DsBreadcrumb,
  Ee as DsButton,
  bl as DsButtonGroup,
  eS as DsButtonPlay,
  zf as DsButtonPlayProgress,
  tS as DsCardAction,
  rS as DsCardProduct,
  nS as DsCarousel,
  aS as DsDialog,
  sS as DsFileUpload,
  Jd as DsGrid,
  iS as DsHeader,
  ae as DsIcon,
  Pd as DsIconAttention,
  Ie as DsIconButton,
  Ld as DsModal,
  lS as DsNavService,
  oS as DsPageHeader,
  uS as DsPagination,
  cS as DsProgressDots,
  fS as DsQuantitySelector,
  dS as DsScrollProgressBar,
  mS as DsSkeletonBox,
  vS as DsSkeletonButton,
  yS as DsSkeletonCircle,
  hS as DsSkeletonSurface,
  gS as DsSkeletonTextLine,
  bS as DsSkeletonWrapper,
  pS as DsSpinner,
  _S as DsStickyPanels,
  M0 as DsTab,
  $S as DsTable,
  kS as DsTabs,
  gu as DsTag,
  wS as DsTestimonial,
  Y as DsText,
  SS as DsToast,
  PS as DsToggletip,
  Tf as DsTooltip,
  Xw as DsUnderscore,
  IS as DsVideoTakeover,
  Fe as dsUseIsMobile,
  St as dsUseUniqueId,
  CS as fkFileUploadProps
};
